var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4256.42 3906.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7ad3ce;}.cls-2{fill:#1d7772;}.cls-3{fill:#b88228;}.cls-4{fill:#b7e5e6;}.cls-5{fill:#b91b31;}.cls-6{fill:#cc912d;}.cls-7,.cls-8{fill:#fff;}.cls-9{fill:#d29859;}.cls-10{fill:#2f4255;}.cls-11{fill:#d1d1d1;}.cls-12{fill:#f3ab3d;}.cls-13{fill:#304b66;}.cls-14{fill:#d4eef9;}.cls-15{fill:#750001;}.cls-16,.cls-17,.cls-18{opacity:.5;}.cls-19{opacity:.7;}.cls-19,.cls-17,.cls-20,.cls-21,.cls-22,.cls-8,.cls-18{isolation:isolate;}.cls-19,.cls-23{fill:#666;}.cls-24{fill:#8c6144;}.cls-25{fill:#e5c9a8;}.cls-26{fill:#5e5d87;}.cls-27{fill:#973b0c;}.cls-28{fill:#e3c383;}.cls-29{fill:#274150;}.cls-30{fill:#e2e6e7;}.cls-31,.cls-18{fill:#fff89e;}.cls-32{fill:#c1272d;}.cls-33{fill:#4d4d4d;}.cls-34{fill:#50b6b0;}.cls-35{fill:#5dc9c3;}.cls-36{fill:#b7e2dd;}.cls-37{fill:#b57b29;}.cls-38{fill:#8a5400;}.cls-39{fill:#534741;}.cls-40{fill:#740009;}.cls-41{fill:#c9c9c9;}.cls-42{fill:#dda34f;}.cls-43{fill:#f79b08;}.cls-44{fill:#7f6e59;}.cls-45{fill:#656565;}.cls-46{fill:#6b6b6b;}.cls-47{fill:#7a513b;}.cls-48{fill:#c3c3c3;}.cls-49{fill:#284353;}.cls-50{fill:#00808b;}.cls-51{fill:#333;}.cls-52{fill:#4cbec1;}.cls-53{fill:#34495e;}.cls-54{fill:#818181;}.cls-55{fill:#c49a62;}.cls-56{fill:#e12f43;}.cls-57{fill:#e6e6e6;}.cls-58{fill:gray;}.cls-59{fill:#2e9e97;}.cls-60{fill:#b2041c;}.cls-61{fill:#fa9a08;}.cls-17{fill:#29a69f;}.cls-62{fill:#efd681;}.cls-63{fill:#62a8c0;}.cls-64{fill:#a28b6f;}.cls-65{fill:#5db3ae;}.cls-66{fill:#828282;}.cls-67{fill:#562f06;}.cls-68{fill:#54a19d;}.cls-69{fill:#43817e;}.cls-70{fill:#b8b8b8;}.cls-71{fill:#6396b5;}.cls-20,.cls-8{opacity:.2;}.cls-72{fill:#f6f4dd;}.cls-73{fill:#ffead9;}.cls-74{fill:#a1a1a1;}.cls-75{fill:#c5994f;}.cls-76{fill:#383851;}.cls-77{fill:#747474;}.cls-78{fill:#b22f2f;}.cls-79{fill:#ffb012;}.cls-80{fill:#dbb57d;}.cls-81{fill:#835b20;}.cls-82{fill:#4d2a0e;}.cls-83{fill:#303530;}.cls-84{fill:#aaadad;}.cls-85{fill:#746757;}.cls-86{fill:#87c7c2;}.cls-87{fill:#273747;}.cls-88{fill:#ffedcc;}.cls-21{opacity:.15;}.cls-89{fill:#ffb85f;}.cls-90{fill:#9f8a6f;}.cls-91{fill:#e70012;}.cls-92{fill:#00aaa0;}.cls-93{fill:#999;}.cls-94{fill:#e7c892;}.cls-95{fill:#ad9a83;}.cls-96{fill:#ccc;}.cls-22{opacity:.1;}.cls-97{fill:#757575;}.cls-98{fill:#260e0a;}.cls-99{fill:#ad000e;}.cls-100{fill:#f46f74;}.cls-101{fill:#f7ece2;}.cls-102{fill:#fed943;}.cls-103{fill:#905e21;}.cls-104{fill:#b3b3b3;}.cls-105{fill:#e89d0e;}.cls-106{fill:#ed1c24;}.cls-107{fill:#f6bc6a;}.cls-108{fill:#7a76a3;}.cls-109{fill:#ce6303;}.cls-110{fill:#bdaa92;}.cls-111{fill:#b87548;}.cls-112{fill:#962029;}.cls-113{fill:#572e00;}.cls-114{fill:#93278f;}.cls-115{fill:#ecd5b6;}.cls-116{fill:#aaa08a;}.cls-117{fill:#bcaaa4;}.cls-118{fill:#e52927;}.cls-119{fill:#473d38;}.cls-120{fill:#fbb03b;}.cls-121{fill:#919191;}.cls-122{fill:#f99a0c;}.cls-123{fill:#f2f2f2;}.cls-124{fill:#f99a08;}.cls-125{fill:#f6ac3f;}.cls-126{fill:#e3e3e3;}.cls-127{fill:#e5ba2d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plane"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1004.64,2966.93h-471.52c-.07-.28-.12-.58-.19-.86H.7c-.42-5-.7-10-.7-15,0-92.79,75.21-168.03,168-168.06,8.7,0,17.4,.67,26,2,19.75-124.68,127.69-220,257.92-220,123.27,0,226.55,85.4,254,200.24,72.9,4.8,134.1,56.7,150.74,127.84,50.06-26.06,111.77-6.61,137.83,43.45,4.97,9.55,8.4,19.82,10.17,30.43l-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1004.64,2966.93h-92.24c-8.84-26.27-26.34-49.66-49.5-65-32.2-21.28-74.55-26.39-110.91-13.35,3.89-33.18-11.44-67.94-38.59-87.43s-65-22.88-95.19-8.57c-7.13-44.39-38.15-82.77-77-105.44s-84.72-31-129.67-31c-60.57,0-125.19,17-164,63.53-27,32.45-38.24,75.12-44.76,116.84-43.56-23.18-98.49-23.6-142.41-1.09-11.65,5.99-22.45,13.49-32.14,22.3,31.15-46.74,83.61-74.81,139.78-74.77,8.7,0,17.4,.67,26,2,19.75-124.68,127.69-220,257.92-220,123.27,0,226.55,85.4,254,200.24,72.9,4.8,134.1,56.7,150.74,127.84,50.06-26.06,111.77-6.61,137.83,43.45,4.97,9.55,8.4,19.82,10.17,30.43l-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3165.17,1899.5h471.52c.07-.28,.12-.58,.19-.86h532.23c.41-5,.69-10,.69-15,.04-92.78-75.15-168.03-167.93-168.07h-.12c-8.69,0-17.36,.67-25.94,2-19.75-124.68-127.7-220-257.92-220-123.27,0-226.55,85.4-254,200.24-72.91,4.8-134.1,56.7-150.74,127.84-50.05-26.07-111.76-6.63-137.83,43.42-4.98,9.55-8.41,19.83-10.17,30.46l.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3165.17,1899.5h92.24c8.84-26.27,26.33-49.66,49.49-65,32.21-21.28,74.56-26.39,110.92-13.35-3.9-33.18,11.44-67.94,38.59-87.43s65-22.88,95.19-8.57c7.12-44.39,38.15-82.77,77-105.44s84.72-31,129.67-31c60.56,0,125.19,17,164,63.53,27,32.45,38.24,75.12,44.76,116.84,43.56-23.18,98.48-23.6,142.41-1.09,11.65,5.99,22.45,13.49,32.14,22.3-31.17-46.74-83.65-74.78-139.83-74.72-8.69,0-17.36,.67-25.94,2-19.75-124.68-127.7-220-257.92-220-123.27,0-226.55,85.4-254,200.24-72.91,4.8-134.1,56.7-150.74,127.84-50.05-26.07-111.76-6.63-137.83,43.42-4.98,9.55-8.41,19.83-10.17,30.46l.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1263.58,1019.02l16.89-2.08c11.79,75.85,31.62,166.56,44.55,270.61,13.43,108,22.26,203.41,28.18,282.12l-25.72,3.17c-12.93-80.72-26.45-173.54-39.15-276.45-12.66-102.56-16.67-196.26-24.75-277.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1274.43,1014.68l-13.67,10.14c43.8,63,92,142.4,154.44,226.65,64.82,87.48,124.21,162.6,174.22,223.67l20.82-15.45c-46.33-67.35-100.58-143.88-162.33-227.12-61.64-83-123.38-153.6-173.48-217.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1392.91,1326.47c-162.58,64.83-346.93-14.41-411.77-176.99-64.83-162.58,14.41-346.93,176.99-411.77,162.58-64.83,346.93,14.41,411.77,176.99,47.13,118.18,19.01,253.09-71.41,342.61-30.18,29.92-66.09,53.45-105.58,69.16Zm-233.69-584c-159.31,63.75-237.06,245.22-173.3,404.53s245.22,237.06,404.53,173.31,237-245.23,173.3-404.54-245.23-237.05-404.54-173.3h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1375.48,1282.94c-138.56,55.3-295.71-12.2-351-150.75-55.3-138.56,12.2-295.71,150.75-351,138.56-55.3,295.71,12.2,351,150.75,40.19,100.71,16.27,215.68-60.75,292-25.73,25.52-56.34,45.59-90,59Zm-198.79-496.78c-135.22,54.11-201.2,208.14-147.09,343.36s208.14,201.21,343.35,147.1,201.21-208.14,147.1-343.36-208.14-201.21-343.36-147.1h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1224.14,
    y: 773.5,
    width: 2.04,
    height: 267.41,
    transform: "translate(-249.36 520.12) rotate(-21.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1323.74,
    y: 1022.68,
    width: 2.04,
    height: 267.41,
    transform: "translate(-334.7 574.67) rotate(-21.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1193.69,
    y: 790.62,
    width: 2.04,
    height: 267.41,
    transform: "translate(-315.63 900.11) rotate(-36.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1168.71,
    y: 815,
    width: 2.04,
    height: 267.41,
    transform: "translate(-299.12 1281.52) rotate(-51.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1150.89,
    y: 845.02,
    width: 2.04,
    height: 267.41,
    transform: "translate(-201.34 1652.16) rotate(-66.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1141.46,
    y: 878.62,
    width: 2.04,
    height: 267.41,
    transform: "translate(-22.28 1998.94) rotate(-81.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1008.37,
    y: 1046.2,
    width: 267.41,
    height: 2.04,
    transform: "translate(-116.12 142.81) rotate(-6.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1017,
    y: 1080.02,
    width: 267.41,
    height: 2.04,
    transform: "translate(-319.27 504.9) rotate(-21.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1034.07,
    y: 1110.49,
    width: 267.41,
    height: 2.04,
    transform: "translate(-433.16 921.29) rotate(-36.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1058.46,
    y: 1135.49,
    width: 267.41,
    height: 2.04,
    transform: "translate(-438.17 1370.84) rotate(-51.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1088.55,
    y: 1153.41,
    width: 267.41,
    height: 2.04,
    transform: "translate(-320.09 1823.61) rotate(-66.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1122.21,
    y: 1162.84,
    width: 267.41,
    height: 2.04,
    transform: "translate(-75.18 2240.93) rotate(-81.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1289.59,
    y: 1030.58,
    width: 2.04,
    height: 267.41,
    transform: "translate(-128.6 160.76) rotate(-6.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1353.91,
    y: 1004.71,
    width: 2.04,
    height: 267.41,
    transform: "translate(-411.96 1038.79) rotate(-36.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1387.59,
    y: 974.33,
    width: 2.05,
    height: 268.54,
    transform: "translate(-340.79 1516.54) rotate(-51.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1396.7,
    y: 950.32,
    width: 2.04,
    height: 267.41,
    transform: "translate(-149.11 1941.95) rotate(-66.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1406.13,
    y: 916.72,
    width: 2.04,
    height: 267.41,
    transform: "translate(166.98 2293.58) rotate(-81.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1273.89,
    y: 1014.48,
    width: 267.41,
    height: 2.04,
    transform: "translate(-110.48 174.07) rotate(-6.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1265.25,
    y: 980.67,
    width: 267.41,
    height: 2.04,
    transform: "translate(-264.59 590.02) rotate(-21.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1248.16,
    y: 950.09,
    width: 267.41,
    height: 2.04,
    transform: "translate(-294.35 1017.88) rotate(-36.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1223.8,
    y: 925.32,
    width: 267.41,
    height: 2.04,
    transform: "translate(-209.87 1420.56) rotate(-51.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1193.72,
    y: 907.39,
    width: 267.41,
    height: 2.04,
    transform: "translate(-30.31 1770.87) rotate(-66.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1160.23,
    y: 898.08,
    width: 267.41,
    height: 2.04,
    transform: "translate(219.68 2051.76) rotate(-81.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1258,
    y: 764.82,
    width: 2.04,
    height: 267.41,
    transform: "translate(-97.79 155.87) rotate(-6.82)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1115.61 815.03 1112.25 815.59 1103.58 764 1144.65 794.73 1142.62 797.45 1108.34 771.81 1115.61 815.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1088.73 837.66 1085.48 838.66 1070.14 788.64 1114.88 813.74 1113.21 816.71 1075.89 795.76 1088.73 837.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1061.94 865.02 1040.21 817.43 1087.84 836.48 1086.57 839.64 1046.83 823.74 1065.04 863.61 1061.94 865.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1042.04 894.23 1014.29 849.88 1064 862.55 1063.16 865.85 1021.68 855.28 1044.93 892.42 1042.04 894.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1026.13 925.79 992.82 885.44 1043.76 891.52 1043.36 894.9 1000.86 889.83 1028.76 923.62 1026.13 925.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1014.48 959.15 976.19 923.5 1027.48 922.87 1027.52 926.28 984.73 926.8 1016.8 956.66 1014.48 959.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1007.28 993.75 964.66 963.4 1015.44 956.09 1015.92 959.45 973.56 965.56 1009.25 990.98 1007.28 993.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1004.65 1028.99 958.44 1004.47 1007.82 990.59 1008.75 993.86 967.54 1005.45 1006.25 1025.99 1004.65 1028.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1006.65 1064.28 957.63 1045.99 1004.78 1025.79 1006.12 1028.91 966.78 1045.78 1007.84 1061.09 1006.65 1064.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1013.24 1099 962.25 1087.27 1006.36 1061.08 1008.1 1064.01 971.3 1085.86 1014 1095.68 1013.24 1099"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1024.3 1132.57 972.22 1127.59 1012.54 1095.87 1014.64 1098.54 981 1125.01 1024.62 1129.18 1024.3 1132.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1039.65 1164.4 987.37 1166.27 1023.2 1129.55 1025.63 1131.93 995.74 1162.56 1039.53 1161 1039.65 1164.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1059.03 1193.96 1007.43 1202.63 1038.16 1161.56 1040.89 1163.6 1015.25 1197.87 1058.46 1190.6 1059.03 1193.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1082.09 1220.73 1032.07 1236.07 1057.18 1191.33 1060.14 1193 1039.2 1230.33 1081.09 1217.48 1082.09 1220.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1060.86 1266 1079.91 1218.37 1083.07 1219.64 1067.18 1259.38 1107.04 1241.18 1108.45 1244.27 1060.86 1266"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1093.32 1291.93 1105.99 1242.21 1109.29 1243.05 1098.72 1284.53 1135.86 1261.28 1137.66 1264.17 1093.32 1291.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1128.88 1313.39 1134.95 1262.45 1138.33 1262.85 1133.26 1305.35 1167.05 1277.45 1169.22 1280.08 1128.88 1313.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1166.93 1330.02 1166.31 1278.73 1169.71 1278.69 1170.23 1321.48 1200.09 1289.41 1202.58 1291.73 1166.93 1330.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1206.84 1341.55 1199.52 1290.78 1202.89 1290.29 1208.99 1332.66 1234.41 1296.96 1237.19 1298.94 1206.84 1341.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1247.9 1347.77 1234.02 1298.39 1237.3 1297.46 1248.88 1338.67 1269.42 1299.96 1272.43 1301.56 1247.9 1347.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1289.43 1348.58 1269.22 1301.43 1272.35 1300.09 1289.21 1339.43 1304.52 1298.37 1307.71 1299.56 1289.43 1348.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1330.71 1343.96 1304.52 1299.85 1307.44 1298.11 1329.29 1334.92 1339.12 1292.21 1342.44 1292.97 1330.71 1343.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1371.03 1333.99 1339.3 1293.68 1341.98 1291.57 1368.45 1325.21 1372.61 1281.59 1376 1281.91 1371.03 1333.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1409.7 1318.85 1372.99 1283.02 1375.36 1280.58 1406 1310.47 1404.43 1266.68 1407.83 1266.56 1409.7 1318.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1446.07 1298.78 1404.99 1268.05 1407.03 1265.33 1441.3 1290.96 1434.04 1247.75 1437.39 1247.19 1446.07 1298.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1479.51 1274.14 1434.77 1249.04 1436.43 1246.07 1473.76 1267.01 1460.92 1225.12 1464.17 1224.12 1479.51 1274.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1509.44 1245.35 1461.81 1226.3 1463.07 1223.14 1502.81 1239.03 1484.61 1199.17 1487.71 1197.76 1509.44 1245.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1535.36 1212.89 1485.65 1200.22 1486.49 1196.92 1527.97 1207.5 1504.72 1170.35 1507.6 1168.55 1535.36 1212.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1556.82 1177.33 1505.88 1171.26 1506.29 1167.88 1548.79 1172.95 1520.89 1139.16 1523.51 1136.99 1556.82 1177.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1573.46 1139.28 1522.16 1139.9 1522.12 1136.5 1564.92 1135.98 1532.85 1106.12 1535.17 1103.63 1573.46 1139.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1584.99 1099.37 1534.21 1106.69 1533.73 1103.32 1576.09 1097.22 1540.4 1071.8 1542.37 1069.03 1584.99 1099.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1591.21 1058.31 1541.82 1072.19 1540.9 1068.91 1582.11 1057.33 1543.4 1036.79 1544.99 1033.78 1591.21 1058.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1544.86 1036.99 1543.52 1033.86 1582.86 1017 1541.8 1001.69 1543 998.5 1592.02 1016.78 1544.86 1036.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1543.28 1001.7 1541.55 998.77 1578.35 976.92 1535.65 967.09 1536.41 963.77 1587.39 975.5 1543.28 1001.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1537.11 966.91 1535.01 964.23 1568.64 937.76 1525.02 933.6 1525.34 930.21 1577.42 935.18 1537.11 966.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1526.45 933.22 1524.01 930.85 1553.91 900.21 1510.12 901.78 1510 898.38 1562.28 896.51 1526.45 933.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1511.48 901.22 1508.76 899.18 1534.4 864.91 1491.19 872.18 1490.62 868.82 1542.22 860.14 1511.48 901.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1492.47 871.44 1489.5 869.78 1510.45 832.45 1468.55 845.3 1467.56 842.04 1517.57 826.71 1492.47 871.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1469.73 844.4 1466.57 843.14 1482.47 803.4 1442.61 821.6 1441.19 818.5 1488.78 796.77 1469.73 844.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1443.66 820.56 1440.36 819.72 1450.93 778.24 1413.79 801.5 1411.98 798.61 1456.33 770.85 1443.66 820.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1414.7 800.33 1411.31 799.93 1416.38 757.43 1382.59 785.32 1380.42 782.7 1420.77 749.39 1414.7 800.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1383.34 784.05 1379.94 784.09 1379.41 741.29 1349.55 773.36 1347.06 771.04 1382.71 732.75 1383.34 784.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1350.13 772 1346.76 772.49 1340.65 730.12 1315.23 765.82 1312.46 763.84 1342.81 721.22 1350.13 772"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1315.62 764.39 1312.35 765.31 1300.77 724.11 1280.22 762.81 1277.22 761.22 1301.74 715 1315.62 764.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1277.3 762.69 1260.44 723.35 1245.12 764.41 1241.93 763.22 1260.22 714.2 1280.43 761.35 1277.3 762.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1242.2 764.67 1220.35 727.86 1210.53 770.57 1207.21 769.8 1218.94 718.82 1245.13 762.93 1242.2 764.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1207.67 771.2 1181.2 737.57 1177.03 781.19 1173.64 780.87 1178.62 728.79 1210.34 769.1 1207.67 771.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1145.21 796.09 1141.81 796.22 1139.94 743.93 1176.66 779.76 1174.28 782.2 1143.65 752.3 1145.21 796.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M990.34,1217.07c9.65-7.2,23.3-5.21,30.5,4.43,7.2,9.65,5.21,23.3-4.43,30.5-9.64,7.2-23.29,5.21-30.49-4.43-7.2-9.64-5.22-23.3,4.43-30.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1169.11,708.57h0c4.47,11.17-.96,23.85-12.13,28.32-11.17,4.47-23.85-.96-28.32-12.13h0c-4.47-11.17,.96-23.85,12.13-28.32,11.17-4.47,23.85,.96,28.32,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1089.16,746.91c7.22,9.63,5.26,23.29-4.37,30.5-9.63,7.22-23.29,5.26-30.5-4.37-7.22-9.63-5.26-23.29,4.37-30.5h.01c9.63-7.22,23.28-5.26,30.49,4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1021.91,804.66c9.46,7.44,11.1,21.13,3.67,30.6s-21.13,11.1-30.6,3.67-11.1-21.13-3.67-30.6h0c7.44-9.46,21.13-11.1,30.59-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M971.8,877.86c11.06,4.73,16.2,17.54,11.46,28.6-4.73,11.06-17.54,16.2-28.6,11.46-11.06-4.73-16.2-17.54-11.46-28.6h0c4.74-11.06,17.54-16.19,28.6-11.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M942.39,961.57c11.91,1.71,20.17,12.75,18.45,24.66-1.71,11.91-12.75,20.17-24.66,18.45-11.91-1.71-20.17-12.75-18.45-24.66h0c1.72-11.91,12.76-20.17,24.66-18.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M935.64,1049.95c11.94-1.45,22.8,7.05,24.25,19,1.45,11.94-7.05,22.8-19,24.25s-22.8-7.05-24.25-19v-.04c-1.43-11.93,7.07-22.76,19-24.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M951.98,1137.12c11.17-4.47,23.84,.96,28.31,12.13,4.47,11.17-.96,23.84-12.13,28.31-11.17,4.47-23.84-.96-28.31-12.13h0c-4.46-11.17,.97-23.84,12.13-28.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1048.1,1284.37c7.44-9.45,21.13-11.08,30.59-3.64s11.08,21.13,3.64,30.59c-7.44,9.45-21.13,11.08-30.58,3.65-9.45-7.44-11.09-21.13-3.65-30.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1121.3,1334.43c4.74-11.06,17.55-16.18,28.61-11.44,11.06,4.74,16.18,17.55,11.44,28.61-4.74,11.06-17.55,16.18-28.61,11.44h0c-11.06-4.74-16.18-17.54-11.45-28.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1204.98,1363.83c1.71-11.91,12.75-20.17,24.66-18.46s20.17,12.75,18.46,24.66c-1.71,11.9-12.75,20.17-24.66,18.46-11.91-1.71-20.17-12.75-18.46-24.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1293.4,1370.57c-1.45-11.94,7.05-22.8,19-24.25,11.94-1.45,22.8,7.05,24.25,19s-7.05,22.8-19,24.25h-.04c-11.93,1.43-22.76-7.07-24.21-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1380.56,1354.22c-4.47-11.17,.97-23.84,12.13-28.31s23.84,.97,28.31,12.13c4.47,11.16-.96,23.84-12.12,28.31-11.17,4.47-23.85-.96-28.32-12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1460.51,1315.85c-7.21-9.63-5.24-23.28,4.39-30.49,9.63-7.21,23.28-5.24,30.49,4.39,7.2,9.63,5.24,23.28-4.39,30.48-9.63,7.2-23.28,5.24-30.49-4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1527.81,1258.1c-9.45-7.44-11.08-21.13-3.64-30.59,7.44-9.45,21.13-11.08,30.59-3.64,9.45,7.44,11.08,21.13,3.65,30.58-7.44,9.45-21.13,11.09-30.59,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1577.91,1184.9c-11.06-4.74-16.18-17.54-11.44-28.6,4.74-11.06,17.54-16.18,28.6-11.44,11.06,4.74,16.18,17.54,11.44,28.6-4.73,11.05-17.53,16.18-28.58,11.45h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1607.28,1101.24c-11.91-1.71-20.17-12.75-18.46-24.66,1.71-11.91,12.75-20.17,24.66-18.46,11.9,1.71,20.17,12.75,18.46,24.66-1.71,11.91-12.75,20.17-24.66,18.46h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 1611.44,
    cy: 991.16,
    r: 21.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1597.67,925.66c-11.17,4.47-23.84-.96-28.31-12.13s.96-23.84,12.13-28.31c11.17-4.47,23.84,.96,28.31,12.12,4.47,11.17-.96,23.85-12.13,28.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1559.3,845.71c-9.63,7.2-23.28,5.23-30.49-4.4-7.2-9.63-5.23-23.28,4.4-30.49,9.63-7.2,23.27-5.24,30.47,4.39,7.21,9.63,5.24,23.29-4.39,30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1501.55,778.41c-7.44,9.45-21.13,11.08-30.59,3.64-9.45-7.44-11.08-21.13-3.64-30.59,7.44-9.45,21.13-11.08,30.58-3.65,9.45,7.44,11.09,21.13,3.65,30.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1428.35,728.35c-4.74,11.06-17.54,16.18-28.6,11.44-11.06-4.74-16.18-17.54-11.44-28.6,4.74-11.06,17.54-16.18,28.6-11.44,11.06,4.74,16.18,17.54,11.44,28.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1344.69,698.94c-1.71,11.91-12.75,20.17-24.66,18.46-11.91-1.71-20.17-12.75-18.46-24.66,1.71-11.9,12.75-20.17,24.66-18.46,11.91,1.71,20.17,12.75,18.46,24.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1256.27,692.19c1.45,11.94-7.05,22.8-19,24.25s-22.8-7.05-24.25-19,7.05-22.8,19-24.25h.04c11.93-1.43,22.76,7.07,24.21,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1169.11,708.57h0c4.47,11.17-.96,23.85-12.13,28.32-11.17,4.47-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1091.91,751.91h0c4.47,11.17-.97,23.85-12.14,28.31-11.17,4.47-23.85-.97-28.31-12.13h0l40.45-16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1254.91,686.66h0c4.47,11.17-.96,23.85-12.13,28.32-11.17,4.47-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1028.67,813.87h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1343.42,687.91h0c4.47,11.17-.97,23.85-12.14,28.31-11.17,4.47-23.85-.97-28.31-12.13h0l40.45-16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M983.55,889.85h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1429.13,711.57h0c4.47,11.17-.96,23.85-12.13,28.32-11.17,4.47-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M959.67,974.93h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1504.48,756.91h0c4.47,11.17-.96,23.85-12.13,28.32-11.17,4.47-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M958.42,1063.42h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1566.43,820.11h0c4.47,11.17-.96,23.85-12.13,28.32-11.17,4.47-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M980.3,1149.25h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1609.8,897.34h0c4.47,11.17-.96,23.85-12.13,28.32-11.17,4.47-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1023.41,1225.85h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1631.43,982.57h0c4.47,11.17-.96,23.85-12.13,28.32-11.17,4.47-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1085.62,1289.68h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1630.43,1071.66h0c4.47,11.17-.97,23.85-12.14,28.31-11.17,4.47-23.85-.96-28.31-12.13h0l40.45-16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1161.6,1334.8h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1606.55,1156.74h0c4.47,11.17-.97,23.85-12.14,28.31-11.17,4.47-23.85-.96-28.31-12.13h0l40.45-16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1246.68,1358.68h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1561.43,1232.72h0c4.47,11.17-.97,23.85-12.14,28.31-11.17,4.47-23.85-.96-28.31-12.13h0l40.45-16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1335.42,1360.57h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1498.49,1295.31h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1421,1338.05h0c4.47,11.17-.96,23.85-12.13,28.32s-23.85-.96-28.32-12.13h0l40.45-16.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 1274.86,
    cy: 1031.47,
    r: 51.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-71",
    cx: 1274.79,
    cy: 1031.46,
    r: 23.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M939.75,1689.89l104-83.25,58.71-50.45-120.05-139.72c-18.89-22.01-36.2-45.33-51.79-69.79-5.21-8.15-10.09-16.2-14.64-24.16-54.87-58.3-109.73-116.61-164.59-174.92-2.44-20.79-1.96-41.82,1.43-62.47,11.19-67.23,51.83-105.18,43.7-113.06-7.59-7.34-36.28,31.92-100.52,51.68-24.09,7.41-47.69,10.39-81.24,29-10.03,5.57-19.67,11.81-28.86,18.68l7.62,189.39,346.23,429.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M896.41,844.74c-3.09-3.61-8.66,3.27-8.66,3.27-4.47,7-21.7,19.69-21.7,19.69,0,0,.85-3.86-.61-6.77s-6.2,.09-6.2,.09c0,0-6.41,10.74-9.33,12.21s-14,14.09-16.47,17.26-3.91,14.88-6.51,19.16-7.88,7.82-7.88,7.82c-1.17-.72-2.69-.35-3.41,.82l-.03,.05c-4.36,5.83-22.38,21.33-43,42.21s-90.24,65-108.54,69.26c-17.3,4-45.47,19.23-52,24,.1,.11,.21,.21,.32,.34,7.5,7.88,25.29,27.83,28.94,31.89-4.24-4.24-27-24-33.18-29.4l-1.7,1-1.91,1.13h0c-.65,.37-1.33,.73-2,1.1l.08,.09c207,213.68,272.27,285.48,269.74,288.78-3.13,4.09-6.2,4-6.2,4-.87-.04-1.72-.3-2.47-.76l-262.51-291.11-.16-.18c-4.24,2.31-8.06,4.16-8.06,4.16-11.1-2-17.11-18.71-45.92-53.44s-40-28.3-58.67-18.47-14.83,32.56-7.58,48.28c7.25,15.72,25.72,45.72,30.28,52.23s9.74,27.15,9.74,27.15c.33,2.82-6.59,13-14.92,19.06s-4,1.39-16.56,11.09-35.49,38.88-39.78,43.61-7.12,5.06-7.12,5.06c-12.38,7.51-45,52.19-46.24,54.33s-4,8.68-11.58,12-24.54,20-31.83,27.34-27.6,16.44-28.3,18.07,.44,1.72-.16,2.24c-2.6,1.9-5.36,3.57-8.24,5-2.33,1-11.85,.81-11.85,.81-26.63,3-45.73,33-45.73,33,.43,4.78,3.86,3.35,5.83,2.11-6.48,5-21.63,19.86-22.81,21.87s2,3.51,2,3.51c-6.61,5.68-5.57,6.88-4,8.67s5.76-1.8,5.76-1.8l1,1.21c2.47,2.86,6.46-1.29,6.85-1.7-.11,.16-.31,.76,1,2.27,1.56,1.8,11.42-2.5,11.42-2.5,60.94-26.25,70.36-46.88,76.36-52s10.3-2.58,10.3-2.58c1.73,1.7,3.59,3.25,5.58,4.63,16.4,11.63,45,18.27,63,24.13,1.75,.54,3.6,.72,5.42,.51,14.39-1.5,33.89-23,49.44-40.21,6.84-7.6,12.92-14.38,17.46-18.27,10.87-9.32,35.4-19.15,54.11-22.46,9.2-1.63,17-1.69,21.09,.66,12.37,7.1,63.89,82.86,74.47,98.83s9.81,4.09,13.9,1.59,7.67,2.83,13.86,10.05,11.59,2.55,11.59,2.55c0,0,20.89,28,39.2,45.62,3.03,3.1,6.29,5.97,9.75,8.58,2.68-2.16,5.52-4.12,8.48-5.87,17.54-10.55,38.88-15.22,38.88-15.22,25.73-5.65,45.24-7.19,88.67-14.62,7.75-1.33,20.37-3.65,31.32-13.34,6.71-5.75,11.9-13.08,15.08-21.33,4.38-11.73,1.76-19,8.23-26.88,2.07-2.49,4.59-4.56,7.43-6.1,.03-.03,.07-.05,.11-.07-.53-.73-.97-1.52-1.3-2.35-2.23-7.46,.27-3.35-1.65-15.28s-139.1-149.75-159.64-167.59c-6.28-5.44-9.16-11.25-10.09-17-2.13-13,6-25.54,7.63-32,1.69-6.67,44.6-49.81,69.17-74.09,9.92-9.81,16.85-16.54,16.85-16.54,15.08-14-.14-50-.85-55.62s-13.58-20.68-12.65-25.67,7.89-7.81,7.89-7.81c38.36-17.32,56.44-63.12,56.44-63.12,3.33-7-1.74-6.86-1.74-6.86l4.81-4.13c2.58-4.29-1.82-5.74-1.82-5.74,3-2.59,3.19-4.82,3.19-4.82-1.3-7.4-9.11-.69-9.11-.69Zm-190.66,222.28c1.94-6.46,3.49-13.02,4.66-19.66,1-28,11.47-32.82,11.47-32.82-2.95,3.74-4.49,8.39-4.37,13.15-.34,15.92-3,31.7-7.9,46.85-1.85,5.65-4,11.2-6.44,16.62-1.59-1.42-3.16-2.85-4.73-4.29,2.84-6.46,5.28-13.09,7.31-19.85h0Zm55.2-74.74c-4.81,18.34-8.22,37.03-10.19,55.89-2.62,27.3-22.75,70.69-22.75,70.69l-2-3.5c4.09-9.84,7.67-19.89,10.71-30.1,6.92-23.26,7.79-36.36,12-55.21,2.86-12.61,6.6-25,11.19-37.08,1.08-2.89,2.24-5.84,3.5-8.88-.81,2.39-1.63,5.15-2.5,8.19h.04Zm229,426.56c.03-.07,.07-.14,.12-.2,.87-1.48,1.12-3.24,.69-4.9-.75-3.37-3.5-6.56-4.84-8.14-1.81-2.07-42.09-42.62-54.51-58.46-.12,.06-.24,.13-.35,.2-5.47,3.25-4.56,12.33-5.06,18.92-.42,5.64-6.6,17.88-14.08,27.73,24.63-8.46,36.84-5.63,43.47-.79,3.18,2.31,8.51,7.57,18.51,13.1l.14,.08c5.29,2.94,10.85,5.37,16.61,7.23,.46,1.74,.2,3.6-.72,5.15-2.42-.49-4.81-1.12-7.16-1.9-2.6-.85-5.14-1.88-7.6-3.09-9.68-4.76-11.4-8.94-18.13-12.61-9.54-5.16-19.28-3.89-31.26-2.35-9.61,1.26-18.94,4.1-27.62,8.41-14.68,9-48.1,20.19-87,22.22-29.88,1.57-55.39,10.44-68.67,16-3.55,1.49-6.23,2.72-7.88,3.53,1.47,.2,3.26,.59,10,6.35,13.7,11.56,157.21,204.44,187.11,244.71,3.49,4.68,5.43,7.32,5.43,7.32l176.58-151.78s-2.32-2.4-6.29-6.57h0c-23.9-25-107.62-112.61-110.71-116.22-1.22-1.41-2.76-2.92-4.15-4.49-.22-.26-.44-.51-.64-.77-2.37-2.8-3.93-5.79-2.03-8.68h.04Zm-34.44,252.6c.44,3-.79,4.21-.79,4.21-.5,.25-1,.53-1.45,.78-1.14,.61-2.56,.35-3.4-.64l-194.4-229.81c1.89-.64,3.78-1.28,5.66-1.94,72.36,83.32,193.78,223.47,194.35,227.4h.03Zm11.64-10.68c-.1,1.47-.22,2.94-.35,4.43l-.61,.53-4.44-.33c-63.24-74.41-126.48-148.81-189.72-223.2,2.64-.17,5.27-.34,7.91-.53,62.39,73.05,124.79,146.09,187.18,219.1h.03Zm14.14-9.06c-.14,.85-.6,1.61-1.28,2.14l-.64,.56-4.41-.32-185.93-214c2.66-.54,5.33-1.09,8-1.65,61.26,70.28,122.52,140.55,183.78,210.8,.44,.74,.6,1.62,.45,2.47h.03Zm10.79-16.58c.62,5.09-1.12,6.08-1.12,6.08-2.07,1.1-4.65,.31-5.74-1.77-.06-.11-.12-.23-.17-.35-58.14-67.28-116.29-134.56-174.46-201.84,2.46-.36,4.93-.73,7.38-1.11,76.7,83.69,173.04,190.2,174.08,198.99h.03Zm15.85-8.47c-2.77,1.86-6.16,1.53-6.84-1.06-56.25-64.85-112.48-129.7-168.7-194.55l10-2.52c56.16,63.58,112.3,127.16,168.43,190.73,1.32,2.06-.2,5.58-2.91,7.4h.02Zm19-13.17c-2.78,1.89-6.08,1.63-6.72-.86-53.68-61.91-107.38-123.82-161.09-185.73,3.29-.9,6.56-1.8,9.85-2.68,53.63,60.67,107.28,121.33,160.94,182,1.23,1.99-.34,5.45-3,7.27h.02Zm9.86-19.89c-52.33-57.65-104.66-115.32-157-173,2.68-.94,5.38-1.86,8.07-2.77,52.5,57.89,105.01,115.76,157.52,173.61-.81,10.05-8.64,2.14-8.64,2.14l.05,.02Zm10.82-9.29l-154.41-170,8.14-3.88,154.85,171.73c-.8,10.04-8.63,2.15-8.63,2.15h.05Zm17.75-12.12c-49.92-54.89-99.85-109.75-149.78-164.59l7-2.85c50.45,55.09,100.92,110.18,151.42,165.28-.85,10.05-8.69,2.16-8.69,2.16h.05Zm26.86-10l-4.2,3.6-1.66,1.42c-1.11-.54-1.99-1.48-2.45-2.63-49.45-53.87-98.89-107.75-148.32-161.66,2.66-.53,5.32-1.1,8-1.64,49.56,53.62,99.1,107.24,148.63,160.86v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M608.25,1056.47l3.28-2.39c-.18,.13-.33,.26-.47,.38-.9,.72-1.84,1.39-2.81,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M611.74,1053.92l.23-.18h0c-.08,.06-.16,.12-.23,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M641.76,1086.57c.25,.31,.16,.2-.21-.2,.07,.06,.14,.13,.21,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M602.46,1059.88c-.52,.28-1,.55-1.52,.83,0,0-2.92-4.45-.77-3.17,.11,.08,.91,.86,2.29,2.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 880.69,
    y: 1613.71,
    width: 316.67,
    height: 36.81,
    transform: "translate(-812.7 1071.33) rotate(-40.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 915.85,
    y: 1628.8,
    width: 366.56,
    height: 155.16,
    transform: "translate(-846.58 1128.44) rotate(-40.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1092.44,1562.44c-.22,3-1.07,4.39-2.15,4.87-1.28,.58-2.76,.53-4-.13l5.85-5c.11,.06,.22,.16,.3,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M766.91,975.84c-1.24,2.78-2.4,5.51-3.49,8.19,.83-2.86,2.01-5.61,3.49-8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M429.6,1348.44c1.69,4.88,.32,9.19-3.55,12.1-1.82,.21-3.67,.03-5.42-.51-18-5.86-46.58-12.5-63-24.13,20.57-1.8,69.28,4.81,71.97,12.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M732.38,1130.28s4.46-6.38,12.51-25.87-5.06-23.09,14.35-42.46,10.67-9.28,10.67-9.28c0,0-13.37,19.12-17.52,40.23s-15.06,43.07-16.67,47-3.34-9.62-3.34-9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M848.23,984.57c-2.17,11.88,9.22,2-7.93,36.88-2.48,5.06-4.85,9.79-7.06,14.23-24.57,24.28-67.48,67.42-69.17,74.09-1.68,6.51-9.76,19-7.63,32-2,1.31-3.79,2.47-5.32,3.42-3.29,2.11-5.31,3.32-5.31,3.32,0,0,1.62-6.21,4.39-15,5-15.79,13.6-39.91,23-51.29,14.61-17.7,29-12.68,48.78-47.4s28.42-62.09,26.25-50.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M361.6,1307.57s131.33-4.18,177.39-31.71,13.86-7,13.86-7c0,0,3.6-13.12-19.86-2.73s-57.75,22.7-78,25.3-93.39,16.14-93.39,16.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M387.97,1274.65s49.33,2.12,75.08-2.77,62.89-19.66,71.24-24.43-1.42,1.24-50.26,11.19-96.06,16.01-96.06,16.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M428.4,1232.02c-2.46-1,81.45,1.69,115.56-8s59.92-34.58,71.68-49.81-23.34,27.79-56,36.2-123.44,24.83-131.24,21.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M648.63,1390.51c-1.24-1.42-10.21-26.12-2.22-25.56s7.42,8.54,20,20.12-.3-14.73,5.39-19.68,15.85-16.27,24.51-6.31,12.75,8.92,3.53,6.94-27.29-11.27-25.56,2.22,10.57,20.8,3.45,27-13.49,1.73-20.73-9.47-7.09,6.17-8.37,4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M619.57,1270.81s205.26,124,246.79,122.91,5.44,17.76-18.14,10.77-95.74-26.76-228.65-133.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M607.91,1245.92s142.08,71.46,193.39,64.35-18.89,21.41-29.34,18-118.72-41.7-164.05-82.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M853.91,1362.09c4.08-1,38.37-13.36,42.83-19.73s10.83-1.92,14.92-3,3.59-13.12,7.68-14.17,14.73-.31,12.75,8.91,6,9.78-6.07,10.28-17.39,.12-25.75,4.88-33.06,13.73-35.72,13.55l-10.64-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M625.7,1088.04s141.13,142.26,177,183.55,65.4,78.13,66.82,76.89-6.93,3.52-8.17,2.1-217.1-241.18-222-246.88l-13.65-15.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M664.75,1084.09s240.5,250.84,245.63,253.88,4.84-1.89,4.65-4.14-213-209.69-247.43-252.22-2.85,2.48-2.85,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M721.62,1112.14c.18-.66,.34-1.45,.5-2.36,1.42-8.26,2.47-26.72,12.45-48.89,11.09-24.63,6.88-41,11.16-44.68s23.78-53.16,23.78-53.16c0,0-14.68,37.75-17,52.3s5.82,12.44-2.79,39.92-6,27.66-13.63,41.83-14.47,15.04-14.47,15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M692.97,1082.05c1.43-1.24,3.6-13.12,8.24-22.15s5-14.36,5.58-22.35c.22-5.14-.81-10.26-3-14.91,0,0,3.72,4.27,4.77,8.35s5.32,.38,3.15,12.26-4.15,21.1-7.19,26.24-7.86,16.83-6.63,18.26l-4.92-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M829.25,931.13c2.28,5.51,4.69,28.41,5.37,37.82s.61,29.46,7.17,31.25,12.81-11.13,12.81-11.13c0,0-2.59-20.24-9.83-31.45s-15.52-26.49-15.52-26.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M490.91,1160.18l26.24,7.18c13.12,3.59,13.79,13,39.91,2.8s34.67-17.64,29.16-15.35-24.7,9-36.77,9.46-6.93,3.53-24-1.67-34.54-2.42-34.54-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M671.66,1381.4c-.08-.24-.18-.47-.31-.69-5.85-10.91-87.23-102-91.51-115.36-4.39-13.68,10.39,23.46,26.48,42s46.09,67.41,56.17,76.14,11.32,10.15,12.94,6.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1305.64,1620.04c.78-3.71,99.31-93.53,105.8-111.37l-112.86-122.38s-17-13.55-19.26-11.55-33.59,13.44-33.59,13.44l-2,6.85-30.07,.24-22.2,11.48s-10.66,7.37-12.86,8.31-23.43,5.49-23.43,5.49l-78.39,60-12.63,38.38,241.49,101.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1364.4,1555.16l-13.49,11.93-34.25-38.87s-8.56-10.62,1.37-13.92,14.43,4.55,14.43,4.55l31.94,36.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1377.84,1538.28l-9.59,8.44-30.91-35.07s-7.81-9.51-.25-11.25,11.88,5.11,11.88,5.11l28.87,32.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1274.91,1486.62c.56-.5,14.07-10.38,14.07-10.38l-32.54-36.94c-.5-.57-6.58-6.32-11.63-2.88s-5.45,9.85-5.45,9.85l35.55,40.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1306.41,1463.93c-3.35,1.93-11.17,6.8-11.1,5.74s-31.11-34.17-31-35.24-1.43-2.54,.84-4.66,7.11-2.35,9.19-1.14,32.07,35.3,32.07,35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1325.98,1455.82c-2.87,1.58-9.58,5.57-9.58,4.61s-29.42-32.43-29.42-33.39-1.4-2.37,.51-4.17,6.21-1.75,8.12-.56,30.37,33.51,30.37,33.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1342.91,1447.04c-2.75,1.51-9.16,5.33-9.15,4.41s-28.13-31-28.13-31.92-1.34-2.26,.49-4,5.94-1.68,7.76-.54,29.03,32.05,29.03,32.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M984.42,1489.17l15.3,17.37-16.49,9.92-12.65-12.07-11.53,4.11,2.23,7.11-16.68,17.73,13.93,34.15,125.69-49.32c4.18-1.49,19.69-9.1,19.69-9.1l-23.53-26.71,11.93-10.51,23.24,22.93,22.46-15.75-21.82-28.21,19.55-12.18,9,10.23,25.06-5.93-11.31-16.27,11.8-8.38,20.53,23.3,20.35-7.84-21-23.86,13.81-6.11,20,22.74,12.94-9.38-14.52-16.48,9.76-1.53,19.79,17.89,10.1-6.88-11.25-17.35,6.55-1.73,6.51,7.39,6-1.23,7.09-10.28,9,2.17h9.12l8.42,2.68-21-23.87s-133.97-29.35-298.07,121.25Zm112.59-40.6c.5,.57-10.16,8-10.16,8l-12.52-14.21,10.66-7.38,12.02,13.59Zm69.9-36.4l-12.52-14.2,6.62-2.81,12.52,14.21c-.05,1.07-6.62,2.8-6.62,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1338.35,1578.1l-17,15-38.05-43.19s-9.44-11.86,2.65-16.46,16.9,4.28,16.9,4.28l35.5,40.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1309.84,1605.91c-.61-.13-40.89-46.41-40.89-46.41,0,0-10.26-3.07-11.33-3.14s-7.69,2.73-7.69,2.73c0,0-6.38,7.65-2.51,14.33,0,0,43,50,43.56,49.45l18.86-16.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M746.04,1541.71l15.6-.63,12.15,11.51s17.66,17.75,17.59,18.82,2.3,6.05,2.3,6.05c0,0,11.33-.9,12.33,.24s44.88,19,44.88,19c0,0-7.35,15.53-9.36,13.26s-79-31.3-79.48-32.94-16.01-35.31-16.01-35.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1169.44,1736.99s137.27-116.88,136.2-117-31-19.13-33.12-19.27-22.71-14.31-22.71-14.31c0,0-41.73-35.92-43.3-36.55s-13.68-2-13.68-2l-46.09,5.19s-81.45-44.32-82.32-47.6-2.6-9.82-4.53-13.16,0-8-6.51-7.39-6.78-3.11-10.28-7.09-105.25,128-105.25,128c0,0,54.88,65.72,53.37,64s178.22,67.18,178.22,67.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1032.35,1630.65c.07-1.07-24.53-27.84-24.53-27.84,0,0-7.25-8.42-12.93-5.6s-16,20.94-16,20.94c0,0,9.33,22.06,10.4,22.13s15.73,14.41,15.79,13.34,27.27-22.97,27.27-22.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1001.67,1598.13s-25.63,6.42-15.29,29.62l21,23.86s-12.3,7.81-12.23,6.74-23.2-27-23.2-27c0,0-9.49-41.07,29.72-33.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1055.91,1614.94s35.22-34.21,36.8-32.42l-30.94-35.39-23.73,2.85s-12.35,21.5-12.39,22.6,.64,12.18,.64,12.18l28.44,32.28,1.18-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1245.56,1509.45c.57-.5-37.55-42.62-37.55-42.62,0,0-3.23-8.26,4-11.56s16,2.08,18,4.36l33.54,38.07-17.99,11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1169.44,1736.99c2.15-2.13-63.13-62.48-60.35-63.92s-12-13.64-13-15.84-7.65-6.39-8.51-9.66-42.13-46.67-44-43c-5.39,10.67-14.09,17.36-42,44-6.76,6.48-13.95,12.5-21.53,18l-80-76.91s-189.35,202.13-166.39,327.25l97.25,110.21s302.45-254.31,338.53-290.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M729.14,1901.79c-25.6-30.67-52.7-61.61-81.29-92.84-9.08-9.89-18.15-19.62-27.22-29.18-13.6-14.34-48-117.56,24.67-232.09l27.2-5.8,60.67,8.14,10.23-9,33.75,34.87,65.09,31.49,34.91-42.87,16.59,17.68c-87.36,86.4-145,198.32-164.6,319.62v-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "736.83 1771.88 744.12 1758.38 715.08 1725.42 710.1 1727.79 702.88 1740.21 736.83 1771.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M852.33,2007.25l10.8-9.51-34.54-39.17s-8.51-9.66-11.69-1.81c-1.88,4.59-1.41,9.81,1.25,14l34.18,36.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M837.12,2018.63l6.82-6-31.54-35.8s-2.46-4.23-6.61-1.92-.41,11.13-.41,11.13l31.74,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1214.57,1532.71c-1.06-.07-41.05-46.6-41.05-46.6,0,0-1.92-9.06,4.61-12l15.88,2,38.65,43.87-18.09,12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1161.37,1474.57l-15-17s-1.67-7.62,4.88-9.35,10.63,1.74,15.63,7.43,10.15,9.22,8.76,9.94-14.27,8.98-14.27,8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1196.46,1547.66l-19.33,17-37.55-42.62s-9.65-8.66-4.83-16.94,15.44-6.54,15.44-6.54l10.55,2.82,35.72,46.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M896.46,1969.39l16.62-14.64-40.55-46s-9-9.12-17.56-1.63,3.74,24.91,3.74,24.91l37.75,37.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M873.44,1988.41c.49-.19,8.58-9.33,8.58-9.33l-39-44.33s-8.92-3.25-10.46,4.17,40.88,49.49,40.88,49.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M841.62,1828.95c2.84-2.51,12.91-17.43,12.91-17.43l-39.55-44.9s-3.07-2.34-8.62,.53-5.73,14.13-5.79,15.2,26.83,33.89,26.83,33.89l14.22,12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M810.98,1872.09c2.85-2.51,12.91-17.43,12.91-17.43l-39.55-44.9s-3.07-2.34-8.62,.53-5.72,14.13-5.79,15.19,26.83,33.9,26.83,33.9l14.22,12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M793.99,1903.21c1.04-2.41,2.24-4.75,3.58-7,1.5-2.54,3.17-4.97,5-7.27l-37-42c-.64-.39-1.35-.65-2.09-.76-3.06-.47-5.62,1.84-6.34,2.65-2.68,3-1.68,9.86,3.26,16.3,11.21,12.69,22.4,25.39,33.59,38.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M779.74,1924.85c.92-2.13,1.98-4.19,3.16-6.18,1.33-2.24,2.82-4.39,4.45-6.43l-32.67-37.09c-.56-.34-1.19-.57-1.84-.67-2.71-.41-5,1.63-5.61,2.34-2.37,2.66-1.48,8.71,2.88,14.4l29.63,33.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1227.12,1682.15l-45.07-51.15s-14.51-21.7,8.43-29.71l14-3.21,52.85,57.41-30.21,26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1205.52,1701.17s-35.58,36.39-38.08,33.55-51.87-62.31-51.87-62.31c0,0,5-36.71,45.39-21.81l44.56,50.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M939.27,1936.73l16.1-14.19-45.56-51.72s-11.92-7.41-18.76-5.05,4.35,20.78,4.35,20.78l43.87,50.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M983.44,1900.84l24-21.15-46.07-52.29s-14.81-14.24-27-6.48-6.48,18.85-6.48,18.85l55.55,61.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1072.05,1825.82c-.44-1.64-53.07-60.24-53.07-60.24,0,0-11.09-11.44-21.62-6.2s-21.3,22.8-9.48,39.65,46.86,56.62,46.86,56.62l37.31-29.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "956.39 1694.54 914.83 1647.37 901.01 1645.42 881.34 1667.79 892.55 1694.25 924.45 1727.03 956.39 1694.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M898.81,1756.36l-38.05-43.19s-9.36-6.38-12.84-5.58-13.31,28.61-13.31,28.61l42,47.7,22.2-27.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M753.12,1743.39c.07-1.07-34.54-39.21-34.54-39.21,0,0-7.27-20.85,4.53-29.23,4.68-3.82,11.4-3.84,16.1-.05,0,0,24.48,50.54,24,50.7s-10.09,17.79-10.09,17.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M727.54,1913.57l11.49,6s-50.54-66.53,164-326.76l-14.54-16.46s-191.08,227.43-160.95,337.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M688.45,1857.89s-59.16-91.21,77.28-288.11l-10.52-11.93s-134.55,184.14-71,299.77l4.58,4-.34-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1064.91,1625.2s20.6,22.23,19,21.6-233,204.2-294.6,330.17l-7-8s9.08-75.59,282.6-343.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M625.14,1781.44s-41.26-85.78,25.21-237.2l-12-4.52s-65,135.95-16.94,242l3.73-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M645.45,1542.4c15.65,1.55,30.08,9.18,40.17,21.24l25.88,6.47c5.06,6.91,9.5,8.72,12.86,8.86,0,0,6.76,.29,27.85-24.53h0l-12-13.64-9,6.94s-12.7-3-17.34-5.92-30.36-3.54-30.36-3.54c-12.82-1.55-25.81-.14-38,4.12h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M925.49,1572.38c5.18-5.58,111.4-98.13,111.4-98.13l20.52,23.3-114.44,103.84-22-25,4.52-4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1083.91,1646.8s111.43-90.09,113.63-91-19.82-25.94-19.82-25.94l-113.7,92.09,19.89,24.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M781.91,1687.79l-35.62-39.28c-5.88-15.57-1.47-30.72,8.19-36.19,6.07-3.44,12.89-2.29,16.2-1.44,0,0-21,18.52-6.65,37.14l25.54,29c-2.59,3.58-5.14,7.17-7.66,10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M788.59,1678.32c.94-1.31,19.8-28,19.8-28l-32.54-36.94s-2.8-4.35-6.46-2.76-20.92,19.81-7,37.86c8.04,10.53,16.8,20.5,26.2,29.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M760.99,1729.4l-31.08-34.17c-1.41-3.42-1.55-7.23-.4-10.75,2.36-6.92,8.91-9.3,9.73-9.58l32.55,36.94-10.8,17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1038.72,1852.15l-48.57-55.13s-13.18-20.69,7.21-37.64c0,0-29.47,7.79-22.38,39.9l54.07,61.38,9.67-8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M926,1725.35l-34-38.65s-11.87-32.94,17.61-40.74c0,0-23.12-7.9-32.25,9.23,0,0-13.25,22.77,1.84,38.75l37,42.06,9.8-10.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M879.15,1778.73c-.21-1.5-36-40.92-36-40.92,0,0-9.11-17.21,8.88-30,0,0-14.27-3.59-25.17,16.11-3.53,9.49-1.53,20.15,5.22,27.7l37.05,42.06s10.38-12.24,10.02-14.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1101.49,1445.57c.5,.57-4.48,2.93-4.48,2.93l-12-13.64-10.66,7.38-3-3.41c.5,.57,14.57-9.81,15.14-10.31s14.5,16.51,15,17.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M984.15,1900.21l-49.06-55.64s-9.11-17.21,5.4-25.95c0,0-19.58,4.12-20.37,25,0,0,0,9.12,5,13.74l47.07,53.42,11.96-10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M885.23,1894.49l44.56,50.58,12.51-11-41.56-47.17s-9.31-14,1.72-18.68c0,0-13.36-9.43-19.72,6.27,0-.01-3.24,8.91,2.49,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M733.51,1781.86c-.29-.34-.59-.67-.89-1l-29.15-33.09s-10.33-23.19,6.91-24.25l4.7,1.91c-1.77,.46-3.34,1.5-4.47,2.94-2,2.73-2.09,6.74-.11,10.19l27.53,31.25c-1.5,4.01-3.01,8.03-4.52,12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M630.78,1743.16l13.52,15.35,1.81-11.69s-13.92-17.52-14-15.92-1.33,12.26-1.33,12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M637.36,1664.7c1.57,.63,16.52,18.75,16.52,18.75l5.86-16.27s-17.09-18.25-16.52-18.75-5.86,16.27-5.86,16.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "689.92 1656.75 681.41 1647.09 685.49 1633.4 695.01 1644.19 689.92 1656.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1249.09,1648.66l-36.55-41.49s-14.52-16.48-31.7,.68c0,0,16-24.21,39.66-7.69l43.56,49.45-8,7-6.97-7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1208.91,1698.17l-44.54-50.6s-30.83-13.22-43.71,12.26c0,0,15.82-21,42.3-7l42.56,48.3,3.39-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1196.46,1547.66c-.44-1.63-38.06-43.19-38.06-43.19,0,0-18.49-13-25.13,7,0,0-1.35-21,13.55-19,6.44,.03,12.63,2.53,17.27,7,0,0,39.69,42.76,38.55,43.76s-6.18,4.43-6.18,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1237.61,1516.46l-35.55-40.35s-17.43-12.91-27.5,2c0,0,13.24-5.61,21.82,3l35,39.78,6.23-4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1208.35,1461.48s3.82-9.42,15.67-1.69l36.05,40.92,5.68-5-37-42.05s-19.18-11.42-20.4,7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M843.33,1827.45c-2.07-1.21-36.55-41.49-36.55-41.49,0,0-6.4-17.58,5.56-20,0,0-18-4.36-19.89,17.52,0,0-2.75,9.49,12.34,25.47l28.54,32.39,10-13.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M806.8,1878.8c.64-1.57-36.55-41.49-36.55-41.49,0,0-7.86-28.4,11.45-28.25,0,0-9,5.87-2.72,17.53l36,40.92s-8.81,12.86-8.18,11.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M791.65,1906.28c.06-1.07-34.55-39.21-34.55-39.21,0,0-7.27-20.85,6.13-20.54,0,0-4.68,6.14,2.69,16.8,0,0,30.48,35.74,31,35.24s-5.27,7.71-5.27,7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M775.76,1928.35c.06-.94-30.23-34.31-30.23-34.31,0,0-6.36-18.25,5.36-18,0,0-4.09,5.37,2.36,14.7,0,0,26.66,31.27,27.16,30.83s-4.65,6.78-4.65,6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M890.91,1974.27l-40-45.46s-7-17.08,7.4-23.68c0,0-5.52,10.92,3.06,19.51l37.55,42.62-8.01,7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M868.38,1991.09l-36-40.92s-6.74-12.23,5.29-15.76c0,0-4,3.51-.61,9.62l38.55,43.76c-.54-.57-7.23,3.3-7.23,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M772.65,1935.13l-29.54-33.56s-5.69,5-1.82,11.69,28,31.83,28,31.83l3.36-9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M770.74,1939.84l-27.11-29.62s-3.93-5.62-1.09-8.12c-.99,.84-1.79,1.89-2.34,3.07-.81,1.79-1.03,3.8-.62,5.73l.64,2.32,7,8c7.18,8.14,14.36,16.29,21.53,24.44l1.99-5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M715.15,1851.57c.93-2.12,1.98-4.19,3.16-6.18,1.33-2.24,2.83-4.39,4.46-6.42l-32.68-37.09c-.56-.34-1.19-.57-1.84-.67-2.71-.41-5,1.63-5.6,2.34-2.37,2.66-1.49,8.71,2.88,14.4l29.62,33.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M711.17,1855.04c.06-.94-30.23-34.31-30.23-34.31,0,0-6.36-18.25,5.37-18,0,0-4.1,5.38,2.35,14.71,0,0,26.67,31.27,27.16,30.83s-4.65,6.77-4.65,6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M717.07,1872.05l-29.54-33.48s-5.68,5-1.81,11.69,28,31.82,28,31.82l3.35-10.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M715.16,1876.76c-9.03-9.88-18.07-19.75-27.1-29.62-13.55-14.8-3.94-5.62-1.1-8.12-.99,.84-1.79,1.89-2.34,3.07-.81,1.79-1.03,3.8-.62,5.73,.22,.77,.43,1.55,.65,2.32l7,8,21.53,24.43c.67-2,1.32-3.89,1.98-5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1093.85,1803.57l-55.08-62.51s-13-41.07,32.92-45.14c0,0-33.52,12.37-24,39.27l54.07,61.37-7.91,7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1046.09,1735.63l54.58,61.94,40.35-35.54-55.57-63.08s-16.57-9.64-31.41,4.45-7.95,32.23-7.95,32.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1174.24,1466.3c.07-1.07-12.52-14.21-12.52-14.21,0,0-12.92-7.79-14.74,3.9,0,0-5.39-16.44,12.71-14.22,3.61,.41,6.94,2.15,9.35,4.88l13.52,15.35-8.32,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M848.36,2010.75c-1.57-.63-33.55-38.07-33.55-38.07,0,0-5.4-16.44,6.06-19.47,0,0-6,10.35-1,16l33.54,38.08-5.05,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M804.67,1988.67l29,33,3.41-3-30.54-34.67s-4.3-8.32,1.18-10.12c.04-.04-8.15,2.13-3.05,14.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M730.23,1799.9l-29-33s-7.73-5.73-11.2-1.45,1.63,16.94,1.63,16.94l32.54,36.94,6.03-19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M722.55,1827.85l-34.54-39.21s-9.48-19.92,4.76-24.38c0,0-5,11.49,4.06,20.65l28.54,32.39-2.82,10.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1338.35,1578.1c-.5-.56-32.14-34.76-32-36.37s-23.64-16.52-26.79-.62c0,0,2.49-22.38,29.77-4,0,0,33.11,36.44,33,37.51s-3.98,3.48-3.98,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1246.91,1564.81s1.58-16.54,19.55-12.18c0,0,7.85,3.18,11.36,7.15l36.55,41.49s-5.79,6.61-5.69,5-38.15-41.59-38-43.19-13.86-11.06-23.77,1.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "1163.51 1389.96 1176.96 1406.37 1173.55 1409.37 1161.03 1395.17 1154.41 1397.97 1151.41 1394.56 1163.51 1389.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1215.91,1376.1l16.52,18.75s9.32-3.16,8.82-3.73l-16-18.19-9.34,3.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "1257.64 1369.62 1264.65 1377.57 1270.7 1375.27 1263.69 1367.31 1257.64 1369.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1097.44,1577.35l-32-36.37s-40.82-16.53-44.23,28.86c0,0,1.53,9.76,4.47,14.24-.76-7.02,.82-14.09,4.49-20.11,1.85-3,8-11.71,19.26-13.75,4.23-.75,8.58-.49,12.69,.75l28.54,32.39,6.78-6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M875.34,1566.71s24.23,33.54,32.38,40.5,73.38,61.52,75.52,61.66,31.49-22.7,28.42-25-57.91-34.78-64.55-40-8.38-11.8-14-15.92-19-13.54-20.5-15.25-37.27-5.99-37.27-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1364.06,1553.44l-33.54-38.08s-18.07-11.34-18,4.76c0,0,3.31-10,15.67-1.69l33,37.51,2.87-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1293.83,1476.01l-33.54-38.08s-20.14-12.54-20.79,6.2c0,0,4.52-12,17.38-3.19l32.54,36.94,4.41-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1379.04,1537.21l-31-35.23s-11.78-8.8-15.1,1.19c0,0,6.75-4.94,12.83,.81l31,35.23,2.27-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1308.61,1462.99l-28-31.82s-11.58-12-16.1,.05c0,0,6.62-2.8,11.69,1.82l28,31.82,4.41-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1173.55,1409.37l-12.52-14.21s12.59,13.14,12.52,14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1327.91,1455.09l-26.58-30.16s-10.92-11.43-14.32-.78c3.64-1.21,7.66-.35,10.49,2.24l26.58,30.16,3.83-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1344.7,1446.34l-25.4-28.83s-10.44-10.92-13.69-.74c3.48-1.15,7.3-.33,10,2.14l25.4,28.83,3.69-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1389.34,1527.13l-7.39,6.51c-18.36-20.63-30.77-34.28-32.9-35.88-.08-.06-2.5-1-2.49-3.09,0-.66-.64-1.52-.46-2.56,.19-.61,.53-1.17,1-1.61,1.33-1.3,4.48-1.51,8.12-.56l34.12,37.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1402.05,1512.91l-7.46,7.58-29.55-33.22c-1.02-.79-1.84-1.82-2.37-3-.42-.74-.58-1.61-.44-2.45,.17-.58,.49-1.11,.93-1.53,1.27-1.25,4.27-1.45,7.75-.54l31.14,33.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1390.48,1526.13l-29.57-33.56s-10.92-11.43-14.32-.78c3.64-1.21,7.66-.36,10.49,2.24l30.57,34.61,2.83-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1403.19,1511.91l-26.81-29.61s-10.44-10.92-13.69-.74c3.47-1.15,7.3-.33,10,2.13l28.13,31.29,2.37-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2509.8,574.77l-19,127.72s-19.35-12.61-50.86-22.68c-9.52-3.04-19.2-5.54-29-7.48-20.24-4.06-40.91-5.52-61.51-4.35-7.1,.42-14.38,1.18-21.77,2.33h0c-10.09,1.58-20.06,3.83-29.85,6.75l19.52-131c22.3-9.05,46.11-13.8,70.18-14,11.74-.07,23.46,.96,35,3.1h0c43.74,8.12,74.68,29.86,87.29,39.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2307.91,576.48s118.12-46.13,208.94,32.57c.3-2.93,.6-5.86,.91-8.77-32.2-24.69-70.7-39.81-111.09-43.62-34.03-3.24-68.33,1.79-100,14.66l-.93,6.27,2.17-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2306.81,581.97s118.1-46.13,208.94,32.6c.3-2.92,.6-5.84,.91-8.76-32.2-24.69-70.7-39.81-111.09-43.62-34.03-3.24-68.33,1.79-100,14.66l-.93,6.27,2.17-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2312.27,546.88s118.13-46.13,208.94,32.56c.3-2.92,.61-5.85,.91-8.77-32.2-24.68-70.7-39.8-111.09-43.61-34.03-3.24-68.33,1.78-100,14.65l-.93,6.27,2.17-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2311.22,552.37s118.13-46.14,208.94,32.56c.3-2.92,.61-5.85,.91-8.77-32.2-24.68-70.7-39.78-111.09-43.59-34.03-3.24-68.33,1.78-100,14.65l-.93,6.27,2.17-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2440.38,619.09l-7.55,50.64c-1.91-.59-3.86-1.17-5.87-1.75-6.82-1.95-14.16-3.76-22-5.28l7.13-47.82c.42-.43,.84-.84,1.25-1.23,19.28-18.2,27.04,5.44,27.04,5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2353.39,609.12l-7.66,51.37c-2,.12-4,.27-6,.45-4.33,.39-8.72,.92-13.18,1.61h0c-3.36,.18-6.28,.59-7.83,1.38l8.74-58.68c.59-.82,1.23-1.61,1.91-2.35,4.21-4.6,14.67-12.77,24.02,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2476.45,625.48l-7.65,51.38c-2,.11-4,.25-6,.44-4.33,.39-8.72,.93-13.18,1.61h0c-3.35,.18-6.28,.59-7.83,1.38l8.75-58.67c.58-.83,1.21-1.62,1.9-2.36,4.2-4.6,14.66-12.77,24.01,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2441.03,614.72l-8.2,55c-2.07-.64-4.2-1.28-6.38-1.9-7.41-2.12-15.38-4.08-23.84-5.74l7.74-51.94c.46-.47,.92-.91,1.36-1.33,20.89-19.76,29.32,5.91,29.32,5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2398.46,608.84l-8.55,57.27c-2.15-.67-4.37-1.33-6.64-2-7.71-2.21-16-4.25-24.82-6l8.06-54.07c.48-.48,.95-1,1.41-1.39,21.76-20.54,30.54,6.19,30.54,6.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "2136.38 1483.95 2405.01 1503.79 2431.28 1335.5 2171.79 1296.83 2136.38 1483.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2264.68,673.17v.15l-2.91,.56,2.91-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2520.63,708.42l-14.7,98.66c-2.29-.89-4.58-1.75-6.87-2.6-7.41-2.74-14.85-5.28-22.27-7.62l-4.24-1.33c-8.54-2.62-17.05-5-25.52-7.15-2.67-.67-5.36-1.33-8.07-2-11.07-2.66-22-4.93-32.69-6.89-3.08-.56-6.14-1.1-9.18-1.61-12.8-2.15-25.2-3.85-37-5.18-1.84-.21-3.66-.4-5.47-.59-11.82-1.24-23-2.12-33.31-2.72l-5.92-.33c-9.71-.49-18.59-.74-26.45-.84l-7.17-.06c-10.08,0-18.07,.2-23.46,.41-5.13,.21-7.91,.42-7.91,.42l14.25-95.68c151.19-28.67,255.98,35.11,255.98,35.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2460.55,674.9c-83-26.8-157.16-19.1-201.16-10.39l-1.31,8.83c17.41-5,128-32,269,39.14l1.21-8.17c-21.57-11.97-44.26-21.82-67.74-29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2459.13,682.87c-83-26.8-157.16-19.1-201.16-10.38l-1.31,8.82c17.41-5,128.05-32,269,39.14l1.22-8.17c-21.58-11.97-44.27-21.82-67.75-29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2398.27,778.07c-12.8-2.16-25.2-3.86-37-5.18,2.23-14.82,4.45-29.63,6.68-44.43,.81-5.4,1.63-10.8,2.44-16.21l3.55,.53,1-6.71-3.61-.13c.08-.54,1.83-10.78,11.2-14.58,4.66-1.78,9.83-1.64,14.38,.4,1.96,.91,3.74,2.16,5.28,3.67,6,6,5.88,14.37,5.78,16.37l-3.09-.86-.89,5.92,3.16,.47c-.77,5.33-1.54,10.65-2.33,15.94-2.18,14.93-4.36,29.87-6.55,44.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2354.62,772.12c-11.82-1.24-23-2.12-33.31-2.72l6.15-42.15c.8-5.53,1.61-11.06,2.42-16.6l4.06-.2,1.06-7.1-3.81-.25s4.56-21.8,23.19-14.62c1.73,.94,3.3,2.14,4.67,3.56,3.27,3.54,5.24,8.09,5.57,12.9l-3.22-.08-.94,6.31,3.16,.47-2.43,16.32-6.57,44.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2447.91,728.24c-.75,4.89-1.51,9.77-2.25,14.66-2.23,14.5-4.45,29-6.68,43.49-5.38-1.27-10.88-2.51-16.49-3.71-6-1.28-11.89-2.47-17.67-3.58,2.32-14.84,4.63-29.68,6.94-44.52l2.4-15.41,3.55,.53,.82-5.52-3.89-1c.28-.84,3.49-10.16,12.77-12.74,3.83-1.01,7.89-.76,11.57,.72,1.74,.92,3.32,2.12,4.67,3.56,5.83,6.26,5.08,14.81,4.86,16.74l-2.7-.81-1,6.71,3.1,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2323.05,710.44c-.85,5.68-1.71,11.35-2.57,17l-6.27,41.43c-9.71-.49-18.59-.74-26.46-.85,1.94-12.86,3.88-25.72,5.81-38.57,.88-5.8,1.75-11.6,2.62-17.4l3.34-.71,.66-7.16h-2.82c.4-7.69,4.76-13.84,10.51-15.32,2.73-.63,5.58-.34,8.13,.81,1.36,.85,2.59,1.89,3.64,3.1,2.47,2.96,3.91,6.65,4.08,10.5h-2.43l-1.06,7.1,2.82,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2478.27,732.77l-.82,5.52,2.25,1.14-8.33,55.93c-8.54-2.62-17.05-5-25.52-7.15l6.42-43.29c.74-4.97,1.48-9.94,2.21-14.89l3.1,.86,.76-5.13-2.64-1.2c1.23-5.1,4.86-9.07,9.47-10.23,2.73-.64,5.59-.35,8.14,.81,1.37,.84,2.59,1.89,3.64,3.1,5,5.79,3.92,13.47,3.63,15.27l-2.31-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2290.42,712.84c-.9,5.77-1.8,11.54-2.71,17.32l-5.94,38c-10.08,0-18.07,.2-23.46,.41l7.83-52.5,2.94-.78,1-7.1-2.93,.77c.15-9.35,4.75-16.49,10.54-17.75,2.22-.43,4.52-.14,6.56,.85,1.19,.85,2.26,1.86,3.17,3,2.3,2.93,3.59,6.53,3.67,10.26l-2,.1-1.12,7.5,2.45-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2506.03,744.16c-.36,2.16-.72,4.31-1.07,6.46l2,.94-7.88,52.92c-7.41-2.74-14.85-5.28-22.27-7.62l8.26-55.42,2.7,.81,.83-5.53-2.69-1.15c1.35-4.93,4.94-8.63,9.32-9.46,2.22-.39,4.51-.1,6.56,.84,1.19,.84,2.26,1.85,3.16,3,4.7,5.9,3.29,13.57,2.91,15.39l-1.83-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2287.99,712.88h2.43c-.9,5.77-1.8,11.54-2.71,17.32-8.66,1.08-16.76,2.39-24.24,3.81l2.67-17.89,2.94-.78,1-7.1-2.93,.77c.15-9.35,4.75-16.49,10.54-17.75,2.22-.43,4.52-.14,6.56,.85,1.19,.85,2.26,1.86,3.17,3,2.3,2.93,3.59,6.53,3.67,10.26l-2,.1-1.1,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2320.23,710.42h2.82c-.85,5.68-1.71,11.35-2.57,17-9.44,.38-18.43,1.08-26.92,2,.88-5.8,1.75-11.6,2.62-17.4l3.34-.71,.66-7.16h-2.82c.4-7.69,4.76-13.84,10.51-15.32,2.73-.63,5.58-.34,8.13,.81,1.36,.85,2.59,1.89,3.64,3.1,2.47,2.96,3.91,6.65,4.08,10.5h-2.43l-1.06,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2363.62,711.64l-2.43,16.32c-11.74-.76-23-.95-33.73-.71,.8-5.53,1.61-11.06,2.42-16.6l4.06-.2,1.06-7.1-3.81-.25s4.56-21.8,23.19-14.62c1.73,.94,3.3,2.14,4.67,3.56,3.27,3.54,5.24,8.09,5.57,12.9l-3.22-.08-.94,6.31,3.16,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2407.15,717.33c-.77,5.33-1.54,10.65-2.33,15.94-4.91-.88-9.91-1.68-15-2.39-7.44-1.04-14.72-1.85-21.85-2.42,.81-5.4,1.63-10.8,2.44-16.21l3.55,.53,1-6.71-3.61-.13c.08-.54,1.83-10.78,11.2-14.58,4.66-1.78,9.83-1.64,14.38,.4,1.96,.91,3.74,2.16,5.28,3.67,6,6,5.88,14.37,5.78,16.37l-3.09-.86-.89,5.92,3.14,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2444.79,727.37l3.1,.87c-.75,4.89-1.51,9.77-2.25,14.66-10.68-3.13-22-6-33.9-8.32l2.4-15.41,3.55,.53,.82-5.52-3.89-1c.28-.84,3.49-10.16,12.77-12.74,3.83-1.01,7.89-.76,11.57,.72,1.74,.92,3.32,2.12,4.67,3.56,5.83,6.26,5.08,14.81,4.86,16.74l-2.7-.81-1,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2480.58,733.51l-2.31-.74-.82,5.52,2.25,1.14-2.14,14.37c-8-3.11-16.39-6.1-25.29-8.88,.74-4.97,1.48-9.94,2.21-14.89l3.1,.86,.76-5.13-2.64-1.2c1.23-5.1,4.86-9.07,9.47-10.23,2.73-.64,5.59-.35,8.14,.81,1.37,.84,2.59,1.89,3.64,3.1,4.96,5.79,3.96,13.47,3.63,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2506.03,744.16c-.36,2.16-.72,4.31-1.07,6.46l2,.94-2.1,14.09c-6.8-3.27-14.13-6.54-21.95-9.73l2.16-14.48,2.7,.81,.83-5.53-2.69-1.15c1.35-4.93,4.94-8.63,9.32-9.46,2.22-.39,4.51-.1,6.56,.84,1.19,.84,2.26,1.85,3.16,3,4.7,5.9,3.29,13.57,2.91,15.39l-1.83-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2249.68,773.8v.16l-2.91,.56,2.91-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2505.64,809.05l-14.7,98.66c-2.29-.88-4.59-1.75-6.88-2.6-7.41-2.74-14.83-5.28-22.26-7.62l-4.24-1.32c-8.54-2.62-17.05-5.01-25.52-7.16-2.7-.68-5.39-1.35-8.07-2-11.07-2.65-22-4.93-32.7-6.89-3.07-.56-6.14-1.1-9.18-1.61-12.8-2.15-25.2-3.85-37-5.18l-5.46-.59c-11.82-1.24-23-2.12-33.32-2.72-2-.12-4-.22-5.91-.32-9.71-.49-18.59-.75-26.46-.85h-7.16c-10.09,0-18.07,.19-23.46,.41-5.14,.2-7.92,.41-7.92,.41l14.26-95.67c151.19-28.73,255.98,35.05,255.98,35.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2445.08,777.19c-83-26.8-157.16-19.1-201.16-10.39l-1.32,8.83c17.41-5,128.06-32,269,39.14l1.31-8.2c-21.61-11.97-44.32-21.81-67.83-29.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2444.14,783.5c-83-26.8-157.17-19.09-201.16-10.38l-1.32,8.83c17.41-5,128.06-32,269,39.13l1.22-8.17c-21.58-11.97-44.26-21.82-67.74-29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2383.28,878.7c-12.8-2.16-25.2-3.85-37-5.18,2.22-14.81,4.45-29.62,6.68-44.43l2.43-16.21,3.56,.53,1-6.71-3.62-.13c.09-.54,1.83-10.78,11.2-14.58,4.66-1.77,9.83-1.63,14.38,.41,1.96,.9,3.75,2.14,5.28,3.66,6.06,6,5.89,14.37,5.79,16.37l-3.1-.86-.88,5.92,3.16,.47-2.34,15.94-6.54,44.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2339.63,872.75c-11.82-1.24-23-2.12-33.32-2.72l6.15-42.14,2.43-16.61,4.06-.2,1.06-7.1-3.82-.25s4.56-21.79,23.2-14.62c1.73,.94,3.31,2.15,4.67,3.57,3.26,3.54,5.23,8.09,5.57,12.89l-3.22-.08-.94,6.32,3.16,.47c-.82,5.44-1.63,10.88-2.43,16.32l-6.57,44.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2432.91,828.87l-2.25,14.67c-2.22,14.49-4.44,28.98-6.67,43.48-5.39-1.27-10.88-2.5-16.49-3.71-6-1.28-11.89-2.47-17.67-3.58l6.93-44.52,2.4-15.4,3.55,.53,.83-5.53-3.89-1c.28-.85,3.49-10.16,12.76-12.74,3.84-1.02,7.9-.77,11.58,.71,1.74,.92,3.32,2.13,4.66,3.57,5.83,6.25,5.08,14.8,4.87,16.73l-2.71-.8-1,6.7,3.1,.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2308.06,811.07l-2.58,17-6.27,41.5c-9.71-.49-18.59-.74-26.45-.84,1.93-12.86,3.87-25.72,5.81-38.58,.87-5.79,1.75-11.58,2.62-17.39l3.33-.72,.66-7.16h-2.82c.4-7.69,4.77-13.83,10.51-15.31,2.73-.63,5.59-.35,8.14,.8,1.36,.85,2.58,1.89,3.63,3.1,2.48,2.95,3.92,6.65,4.08,10.5h-2.42l-1.06,7.11h2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2463.28,833.4l-.82,5.52,2.25,1.15-8.34,55.92c-8.54-2.62-17.05-5-25.52-7.15,2.14-14.43,4.28-28.86,6.43-43.29,.73-4.97,1.47-9.93,2.2-14.89l3.1,.86,.77-5.13-2.65-1.2c1.24-5.09,4.86-9.06,9.48-10.22,2.72-.64,5.58-.35,8.13,.8,1.37,.84,2.59,1.89,3.64,3.11,5,5.78,3.93,13.47,3.64,15.27l-2.31-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2275.43,813.47c-.9,5.78-1.8,11.56-2.71,17.33l-5.94,38c-10.09,0-18.07,.19-23.46,.41l7.82-52.51,2.94-.77,1.06-7.11-2.94,.78c.16-9.36,4.75-16.5,10.55-17.76,2.22-.42,4.52-.13,6.56,.85,1.19,.85,2.25,1.86,3.16,3,2.3,2.93,3.59,6.53,3.68,10.25l-2,.1-1.12,7.5,2.4-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2491.03,844.8c-.36,2.15-.71,4.3-1.07,6.45l2,.94-7.89,52.92c-7.41-2.74-14.83-5.28-22.26-7.62l8.26-55.42,2.7,.81,.82-5.53-2.64-1.2c1.35-4.93,4.94-8.63,9.31-9.46,2.22-.39,4.51-.09,6.56,.84,1.2,.84,2.26,1.85,3.17,3,4.69,5.9,3.29,13.57,2.91,15.39l-1.87-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2273,813.51h2.43c-.9,5.78-1.8,11.56-2.71,17.33-8.67,1.08-16.77,2.38-24.24,3.8l2.66-17.89,2.94-.77,1.06-7.11-2.94,.78c.16-9.36,4.75-16.5,10.55-17.76,2.22-.42,4.52-.13,6.56,.85,1.19,.85,2.25,1.86,3.16,3,2.3,2.93,3.59,6.53,3.68,10.25l-2,.1-1.15,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2305.24,811.06h2.82l-2.58,17c-9.44,.38-18.43,1.08-26.91,2,.87-5.79,1.75-11.58,2.62-17.39l3.33-.72,.66-7.16h-2.82c.4-7.69,4.77-13.83,10.51-15.31,2.73-.63,5.59-.35,8.14,.8,1.36,.85,2.58,1.89,3.63,3.1,2.48,2.95,3.92,6.65,4.08,10.5h-2.42l-1.06,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2348.63,812.28c-.82,5.44-1.63,10.88-2.43,16.32-11.75-.77-23-1-33.74-.71l2.43-16.61,4.06-.2,1.06-7.1-3.82-.25s4.56-21.79,23.2-14.62c1.73,.94,3.31,2.15,4.67,3.57,3.26,3.54,5.23,8.09,5.57,12.89l-3.22-.08-.94,6.32,3.16,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2392.16,817.96l-2.34,15.94c-4.9-.88-9.9-1.68-15-2.39-7.44-1.04-14.72-1.85-21.85-2.42l2.43-16.21,3.56,.53,1-6.71-3.62-.13c.09-.54,1.83-10.78,11.2-14.58,4.66-1.77,9.83-1.63,14.38,.41,1.96,.9,3.75,2.14,5.28,3.66,6.06,6,5.89,14.37,5.79,16.37l-3.1-.86-.88,5.92,3.15,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2429.79,828l3.1,.87-2.25,14.67c-10.67-3.14-22-6-33.9-8.33l2.4-15.4,3.55,.53,.83-5.53-3.89-1c.28-.85,3.49-10.16,12.76-12.74,3.84-1.02,7.9-.77,11.58,.71,1.74,.92,3.32,2.13,4.66,3.57,5.83,6.25,5.08,14.8,4.87,16.73l-2.71-.8-1,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2465.59,834.15l-2.31-.75-.82,5.52,2.25,1.15-2.14,14.36c-8-3.11-16.39-6.1-25.29-8.88,.73-4.97,1.47-9.93,2.2-14.89l3.1,.86,.77-5.13-2.65-1.2c1.24-5.09,4.86-9.06,9.48-10.22,2.72-.64,5.58-.35,8.13,.8,1.37,.84,2.59,1.89,3.64,3.11,4.96,5.78,3.96,13.47,3.64,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2491.03,844.8c-.36,2.15-.71,4.3-1.07,6.45l2,.94-2.1,14.09c-6.81-3.27-14.13-6.54-22-9.72l2.16-14.49,2.7,.81,.82-5.53-2.64-1.2c1.35-4.93,4.94-8.63,9.31-9.46,2.22-.39,4.51-.09,6.56,.84,1.2,.84,2.26,1.85,3.17,3,4.69,5.9,3.29,13.57,2.91,15.39l-1.82-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2234.27,877.19v.16l-2.91,.56,2.91-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2490.23,912.45l-14.7,98.66c-2.29-.89-4.58-1.75-6.88-2.6-7.41-2.74-14.83-5.28-22.26-7.63l-4.24-1.32c-8.54-2.62-17.05-5-25.52-7.15-2.67-.67-5.36-1.33-8.07-2-11.07-2.66-22-4.94-32.69-6.89-3.08-.57-6.14-1.1-9.18-1.61-12.8-2.16-25.2-3.86-37-5.18l-5.47-.6c-11.82-1.24-23-2.11-33.31-2.71l-5.92-.33c-9.71-.49-18.59-.74-26.46-.84-2.49,0-4.88,0-7.16-.06-10.08,0-18.07,.2-23.46,.41-5.13,.21-7.92,.41-7.92,.41l14.26-95.67c151.19-28.68,255.98,35.11,255.98,35.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2429.67,880.57c-83-26.8-157.16-19.09-201.16-10.38l-1.31,8.83c17.41-5,128.05-32,269,39.13l1.21-8.17c-21.58-11.97-44.26-21.82-67.74-29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2428.73,886.89c-83-26.79-157.16-19.09-201.16-10.38l-1.31,8.83c17.41-5,128.05-32,269,39.14l1.21-8.17c-21.58-11.97-44.26-21.82-67.74-29.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2367.91,982.09c-12.8-2.15-25.2-3.85-37-5.18,2.23-14.81,4.46-29.61,6.68-44.42,.81-5.41,1.62-10.82,2.44-16.21l3.55,.53,1-6.71-3.61-.14c.08-.53,1.83-10.78,11.19-14.57,6.78-2.67,14.51-1.08,19.67,4.07,6,6,5.88,14.37,5.78,16.37l-3.1-.87-.88,5.92,3.16,.47c-.78,5.33-1.56,10.67-2.33,16-2.21,14.9-4.39,29.81-6.55,44.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2324.22,976.14c-11.82-1.24-23-2.11-33.31-2.71,2.04-14.05,4.09-28.1,6.15-42.15,.8-5.54,1.61-11.07,2.42-16.6l4.06-.2,1.06-7.11-3.82-.24s4.57-21.8,23.2-14.63c1.73,.95,3.3,2.15,4.67,3.57,3.27,3.54,5.23,8.09,5.57,12.89l-3.22-.07-.94,6.31,3.16,.47-2.43,16.32-6.57,44.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2417.48,932.26l-2.25,14.67c-2.22,14.5-4.44,29-6.67,43.49-5.39-1.27-10.88-2.5-16.49-3.71-6-1.28-11.89-2.47-17.67-3.58,2.31-14.84,4.62-29.68,6.93-44.52,.81-5.14,1.62-10.28,2.41-15.41l3.55,.53,.82-5.52-3.89-1c.28-.84,3.49-10.16,12.77-12.74,3.83-1.02,7.89-.77,11.57,.71,1.74,.92,3.32,2.13,4.67,3.57,5.82,6.25,5.07,14.81,4.86,16.74l-2.71-.81-1,6.71,3.1,.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2292.65,914.47c-.86,5.67-1.72,11.33-2.58,17-2.08,13.82-4.17,27.63-6.26,41.44-9.71-.5-18.6-.75-26.46-.85,1.94-12.86,3.88-25.72,5.81-38.57,.88-5.8,1.75-11.6,2.62-17.4l3.33-.71c.23-2.39,.46-4.78,.67-7.17h-2.82c.4-7.7,4.76-13.84,10.5-15.32,2.73-.63,5.59-.35,8.14,.81,1.36,.85,2.58,1.89,3.64,3.1,2.47,2.96,3.91,6.65,4.08,10.5h-2.43l-1.06,7.1,2.82,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2447.91,936.79l-.82,5.53,2.25,1.14-8.33,55.92c-8.54-2.62-17.07-5-25.52-7.15l6.42-43.28c.73-4.97,1.47-9.93,2.21-14.9l3.09,.87,.77-5.13-2.65-1.2c1.24-5.1,4.87-9.07,9.48-10.23,2.73-.64,5.59-.35,8.14,.81,1.36,.84,2.59,1.89,3.63,3.1,5,5.79,3.93,13.47,3.64,15.27l-2.31-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2260.02,916.87c-.9,5.77-1.8,11.54-2.71,17.32l-5.94,38c-10.08,0-18.07,.2-23.46,.41l7.82-52.51,2.94-.77,1.06-7.1-2.94,.77c.16-9.35,4.76-16.49,10.55-17.75,2.22-.43,4.52-.14,6.56,.84,1.19,.85,2.25,1.86,3.17,3,2.3,2.93,3.59,6.53,3.67,10.26l-2,.1-1.12,7.5,2.4-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2475.63,948.19l-1.08,6.46,2,.94-7.89,52.92c-7.41-2.74-14.83-5.28-22.26-7.63l8.26-55.41,2.7,.8,.83-5.52-2.65-1.2c1.35-4.93,4.94-8.63,9.31-9.47,2.22-.39,4.51-.09,6.56,.85,1.2,.84,2.27,1.85,3.17,3,4.7,5.9,3.29,13.57,2.91,15.38l-1.86-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2257.59,916.91h2.43c-.9,5.77-1.8,11.54-2.71,17.32-8.67,1.08-16.76,2.39-24.24,3.8l2.66-17.89,2.94-.77,1.06-7.1-2.94,.77c.16-9.35,4.76-16.49,10.55-17.75,2.22-.43,4.52-.14,6.56,.84,1.19,.85,2.25,1.86,3.17,3,2.3,2.93,3.59,6.53,3.67,10.26l-2,.1-1.15,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2289.83,914.45h2.82c-.86,5.67-1.72,11.33-2.58,17-9.44,.38-18.42,1.09-26.91,2,.88-5.8,1.75-11.6,2.62-17.4l3.33-.71c.23-2.39,.46-4.78,.67-7.17h-2.82c.4-7.7,4.76-13.84,10.5-15.32,2.73-.63,5.59-.35,8.14,.81,1.36,.85,2.58,1.89,3.64,3.1,2.47,2.96,3.91,6.65,4.08,10.5h-2.43l-1.06,7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2333.22,915.67l-2.43,16.32c-11.74-.76-23-1-33.73-.71,.8-5.54,1.61-11.07,2.42-16.6l4.06-.2,1.06-7.11-3.82-.24s4.57-21.8,23.2-14.63c1.73,.95,3.3,2.15,4.67,3.57,3.27,3.54,5.23,8.09,5.57,12.89l-3.22-.07-.94,6.31,3.16,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2376.75,921.35c-.78,5.33-1.56,10.67-2.33,16-4.91-.88-9.91-1.68-15-2.4-7.44-1.03-14.72-1.84-21.85-2.41,.81-5.41,1.62-10.82,2.44-16.21l3.55,.53,1-6.71-3.61-.14c.08-.53,1.83-10.78,11.19-14.57,6.78-2.67,14.51-1.08,19.67,4.07,6,6,5.88,14.37,5.78,16.37l-3.1-.87-.88,5.92,3.14,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2414.38,931.4l3.1,.86-2.25,14.67c-10.67-3.13-22-6-33.9-8.32,.81-5.14,1.62-10.28,2.41-15.41l3.55,.53,.82-5.52-3.89-1c.28-.84,3.49-10.16,12.77-12.74,3.83-1.02,7.89-.77,11.57,.71,1.74,.92,3.32,2.13,4.67,3.57,5.82,6.25,5.07,14.81,4.86,16.74l-2.71-.81-1,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2450.18,937.57l-2.31-.75-.82,5.53,2.25,1.14-2.14,14.36c-7.95-3.1-16.39-6.09-25.29-8.87,.73-4.97,1.47-9.93,2.21-14.9l3.09,.87,.77-5.13-2.65-1.2c1.24-5.1,4.87-9.07,9.48-10.23,2.73-.64,5.59-.35,8.14,.81,1.36,.84,2.59,1.89,3.63,3.1,4.96,5.76,3.93,13.44,3.64,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2475.63,948.19l-1.08,6.46,2,.94-2.1,14.09c-6.8-3.27-14.13-6.55-22-9.73l2.16-14.48,2.7,.8,.83-5.52-2.65-1.2c1.35-4.93,4.94-8.63,9.31-9.47,2.22-.39,4.51-.09,6.56,.85,1.2,.84,2.27,1.85,3.17,3,4.7,5.9,3.29,13.57,2.91,15.38l-1.81-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2219.1,979.01v.16l-2.91,.56,2.91-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2475.06,1014.26l-14.7,98.66c-2.29-.88-4.58-1.75-6.88-2.59-7.41-2.75-14.83-5.29-22.26-7.63-1.41-.45-2.83-.89-4.24-1.32-8.54-2.62-17.05-5-25.52-7.15-2.7-.67-5.39-1.33-8.07-2-11.07-2.65-22-4.93-32.69-6.89-3.08-.56-6.14-1.1-9.18-1.61-12.81-2.15-25.21-3.85-37-5.18l-5.46-.59c-11.82-1.24-23-2.11-33.32-2.72l-5.91-.32c-9.71-.49-18.59-.74-26.46-.85h-7.16c-10.08,0-18.07,.19-23.46,.41-5.14,.2-7.92,.41-7.92,.41l14.26-95.67c151.18-28.74,255.97,35.04,255.97,35.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2414.5,982.4c-83-26.8-157.16-19.1-201.16-10.38l-1.31,8.82c17.41-5,128.05-32,269,39.14l1.21-8.17c-21.58-11.97-44.26-21.82-67.74-29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2413.56,988.71c-83-26.8-157.16-19.09-201.16-10.38l-1.32,8.83c17.41-5,128.06-32,269,39.13l1.22-8.16c-21.58-11.97-44.26-21.82-67.74-29.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2352.7,1083.91c-12.8-2.15-25.2-3.85-37-5.18,2.23-14.81,4.46-29.62,6.68-44.43l2.43-16.21,3.56,.53,1-6.71-3.61-.13c.08-.54,1.82-10.78,11.19-14.58,4.66-1.78,9.83-1.63,14.38,.41,1.96,.91,3.75,2.15,5.28,3.67,6.06,6,5.89,14.37,5.79,16.36l-3.1-.86-.88,5.92,3.16,.47c-.78,5.33-1.56,10.67-2.33,16-2.18,14.9-4.36,29.81-6.55,44.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2309.05,1077.96c-11.82-1.24-23-2.11-33.32-2.72,2.05-14.04,4.1-28.09,6.16-42.14,.8-5.54,1.61-11.08,2.42-16.61l4.06-.2,1.06-7.1-3.82-.25s4.57-21.79,23.2-14.62c1.73,.95,3.3,2.15,4.67,3.57,3.26,3.54,5.23,8.09,5.57,12.89l-3.22-.08-.94,6.32,3.16,.47-2.43,16.32-6.57,44.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2402.31,1034.08l-2.25,14.67c-2.22,14.49-4.44,28.98-6.67,43.48-5.39-1.27-10.88-2.5-16.49-3.71-6-1.27-11.89-2.46-17.67-3.58,2.31-14.84,4.62-29.68,6.93-44.51,.81-5.14,1.61-10.28,2.4-15.41l3.56,.53,.82-5.53-3.89-1c.28-.85,3.49-10.16,12.76-12.74,3.84-1.02,7.9-.77,11.58,.71,1.74,.92,3.32,2.13,4.67,3.57,5.82,6.25,5.07,14.8,4.86,16.73l-2.71-.8-1,6.71,3.1,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2277.48,1016.28l-2.58,17c-2.08,13.81-4.17,27.62-6.26,41.43-9.71-.49-18.6-.74-26.46-.84,1.94-12.86,3.88-25.72,5.81-38.57,.87-5.8,1.74-11.6,2.62-17.4l3.33-.72c.22-2.38,.44-4.77,.67-7.16h-2.83c.4-7.69,4.77-13.83,10.51-15.31,2.73-.63,5.59-.35,8.14,.8,1.36,.85,2.58,1.9,3.63,3.11,2.48,2.95,3.92,6.64,4.08,10.49h-2.42l-1.06,7.11,2.82,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2432.7,1038.57l-.82,5.52,2.25,1.15-8.33,55.92c-8.55-2.62-17.06-5-25.53-7.15,2.15-14.43,4.29-28.86,6.43-43.29,.73-4.96,1.47-9.92,2.2-14.89l3.1,.87,.77-5.14c-.88-.4-1.77-.79-2.65-1.2,1.24-5.09,4.87-9.06,9.48-10.22,2.73-.64,5.59-.35,8.14,.8,1.36,.85,2.58,1.9,3.63,3.11,5,5.78,3.93,13.47,3.64,15.27l-2.31-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2244.85,1018.68c-.9,5.78-1.8,11.56-2.71,17.33l-5.94,38c-10.08,0-18.07,.19-23.46,.41l7.82-52.51,2.94-.77,1.06-7.11-2.94,.78c.16-9.35,4.75-16.5,10.55-17.75,2.22-.43,4.52-.14,6.56,.84,1.19,.85,2.25,1.86,3.16,3,2.3,2.93,3.59,6.53,3.68,10.26l-2,.1-1.12,7.49,2.4-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2460.45,1050.01c-.35,2.15-.7,4.3-1.07,6.45l2,.94-7.89,52.93c-7.41-2.75-14.83-5.29-22.26-7.63l8.26-55.42,2.7,.81,.82-5.52-2.64-1.2c1.35-4.93,4.94-8.64,9.31-9.47,2.22-.39,4.51-.09,6.56,.85,1.2,.84,2.27,1.85,3.17,3,4.69,5.9,3.29,13.58,2.91,15.39l-1.87-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2242.42,1018.72h2.43c-.9,5.78-1.8,11.56-2.71,17.33-8.67,1.08-16.77,2.38-24.24,3.8l2.66-17.89,2.94-.77,1.06-7.11-2.94,.78c.16-9.35,4.75-16.5,10.55-17.75,2.22-.43,4.52-.14,6.56,.84,1.19,.85,2.25,1.86,3.16,3,2.3,2.93,3.59,6.53,3.68,10.26l-2,.1-1.15,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2274.66,1016.27h2.82l-2.58,17c-9.44,.38-18.43,1.08-26.91,2,.87-5.8,1.74-11.6,2.62-17.4l3.33-.72c.22-2.38,.44-4.77,.67-7.16h-2.83c.4-7.69,4.77-13.83,10.51-15.31,2.73-.63,5.59-.35,8.14,.8,1.36,.85,2.58,1.9,3.63,3.11,2.48,2.95,3.92,6.64,4.08,10.49h-2.42l-1.06,7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2318.05,1017.49l-2.43,16.32c-11.74-.76-23-1-33.73-.71,.8-5.54,1.61-11.08,2.42-16.61l4.06-.2,1.06-7.1-3.82-.25s4.57-21.79,23.2-14.62c1.73,.95,3.3,2.15,4.67,3.57,3.26,3.54,5.23,8.09,5.57,12.89l-3.22-.08-.94,6.32,3.16,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2361.58,1023.17c-.78,5.33-1.56,10.67-2.33,16-4.91-.89-9.91-1.69-15-2.4-7.44-1.04-14.72-1.85-21.85-2.42l2.43-16.21,3.56,.53,1-6.71-3.61-.13c.08-.54,1.82-10.78,11.19-14.58,4.66-1.78,9.83-1.63,14.38,.41,1.96,.91,3.75,2.15,5.28,3.67,6.06,6,5.89,14.37,5.79,16.36l-3.1-.86-.88,5.92,3.14,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2399.21,1033.22l3.1,.86-2.25,14.67c-10.67-3.14-22-6-33.9-8.32,.81-5.14,1.61-10.28,2.4-15.41l3.56,.53,.82-5.53-3.89-1c.28-.85,3.49-10.16,12.76-12.74,3.84-1.02,7.9-.77,11.58,.71,1.74,.92,3.32,2.13,4.67,3.57,5.82,6.25,5.07,14.8,4.86,16.73l-2.71-.8-1,6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2435.01,1039.36l-2.31-.75-.82,5.52,2.25,1.15-2.14,14.36c-7.95-3.1-16.39-6.1-25.29-8.88,.73-4.96,1.47-9.92,2.2-14.89l3.1,.87,.77-5.14c-.88-.4-1.77-.79-2.65-1.2,1.24-5.09,4.87-9.06,9.48-10.22,2.73-.64,5.59-.35,8.14,.8,1.36,.85,2.58,1.9,3.63,3.11,4.96,5.78,3.93,13.48,3.64,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2460.45,1050.01c-.35,2.15-.7,4.3-1.07,6.45l2,.94-2.1,14.09c-6.8-3.27-14.13-6.54-22-9.72l2.16-14.49,2.7,.81,.82-5.52-2.64-1.2c1.35-4.93,4.94-8.64,9.31-9.47,2.22-.39,4.51-.09,6.56,.85,1.2,.84,2.27,1.85,3.17,3,4.69,5.9,3.29,13.58,2.91,15.39l-1.82-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2203.52,1083.57v.16l-2.91,.56,2.91-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2459.48,1118.84l-14.71,98.66c-2.29-.88-4.58-1.75-6.87-2.6-7.41-2.74-14.83-5.28-22.26-7.62l-4.24-1.32c-8.55-2.62-17.05-5.01-25.52-7.16-2.7-.68-5.39-1.35-8.07-2-11.07-2.65-22-4.93-32.7-6.89-3.08-.56-6.14-1.1-9.18-1.61-12.8-2.15-25.2-3.85-37-5.18l-5.47-.59c-11.81-1.24-23-2.11-33.31-2.72l-5.91-.32c-9.71-.49-18.6-.74-26.46-.85h-7.16c-10.09,0-18.07,.19-23.46,.41-5.14,.2-7.92,.41-7.92,.41l14.26-95.67c151.19-28.73,255.98,35.05,255.98,35.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2398.91,1086.98c-83-26.8-157.17-19.1-201.16-10.39l-1.32,8.83c17.41-5,128.06-32,269,39.14l1.22-8.17c-21.58-11.97-44.26-21.82-67.74-29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2397.98,1093.29c-83-26.8-157.17-19.09-201.16-10.38l-1.32,8.83c17.41-5,128.06-32,269,39.13l1.22-8.17c-21.58-11.97-44.26-21.82-67.74-29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2337.12,1188.49c-12.81-2.16-25.2-3.85-37-5.18,2.22-14.81,4.45-29.62,6.68-44.43l2.43-16.21,3.55,.53,1-6.71-3.61-.13c.09-.54,1.83-10.78,11.2-14.58,4.66-1.77,9.83-1.63,14.38,.41,1.96,.9,3.75,2.14,5.28,3.66,6.05,6,5.88,14.37,5.79,16.37l-3.1-.86-.88,5.92,3.15,.47c-.77,5.33-1.54,10.65-2.33,15.94l-6.54,44.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2293.46,1182.57c-11.81-1.24-23-2.11-33.31-2.72l6.15-42.14c.81-5.54,1.61-11.08,2.42-16.61l4.07-.2,1.06-7.1-3.82-.25s4.56-21.79,23.2-14.62c1.73,.94,3.31,2.15,4.67,3.57,3.27,3.54,5.23,8.09,5.56,12.89l-3.21-.08-.94,6.32,3.15,.47c-.81,5.44-1.62,10.88-2.42,16.32-2.19,14.69-4.38,29.41-6.58,44.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2386.73,1138.66l-2.25,14.67c-2.23,14.49-4.45,28.98-6.67,43.48-5.39-1.27-10.88-2.5-16.49-3.71-6-1.28-11.89-2.47-17.67-3.58l6.93-44.52,2.4-15.4,3.55,.53,.83-5.53-3.89-1c.27-.85,3.48-10.16,12.76-12.74,3.83-1.02,7.89-.77,11.57,.71,1.74,.92,3.32,2.13,4.67,3.57,5.83,6.25,5.08,14.8,4.86,16.73l-2.7-.8-1,6.7,3.1,.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2261.91,1120.86l-2.58,17-6.27,41.43c-9.71-.49-18.59-.74-26.45-.84,1.93-12.86,3.86-25.72,5.8-38.57,.88-5.8,1.76-11.6,2.63-17.4l3.33-.72,.66-7.16h-2.82c.4-7.69,4.77-13.83,10.51-15.31,2.72-.63,5.58-.35,8.13,.8,1.36,.85,2.59,1.89,3.64,3.11,2.48,2.95,3.92,6.64,4.08,10.49h-2.43l-1,7.11,2.77,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2417.12,1143.19l-.83,5.52c.75,.39,1.51,.76,2.25,1.15l-8.33,55.92c-8.54-2.62-17.05-5-25.52-7.15l6.42-43.29c.74-4.96,1.48-9.92,2.21-14.89l3.1,.86,.76-5.13-2.64-1.2c1.24-5.09,4.86-9.06,9.48-10.22,2.72-.64,5.58-.35,8.13,.8,1.37,.84,2.59,1.89,3.64,3.11,5,5.78,3.93,13.47,3.64,15.27l-2.31-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2229.26,1123.26l-2.7,17.33-5.94,38c-10.09,0-18.07,.19-23.46,.41l7.82-52.51,2.94-.77,1.06-7.11-2.94,.78c.16-9.36,4.75-16.5,10.55-17.75,2.22-.43,4.52-.14,6.56,.84,1.19,.85,2.25,1.86,3.16,3,2.3,2.93,3.59,6.53,3.68,10.25l-2,.1-1.12,7.5,2.39-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2444.91,1154.57c-.36,2.15-.71,4.3-1.07,6.45l2,.94-7.88,52.92c-7.41-2.74-14.83-5.28-22.26-7.62l8.25-55.42,2.71,.81,.82-5.53-2.64-1.2c1.35-4.93,4.93-8.63,9.31-9.46,2.22-.39,4.51-.09,6.56,.85,1.2,.84,2.26,1.85,3.16,3,4.7,5.9,3.3,13.57,2.92,15.39l-1.88-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2226.84,1123.3h2.42l-2.7,17.33c-8.67,1.08-16.77,2.38-24.25,3.8l2.67-17.89,2.94-.77,1.06-7.11-2.94,.78c.16-9.36,4.75-16.5,10.55-17.75,2.22-.43,4.52-.14,6.56,.84,1.19,.85,2.25,1.86,3.16,3,2.3,2.93,3.59,6.53,3.68,10.25l-2,.1-1.15,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2259.08,1120.85h2.83l-2.58,17c-9.44,.38-18.43,1.08-26.92,2,.88-5.8,1.76-11.6,2.63-17.4l3.33-.72,.66-7.16h-2.82c.4-7.69,4.77-13.83,10.51-15.31,2.72-.63,5.58-.35,8.13,.8,1.36,.85,2.59,1.89,3.64,3.11,2.48,2.95,3.92,6.64,4.08,10.49h-2.43l-1.06,7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2302.46,1122.07c-.81,5.44-1.62,10.88-2.42,16.32-11.75-.77-23-1-33.74-.71,.81-5.54,1.61-11.08,2.42-16.61l4.07-.2,1.06-7.1-3.82-.25s4.56-21.79,23.2-14.62c1.73,.94,3.31,2.15,4.67,3.57,3.27,3.54,5.23,8.09,5.56,12.89l-3.21-.08-.94,6.32,3.15,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2345.99,1127.75c-.77,5.33-1.54,10.65-2.33,15.94-4.91-.88-9.91-1.68-15-2.39-7.43-1.04-14.71-1.85-21.84-2.42l2.43-16.21,3.55,.53,1-6.71-3.61-.13c.09-.54,1.83-10.78,11.2-14.58,4.66-1.77,9.83-1.63,14.38,.41,1.96,.9,3.75,2.14,5.28,3.66,6.05,6,5.88,14.37,5.79,16.37l-3.1-.86-.88,5.92,3.13,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2383.63,1137.79l3.1,.87-2.25,14.67c-10.67-3.14-22-6-33.9-8.33l2.4-15.4,3.55,.53,.83-5.53-3.89-1c.27-.85,3.48-10.16,12.76-12.74,3.83-1.02,7.89-.77,11.57,.71,1.74,.92,3.32,2.13,4.67,3.57,5.83,6.25,5.08,14.8,4.86,16.73l-2.7-.8-1,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2419.43,1143.94l-2.31-.75-.83,5.52c.75,.39,1.51,.76,2.25,1.15l-2.14,14.36c-7.95-3.1-16.38-6.1-25.29-8.88,.74-4.96,1.48-9.92,2.21-14.89l3.1,.86,.76-5.13-2.64-1.2c1.24-5.09,4.86-9.06,9.48-10.22,2.72-.64,5.58-.35,8.13,.8,1.37,.84,2.59,1.89,3.64,3.11,4.96,5.78,3.93,13.47,3.64,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2444.91,1154.57c-.36,2.15-.71,4.3-1.07,6.45l2,.94-2.09,14.09c-6.81-3.27-14.13-6.54-22-9.72l2.15-14.49,2.71,.81,.82-5.53-2.64-1.2c1.35-4.93,4.93-8.63,9.31-9.46,2.22-.39,4.51-.09,6.56,.85,1.2,.84,2.26,1.85,3.16,3,4.7,5.9,3.3,13.57,2.92,15.39l-1.83-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2187.58,1190.57v.15l-2.91,.56,2.91-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2443.43,1226.49l-15.28,102.61c-1.38-.59-3.8-1.59-6.87-2.66-7.6-2.68-15.46-4.55-23.45-5.57-18.21-2.39-72.15-12.06-81.87-13.85-23.39-4.28-85.47-16.86-104.77-17h-7.17c-10.09,0-18.09,.3-23.48,.56-5.14,.24-7.93,.47-7.93,.47l14.83-99.49c86.9-15.06,176.33-2.83,256,35v-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2382.98,1193.92c-83-26.79-157.16-19.09-201.16-10.38l-1.31,8.83c17.41-5,128.05-32,269,39.13l1.21-8.16c-21.58-11.97-44.26-21.82-67.74-29.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2382.04,1200.24c-83-26.8-157.16-19.1-201.16-10.38l-1.31,8.82c17.4-5,128.05-32,269,39.14l1.21-8.17c-21.58-11.97-44.26-21.82-67.74-29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2320.28,1301.94l-19-2.83-18.59-2.77c2.83-16.67,5.54-33.5,8.15-50.51,.83-5.42,1.65-10.82,2.44-16.21l3.55,.53,1-6.71-3.61-.13c.08-.54,1.82-10.78,11.19-14.58,6.78-2.68,14.5-1.08,19.66,4.07,6.06,6,5.89,14.37,5.79,16.37l-3.1-.87-.88,5.92,3.16,.48c-.5,3.37-1.84,12.57-2.33,15.94-2.49,17.1-4.96,34.2-7.43,51.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2276.91,1295.47c-5.82-.79-11.76-1.68-17.81-2.65-5.26-.86-10.41-1.76-15.44-2.7,1.54-10.19,2.77-18.54,3.64-24.42,.55-3.72,.94-6.4,3.08-21.08,.8-5.53,1.61-11.06,2.42-16.6l4.06-.2,1.06-7.1-3.82-.25s4.57-21.8,23.2-14.62c1.73,.94,3.3,2.14,4.67,3.56,3.27,3.54,5.23,8.09,5.57,12.9l-3.22-.08-.94,6.31,3.16,.47c-.82,5.44-1.63,10.88-2.43,16.32-2.47,16.71-4.87,33.43-7.2,50.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2370.79,1245.57l-2.25,14.66c-2.43,15.93-4.84,31.86-7.21,47.78l-15.88-2.36-18.59-2.77c2.56-17,5.15-34,7.78-51l2.4-15.41,3.56,.53,.82-5.52-3.89-1c.28-.84,3.49-10.16,12.76-12.74,3.84-1.01,7.9-.76,11.58,.72,1.74,.92,3.32,2.12,4.67,3.56,5.82,6.26,5.07,14.81,4.86,16.74l-2.71-.81-1,6.71,3.1,.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2245.96,1227.81c-.87,5.66-1.73,11.33-2.58,17-2.23,15-4.35,29.9-6.37,44.69-4.72-.67-9.5-1.38-14.33-2.14-4.05-.67-8.05-1.33-12-2,1.94-12.86,3.88-25.72,5.81-38.57,.87-5.8,1.74-11.6,2.62-17.4l3.33-.71c.23-2.39,.44-4.78,.67-7.16h-2.82c.39-7.69,4.76-13.84,10.5-15.32,2.73-.63,5.59-.34,8.14,.81,1.36,.85,2.58,1.89,3.63,3.1,2.48,2.95,3.92,6.65,4.08,10.5h-2.42l-1.06,7.1,2.8,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2401.18,1250.14l-.82,5.52,2.25,1.14c-2.79,18.72-5.57,37.44-8.36,56.16l-12.78-1.9-13.16-2c2.27-15.6,4.56-31.2,6.87-46.8l2.2-14.89,3.1,.86,.77-5.13-2.65-1.2c1.24-5.1,4.87-9.07,9.48-10.23,2.73-.64,5.59-.35,8.14,.81,1.36,.84,2.59,1.89,3.63,3.1,5,5.79,3.93,13.47,3.64,15.27l-2.31-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2213.33,1230.21c-.9,5.77-1.8,11.54-2.71,17.32l-5.94,38c-10.08,0-18.07,.2-23.46,.41l7.82-52.5,2.94-.78,1.06-7.1-2.94,.77c.16-9.35,4.75-16.49,10.55-17.75,2.22-.43,4.52-.14,6.56,.85,1.19,.85,2.26,1.86,3.17,3,2.29,2.94,3.58,6.53,3.67,10.26l-2,.1-1.12,7.5,2.4-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2428.91,1261.57c-.35,2.16-.71,4.31-1.07,6.46l2,.94-7.89,52.92c-7.41-2.74-14.83-5.28-22.26-7.63l8.26-55.41,2.7,.81,.83-5.53-2.65-1.2c1.35-4.93,4.94-8.63,9.31-9.46,2.22-.4,4.51-.1,6.56,.84,1.2,.84,2.27,1.85,3.17,3,4.69,5.9,3.29,13.57,2.91,15.39l-1.87-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2210.91,1230.25h2.43c-.9,5.77-1.8,11.54-2.71,17.32-8.67,1.08-16.77,2.39-24.24,3.81l2.66-17.89,2.94-.78,1.06-7.1-2.94,.77c.16-9.35,4.75-16.49,10.55-17.75,2.22-.43,4.52-.14,6.56,.85,1.19,.85,2.26,1.86,3.17,3,2.29,2.94,3.58,6.53,3.67,10.26l-2,.1-1.15,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2243.14,1227.79h2.82l-2.58,17c-9.44,.38-18.43,1.08-26.91,2,.87-5.8,1.74-11.6,2.62-17.4l3.33-.71c.23-2.39,.44-4.78,.67-7.16h-2.83c.4-7.69,4.77-13.84,10.51-15.32,2.73-.63,5.59-.34,8.14,.81,1.36,.85,2.58,1.89,3.63,3.1,2.48,2.95,3.92,6.65,4.08,10.5h-2.42l-1.06,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2286.53,1229.01l-2.43,16.32c-11.74-.76-23-1-33.73-.71,.8-5.53,1.61-11.06,2.42-16.6l4.06-.2,1.06-7.1-3.82-.25s4.57-21.8,23.2-14.62c1.73,.94,3.3,2.14,4.67,3.56,3.27,3.54,5.23,8.09,5.57,12.9l-3.22-.08-.94,6.31,3.16,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2330.06,1234.7c-.78,5.33-1.56,10.65-2.33,15.94-4.91-.88-9.91-1.68-15-2.39-7.44-1.04-14.72-1.85-21.85-2.42,.81-5.4,1.63-10.8,2.44-16.21l3.55,.53,1-6.71-3.61-.13c.08-.54,1.82-10.78,11.19-14.58,6.78-2.68,14.5-1.08,19.66,4.07,6.06,6,5.89,14.37,5.79,16.37l-3.1-.87-.88,5.92,3.14,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2367.69,1244.74l3.1,.87-2.25,14.66c-10.67-3.13-22-6-33.9-8.32,.81-5.14,1.61-10.28,2.4-15.41l3.56,.53,.82-5.52-3.89-1c.28-.84,3.49-10.16,12.76-12.74,3.84-1.01,7.9-.76,11.58,.72,1.74,.92,3.32,2.12,4.67,3.56,5.82,6.26,5.07,14.81,4.86,16.74l-2.71-.81-1,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2403.49,1250.88l-2.31-.74-.82,5.52,2.25,1.14-2.14,14.37c-7.95-3.11-16.39-6.1-25.29-8.88,.73-4.97,1.46-9.94,2.2-14.89l3.1,.86,.77-5.13-2.65-1.2c1.24-5.1,4.87-9.07,9.48-10.23,2.73-.64,5.59-.35,8.14,.81,1.36,.84,2.59,1.89,3.63,3.1,4.96,5.79,3.93,13.47,3.64,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2428.91,1261.57c-.35,2.16-.71,4.31-1.07,6.46l2,.94-2.1,14.09c-6.8-3.27-14.13-6.54-22-9.73l2.16-14.48,2.7,.81,.83-5.53-2.65-1.2c1.35-4.93,4.94-8.63,9.31-9.46,2.22-.4,4.51-.1,6.56,.84,1.2,.84,2.27,1.85,3.17,3,4.69,5.9,3.29,13.57,2.91,15.39l-1.82-1.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 2299.14,
    y: 1161.22,
    width: 6.26,
    height: 282.72,
    transform: "translate(674.42 3387.6) rotate(-81.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2298.44,
    y: 1167.23,
    width: 5.87,
    height: 282.72,
    transform: "translate(667.72 3391.83) rotate(-81.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2323.91,1357.11c.32,.45,25-18.84,25-18.84l15.3,24.85-22.21,18.85-18.09-24.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2334.64,1357.13c.19,.25,14.37-10.84,14.37-10.84l8.8,14.29-12.78,10.85-10.39-14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2260.42,1347.65c.33,.44,25-18.85,25-18.85l15.3,24.85-22.21,18.86-18.09-24.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2268.98,1348.84c.19,.25,14.37-10.84,14.37-10.84l8.8,14.29-12.77,10.85-10.4-14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2171.44,1336.36c.17,.43,16-20.17,16-20.17l7.61,23.7-14.36,20-9.25-23.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2176.47,1337.03c.09,.24,9.21-11.61,9.21-11.61l4.38,13.64-8.26,11.52-5.33-13.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2208.62,1341.91c.25,.43,20.39-19.53,20.39-19.53l11.37,24.26-18.2,19.46-13.56-24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2215.37,1342.83c.15,.25,11.73-11.23,11.73-11.23l6.54,14-10.46,11.19-7.81-13.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2384.45,1368.11c.25,.43,20.39-19.53,20.39-19.53l11.37,24.26-18.19,19.46-13.57-24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2393.35,1367.86c.14,.24,11.73-11.24,11.73-11.24l6.54,14-10.47,11.19-7.8-13.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2221.23,1491.05l24.13-135.36-5.13-2.74,1.27-8.52,5.42,.81s4.27-28.66-15.14-33.93c0,0-24.44-6-28.84,26.19l4.65,.69-2.22,9.57-3.87-.58-21.35,143.29-14.72-2.19,28.61-144.19-4.23-.86,3.23-8.4,3.88,.58s-.46-26.19-10.74-28.91-17.64,22.7-17.34,28.69l3.54,.13s-.47,5.86-.53,6.25-3,1.53-3,1.53l-21.24,142.52-11.23-1.67,22.61-141.13-3.74-4.12,.75-5,3.6-.26,6.75-45.31,270,40.23-7.16,48,3.87,.57-1.56,10.46-6,.68-17.31,116.18-11.62-1.73,17-114.24-3.24-4.84,1.38-9.29,4.26,.63s12.55-23.07-9.87-34.72c0,0-21.18-4-24.19,26.87l2.32,.35-1.33,8.91-3.87-.58-18.75,125.86-12.73-2.29,19.19-123.42-3.76-1.36,3.11-10.22,3.48,.52s8-26.92-19-34.51c0,0-26.84-3.2-29.73,26.85h2.77l-1.21,8.14-3.49-.52-19.85,133.22-11.62-1.73,19.47-131.28-4.64-.69,1.5-10.07,3.87,.58s3.3-32.76-22.94-34.69c0,0-23.7-.37-27.06,24.86l3.37,1.29-2.22,9.57s-4.78,2.85-4.55,1.3-19.15,136.5-20.31,136.32-12.7-2.29-12.7-2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M3197.45,1458.16l-524.87,181.49s-150.88-151-137-144.43,630.86-53.44,630.86-53.44l31.01,16.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M3197.81,1455.83l-525.9,180.44,324.19,352.76c189-195.57,289.71-390.13,240.69-489.9-7.55-15.44-19.67-30.56-38.98-43.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M3227.71,1359.88l-68.91,69.69,70.49,52.06s104.57-91.19,97.89-92.81-99.47-28.94-99.47-28.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M3337.79,1633.3c6.14-9.8-209,498.37-209,498.37l191,198.71,21.49-49.21-22.28-27.6,21-47.32-22.13-27.14,21.6-49.07-17.46-22.47,18.78-61.56-16.78-25.84,23-51.66-15.49-31.71,19.68-48.62-12.65-28.95,21-53.76-15.16-21.41,22-52.71-19.49-23.27,21.85-51.52-30.96-23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2504.52,1456.99l22,36.79s643.82-60.1,642.11-61.23-56.9-15.18-55.16-16.45-608.95,40.89-608.95,40.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "3313.62 1401.71 3229.29 1481.66 3343.75 1624.66 3419.59 1552.76 3313.62 1401.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "3236.89 1494.34 2997.77 1993.46 3012.66 2009.16 3251.15 1506.66 3237.26 1492 3236.89 1494.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3327.06,1605.7c-71.05,170.09-142.1,340.18-213.15,510.27l14.89,15.7c71.49-170.52,142.99-341.04,214.48-511.55l-16.22-14.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "3251.15 1506.66 3327.06 1605.7 3113.93 2115.96 3012.66 2009.16 3251.15 1506.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3226.36,1361.17l-16.26,15.4,97.49,26.88h0c37.16,50.93,74.31,101.86,111.46,152.81l20.32-19.27-112.19-148.14h0l-100.82-27.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3188.43,1397.12l-16.25,15.45,97.49,26.87h0c37.16,50.93,74.31,101.86,111.46,152.81l20.32-19.26-112.19-148.15h0l-100.83-27.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M3306.4,1507.97l-30.84,30.54s14.43,20.84,15.32,20,33-29.34,32-30.39-16.48-20.15-16.48-20.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "3174.13 1435.31 2526.18 1496.11 2521.31 1482.83 3165.99 1431.21 3174.13 1435.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "3116.21 1415.88 2506.78 1464.79 2501.55 1453.85 3107.55 1412.17 3116.21 1415.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M3175.25,1437.46l-8.76,4.32s34.66,14.86,34.3,17.19,29.69,39.45,29.69,39.45l6.78-6.42-31.95-40.29-30.06-14.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M2635.22,1537.87l84.39,89,272,286.9,9.21-14.7s-273.38-285.61-270-284.8-84.84-78.63-84.84-78.63l-10.76,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M2706.63,1531.81l10.74-2.23,81.33,64.07,231.86,255.38s-6.23,17.84-9.21,14.7-236.2-257.24-236.2-257.24l-78.52-74.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M2765.67,1523.57c3.34,.81,84.75,56.83,84.75,56.83l198.38,225.5s12.19-11.56,7.86-13.42-193.42-220.25-193.42-220.25l-84.12-53.46-13.45,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M2841.91,1508.98c2.35-.24,74.47,48.7,74.47,48.7l165.53,190.94,6.14-9.8-157.91-188.25-74.83-46.37-13.4,4.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "2907.67 1494.3 2923.11 1491.6 2988.64 1530.87 3120.86 1683.88 3110.66 1697.53 2980.51 1538.58 2907.67 1494.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M2978.45,1484.86c4.69-.47,13.45-4.8,13.45-4.8l55.6,28.81,105.41,124.7-14.9,14.12-101-130.92-58.56-31.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "3050.94 1471.81 3062.04 1467.24 3106 1489.2 3178.29 1581.71 3169.8 1591.75 3096.52 1498.18 3050.94 1471.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3112.05,1457.57l11.11-4.57,35.29,18.24,49.55,60.39-10.83,10.27-47.21-60.63s-39.26-22.38-37.91-23.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "3155.46 2086.53 3336.69 2288.52 3345.9 2273.82 3158.26 2075.92 3155.46 2086.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "3174.15 2033.02 3336.88 2212.77 3345.46 2194.7 3179.66 2019.84 3174.15 2033.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "3194.27 1975.57 3337.44 2134.7 3344.66 2117.91 3202.69 1968.18 3194.27 1975.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "3341.06 2051.73 3217.14 1921.03 3228.88 1903.58 3349.91 2039.36 3341.06 2051.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3244.14,1856.64c4.34,2.51,102.17,116.54,102.17,116.54,0,0,8.49-10,7.5-11.08s-103.37-120.53-103.37-120.53l-6.3,15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3270.24,1800.74c1.36-1.29,79.34,91.8,79.34,91.8l5.87-15.5-81.68-91.08-3.53,14.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3290.72,1745.57c13.56,7,69.07,73.7,69.07,73.7l6.86-14.46-69-75.81-6.93,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3317.17,1682.44l45.52,58.48s13.54-12.84,9.21-14.69-49.54-56.15-49.54-56.15l-5.19,12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3337.77,1633.32l28.82,30.34,4.51-14.22-27.8-29.32-5.53,13.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "3226.07 1474.78 3189.5 1509.45 3198.43 1518.87 3156.45 1558.68 3166.38 1569.15 3125.75 1607.67 3133.69 1616.04 3093.06 1654.56 3103.98 1666.08 3060.65 1707.17 3068.59 1715.55 3023.9 1757.92 3032.83 1767.34 2990.85 1807.15 3000.78 1817.62 2958.79 1857.42 2967.73 1866.85 2923.04 1909.22 2998.49 1988.8 3240.96 1490.48 3226.07 1474.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M2605.07,1568.45l39.27-37.23,26.8,28.26,39.27-37.24,31.38,26.31,34.54-32.74,33.19,21.85,40.83-38.72,33.71,22.62,35.52-33.68,32.09,20.38,35.26-33.43,32.38,18.9,35.73-33.87,36.12,21.37,31.54-29.9,34.76,18.9,28.44-27-12.64-7.91-638.62,58.81,70.43,74.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "1801.84 778.13 1806.87 779.7 1852.34 669.67 1846.75 664.6 1801.84 778.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1587.97 519.04 1602.12 517.94 1600.8 509.8 1583.73 514.95 1587.97 519.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1575.84,503.09l27.51,.33,4.31-10.25-18.61,3-16.29,2.64,1.91,4.46,1.17-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1585.16,457.41c5.04,5.08,10.25,10.21,15.62,15.38,4.75,4.52,9.46,8.93,14.13,13.24l8.55-6.16c-6.25-4.08-12.88-8.2-19.9-12.3-6.27-3.66-12.39-7.05-18.36-10.16h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1639.54,431.89s-3.85,35.25-2.72,42.23l10.66-.53s-4.49-35.09-7.94-41.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1668.39,477.37s27.68-35.52,27.3-37.85c0,0-25.85,17.32-37.74,32.38l10.44,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1675.34,483.41s24.46-11.12,46.19-17c0,0-36.92,22.69-42.55,24.8l-3.64-7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1680.11,498.16s35.1-4.49,49.62-3.26c0,0-48.11,12.56-49.46,11.59l-.16-8.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1605.77,525.71c-5.18-5.57-6.92-13.52-4.56-20.75,3.94-12.58,13.47-20.09,14.44-21.44s22.18-17.92,42.3-11.62,20.28,14.67,20.28,14.67c0,0,6.74,14.81,4.18,19.81s-6.73-13.43-6.73-13.43l-12.95-6.26-18-.66-18.43,4.17s-10.88,6.54-10.69,7.7-9.84,27.81-9.84,27.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1609.63,527.47s1.06,21.32-5,28.27,44.33,52.52,79.91,47.36l16.42-12.81s-12.66-26.6-12.06-30.28,3.49-.57,1.19-7.36-4.39-12.42-6.31-16.89-1.54-2.13-.34-9.49-5.52-20.6-5.52-20.6l-68.29,21.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1629.28,552.95c1.56,4.95,1.99,10.17,1.28,15.31-1,6.54-3.33,8.68-3,11.22,.7,4.69,10.6,9.87,50.91,12.06-5.21-12.09-7.34-25.28-6.21-38.39-2.04,1.09-3.84,2.6-5.26,4.43-2.14,2.79-2,4.57-3.58,6-2.56,2.24-7,.85-11,0-8.36-1.93-16.23-5.54-23.14-10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1619.04,504.46c-2.87,8.36-3.48,17.33-1.77,26,3.95,19,20.91,40.2,37.13,37.57,16.71-2.7,27.17-23.9,23.38-47.36-1.78-11-6.36-20.49-12.45-27.24l-46.29,11.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "1764 706.65 1786.57 646.88 1846.75 664.6 1803.08 778.76 1784.99 777.28 1764 706.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1486.49,339s.29-17.3-.28-20.79,36.52-17.84,57-9.22l7.85,19-64.57,11.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1642.85,1086.82s-4.53,16.26-5.32,18.77-8.84,26.5-10.79,29.21-8,9.65-6.27,13,31-7.41,31-7.41l204.79-33.14c1.16-.19,3.49-.57,2-2.71s-4.06-2.92-4.25-4.09-3.08-4.27-3.46-6.6-1.66-17.64-2-20-11-53.14-12.34-54.11-.57-3.49,0-7.17,1.57-5,.63-10.85-13.54-46.76-12.56-48.11-.38-2.33,1.95-2.71,1.37-3.63,.91-7.82-7.19-16.23-7.19-16.23l-72.17,18.84-36.75,68-68.18,73.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1768.33,939.96s1.29,15.31,9.43,14,21.39-15.4,27.21-16.34,8.11,5.85,17,9.19,3.74-13.74,3.37-16.07-1.54-2.14,2.73-5.22-.46-25-7.91-48.86c.03-3.56-.14-7.12-.53-10.66-.56-3.49-19.51-54.15-19.1-59s6.61-3.45,7.8-10.81,3.79-20.91,2.43-21.88l-3.9,5.4-17.42-4.34s-19.1-59-20.64-61.13,6.26-13,5.32-18.77-2.86-10.28-.31-16.67l2.55-6.38s-16.22-11.7-22.23-11.92c0,0-2.51-.79-3.45-6.61,0,0-5-8.74-7.7-10.69s-4-10.09-4-10.09c0,0-1.63-24.81-18.45-32.84,0,0-13.37-1.42-16.64-6.86s-19.93-5.13-34.87-1.52c0,0-6.64,.82-7.58-.09l106.89,348.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1772.15,788.31c7.03,51.42,8.35,103.46,3.92,155.17l-2.18,8.71s-15.16,9.62-16.92,13.48c-1.06,2.34-2.13,4.68-2.2,6.59-.13,1.21,.39,2.39,1.38,3.1,2.71,2,14.91,3.56,17.61,5.51s6.57,3.71,5.78,6.22-8,9.65-10.13,11.19-42,28.29-42,28.29c0,0-8.75,5-11.86,7.89s-11.86,7.89-12.65,10.4c-.25,.82-1,3-2.09,5.63-2.19,5.6-5.52,13.48-7.5,16.22-2.93,4.06-27.24,23.51-27.24,23.51l-21.54,7.07s-5.22-2.73-4.44-5.25,2-2.7,.6-3.68-2.7-2-3.08-4.28-2.67-9.12-1.5-9.3,2.92-4.06,2.73-5.22l-.75-4.66c-.21-2.39-.21-4.78,0-7.17-.93-1.78-1.64-3.67-2.1-5.62-.38-2.33-11.25-40-.61-77.51-1.94-2.75-3.61-5.68-5-8.74-1.92-4.47-3.46-6.61-.91-13s2.92-4.06,5.32-18.77c0,0-3.2-19.78-6.09-22.89-2.4-2.59-3.3-11.17-3.77-15.34-.09-.86-.16-1.53-.22-1.93-.38-2.32,1.19-7.35-2.07-12.79s-7.11-14.38-7.48-16.7l-1.51-9.31c-.19-1.16-4.05-2.92-4.43-5.25s-3.08-4.28-3.46-6.61c-.39-4.39-.3-8.8,.26-13.17,.78-3.43,1.83-6.8,3.15-10.06,0,0,5.63-2.11,6.82-9.46s-1.66-17.64-5.53-19.41l-1-.42c-3.33-1.46-5.62-2.09-7.75-1.75-.75,.12-2,.44-3.4,.68-2.94,.49-6.72,.6-8.8-2.28-3.08-4.28-4-10.1-4.77-14.75s11.05-42.38,14.39-51.28-9-18.84-9-18.84c0,0-4.81-7.58-3.24-12.61,0,0-1.18-1.65-5.68-3-.61-.19-1.3-.38-2.05-.54-5.05-1.21-8.95-5.23-10-10.32-.3-1.65-.48-3.32-.53-5-.09-2.91,.58-5.8,1.95-8.37,2.74-5.22-1.32-8.15-1.32-8.15-.22-2-.15-4.02,.22-6,.6-3.68,2.55-6.38,.82-9.69s-2.67-9.11-5.18-9.9-4.84-.41-9.28-5.66c-1.34-1.52-2.8-2.93-4.36-4.23-1.19-1.14-1.91-2.32-2.21-5.13h0c-.07-.77-.13-1.64-.14-2.68,0,0,.78-2.51-2.11-5.63-.52-.55-1.38-1.47-2.46-2.68h0c-5-5.6-14.3-17.66-12.48-30.71,0,0,4.06-41.26,15-47.79,0,0,.39,39.33,16.62,51,0,0,8.14-1.31,13.27-21.25s6.93-31,6.93-31c0,0-2.1-5.63-2.29-6.79s-3.26-6.27-3.45-6.59c.37,.06,7.51,1.43,13.7,10.9,6.35,9.72,.15,8.33,8.42,22.52,4.42,7.82,9.23,15.4,14.42,22.73,6.26,8.53,15.26,14.67,25.5,17.37,16.76,3.81,32.55,11.04,46.39,21.24,7.18,5.4,13.78,11.54,19.68,18.31,11.32,12.59,28.94,34.9,46,70.16,8.82,31.26,15.46,63.09,19.88,95.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1533.03,334.57l-26.76,4.33-.63,10.84,4,10.1,2.32-.38,8.92,55.1c.94,5.8,6.4,9.74,12.2,8.8,5.8-.94,9.74-6.4,8.8-12.2l-8.92-55.1,3.49-.56,.63-10.85-4.05-10.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1485.74,337.39s28.4-23.7,65.15-10.54c0,0-2.17,8.71-17.11,12.32s-45.19,8.51-48-1.78h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1538.15,358.76s-5-1.57-7.17,0-3.71,6.57-2.36,7.54,7,6.23,7,6.23l6.18,38.2s.07,8.38-5.91,11.72-13-3.21-13-3.21c0,0,6.52,62.74,16.7,81.39,0,0,7.79,33.36,6.4,39.56s11.63,42.29,19.58,39.81,12.08-13.9,12.08-13.9l7.9-32.32-.9-13s-3.65-7.77-5.75-13.4-6.1-22.89-6.85-27.54-20.64-61.14-20.64-61.14c0,0-1.28-15.31-1.85-18.8s4.81-29.44-11.41-41.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1515.85,361.17l-10.85-.63s-2.51-.78-2.73,5.22,1.31,8.14,3,11.45c1.31,2.49,2.15,5.2,2.48,8,.38,2.33-3.49,.57,1.13,7,4.62,6.43,4.81,7.58,7.52,9.53s6.57,3.72,7.73,3.53,3.9-5.41,4.31-10.25,.22-6-1.32-8.15,.79-2.51-.34-9.49-2.59-16.36-10.93-16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1501.03,306.29c-1.77-1.07-4.24-3.09-7.7-10.69-3.91-8.7-6.23-18.03-6.85-27.55,0,0,9.28,5.66,9.65,8s-.34-9.5-5.94-14.56-8.67-9.34-6.53-10.88c0,0-.41,4.84,6,7.39s9.84,9.15,9.84,9.15c0,0-2.29-6.79-1.51-9.3s3.75-13.74,1-15.69c-.36-.26-.49-.43-.46-.49s8.36,8.1,10.64,19.13c1.09,5.31,.6,10.69,3,11.45,.8,.16,1.62,.02,2.33-.38,2.77-1.21,3.69-4.5,3.9-5.4,1.22-5.16-1.12-7-2.07-12.8-.38-2.33,2.36-7.55,2.74-5.22s1.13,7,4,10.09,8.3,7,8.27,14.19-1.42,13.36-2.4,14.71-.6,3.68,1.73,3.3,3.71-6.57,3.71-6.57c-.23-1.26,.6-2.46,1.86-2.69,.03,0,.06-.01,.09-.01,0,0-1.16,.19-.78,2.52s3.08,4.27-.82,9.68c-3.09,4.28-6.19,8.6-12.46,11.57-2.06,1-12.88,6.11-21.24,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1519.51,305c.75-.88,1.7-2.38,2.2-7,.54-5.3,.12-10.66-1.23-15.81,0,0-3.92,4.64-3.71,5.94s-1.49-5.1,.59-8.77,3-6.48,1.54-6.92c0,0,1.07,2.49-1.86,5-1.87,1.76-3.13,4.07-3.6,6.59,0,0,0-4-.84-5.2s-4.41-6.63-3.32-8.14c.14-.19,.18-.31,.15-.33-1.88,3.7-2.66,7.87-2.26,12,.35,3,1.56,5.78,.4,6.61-.4,.21-.86,.29-1.3,.21-1.27-.25-2.37-1.05-3-2.18-1.56-2.52-.63-3.89-1.16-7.15-.21-1.3-2.58-3.58-2.37-2.28s.63,3.9-.35,6.06-3.17,5.18-1.89,9,3.11,6.83,3.87,7.38,1,1.84-.34,2-3.13-2.82-3.13-2.82c-.1-.71-.75-1.2-1.46-1.1-.02,0-.04,0-.05,0,0,0,.65-.11,.87,1.19s-.88,2.81,2.14,5c2.39,1.73,4.79,3.47,8.64,3.94,1.29,.13,7.93,.93,11.47-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1645.84,492.96c2.51,3-1.16,9.86-2.48,12.34-7.24,13.49-22,20.78-34.51,24.69-.24-3.5,.04-7.02,.84-10.44,1.77-6.66,5.27-12.74,10.14-17.61,3.01-3.26,6.65-5.88,10.69-7.7,.86-.37,12.11-5.15,15.32-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1646.4,496.45c5,8.12,13.61,12.13,13.61,12.13,4.77,2.2,9.94,3.39,15.19,3.5l4.65-.75c-.39-1.8-3.25-13.79-14.76-19.68-5.05-2.53-10.73-3.49-16.33-2.75-.7,.41-3,1.86-3.28,4.23-.08,1.18,.25,2.35,.92,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1680.1,512.13l2.17-1.37s3.43-23.13-20-27.54c0,0-33.41-6.91-53.48,16.86,0,0-11.71,16.26-1.29,28.93l2.18-.35s2.74-21,21.9-28.17c0,0,21.33-8.58,34.12-3.47,0,0,11.13,2.3,14.4,15.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1822.59,692.39c.31,.84,.84,1.58,1.54,2.14,.41,.38,.86,.72,1.35,1,3.1,1.8,5.19,4.41,7.49,5.12,.33,.1,.39,0,.42,0,.23-.38-2.78-3.83-5.2-3.17-.83,.32-1.57,.85-2.14,1.54-.58,.6-.87,.9-1,1.36-.22,1,.65,1.5,1.73,3.3,.81,1.41,1.46,2.9,1.92,4.46l2.89,3.12-4.06-2.93c-1.02-.85-2.43-1.08-3.67-.6-1.04,.55-1.76,1.55-1.95,2.71-.34,1.69,1.62,2.67,2.1,5.63,.19,1.16,3.08,4.27,3.08,4.27l.57,3.49s-5.7,16.45-6.87,16.64,17.27-4,24-29c0,0,1.38-6.19,3.52-7.73s1.57-5,2.55-6.38c.29-.39,.5-.83,.63-1.29,.19-.78,.19-1.61,0-2.39-.59-2.27-4.38-5.39-7.33-8.37s-4-4.77-6.94-6c-.81-.34-1.66-.6-2.52-.78-1.74-.36-3.53,.4-4.47,1.91-.41,.9-.41,1.93,0,2.83,.14,.26,.34,.49,.58,.66,1.35,1,2.52,.79,4.06,2.93s4.43,5.25,4.43,5.25c1.43,1.9,2,3,1.73,3.3s-2.1-.53-5.22-2.73l-5.22-2.74c-1.51-.94-3.23-1.48-5-1.57-.4-.03-.8,.03-1.17,.18-1.41,.72-2.16,2.29-1.83,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1639.6,830.65c-7.41,11.12-12.05,42-14.61,65.22-.09-.86-.16-1.53-.22-1.93-.38-2.32,1.19-7.35-2.07-12.79s-7.11-14.38-7.48-16.7l-1-6.4c1.17-6.79,3.33-13.37,6.39-19.54,3.13-6.26,6.16-9.93,8.59-13.33,6.61-9.25,9.42-17.39,14.1-30.94,10.9-31.57,9.48-70.54,9.27-75.52,6.87,13.21-.48,93.2-12.97,111.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1603.58,659.78c-9.86,13.67-20.32,17.34-22.29,27.17-.61-.19-1.3-.38-2.05-.54-5.05-1.21-8.95-5.23-10-10.32-.3-1.65-.48-3.32-.53-5,11.32-7.74,35.55-27.27,34.32-51.82-.03,.01,11.28,25.64,.55,40.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1649.43,682.72c-.07,8.67-1,29-18.45,43.07-19.65,15.87-21.3,56-21.42,65-3.33-1.46-5.62-2.09-7.75-1.75-.75,.12-2,.44-3.4,.68-2.13-6-3.65-17.66-2.69-23.57,1.2-7.36,24-43.29,38-52.72,10.26-6.86,14.54-23.05,15.71-30.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1649.43,682.72c0-2.34,0-3.84,.18-4.12s.3,1.31-.18,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1584.59,579.28c-1.39,6.2,3.61,14.94-7.69,26.32-8.47,8.55-19,12.71-25.37,13.5l-2.21-5.13h0c-.07-.77-.13-1.64-.14-2.68,0,0,.78-2.51-2.11-5.63-.52-.55-1.38-1.47-2.46-2.68,7.77,1.18,19.39,1.64,25.17-4.57,9.15-9.84,15-25.12,14.47-28.61s1.72,3.29,.34,9.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1779.54,987.09c.29,3-2.41,5.64-10.13,11.19-2.13,1.54-42,28.29-42,28.29,0,0-8.75,5-11.86,7.89s-11.86,7.89-12.65,10.4c-.25,.82-1,3-2.09,5.63-1.22-15.22-1.5-30.5-.82-45.75,.16-4.4,1.25-15.37,4.08-30.19,6-31.38,12.47-38,18.06-61.74,2.89-12.27,8.26-35.08,4.17-62.76-1.95-13.2-4.84-19.28-10.41-37.74-.56-1.87-3.77-11-6.57-23.46-1-4.59-2.8-13.15-2.24-13.3s3.44,10.15,6.69,19.22c9.08,25.31,18.41,29.76,25.93,49.53,5.24,14.08,8.44,28.84,9.48,43.83,1.35,19.51-.87,42.28,.29,60.85,0,0,.84,13.33,5.28,23.28l1.38,3.1c4.37,.79,22.72,4.37,23.41,11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1649.97,793.27s-3.85,24.41-.49,63.47-5.38,81.72-11.28,93.8,12.07-3.6,14.64-26.21,6.92-63,1-88.92-3.87-42.14-3.87-42.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1647.22,1052.05c1.8,7.6,23.37-49.86,31.84-84.56s11.54-92.26,7.42-116.93l-4.12-24.66s-.23,84-8.45,110.76-32.09,92.52-26.69,115.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1592.85,555.57c.26,1.55,4.12,24.67-4.36,40.35s-25.43,28-28.51,28.53-3.6,6.94,1.28,7.71,6.69,2.06,15.93-9,19.27-17.48,19.78-33.41-4.12-34.18-4.12-34.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1545.77,535.73c-.17-2.4-3,4.45-3.29,12.42s8,28.78,16.71,33.66,12.66-6.38,10.19-3.84-5.9,7.35-10.1-2-11.49-12.83-13.51-40.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1624.21,591.57s17.75,58.84,2.6,82-28.26,39.58-30.82,52.69-2.57,13.1,6.16-1,26-24.94,30.82-52.69,6.41-56.61-8.76-81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1783.13,954.87s14.69,116.4,22.4,134.13,16.63,23.7,16.63,23.7c0,0-28.19,2-31-24.46s-17.11-133.85-17.11-133.85l9.08,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1707.35,1042.01c.26,1.54,10.29,23.64,3.61,40.6s-6.21,49.47-19.28,51.21-6.34,1-6.34,1c0,0,18.18-20.88,19.2-43.24s-.27-39.57,.24-46,2.57-3.57,2.57-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1808.06,952.29s9.78,58.59,10.56,82.23,4.64,65.79,11.58,69.38,6.69,2.05,4.89,.77-8-9.76-9-15.93-4.65-75.29-7.22-90.71-10.81-45.74-10.81-45.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1687.32,1073.88c.25,1.54-1.29,11.3-6.42,28s-14.38,27.76-20.29,30.33-1.54,.26,4.88-8.74,14.89-35,15.27-41.78c.1-3.81,2.82-7.05,6.56-7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1748.4,1012.48s3.93,52.13,4.19,63.18,5.91,16.44,5.91,16.44c.57-8.41,.23-16.85-1-25.18-2.06-12.34-4.64-46.77-5.41-51.4s-1.7-.69-3.69-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1788.96,667.05l33.41,10.27-2.57,3.6-33.67-11.81,2.83-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1785.62,675.57l33.41,10.27-2.57,3.6-33.67-11.87,2.83-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1782.54,685.57l33.37,10.26-2.31,5.14-33.89-13.4,2.83-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1778.17,697.38l33.41,10.27-2.57,3.6-33.66-11.81,2.82-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1585.07,513.35c2.44,5.53,4.19,11.35,5.2,17.31,1.29,7.71-2.05,25.7-3.07,29s-.52-3.09,2.05-6.68,1.8-8.23,3.08-19.54-1.29-17.21-2.83-17-5.33-3.82-5.33-3.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1682.81,619.8c-.26-1.54-20.53,95.35-16.15,121.56s7.2,24.15,10,60.13c2.8,35.98,2.83,16.95,2.57,15.41s-.78-33.15-4.9-57.82-1.05-82.23,2.29-90.71,7.48-40.86,6.19-48.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1643.29,591.93s13.69,20.3,11.13,42.91-12.32,49.6-14.89,53.2,6.42-9,10-15.93,8.73-33.16,8.21-45.75-3.2-19.27-14.45-34.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1624.4,
    y: 1138.3,
    width: 243.24,
    height: 38.7,
    transform: "translate(-166.82 303.38) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1614.65,
    y: 1121.83,
    width: 257.06,
    height: 20.73,
    transform: "translate(-162.67 302.57) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1628.22,
    y: 1173.22,
    width: 283.31,
    height: 229.86,
    transform: "translate(-183.01 299.2) rotate(-9.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1603.06,
    y: 1174.25,
    width: 302.46,
    height: 39.6,
    transform: "translate(-168.65 296.51) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "1931.69 1338.94 1633.13 1387.39 1630.01 1367.92 1928.56 1319.47 1931.69 1338.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1616.53,
    y: 1213.08,
    width: 283.86,
    height: 9.67,
    transform: "translate(-176.58 306.26) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1641.34,
    y: 1363.05,
    width: 283.86,
    height: 6.91,
    transform: "translate(-200.71 312.37) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1622.36,
    y: 1142.62,
    width: 243.24,
    height: 5.53,
    transform: "translate(-164.83 302.88) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1690.29,
    y: 1255.76,
    width: 34.55,
    height: 89.83,
    transform: "translate(-190.91 299.01) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1690.29,
    y: 1255.76,
    width: 34.55,
    height: 89.83,
    transform: "translate(-190.91 299.01) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "1717.19 1253.56 1731.98 1342.17 1725.85 1343.2 1712.08 1260.72 1684.13 1265.39 1683.11 1259.25 1717.19 1253.56"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1743.43,
    y: 1246.9,
    width: 34.55,
    height: 89.83,
    transform: "translate(-188.72 307.64) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "1770.35 1244.69 1785.15 1333.29 1779.01 1334.32 1765.24 1251.85 1737.3 1256.51 1736.27 1250.38 1770.35 1244.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1796.62,
    y: 1238.01,
    width: 34.55,
    height: 89.83,
    transform: "translate(-186.53 316.27) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "1823.52 1235.81 1838.31 1324.42 1832.18 1325.44 1818.41 1242.97 1790.46 1247.63 1789.44 1241.5 1823.52 1235.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "1648.98 1424.11 1626.51 1482.52 1961.85 1426.52 1927.57 1375.37 1648.98 1424.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1630.81,
    y: 1453.94,
    width: 339.98,
    height: 80.3,
    transform: "translate(-221.49 317) rotate(-9.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1022.84,411.35s-16.12-2.52-32,5c-16.51,6.06-26,19.35-26,19.35-38.12,58.16,23.62,83.68,23.62,83.68,5.26,.9,37.93,14.24,37.93,14.24l11.61-4.88h.08l11.61-4.88s13.34-32.67,16.38-37c0-.06,25-62.02-43.23-75.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1016.34,414.09s-13.26-3.74-25.51,2.28c-12.87,4.54-19.48,16.61-19.48,16.61-26.2,53.15,25.82,82.76,25.82,82.76,4.32,1.29,31.83,16.8,31.83,16.8l9-3.78h.06l9-3.78s8.18-30.5,10.29-34.49c.02-.03,15.28-57.92-41.01-76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1009.04,417.15s-10-5.09-18.21-.78c-8.8,2.83-12.19,13.55-12.19,13.55-12.82,47.53,28.29,81.72,28.29,81.72,3.28,1.73,25,19.67,25,19.67l6.09-2.56h0l6.09-2.55s2.39-28.07,3.46-31.62c.04,0,4.39-53.31-38.53-77.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1000.56,420.71s-6.28-6.66-9.73-4.34c-4.06,.84-3.71,10-3.71,10,2.72,41,31.15,80.52,31.15,80.52,2.07,2.23,17.07,23,17.07,23l2.69-1.13h0l2.69-1.13s-4.33-25.24-4.48-28.29c.02-.02-8.33-47.98-35.68-78.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1041.66,
    y: 530.73,
    width: 0.82,
    height: 13.91,
    transform: "translate(-126.87 445.01) rotate(-22.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1051.6,559.87h0c-5.21,2.19-11.2-.26-13.39-5.47l-1.9-4.52,18.86-7.93,1.9,4.53c2.19,5.2-.25,11.19-5.46,13.38h-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1033.9,
    y: 542.98,
    width: 22.91,
    height: 3.68,
    transform: "translate(-129.43 447.45) rotate(-22.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1030.78,
    y: 535.21,
    width: 0.82,
    height: 13.49,
    transform: "translate(-119.09 726.1) rotate(-36.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1052.27,
    y: 525.98,
    width: 0.82,
    height: 13.49,
    transform: "translate(-68.98 166.92) rotate(-8.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1053.05,515.78l-34.92,15.11,6,6.81,29.78-12.51-.86-9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1017.22,457.57c-5.14,14.59-19.3,22.89-31.63,18.55s-18.15-19.69-13-34.28,19.3-22.9,31.63-18.55,18.14,19.65,13,34.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M3720.08,1098.86s-4.68-20-21-34.94c-14.87-16.37-34.84-21.14-34.84-21.14-85.8-16.94-86.35,67.09-86.35,67.09,1.44,6.55,1.33,50.92,1.33,50.92l11.18,11.24,.07,.07,11.18,11.23s44.37,.1,50.92,1.57c.02,0,84.04-.16,67.51-86.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M3713.82,1092.57s-1.92-17.21-14.72-28.65c-11.38-12.86-28.57-14.85-28.57-14.85-74.33-5.4-84.25,69.21-84.25,69.21,.55,5.65-4.52,45-4.52,45l8.67,8.71v.06l8.67,8.71s39.41-4.88,45.06-4.31c.05,.04,74.75-9.53,69.66-83.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M3706.8,1085.57s1.18-14.1-7.7-21.6c-7.46-8.92-21.56-7.8-21.56-7.8-61.45,7.53-81.87,71.6-81.87,71.6-.46,4.64-11.09,38.44-11.09,38.44l5.86,5.88h0l5.86,5.89s33.84-10.48,38.49-10.92c.03,0,64.19-20.13,72.01-81.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M3698.64,1077.32s4.79-10.48,.46-13.4c-2.9-4.34-13.4,.4-13.4,.4-46.49,22.56-79.11,74.37-79.11,74.37-1.63,3.47-18.73,30.76-18.73,30.76l2.59,2.6h0l2.59,2.6s27.37-17,30.85-18.59c.02,.02,52.02-32.35,74.75-78.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 3573.32,
    y: 1180.76,
    width: 17.49,
    height: 1.03,
    transform: "translate(209.45 2870.07) rotate(-44.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M3560.59,1202.57h0c-5.02-5.02-5.02-13.16,0-18.19h0l4.37-4.35,18.15,18.23-4.38,4.35c-5.03,4.97-13.13,4.96-18.14-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 3572.38,
    y: 1173.98,
    width: 4.63,
    height: 28.81,
    transform: "translate(202.57 2867.53) rotate(-44.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 3563.68,
    y: 1169.99,
    width: 16.97,
    height: 1.03,
    transform: "translate(724.76 3624.63) rotate(-58.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 3584.11,
    y: 1190.32,
    width: 16.97,
    height: 1.03,
    transform: "translate(-102.2 2011.39) rotate(-30.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M3612.65,1183.43l-34.11-33.55-5.12,10.17,28.67,28.81,10.56-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3663.61,1114.13c-19.44,.91-35.81-11.67-36.58-28.09s14.37-30.46,33.8-31.36,35.81,11.67,36.58,28.08-14.37,30.47-33.8,31.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1893.15,1225.33s-46.54,95.33-45.23,91.34,68.15-81.64,163.65-68c25.37,.75,50.22,7.4,72.58,19.41,22.94,12.38,42.66,29.97,57.57,51.35-12.82-30.7-25.64-61.4-38.47-92.11l-210.1-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1790.45,1426.44s155.63-216.17,181-496c0,0,25.41-238.46,27.36-240.43h0c.41-.1,2.37,7,5.06,17.75,.91,45.16,3.75,103.61,11.46,171.45,0,0,9.11,80,22.92,147.81,35,171.79,131.36,351,161.86,406l105.52,4c-7.8-9.87-19.27-24.77-32.37-43.45-29.89-42.6-50.65-79.72-97.49-171.4-35.17-68.85-52.76-103.28-57.75-116.27-18.13-47.15-26.82-86.39-39.66-159.63-17.3-98.72-26-148.08-34.61-230.58-10.21-97.2-19.87-231.33-18.74-396.39l-45.76,2.24c-.47,119.42-7.03,238.73-19.67,357.48-27,254.12-49.39,337.64-70.24,391.4-26.23,67.63-59.65,130.61-78.19,165.54-36.79,69.38-77.68,136.52-122.43,201.06l101.73-10.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1916.07,
    y: 963.29,
    width: 166.17,
    height: 15.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1921.8,
    y: 932.23,
    width: 156.62,
    height: 31.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M2177.74,1227.27l-359.08,1.94,17.19-36.88,324.7-1.94,17.19,36.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1835.85,
    y: 1141.86,
    width: 326.61,
    height: 27.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1988.12,
    y: 1235.97,
    width: 15.73,
    height: 2.58,
    transform: "translate(742.05 3222.81) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1980.28 1245.85 1979.06 1230.17 1981.63 1229.97 1982.85 1245.65 1980.28 1245.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1966.25 1247.94 1963.62 1230.53 1966.17 1230.14 1968.8 1247.54 1966.25 1247.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1952.46 1251.29 1948.14 1234.46 1950.63 1233.8 1954.95 1250.63 1952.46 1251.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1939.01 1255.85 1932.67 1238.39 1935.09 1237.48 1941.43 1254.94 1939.01 1255.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1925.99 1261.56 1917.2 1242.28 1919.54 1241.18 1928.33 1260.46 1925.99 1261.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1913.47 1268.32 1904.26 1248.74 1906.58 1247.61 1915.8 1267.19 1913.47 1268.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1899.01 1273.76 1888.48 1258.19 1890.8 1256.56 1901.34 1272.13 1899.01 1273.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1886.63 1281.39 1874.86 1266.9 1877.04 1265.08 1888.8 1279.57 1886.63 1281.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1876.42 1291.21 1865.56 1280 1867.4 1278.16 1878.25 1289.37 1876.42 1291.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2011.2 1244.8 2008.64 1244.55 2010.11 1228.9 2012.68 1229.15 2011.2 1244.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2025.2 1247.13 2022.66 1246.68 2025.57 1229.33 2028.11 1229.77 2025.2 1247.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2038.93 1250.71 2036.45 1250.01 2041.04 1233.26 2043.53 1233.96 2038.93 1250.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2052.31 1255.5 2049.9 1254.55 2056.53 1237.2 2058.93 1238.15 2052.31 1255.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2065.23 1261.43 2062.91 1260.29 2072.01 1241.17 2074.33 1242.31 2065.23 1261.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2077.63 1268.41 2075.33 1267.23 2084.86 1247.81 2087.17 1248.98 2077.63 1268.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2092 1274.09 2089.7 1272.42 2100.49 1257.03 2102.79 1258.7 2092 1274.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2104.26 1281.93 2102.11 1280.07 2114.12 1265.78 2116.26 1267.64 2104.26 1281.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2114.31 1291.92 2112.5 1290.05 2123.53 1279.03 2125.34 1280.89 2114.31 1291.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1865.47 1301.26 1859.07 1295.74 1860.73 1293.74 1867.14 1299.26 1865.47 1301.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2123.2,1273.93c-35-28.39-79.76-44.24-126.06-44.63-45.17-.39-89.35,14-124.39,40.64l-2.32-3.15c35.72-27.1,80.73-41.82,126.74-41.42,47.16,.4,92.78,16.55,128.45,45.48l-2.42,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2162.46,1359.26c-33.63-64.43-99.57-104.39-170-102.88-100.48,2.16-153.26,87.53-156.62,93.17l6.54-25c32.64-49.58,91.89-80,154.62-79.52,66.3,.57,126.63,34.69,157.47,89.07l7.99,25.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2171.67,1208.14l-6.42,6.42-8.55,8.57-1.85,1.84-1.32,1.3-3.29,3.29-1.81-1.87,1.45-1.45,3.16-3.15,1.84-1.84,8.56-8.56,1.84-1.84,.35-.35,4.83-4.83c.45,.82,.81,1.64,1.21,2.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2129.6 1229.38 2127.79 1227.51 2159.65 1195.68 2161.46 1197.55 2129.6 1229.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2108.97 1229.21 2107.16 1227.34 2139.02 1195.5 2140.83 1197.37 2108.97 1229.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2088.33 1229.03 2086.53 1227.16 2118.38 1195.33 2120.19 1197.2 2088.33 1229.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2067.7 1228.86 2065.89 1226.99 2097.75 1195.15 2099.56 1197.02 2067.7 1228.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2047.07 1228.68 2045.26 1226.81 2077.12 1194.98 2078.93 1196.85 2047.07 1228.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2026.43 1228.51 2024.63 1226.64 2056.48 1194.8 2058.29 1196.67 2026.43 1228.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2005.8 1228.33 2003.99 1226.46 2035.85 1194.63 2037.66 1196.49 2005.8 1228.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1985.17 1228.16 1983.36 1226.29 2015.22 1194.45 2017.03 1196.32 1985.17 1228.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1964.53 1227.98 1962.73 1226.11 1994.58 1194.27 1996.39 1196.14 1964.53 1227.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1943.9 1227.81 1942.09 1225.94 1973.95 1194.1 1975.76 1195.97 1943.9 1227.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1923.27 1227.63 1921.46 1225.76 1953.32 1193.93 1955.13 1195.79 1923.27 1227.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1902.63 1227.45 1900.82 1225.59 1932.68 1193.75 1934.49 1195.62 1902.63 1227.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1882 1227.28 1880.19 1225.41 1912.05 1193.57 1913.86 1195.44 1882 1227.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1861.37 1227.11 1859.56 1225.24 1891.42 1193.4 1893.23 1195.27 1861.37 1227.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1840.73 1226.93 1838.92 1225.06 1870.78 1193.22 1872.59 1195.09 1840.73 1226.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1820.1 1226.75 1818.29 1224.89 1850.15 1193.05 1851.96 1194.92 1820.1 1226.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1932.42,913.57l-5.92-2.6c28.37-66.58,53.45-597.2,53.7-602.55l6.44,.31c-1.02,21.84-25.39,537.13-54.22,604.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2067.04,914.67c-27.71-68.15-43.62-583.76-44.28-605.68l6.44-.2c.16,5.36,16.53,536.33,43.8,603.38l-5.96,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2017.91,904.35c-12.15-76.71-19.91-238.73-20-240.36v-.18l2.86-347.24,6.45,.06-2.85,347.17c.22,4.64,7.93,163.92,19.91,239.54l-6.37,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1980.42,904.69l-6.35-1.15c13.21-75.41,23.54-234.53,23.84-239.17l2.85-347.17h6.45l-2.86,347.45c-.1,1.68-10.53,163.54-23.93,240.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2001.77,
    y: 311.75,
    width: 3.17,
    height: 49.01,
    transform: "translate(1649.99 2336.66) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2001.18 358.29 1983.29 338.48 1985.66 336.26 2003.56 356.07 2001.18 358.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1984.17 356.88 1981.9 354.54 2000.11 336.35 2002.37 338.68 1984.17 356.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2000.1 337.35 1983.48 320.18 1985.78 317.88 2002.4 335.06 2000.1 337.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1984.28 337.26 1982.11 334.84 2000.3 317.96 2002.48 320.38 1984.28 337.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2007.41 358.34 2005.07 356.09 2023.28 336.58 2025.62 338.84 2007.41 358.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2024.48 357.25 2004.01 337.42 2006.23 335.05 2026.7 354.88 2024.48 357.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2008.83 337.43 2006.57 335.09 2023.47 318.2 2025.73 320.54 2008.83 337.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2024.65 337.6 2006.73 320.42 2008.94 318.03 2026.86 335.22 2024.65 337.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1868.02,1135.17l-5.87-2.71c32.28-72.17,48.57-151.31,62.94-221.13l6.31,1.34c-14.44,70.16-30.8,149.67-63.38,222.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1935.32,1132.44l-2.52-.67h-3.85c0-.65,.06-.84,1.05-3.89,18-55.33,31.49-125.14,38-196.57l6.42,.61c-6.55,71.9-20.15,142.23-38.29,198-.44,1.34-.73,2.19-.81,2.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1934.24 1107.64 1892.03 1065.34 1894.75 1062.54 1936.96 1104.84 1934.24 1107.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1883.41 1107.45 1881.36 1104.12 1946.53 1062.74 1948.58 1066.07 1883.41 1107.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1903.71 1134.74 1877.49 1108.47 1880.21 1105.67 1906.43 1131.94 1903.71 1134.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1895.39 1133.74 1893.34 1130.4 1931.99 1105.86 1934.04 1109.2 1895.39 1133.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1906.71,
    y: 1075.78,
    width: 3.93,
    height: 60.61,
    transform: "translate(786.31 3005.24) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1901.12,1131.48l-3.66-1.29c9.93-29.1,18.84-59,26.48-88.75,8.92-34.75,16.36-70.35,22.11-105.78l3.82,.64c-5.77,35.55-13.23,71.26-22.18,106.14-7.67,29.88-16.61,59.84-26.57,89.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2126.5,1137.37c-31.38-73.38-46.43-153.16-59.72-223.55l6.34-1.23c13.22,70,28.2,149.45,59.29,222.17l-5.91,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2059.26,1133.49c-.08-.33-.35-1.18-.77-2.55-17.22-56.09-29.67-126.63-35-198.63l6.43-.5c5.34,71.52,17.68,141.55,34.77,197.18,.94,3.07,1,3.26,1,3.91l-6.45-.06h3.23l-3.21,.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2060.74 1108.71 2058.07 1105.87 2100.97 1064.3 2103.64 1067.14 2060.74 1108.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2111.57 1109.39 2047.09 1066.91 2049.19 1063.61 2113.67 1106.09 2111.57 1109.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2090.82 1136.33 2088.15 1133.49 2114.8 1107.66 2117.47 1110.51 2090.82 1136.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2099.16 1135.47 2060.92 1110.27 2063.02 1106.97 2101.26 1132.17 2099.16 1135.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2084.7,
    y: 1077.3,
    width: 3.93,
    height: 60.61,
    transform: "translate(961.25 3184.72) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2093.47,1133.11c-9.48-29.36-17.92-59.47-25.1-89.48-8.37-35-15.25-70.84-20.44-106.5l3.83-.58c5.17,35.55,12,71.26,20.37,106.15,7.15,29.92,15.57,59.92,25,89.18l-3.66,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1830.29,1136.57l-.48,58.51,336.5,2.86,.48-58.52-336.5-2.85Zm6.32,5.85l323.76,2.75-.38,46.93-323.77-2.75,.39-46.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1991.36,
    y: 842.61,
    width: 15.07,
    height: 172.81,
    transform: "translate(1052.82 2919.9) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1844.08,
    y: 1153.93,
    width: 30.31,
    height: 3.87,
    transform: "translate(687.51 3005.15) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1867.07,
    y: 1154,
    width: 30.31,
    height: 3.87,
    transform: "translate(710.56 3028.41) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1890.58,
    y: 1154.35,
    width: 30.31,
    height: 3.87,
    transform: "translate(733.19 3052.06) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1913.62,
    y: 1154.46,
    width: 30.31,
    height: 3.87,
    transform: "translate(756.26 3075.42) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1936.69,
    y: 1154.58,
    width: 30.31,
    height: 3.87,
    transform: "translate(779.02 3098.61) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1960.04,
    y: 1154.86,
    width: 30.31,
    height: 3.87,
    transform: "translate(801.89 3122.22) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1983.23,
    y: 1155.03,
    width: 30.31,
    height: 3.87,
    transform: "translate(824.37 3145.39) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 2006.57,
    y: 1155.31,
    width: 30.31,
    height: 3.87,
    transform: "translate(847.24 3169) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 2029.79,
    y: 1155.51,
    width: 30.31,
    height: 3.87,
    transform: "translate(870.05 3192.42) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 2052.8,
    y: 1155.6,
    width: 30.31,
    height: 3.87,
    transform: "translate(892.77 3215.51) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 2076.36,
    y: 1155.97,
    width: 30.31,
    height: 3.87,
    transform: "translate(915.76 3239.44) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 2099.3,
    y: 1156.03,
    width: 30.31,
    height: 3.87,
    transform: "translate(938.82 3262.65) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 2122.78,
    y: 1156.37,
    width: 30.31,
    height: 3.87,
    transform: "translate(961.39 3286.26) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1971.21 964.62 1969.4 962.75 1996.71 935.46 1998.52 937.33 1971.21 964.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1996.47 964.84 1969.61 937.09 1971.45 935.25 1998.31 963 1996.47 964.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1998.29 964.85 1996.48 962.98 2023.79 935.69 2025.6 937.56 1998.29 964.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2023.55 965.07 1996.69 937.32 1998.53 935.48 2025.39 963.23 2023.55 965.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2025.37 965.08 2023.57 963.21 2050.87 935.92 2052.68 937.79 2025.37 965.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2050.63 965.3 2023.77 937.55 2025.61 935.71 2052.47 963.46 2050.63 965.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2052.45 965.31 2050.65 963.44 2077.95 936.15 2079.76 938.02 2052.45 965.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2077.71 965.53 2050.86 937.78 2052.69 935.94 2079.55 963.69 2077.71 965.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1944.13 964.39 1942.32 962.52 1969.63 935.23 1971.44 937.1 1944.13 964.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1969.39 964.61 1942.53 936.86 1944.37 935.02 1971.22 962.77 1969.39 964.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1917.05 964.16 1915.24 962.29 1942.55 935 1944.35 936.87 1917.05 964.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1942.3 964.38 1915.45 936.63 1917.29 934.79 1944.14 962.54 1942.3 964.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1914.58,
    y: 968.73,
    width: 14.42,
    height: 2.58,
    transform: "translate(935.04 2883.27) rotate(-89.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1919.76,
    y: 968.72,
    width: 14.42,
    height: 2.58,
    transform: "translate(940.52 2888.62) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1924.92,
    y: 968.78,
    width: 14.42,
    height: 2.58,
    transform: "translate(945.58 2893.84) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1930.06,
    y: 968.86,
    width: 14.42,
    height: 2.58,
    transform: "translate(950.25 2898.88) rotate(-89.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1935.34,
    y: 968.68,
    width: 14.42,
    height: 2.58,
    transform: "translate(956.01 2904.15) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1940.49,
    y: 968.72,
    width: 14.42,
    height: 2.58,
    transform: "translate(961.07 2909.35) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1943.68,
    y: 973.08,
    width: 14.42,
    height: 2.58,
    transform: "translate(957.07 2915.42) rotate(-89.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1950.88,
    y: 968.65,
    width: 14.42,
    height: 2.58,
    transform: "translate(971.78 2919.84) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1955.97,
    y: 968.84,
    width: 14.42,
    height: 2.58,
    transform: "translate(976.29 2924.95) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1961.2,
    y: 968.74,
    width: 14.42,
    height: 2.58,
    transform: "translate(981.92 2930.25) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1966.36,
    y: 968.78,
    width: 14.42,
    height: 2.58,
    transform: "translate(987 2935.45) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1971.41,
    y: 969.03,
    width: 14.42,
    height: 2.58,
    transform: "translate(991.76 2940.74) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1976.55,
    y: 969.12,
    width: 14.42,
    height: 2.58,
    transform: "translate(996.42 2945.8) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1981.76,
    y: 969.06,
    width: 14.42,
    height: 2.58,
    transform: "translate(1001.64 2950.95) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1986.81,
    y: 969.35,
    width: 14.42,
    height: 2.58,
    transform: "translate(1006.01 2956.11) rotate(-89.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1992.04,
    y: 969.25,
    width: 14.42,
    height: 2.58,
    transform: "translate(1011.64 2961.42) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1997.22,
    y: 969.24,
    width: 14.42,
    height: 2.58,
    transform: "translate(1017.14 2966.76) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2002.46,
    y: 969.1,
    width: 14.42,
    height: 2.58,
    transform: "translate(1022.48 2971.85) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2007.48,
    y: 969.43,
    width: 14.42,
    height: 2.58,
    transform: "translate(1026.43 2976.86) rotate(-89.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2012.59,
    y: 969.57,
    width: 14.42,
    height: 2.58,
    transform: "translate(1031.35 2982.12) rotate(-89.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2017.86,
    y: 969.37,
    width: 14.42,
    height: 2.58,
    transform: "translate(1037.13 2987.36) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2023.02,
    y: 969.42,
    width: 14.42,
    height: 2.58,
    transform: "translate(1042.2 2992.56) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2028.17,
    y: 969.5,
    width: 14.42,
    height: 2.58,
    transform: "translate(1047.56 2997.96) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2033.34,
    y: 969.5,
    width: 14.42,
    height: 2.58,
    transform: "translate(1052.34 3002.97) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2038.47,
    y: 969.59,
    width: 14.42,
    height: 2.58,
    transform: "translate(1057.7 3008.36) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2043.73,
    y: 969.44,
    width: 14.42,
    height: 2.58,
    transform: "translate(1063.06 3013.47) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2048.79,
    y: 969.69,
    width: 14.42,
    height: 2.58,
    transform: "translate(1067.84 3018.77) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2053.93,
    y: 969.77,
    width: 14.42,
    height: 2.58,
    transform: "translate(1072.49 3023.82) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2059.11,
    y: 969.77,
    width: 14.42,
    height: 2.58,
    transform: "translate(1077.98 3029.18) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2064.29,
    y: 969.77,
    width: 14.42,
    height: 2.58,
    transform: "translate(1082.76 3034.18) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2069.45,
    y: 969.8,
    width: 14.42,
    height: 2.58,
    transform: "translate(1087.84 3039.37) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1997.38,
    y: 895.25,
    width: 3.93,
    height: 167.65,
    transform: "translate(1003.21 2969.98) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1997.51,
    y: 880.17,
    width: 3.93,
    height: 167.65,
    transform: "translate(1018.41 2955.15) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1955.58 1022.64 1914.65 981.66 1917.36 978.86 1958.29 1019.84 1955.58 1022.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1903.7,1022.75v-3.93c-.19,0-.39,.03-.57,.09,2.73-1.13,37.06-24.47,59.46-39.87l2.17,3.26c-58.85,40.47-60.27,40.46-61.06,40.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1933.6,
    y: 994.44,
    width: 3.93,
    height: 56.74,
    transform: "translate(893.45 2948.06) rotate(-89.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1946.21 1064.49 1905.27 1023.52 1907.99 1020.72 1948.92 1061.69 1946.21 1064.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1895.42 1064.28 1893.28 1061 1954.57 1019.59 1956.72 1022.86 1895.42 1064.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1920.6,
    y: 1034.59,
    width: 3.93,
    height: 56.74,
    transform: "translate(843.2 2976.37) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2040.8 1023.36 2038.14 1020.51 2079.74 980.24 2082.4 983.09 2040.8 1023.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2092.67,1024.35c-.78,0-2.23,0-60.43-41.48l2.23-3.22c22.14,15.78,56.08,39.69,58.8,40.88-.18-.07-.37-.11-.57-.11l-.03,3.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2066.63,
    y: 995.57,
    width: 3.93,
    height: 56.74,
    transform: "translate(1024.03 3082.19) rotate(-89.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2049.49 1065.37 2046.82 1062.52 2088.42 1022.25 2091.09 1025.1 2049.49 1065.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2100.27 1066.02 2039.66 1023.57 2041.86 1020.33 2102.47 1062.78 2100.27 1066.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2071.34,
    y: 1035.86,
    width: 4.24,
    height: 56.74,
    transform: "translate(991.53 3128.51) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2008.06,130.84h-3.8c-1.59,44-5.86,112-17.16,122.07l18.06,.15,18.05,.15c-11.12-10.31-14.3-78.39-15.15-122.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1978.23,
    y: 252.11,
    width: 54.47,
    height: 77.38,
    transform: "translate(1697.52 2293.7) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1998.59,
    y: 230.62,
    width: 13.02,
    height: 52.88,
    transform: "translate(1730.9 2259.89) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1975.31,
    y: 253.4,
    width: 13.02,
    height: 6.19,
    transform: "translate(1708.73 2236.11) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1990.59,
    y: 253.4,
    width: 13.02,
    height: 6.19,
    transform: "translate(1723.88 2251.38) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 2018.24,
    y: 254.5,
    width: 13.02,
    height: 4.23,
    transform: "translate(1751.18 2279.15) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 2002.03,
    y: 251.56,
    width: 13.02,
    height: 9.96,
    transform: "translate(1735.18 2262.86) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2003,
    y: 125.28,
    width: 6.33,
    height: 10.32,
    transform: "translate(1858.57 2135.41) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1964.33,
    y: 288.15,
    width: 34.07,
    height: 5.36,
    transform: "translate(1673.6 2269.63) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1973.82,
    y: 288.33,
    width: 34.07,
    height: 5.36,
    transform: "translate(1682.83 2279.31) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1983.35,
    y: 288.4,
    width: 34.07,
    height: 5.36,
    transform: "translate(1692.21 2288.91) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1992.87,
    y: 288.48,
    width: 34.07,
    height: 5.36,
    transform: "translate(1701.57 2298.51) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 2002.4,
    y: 288.56,
    width: 34.07,
    height: 5.36,
    transform: "translate(1710.93 2308.12) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 2011.96,
    y: 288.44,
    width: 34.07,
    height: 5.36,
    transform: "translate(1720.89 2317.61) rotate(-89.52)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1978.53 874.52 1945.36 829.68 1948.46 827.32 1981.62 872.16 1978.53 874.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1940.08,874.97v-3.93c-.3,0-.6,.06-.86,.21,2.31-1.48,28-26.87,43.69-42.52l2.71,2.8c-43.45,43.46-44.51,43.45-45.54,43.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1972.97 922.97 1939.81 878.13 1942.9 875.76 1976.07 920.6 1972.97 922.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1934.53,922.35v-2.86c-.29,0-.59,.04-.86,.15,2.3-1.07,28-19.51,43.59-30.88l2.72,2c-43.36,31.61-44.42,31.6-45.45,31.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1963.78,
    y: 809.15,
    width: 3.93,
    height: 39.96,
    transform: "translate(1119.83 2787.71) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1984.03 832.63 1950.87 787.79 1953.96 785.43 1987.12 830.27 1984.03 832.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1945.58,833.08v-3.93c-.3-.01-.6,.06-.86,.21,2.31-1.48,28-26.87,43.68-42.52l2.72,2.8c-43.45,43.46-44.51,43.45-45.54,43.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1969.31,
    y: 767.26,
    width: 3.93,
    height: 39.96,
    transform: "translate(1167.21 2751.7) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1988.24 790.73 1955.08 745.89 1958.17 743.53 1991.34 788.37 1988.24 790.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1949.8,791.18v-3.93c-.3-.01-.6,.06-.86,.21,2.31-1.48,28-26.87,43.69-42.52l2.71,2.8c-43.43,43.45-44.52,43.45-45.54,43.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1973.5,
    y: 725.35,
    width: 3.93,
    height: 39.96,
    transform: "translate(1213.27 2714.35) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1992.46 748.83 1959.29 703.99 1962.39 701.63 1995.55 746.47 1992.46 748.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1954.01,749.28v-3.94c-.3,0-.6,.07-.86,.22,2.31-1.48,28-26.87,43.69-42.52l2.71,2.8c-43.45,43.45-44.51,43.44-45.54,43.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1977.71,
    y: 683.45,
    width: 3.93,
    height: 39.96,
    transform: "translate(1259.34 2677.02) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1995.46 705.7 1962.26 666.1 1965.2 663.56 1998.41 703.15 1995.46 705.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1958.27 705.53 1955.65 702.64 1997.24 663.68 1999.86 666.57 1958.27 705.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1980.63,
    y: 645.47,
    width: 3.93,
    height: 39.96,
    transform: "translate(1300.21 2642.28) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1999.95,
    y: 588.58,
    width: 3.93,
    height: 75.42,
    transform: "translate(1358.53 2622.78) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2000.29,
    y: 550.59,
    width: 3.93,
    height: 75.42,
    transform: "translate(1396.86 2585.44) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2002.53,
    y: 487.53,
    width: 3.71,
    height: 67.06,
    transform: "translate(1466.2 2520.92) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2002.26,
    y: 518.97,
    width: 3.71,
    height: 67.06,
    transform: "translate(1434.49 2551.81) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2000.92,
    y: 457.99,
    width: 3.6,
    height: 63.19,
    transform: "translate(1496.02 2488.04) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2001.18,
    y: 427.85,
    width: 3.6,
    height: 63.19,
    transform: "translate(1526.42 2458.43) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2002.14,
    y: 403.57,
    width: 3.41,
    height: 56.74,
    transform: "translate(1554.78 2432.01) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2002.33,
    y: 377.34,
    width: 3.41,
    height: 56.74,
    transform: "translate(1581.2 2406.21) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2003.23,
    y: 354.38,
    width: 3.29,
    height: 52.88,
    transform: "translate(1606.92 2382.37) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2003.45,
    y: 330.8,
    width: 3.29,
    height: 52.88,
    transform: "translate(1630.72 2359.21) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1959.55,
    y: 854.99,
    width: 3.93,
    height: 39.96,
    transform: "translate(1069.81 2828.93) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1997.11 665.11 1965.17 628.15 1968.08 625.55 2000.01 662.52 1997.11 665.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1965.12 664.9 1962.36 662.14 1997.48 625.75 2000.24 628.5 1965.12 664.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2021.58 874.89 2018.52 872.47 2052.42 828.2 2055.47 830.62 2021.58 874.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2060.01,875.99c-1,0-2.09,0-44.85-44.21l2.76-2.75c15.4,15.92,40.7,41.74,43,43.26-.26-.16-.55-.24-.85-.23l-.06,3.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2026.34 923.42 2023.29 921 2057.18 876.74 2060.23 879.15 2026.34 923.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2064.78,923.21c-1,0-2.09,0-44.85-44.21l2.76-2.75c15.4,15.92,40.7,41.74,43,43.26-.26-.16-.55-.24-.85-.23l-.06,3.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2033.43,
    y: 809.75,
    width: 3.93,
    height: 39.96,
    transform: "translate(1188.29 2857.96) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2016.77 832.91 2013.71 830.5 2047.61 786.23 2050.66 788.64 2016.77 832.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2055.2,834.01c-1,0-2.09,0-44.86-44.2l2.76-2.76c15.41,15.92,40.7,41.74,43,43.26-.26-.15-.56-.23-.86-.23l-.04,3.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2028.59,
    y: 767.76,
    width: 3.93,
    height: 39.96,
    transform: "translate(1225.48 2811.49) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2013.24 790.95 2010.19 788.53 2044.08 744.26 2047.13 746.68 2013.24 790.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2051.67,792.04c-1,0-2.09,0-44.85-44.2l2.76-2.76c15.41,15.92,40.7,41.74,43,43.26-.26-.15-.55-.23-.85-.23l-.06,3.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2025.06,
    y: 725.78,
    width: 3.93,
    height: 39.96,
    transform: "translate(1263.95 2766.33) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2009.72 748.98 2006.66 746.56 2040.56 702.29 2043.61 704.71 2009.72 748.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2048.15,750.08c-1,0-2.09,0-44.85-44.21l2.75-2.75c15.41,15.91,40.7,41.74,43,43.25-.26-.15-.56-.23-.86-.23l-.04,3.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2025.29,
    y: 685.07,
    width: 3.93,
    height: 39.96,
    transform: "translate(1301.97 2725.16) rotate(-89.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2007.42 705.8 2004.51 703.2 2038.37 664.18 2041.27 666.78 2007.42 705.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2044.61 706.27 2003.66 666.6 2006.33 663.76 2047.28 703.42 2044.61 706.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2040.66,
    y: 857.13,
    width: 3.93,
    height: 39.96,
    transform: "translate(1145.14 2910.87) rotate(-89.43)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2006.44 665.19 2003.58 662.55 2036.12 626.13 2038.98 628.77 2006.44 665.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2038.42 665.52 2003.91 628.53 2006.71 625.82 2041.23 662.81 2038.42 665.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1998.72 625.81 1968.06 590.16 1970.97 587.57 2001.63 623.22 1998.72 625.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1968.05 625.58 1965.23 622.88 1997.77 587.77 2000.58 590.47 1968.05 625.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1999.05 587.83 1969.66 554.82 1972.53 552.18 2001.92 585.19 1999.05 587.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1972.24 587.6 1969.41 584.92 1999.34 552.41 2002.17 555.09 1972.24 587.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1999.59 552.24 1971.9 521.86 1974.27 519.64 2001.96 550.02 1999.59 552.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1999.83 520.77 1974.28 491.72 1976.68 489.54 2002.23 518.59 1999.83 520.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1973.82 520.58 1971.51 518.3 1998.82 489.7 2001.14 491.98 1973.82 520.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2000.09 489.32 1975.81 461.59 1978.22 459.41 2002.5 487.14 2000.09 489.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1976.66 489.15 1974.34 486.87 2000.36 459.57 2002.67 461.85 1976.66 489.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2000.33 459.17 1977.34 432.77 1979.75 430.59 2002.75 457 2000.33 459.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1978.2 459.02 1975.88 456.74 1999.29 432.04 2001.61 434.31 1978.2 459.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2000.58 431.68 1978.86 407.91 1981.22 405.68 2002.95 429.45 2000.58 431.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1979.72 431.5 1977.39 429.23 1999.51 405.83 2001.83 408.1 1979.72 431.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2000.8 405.47 1980.35 383.02 1982.71 380.79 2003.16 403.25 2000.8 405.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1981.21 406.62 1978.88 404.35 2001 380.95 2003.33 383.22 1981.21 406.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2001 380.57 1981.83 359.44 1984.2 357.22 2003.37 378.35 2001 380.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1982.72 380.42 1980.38 378.16 1999.9 357.35 2002.23 359.61 1982.72 380.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1973.56,552.03l-2.31-2.28c9.88-10.35,25.94-27.47,27-29.38-.09,.18-.13,.39-.13,.59h3.23c-.01,.81-.02,2-27.79,31.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2005.48 625.86 2002.61 623.23 2033.85 588.11 2036.72 590.74 2005.48 625.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2036.14 626.15 2004.19 590.5 2007.05 587.85 2039 623.51 2036.14 626.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2005.77 587.89 2002.94 585.2 2032.87 552.69 2035.7 555.38 2005.77 587.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2032.58 588.11 2003.19 555.1 2006.06 552.46 2035.45 585.48 2032.58 588.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2005.81 552.29 2003.48 550.03 2031.67 520.12 2034 522.39 2005.81 552.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2006.09 520.82 2003.72 518.6 2029.75 489.99 2032.11 492.21 2006.09 520.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2032.1 521.07 2003.98 490.69 2006.32 488.45 2034.45 518.83 2032.1 521.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2006.35 489.37 2003.98 487.15 2028.7 459.84 2031.07 462.06 2006.35 489.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2029.78 489.6 2004.21 461.86 2006.56 459.62 2032.13 487.36 2029.78 489.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2006.6 459.23 2004.22 457.01 2027.65 431 2030.03 433.21 2006.6 459.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2028.73 459.45 2004.45 433.03 2006.8 430.79 2031.09 457.21 2028.73 459.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2006.8 431.73 2004.47 429.46 2026.59 406.06 2028.91 408.33 2006.8 431.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2027.7 431.95 2003.4 406.84 2005.7 404.54 2030 429.65 2027.7 431.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2007.01 405.52 2004.69 403.26 2025.5 381.16 2027.83 383.42 2007.01 405.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2026.58 407 2004.85 383.23 2007.21 381 2028.94 404.77 2026.58 407"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2007.22 380.62 2004.89 378.36 2024.4 357.56 2026.74 359.82 2007.22 380.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2025.54 380.82 2005.08 359.68 2007.38 357.38 2027.84 378.52 2025.54 380.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2031.84,552.57c-27.29-29.54-27.28-30.72-27.27-31.5h3.22c.01-.2-.03-.41-.12-.59,1,1.93,16.81,19.32,26.52,29.83l-2.35,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1784.09,1437.57l-5.46-3.5c26.62-43,51.68-87.63,74.47-132.79,18.23-36.14,35.43-73.4,51.11-110.75l5.93,2.57c-15.74,37.49-33,74.89-51.31,111.17-22.87,45.35-48.02,90.2-74.74,133.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1837.83,1192.7l-1.21,2.43c-1.6,3.16-3.2,6.32-4.79,9.48-.42,.82-.84,1.63-1.27,2.44-1.96,3.85-3.96,7.69-6,11.54l-2.55,4.87c-.5,1-1,1.91-1.52,2.88-.12,.23-.24,.47-.38,.71-.33,.64-.68,1.28-1,1.92s-.62,1.19-.95,1.78c-8.98,16.83-18.3,33.47-27.95,49.93-.46,.81-.93,1.64-1.43,2.45l-1.28,2.19-1.54,2.61c-.07,.13-.16,.27-.25,.41-.38,.66-.76,1.29-1.17,2-1.89,3.21-3.81,6.42-5.75,9.61-9.28,15.33-18.87,30.54-28.78,45.63l-3.46,5.26c-.26,.38-.52,.77-.78,1.17-.67,1-1.34,2-2,3-.1,.17-.22,.34-.34,.51s-.33,.5-.5,.75c-10.93,16.33-22.17,32.43-33.72,48.32-1.38,1.91-2.77,3.81-4.16,5.7l-1.32,1.8c-5.87,7.94-11.8,15.82-17.79,23.63l-5.07-4c5.45-7.08,10.84-14.23,16.19-21.46,27.1-36.65,52.7-74.82,76.28-113.74,2.67-4.4,5.33-8.83,8-13.29,.03-.04,.05-.08,.07-.12,15.63-26.42,30.53-53.55,44.5-80.91,.42-.81,.83-1.64,1.25-2.45,.92-1.8,1.82-3.61,2.74-5.41,.77-1.52,1.51-3,2.28-4.54l5.65,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2208.04,1441.19c-26-43.57-50.42-88.83-72.55-134.55-17.7-36.57-34.35-74.26-49.47-112l6-2.47c15.07,37.62,31.65,75.17,49.29,111.6,22,45.54,46.36,90.64,72.27,134l-5.54,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2311.38,1437.03l-5.14,4c-6.13-8.26-12.2-16.59-18.19-25-.15-.25-.32-.47-.49-.72-1.15-1.62-2.3-3.23-3.45-4.87-11.47-16.38-22.65-33-33.54-49.87-.42-.63-.83-1.26-1.21-1.89-.8-1.22-1.57-2.42-2.35-3.64-.87-1.38-1.75-2.76-2.61-4.14-9.93-15.6-19.53-31.36-28.8-47.29-2.09-3.57-4.16-7.14-6.2-10.75-.18-.32-.37-.61-.54-.93l-.89-1.55-.4-.71c-.57-1-1.13-2-1.7-3-.27-.47-.54-.94-.79-1.41-9.74-17.26-19.15-34.75-28.23-52.46l-.56-1c-.39-.77-.77-1.54-1.18-2.3-.5-1-1-2-1.52-3-1.15-2.26-2.29-4.53-3.41-6.79s-2.24-4.44-3.33-6.69c-.17-.33-.33-.66-.5-1s-.47-1-.72-1.45c-1.89-3.83-3.75-7.68-5.59-11.53-.19-.36-.37-.73-.54-1.1s-.46-.92-.66-1.39-.35-.71-.52-1.06l5.8-2.85c.72,1.53,1.46,3,2.2,4.58,1.37,2.84,2.75,5.68,4.14,8.52,.4,.82,.81,1.64,1.21,2.47,3.17,6.45,6.42,12.89,9.69,19.32,.13,.22,.24,.44,.34,.67,12.5,24.44,25.7,48.58,39.44,72.15,22.93,39.31,47.89,77.9,74.44,115,5.2,7.22,10.47,14.51,15.8,21.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1728.87,
    y: 1354.88,
    width: 30.14,
    height: 141.86,
    transform: "translate(303.27 3157.5) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2235.69,
    y: 1359.22,
    width: 30.14,
    height: 141.86,
    transform: "translate(801.42 3668.59) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 1735.8,
    y: 1371.31,
    width: 16.39,
    height: 141.86,
    transform: "translate(286.89 3173.83) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 2242.61,
    y: 1375.65,
    width: 16.39,
    height: 141.86,
    transform: "translate(785.03 3684.94) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1993.42,
    y: 1048.69,
    width: 5.53,
    height: 358.18,
    transform: "translate(751.38 3213.4) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1851.72,1225.17l-.59,.58-1.25,1.26-3.24-3.34-1.3-1.35-1.81-1.87-17.71-18.3c.42-.81,.83-1.64,1.25-2.45l24.65,25.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1870.5 1227.18 1839.17 1194.81 1841.01 1192.97 1872.34 1225.34 1870.5 1227.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1891.14 1227.36 1859.81 1194.98 1861.65 1193.15 1892.98 1225.52 1891.14 1227.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1911.77 1227.53 1880.44 1195.16 1882.28 1193.32 1913.61 1225.7 1911.77 1227.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1932.4 1227.71 1901.07 1195.33 1902.91 1193.5 1934.24 1225.87 1932.4 1227.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1953.04 1227.88 1921.71 1195.51 1923.55 1193.67 1954.88 1226.04 1953.04 1227.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1973.67 1228.06 1942.34 1195.69 1944.18 1193.85 1975.51 1226.22 1973.67 1228.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1994.3 1228.23 1962.97 1195.86 1964.81 1194.02 1996.14 1226.4 1994.3 1228.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2014.94 1228.41 1983.61 1196.04 1985.44 1194.2 2016.78 1226.57 2014.94 1228.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2035.57 1228.59 2004.24 1196.21 2006.08 1194.37 2037.41 1226.75 2035.57 1228.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2056.21 1228.76 2024.87 1196.39 2026.71 1194.55 2058.04 1226.92 2056.21 1228.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2076.84 1228.94 2045.51 1196.56 2047.35 1194.72 2078.68 1227.1 2076.84 1228.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2097.47 1229.11 2066.14 1196.74 2067.98 1194.9 2099.31 1227.27 2097.47 1229.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2118.11 1229.28 2086.77 1196.91 2088.61 1195.07 2119.94 1227.45 2118.11 1229.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2138.74 1229.46 2107.41 1197.09 2109.25 1195.25 2140.58 1227.62 2138.74 1229.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2159.37 1229.64 2128.04 1197.26 2129.88 1195.43 2161.21 1227.8 2159.37 1229.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2180.01 1229.81 2148.67 1197.44 2150.51 1195.6 2181.84 1227.97 2180.01 1229.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1741.37,1417.09l-3.51-3.84c48.45-45.87,111.88-186.44,112.52-187.86l4.69,2.18c-2.61,5.81-64.5,142.94-113.7,189.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1860.5 1287.4 1817.13 1229.37 1821.23 1226.2 1864.61 1284.23 1860.5 1287.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1793.8 1414.1 1742.7 1354.69 1746.58 1351.24 1797.68 1410.65 1793.8 1414.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1826.3 1355.11 1783.01 1287.91 1787.32 1285.03 1830.62 1352.24 1826.3 1355.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1786.4 1288.77 1783.93 1284.17 1886.28 1227.38 1888.75 1231.98 1786.4 1288.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1743.3 1355.24 1740.82 1350.64 1861.31 1283.52 1863.79 1288.12 1743.3 1355.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1703.94 1412.67 1701.85 1407.88 1827.42 1351.28 1829.51 1356.07 1703.94 1412.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1819.26,
    y: 1245.61,
    width: 5.24,
    height: 81.02,
    transform: "translate(520.22 3096.93) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1783.9,
    y: 1309.44,
    width: 5.49,
    height: 89.07,
    transform: "translate(417.44 3128.98) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2249.79,1421.41c-48.43-47.41-108.05-185.57-110.56-191.43l4.72-2.09c.62,1.42,61.73,143.06,109.42,189.74l-3.58,3.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2132.82 1289.72 2128.76 1286.48 2173.08 1229.19 2177.13 1232.43 2132.82 1289.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2197.43 1417.52 2193.6 1414.01 2245.67 1355.48 2249.49 1358.99 2197.43 1417.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2165.89 1357.99 2161.62 1355.05 2206.02 1288.59 2210.29 1291.53 2165.89 1357.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2206.88 1292.34 2105.47 1233.82 2108.02 1229.26 2209.42 1287.78 2206.88 1292.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2248.88 1359.53 2129.51 1290.37 2132.06 1285.82 2251.44 1354.98 2248.88 1359.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2287.29 1417.62 2162.67 1358.9 2164.84 1354.15 2289.46 1412.87 2287.29 1417.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2169.15,
    y: 1248.58,
    width: 5.24,
    height: 81.02,
    transform: "translate(864.15 3449.75) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 2207.17,
    y: 1313.02,
    width: 5.5,
    height: 89.07,
    transform: "translate(833.51 3555.78) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1986.97,
    y: 1017.83,
    width: 22.92,
    height: 325.63,
    transform: "translate(800.73 3168.9) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1988.72,
    y: 1018.6,
    width: 18.57,
    height: 336.27,
    transform: "translate(794.22 3174.52) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1988.56,
    y: 821.39,
    width: 21.62,
    height: 191.51,
    transform: "translate(1065.16 2908.6) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1996.64,
    y: 808.19,
    width: 5.32,
    height: 191.51,
    transform: "translate(1078.29 2895.44) rotate(-89.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1830.12,
    y: 1132.16,
    width: 336.16,
    height: 5.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1965.73,
    y: 313.04,
    width: 78.31,
    height: 9.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1967.64,
    y: 262.57,
    width: 76.4,
    height: 5.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 1673.5,
    y: 1405.84,
    width: 141.34,
    height: 7.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 2179.65,
    y: 1407.79,
    width: 141.34,
    height: 7.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.91,2065.13s.08,.05,.13,.06l.86,.49c36.13,20.17,72.25,40.36,108.37,60.55,54.18,30.29,0,0,.07,0,2.44,1.37,4.86,2.72,7.32,4.08l15.52,8.68c30.77,17.19,61.54,34.38,92.33,51.57,36.45,20.37,72.91,40.74,109.38,61.11,2,1.16,4.09,2.28,6.12,3.44l59.29,33.13c2.88,1.59,5.74,3.2,8.63,4.8,63.89,35.71,127.79,71.41,191.68,107.1l-4.65,12.81-128,353.33c-21.9-27.85-43.79-55.7-65.68-83.57-16.75-25.86-33.49-51.75-50.23-77.66l-137.66-191.33c-4.34-7.11-8.67-14.2-13-21.29-9.93-16.25-19.87-32.48-29.8-48.69-55.12-89.92-110.22-179.85-165.31-269.8-1-1.61-2-3.22-3-4.83-.78-1.33-1.57-2.64-2.37-3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M295.02,2065.19l258.17-68.11c20.36-7.06,40.73-14.11,61.12-21.15,7.95-2.77,15.91-5.53,23.9-8.27,86.26-21.33,172.52-42.62,258.79-63.87l124.47-30.72,26.14-6.45,44.21-10.91-197.23,544.46-4.65,12.81-190.45-111.36h-.1l-6.74-4-61.27-35.83-.34-.19-4.76-2.79-108.9-63.66-3.3-1.9-33.78-19.76-130.39-76.24c-.06-.02-.12-.05-.17-.09l-53.83-31.48-.89-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M284.81,2065.23l2.69-.76,.76-.21,9.06,4.85c-.82-1.33-1.61-2.64-2.43-4,.04,.03,.08,.05,.13,.06l258.17-68.11c20.36-7.06,40.73-14.11,61.12-21.15-4.64,14.73-22.85,34.79-32.94,44.3-11.11,10.45-17.1-2-24.14,.16s-32.49,19.76-32.49,19.76l26.61,45.65,.93,1.61-1.83,2.55-17.42,24.63s9.59,56.94,2.1,64.9c-3.76,4-9.26,7.81-15.64,11.12-1.15,.64-2.38,1.25-3.63,1.83-.58,.29-1.19,.57-1.78,.84l-.87,.38-212.93-119.7-10.75-6-4.72-2.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "553.05 2178.8 563.34 2154.32 577.46 2160.17 565.61 2184 553.05 2178.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M786.02,2299.57s59.63-106.9,57.09-114-1-6.46-1-6.46l-12.83,17.38-23.75,8.31-36.8,87.62,17.29,7.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "709.47 2196.73 715.97 2181.27 703.47 2171.55 699.46 2198.63 709.47 2196.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M792.1,2100.87l47.63-113.39-17.91,3.17s-31.61,92.8-35.4,101.82,5.68,8.4,5.68,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M632,2170.67s30.79-68.93,34.09-81.18,19-45.1,19-45.1l9.41,3.91s-26.68,76.68-27.77,79.26-18.56,13.49-23.54,34.11-12.23,11.58-12.23,11.58l1.04-2.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "423.05 2106.76 430.63 2088.72 435.33 2090.67 426.13 2112.57 423.05 2106.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M394.97,2081.5l13.53-32.21s-2.48-11.62-3.13-1.3-18.3,34.78-18.3,34.78l-1.73,12.9,5.3-3.86,4.33-10.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M729.67,2047.77s37.78-81.17,35.72-85-13.52-11.66-13.52-11.66c0,0-27.77,79.27-28.31,80.56s6.11,16.1,6.11,16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1021.47,1873.07l-30,130.4,4.7,1.95s14.34-12.21,21.49-38,2.55-36.76,8.45-46.42,21.53-54.38,21.53-54.38l-26.17,6.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "878.63 2030.84 886.74 2011.51 893.56 2012.82 882.2 2039.88 873.86 2033.4 878.63 2030.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M874.58,2365.02l40-95.36s-24-13-20.24-22-.48-47.1-.48-47.1l-4.7-1.95s-12.78,56.73-7.59,61.91,10.82,18.1,10.82,18.1l-23.27,59.95,5.46,26.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "699.49 2301.62 716.6 2258.69 708.71 2259.96 696.42 2276.04 692.47 2298.61 699.49 2301.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "635.63 2087.46 677.85 1986.95 664.7 1987.55 624.65 2082.9 635.63 2087.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "458.33 2101.71 470.78 2072.08 474.4 2076.6 461.95 2106.24 458.33 2101.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M558.97,2081.4s12.88-21.89,14-24.47-2.06-3.88-2.06-3.88l-10.6,7.71-10.34,29,3.14,1.3,5.86-9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M902.85,2113.5l71.45-170.09-3.14-1.3s-69.12,151.38-72.36,159.12,4.05,12.27,4.05,12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M736.78,2285.21l61.81-155.93-5.25-.66-32.43,77.31c-8.12,19.33-29.12,60.55-30.25,67.64s6.12,11.64,6.12,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M631.38,2261.8s44.11-80.66,44.71-86.47-6.76-5.83-6.76-5.83l-1.25,16.13s-17,18.65-24,30.89-17.87,42.52-17.87,42.52l5.17,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M889.57,1908.29s-15.47,19.31-12.45,29.64-10.61,51.58-10.61,51.58l4.17,3.24,26.31-89-7.42,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M903.43,2239.3s46.55-110.81,46.12-118.55-2.81-28.4,3-33.54,11.37-27.06,11.37-27.06h7.35s-9.85,32.23-13.09,40,.8,20-3.53,30.31l-46.54,110.82-4.68-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M979.74,2101.49c2.65-1.93,29.22-69.58,33.55-79.89s8.83-34.16,8.83-34.16l14.17,1.33s-22.41,70.9-29.39,83.13-27,59.91-26.46,58.63-7.14-18.09-7.14-18.09l6.44-10.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.98,2063.57c.42,.24,.86,.46,1.28,.7l9.06,4.85c17.44,9.33,34.91,18.68,52.4,28.05,.05,.04,.11,.07,.17,.09,20.58,11.06,41.16,22.09,61.75,33.09l10.28,5.52h.08c1.74,1,3.46,2.11,5.16,3.15,48,29.14,85,51.46,87.18,52.3,.58,.25,1.1,.62,1.52,1.1,.67,.81,1.18,1.74,1.52,2.74,2.56,7,1.34,21.2,2,26.36,.78,6.58,4.83,55.23-1.28,68.56s-8.55,18.68-8.55,18.68c0,0-13,20.06-12.23,26.65s11.39,32.67,11.39,32.67l-13.32,24.38c-9.93-16.25-19.87-32.48-29.8-48.69-55.12-89.94-110.22-179.88-165.31-269.83l-10.75-6c-.67-1.15-1.35-2.3-2-3.44-.21-.33-.38-.63-.55-.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2282.8,
    y: 1135.93,
    width: 644.41,
    height: 155.71,
    transform: "translate(489.77 3159.32) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 2284.47,
    y: 1163.24,
    width: 644.41,
    height: 102.45,
    transform: "translate(490.18 3161.29) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2642.47,
    y: 888.86,
    width: 125.1,
    height: 170.61,
    transform: "translate(773.19 3103.52) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2653.32,
    y: 921.3,
    width: 108.94,
    height: 106.52,
    transform: "translate(774.54 3106.32) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2657.47,
    y: 925.36,
    width: 100.63,
    height: 98.39,
    transform: "translate(774.54 3106.32) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "2810.03 821.87 2735.45 790.74 2754.35 744.95 2828.94 776.08 2810.03 821.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "2817.15 903.65 2673.35 843.63 2735.56 790.79 2810.46 822.05 2817.15 903.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2832.11,770.74l-74.58-31.12c37.8-35.95,69.15-78.13,92.67-124.7l3.76,1.55c-16.87,49.6-24.28,101.93-21.85,154.27h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2786.59 723.01 2793.69 725.94 2794.4 714.74 2786.59 723.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2805.12 698.2 2812.22 701.12 2812.57 690.78 2805.12 698.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2825.08 673.47 2832.17 676.4 2832 667.34 2825.08 673.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2820.98 704.73 2828.07 707.66 2828.43 697.32 2820.98 704.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2801.61 729.2 2808.71 732.13 2809.42 720.94 2801.61 729.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2816.63 735.4 2823.73 738.32 2824.44 727.13 2816.63 735.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2791.28,
    y: 709.57,
    width: 8.31,
    height: 83.05,
    transform: "translate(1035.35 3049.07) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2788.99,
    y: 715.12,
    width: 8.31,
    height: 83.05,
    transform: "translate(1028.8 3050.39) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 2849.29,
    y: 607.85,
    width: 6.46,
    height: 12.64,
    transform: "translate(1197.26 3017.12) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 2842.21,
    y: 593.11,
    width: 37.39,
    height: 2.26,
    transform: "translate(1220.88 3012.54) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2768.33,757.92l-5.78,2.08-14.44,35,7.93,3.27,14.44-35c-.72-1.8-1.44-3.58-2.15-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2782.91,763.94l-5.77,2.08-14.45,35,7.93,3.27,14.44-35c-.69-1.78-1.41-3.56-2.15-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2797.53,769.97l-5.77,2.07-14.44,35,7.93,3.27,14.44-35-2.16-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2812.14,775.99l-5.78,2.08-14.44,35,7.93,3.27,14.44-35c-.72-1.79-1.44-3.57-2.15-5.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2710.52 845.93 2714.48 836.34 2720.22 831.87 2721.57 839.26 2717.61 848.86 2710.52 845.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2731.98 829.4 2735.94 819.8 2741.68 815.34 2743.03 822.73 2739.07 832.32 2731.98 829.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2756.6 839.55 2760.56 829.96 2766.3 825.49 2767.65 832.88 2763.69 842.48 2756.6 839.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2781.22 849.7 2785.17 840.11 2790.92 835.65 2792.27 843.03 2788.31 852.63 2781.22 849.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2734.72 855.91 2738.68 846.31 2744.42 841.85 2745.77 849.24 2741.81 858.84 2734.72 855.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2758.92 865.89 2762.88 856.29 2768.62 851.83 2769.97 859.22 2766.01 868.81 2758.92 865.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "2783.12 875.87 2787.08 866.28 2792.82 861.81 2794.17 869.2 2790.21 878.8 2783.12 875.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2715.55,
    y: 819.7,
    width: 39.7,
    height: 155.71,
    transform: "translate(862.81 3084.2) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2696.1,902.4l7.42-18c-.95-2.47-1.9-4.94-2.84-7.41l-7.24,3.26-7.42,18,10.08,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2710.2,908.21l7.42-18c-.94-2.47-1.89-4.94-2.84-7.41l-7.23,3.25-7.42,18,10.07,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2724.31,914.03l7.42-18-2.84-7.41-7.24,3.25-7.42,18,10.08,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2738.42,919.85l7.42-18c-.95-2.47-1.89-4.94-2.84-7.41l-7.24,3.26-7.42,18,10.08,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2752.52,925.67l7.42-18c-.94-2.47-1.89-4.94-2.84-7.41l-7.19,3.31-7.42,18,10.03,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2766.63,931.48l7.42-18-2.84-7.41-7.24,3.25-7.42,18,10.08,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2780.74,937.3l7.42-18c-.95-2.47-1.89-4.94-2.84-7.41l-7.24,3.25-7.42,18,10.08,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2638.91,1048.1l7.43-18c-.95-2.47-1.89-4.94-2.84-7.41l-7.24,3.26-7.42,18,10.07,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2653.05,1053.92l7.42-18c-.94-2.47-1.89-4.94-2.84-7.41l-7.23,3.26-7.42,18,10.07,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2667.16,1059.73l7.42-18-2.84-7.41-7.24,3.25-7.42,18,10.08,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2681.26,1065.57l7.43-18c-.95-2.47-1.9-4.95-2.84-7.42l-7.24,3.26-7.42,18,10.07,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2695.37,1071.37l7.42-18c-.94-2.47-1.89-4.94-2.84-7.41l-7.23,3.26-7.42,18,10.07,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2709.48,1077.19l7.42-18-2.84-7.41-7.24,3.26-7.42,18,10.08,4.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2740.1,
    y: 795.77,
    width: 8.31,
    height: 162.93,
    transform: "translate(887.07 3079.81) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2738.56,
    y: 801.75,
    width: 6.46,
    height: 162.93,
    transform: "translate(880.02 3081.23) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2750.71,990.57c9.53-23.1-1.06-49.37-23.64-58.68s-48.62,1.86-58.14,25,1.06,49.38,23.64,58.69,48.62-1.9,58.14-25.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2720.82,
    y: 937.38,
    width: 7.85,
    height: 1.81,
    transform: "translate(818.18 3099.22) rotate(-67.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "2705.07 939.6 2704.11 931.85 2705.91 931.6 2706.86 939.34 2705.07 939.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "2689.24 946.78 2684.59 940.62 2686.04 939.49 2690.69 945.65 2689.24 946.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2674.85,
    y: 954.85,
    width: 1.85,
    height: 7.67,
    transform: "translate(769.4 3066.9) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "2669.3 979.5 2669.07 977.68 2676.71 976.58 2676.93 978.41 2669.3 979.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "2677.61 999.2 2676.52 997.75 2682.66 992.93 2683.75 994.38 2677.61 999.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2691.51,
    y: 1007.18,
    width: 7.85,
    height: 1.81,
    transform: "translate(735.53 3115.31) rotate(-67.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "2713.84 1014.39 2712.88 1006.64 2714.68 1006.38 2715.64 1014.13 2713.84 1014.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "2733.71 1006.5 2729.07 1000.34 2730.51 999.2 2735.16 1005.36 2733.71 1006.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2742.93,
    y: 983.34,
    width: 1.85,
    height: 7.67,
    transform: "translate(785.19 3147.47) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "2743.04 969.4 2742.82 967.58 2750.46 966.48 2750.68 968.31 2743.04 969.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "2737.09 953.06 2736 951.61 2742.14 946.79 2743.23 948.24 2737.09 953.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2706.98,965.81l-3,.24c-.21,.91-.43,1.83-.64,2.74l28.42,41.18,.6-.26-25.38-43.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M2715.91,968.99l-26.53,20.52,.66,.77,27.43-19.15-1.56-2.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2742.03,
    y: 1022.26,
    width: 18.31,
    height: 5.42,
    transform: "translate(754.78 3177.64) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2750.53,
    y: 1025.85,
    width: 18.31,
    height: 5.42,
    transform: "translate(756.73 3187.71) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2767.05,
    y: 962.09,
    width: 18.31,
    height: 5.42,
    transform: "translate(825.89 3163.53) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2775.32,
    y: 965.47,
    width: 18.31,
    height: 5.42,
    transform: "translate(827.88 3173.27) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2618.1,
    y: 971.15,
    width: 18.31,
    height: 5.42,
    transform: "translate(725.71 3031.76) rotate(-67.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2626.43,
    y: 974.58,
    width: 18.31,
    height: 5.42,
    transform: "translate(727.33 3041.26) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2643.01,
    y: 910.89,
    width: 18.31,
    height: 5.42,
    transform: "translate(796.47 3017.18) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2651.48,
    y: 914.43,
    width: 18.31,
    height: 5.42,
    transform: "translate(798.44 3027.2) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2667.68,
    y: 973.29,
    width: 6.77,
    height: 162.93,
    transform: "translate(677.68 3121.99) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2630.34,
    y: 1063.82,
    width: 6.77,
    height: 162.93,
    transform: "translate(570.87 3143.49) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2620.87,
    y: 1086.78,
    width: 6.77,
    height: 162.93,
    transform: "translate(543.79 3148.95) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2575.27,
    y: 1084.49,
    width: 91.29,
    height: 5.26,
    transform: "translate(616.72 3095.65) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2588.11,
    y: 1089.78,
    width: 91.29,
    height: 5.26,
    transform: "translate(619.77 3110.8) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2630.1,
    y: 1107.05,
    width: 91.29,
    height: 5.26,
    transform: "translate(629.79 3160.31) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2642.84,
    y: 1112.25,
    width: 91.29,
    height: 5.26,
    transform: "translate(632.86 3175.31) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2595.33,
    y: 1142.86,
    width: 18.05,
    height: 7.67,
    transform: "translate(551.4 3117.21) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2608.58,
    y: 1148.25,
    width: 18.05,
    height: 7.67,
    transform: "translate(554.61 3132.79) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2582.04,
    y: 1137.42,
    width: 18.05,
    height: 7.67,
    transform: "translate(548.21 3101.56) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2595.33,
    y: 1142.86,
    width: 18.05,
    height: 7.67,
    transform: "translate(551.4 3117.21) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2621.95,
    y: 1153.78,
    width: 18.05,
    height: 7.67,
    transform: "translate(557.77 3148.58) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2635.35,
    y: 1159.34,
    width: 18.05,
    height: 7.67,
    transform: "translate(560.93 3164.41) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2648.62,
    y: 1164.76,
    width: 18.05,
    height: 7.67,
    transform: "translate(564.12 3180.03) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2661.98,
    y: 1170.27,
    width: 18.05,
    height: 7.67,
    transform: "translate(567.3 3195.79) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2583.55,
    y: 1177.31,
    width: 6.77,
    height: 162.93,
    transform: "translate(437 3170.46) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2574.08,
    y: 1200.26,
    width: 6.77,
    height: 162.93,
    transform: "translate(409.93 3175.91) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2528.45,
    y: 1197.95,
    width: 91.29,
    height: 5.26,
    transform: "translate(482.86 3122.58) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2541.01,
    y: 1202.95,
    width: 91.29,
    height: 5.26,
    transform: "translate(486 3137.29) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2583.21,
    y: 1220.44,
    width: 91.29,
    height: 5.26,
    transform: "translate(495.94 3187.12) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2596.1,
    y: 1225.79,
    width: 91.29,
    height: 5.26,
    transform: "translate(498.98 3202.35) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2548.4,
    y: 1256.19,
    width: 18.05,
    height: 7.67,
    transform: "translate(417.59 3143.95) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2561.8,
    y: 1261.76,
    width: 18.05,
    height: 7.67,
    transform: "translate(420.73 3159.79) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2535.08,
    y: 1250.72,
    width: 18.05,
    height: 7.67,
    transform: "translate(414.4 3128.25) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2548.4,
    y: 1256.19,
    width: 18.05,
    height: 7.67,
    transform: "translate(417.59 3143.95) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2575.19,
    y: 1267.3,
    width: 18.05,
    height: 7.67,
    transform: "translate(423.89 3175.59) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2588.49,
    y: 1272.75,
    width: 18.05,
    height: 7.67,
    transform: "translate(427.08 3191.26) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2601.91,
    y: 1278.33,
    width: 18.05,
    height: 7.67,
    transform: "translate(430.23 3207.12) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2615.3,
    y: 1283.88,
    width: 18.05,
    height: 7.67,
    transform: "translate(433.39 3222.93) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2536.76,
    y: 1290.8,
    width: 6.77,
    height: 162.93,
    transform: "translate(303.13 3197.42) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2527.29,
    y: 1313.75,
    width: 6.77,
    height: 162.93,
    transform: "translate(276.05 3202.87) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2481.42,
    y: 1311.17,
    width: 91.29,
    height: 5.26,
    transform: "translate(349.09 3149.15) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2494.35,
    y: 1316.57,
    width: 91.29,
    height: 5.26,
    transform: "translate(352.09 3164.45) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2536.47,
    y: 1333.98,
    width: 91.29,
    height: 5.26,
    transform: "translate(362.07 3214.16) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2549.25,
    y: 1339.22,
    width: 91.29,
    height: 5.26,
    transform: "translate(365.12 3229.23) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2501.6,
    y: 1369.68,
    width: 18.05,
    height: 7.67,
    transform: "translate(283.71 3170.9) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2514.92,
    y: 1375.15,
    width: 18.05,
    height: 7.67,
    transform: "translate(286.9 3186.61) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2488.33,
    y: 1364.26,
    width: 18.05,
    height: 7.67,
    transform: "translate(280.51 3155.29) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2501.6,
    y: 1369.68,
    width: 18.05,
    height: 7.67,
    transform: "translate(283.71 3170.9) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2528.37,
    y: 1380.75,
    width: 18.05,
    height: 7.67,
    transform: "translate(290.04 3202.5) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2541.74,
    y: 1386.29,
    width: 18.05,
    height: 7.67,
    transform: "translate(293.19 3218.3) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2555.13,
    y: 1391.84,
    width: 18.05,
    height: 7.67,
    transform: "translate(296.34 3234.1) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2568.37,
    y: 1397.22,
    width: 18.05,
    height: 7.67,
    transform: "translate(299.57 3249.67) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2489.95,
    y: 1404.29,
    width: 6.77,
    height: 162.93,
    transform: "translate(169.25 3224.38) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2480.49,
    y: 1427.24,
    width: 6.77,
    height: 162.93,
    transform: "translate(142.18 3229.83) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2434.76,
    y: 1424.82,
    width: 91.29,
    height: 5.26,
    transform: "translate(215.14 3176.34) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2447.63,
    y: 1430.16,
    width: 91.29,
    height: 5.26,
    transform: "translate(218.18 3191.55) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2489.71,
    y: 1447.51,
    width: 91.29,
    height: 5.26,
    transform: "translate(228.17 3241.18) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2502.62,
    y: 1452.91,
    width: 91.29,
    height: 5.26,
    transform: "translate(230.85 3256.05) rotate(-67.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2454.82,
    y: 1483.16,
    width: 18.05,
    height: 7.67,
    transform: "translate(149.85 3197.88) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2468.29,
    y: 1488.83,
    width: 18.05,
    height: 7.67,
    transform: "translate(152.95 3213.84) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2441.55,
    y: 1477.76,
    width: 18.05,
    height: 7.67,
    transform: "translate(146.63 3182.27) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2454.82,
    y: 1483.16,
    width: 18.05,
    height: 7.67,
    transform: "translate(149.85 3197.88) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2481.67,
    y: 1494.36,
    width: 18.05,
    height: 7.67,
    transform: "translate(156.11 3229.63) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2494.93,
    y: 1499.76,
    width: 18.05,
    height: 7.67,
    transform: "translate(159.32 3245.23) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2508.27,
    y: 1505.26,
    width: 18.05,
    height: 7.67,
    transform: "translate(162.5 3260.97) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2521.57,
    y: 1510.69,
    width: 18.05,
    height: 7.67,
    transform: "translate(165.71 3276.62) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3032.91,1154.36c-9.29,2.43-18.93,3.26-28.5,2.43-13.76-1.27-27.03-5.72-38.77-13,40.12,45.47,90.65,80.55,147.27,102.26l12.84-15.67-92.84-76.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3236.6,1365.84c-51.15-29.64-94.59-70.93-126.77-120.52-.13-.21-.27-.4-.39-.6-.69-1.06-1.36-2.1-2-3.13l.22-.27c3.96-4.81,7.92-9.62,11.87-14.45,.24-.32,.51-.63,.76-.94l5.42,4.45,23.27,19c.64,.53,1.29,1.07,1.94,1.59,9.26,7.61,18.53,15.21,27.82,22.81l1.94,1.59,21.63,17.73,10.62,8.7,.13,.1c-.56,9.59,.52,19.2,3.21,28.42,3.71,12.49,10.11,24.01,18.77,33.75,.54,.66,1.07,1.25,1.56,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M3112.09,1242.57l-11.61,14.17s-84.44-41-137.51-101.2l2.13-13.23s83.13,83.8,146.99,100.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M3239.28,1367l-12.55,4.68c-1.37-.79-2.72-1.59-4.08-2.4-20.8-12.53-40.37-28-57.51-43.42-3-2.71-5.92-5.41-8.77-8.1-20.12-18.92-38.8-39.31-55.9-61l5.32-6.49,4-4.93,.27-.35,2-2.4c.44,.93,.9,1.84,1.38,2.76,26.5,51.2,102.72,105.8,121.56,118.79,2.75,1.85,4.28,2.86,4.28,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3329.76,1253.05c-52.07-29.25-95.87-71.23-127.32-122l1.4-1.7c12.67-15.49,25.36-30.98,38.09-46.47,.33-.41,.68-.83,1-1.25,5,4.21,10,8.45,15,12.67,4.09,26.52,11.49,52.43,22,77.12,12.51,29.35,29.19,56.74,49.53,81.32l.3,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3147.64,1062.94c-31.39-6.54-61.66-17.58-89.88-32.8,38.92,45.32,88.7,80.02,144.68,100.86l40.47-49.43-15.38-12.26c-26.79,1.21-53.63-.93-79.89-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M3203.84,1129.3l-11.61,14.17s-84.45-41-137.51-101.19l2.12-13.24s83.13,83.8,147,100.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M3331.02,1253.73l-12.56,4.69-2.22-1.31c-68.44-40.5-124-113.64-124-113.64l4.36-5.31,5.85-7.16,1.4-1.7c26.55,55,113,114.87,125.63,123.39l1.54,1.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3281.02 1054.61 3277.95 1058.36 3270.57 1052.3 3266.23 1048.76 3264.89 1047.67 3260.35 1043.95 3263.43 1040.19 3267.97 1043.91 3269.31 1045 3273.64 1048.56 3281.02 1054.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3289.06 1044.82 3285.98 1048.58 3278.58 1042.51 3274.25 1038.96 3272.93 1037.88 3268.38 1034.15 3271.46 1030.39 3276 1034.11 3277.33 1035.2 3281.66 1038.76 3289.06 1044.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3297.09 1035.02 3294.01 1038.78 3286.62 1032.72 3282.28 1029.16 3280.95 1028.08 3276.42 1024.36 3279.48 1020.61 3284.02 1024.34 3285.35 1025.41 3289.7 1028.97 3297.09 1035.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3305.11 1025.22 3302.03 1028.98 3294.65 1022.92 3290.32 1019.37 3288.98 1018.28 3284.44 1014.56 3287.51 1010.81 3292.05 1014.53 3293.38 1015.62 3297.73 1019.17 3305.11 1025.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3313.14 1015.45 3310.07 1019.19 3302.68 1013.13 3298.33 1009.58 3297 1008.5 3292.46 1004.77 3295.53 1001.01 3300.09 1004.74 3301.41 1005.82 3305.75 1009.39 3313.14 1015.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3321.16 1005.65 3318.09 1009.39 3310.71 1003.33 3306.36 999.78 3305.03 998.7 3300.49 994.98 3303.57 991.22 3308.11 994.94 3309.43 996.02 3313.78 999.59 3321.16 1005.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3329.19 995.85 3326.11 999.6 3318.72 993.55 3314.39 989.99 3313.05 988.9 3308.52 985.18 3311.6 981.42 3316.13 985.15 3317.47 986.23 3321.8 989.79 3329.19 995.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3337.22 986.05 3334.14 989.81 3326.76 983.76 3322.42 980.19 3321.09 979.11 3316.55 975.39 3319.61 971.63 3324.16 975.37 3325.49 976.44 3329.84 980 3337.22 986.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3264.9 1070.32 3258.75 1077.82 3256.53 1080.52 3245.43 1071.42 3241.1 1067.88 3243.33 1065.17 3249.48 1057.67 3253.8 1061.21 3255.14 1062.3 3259.47 1065.86 3264.9 1070.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3354.77 949.58 3350.16 955.2 3329.84 980 3326.76 983.76 3321.8 989.79 3318.72 993.55 3313.78 999.59 3310.71 1003.33 3305.75 1009.39 3302.68 1013.13 3297.73 1019.17 3294.65 1022.92 3289.7 1028.97 3286.62 1032.72 3281.66 1038.76 3278.58 1042.51 3273.64 1048.56 3270.57 1052.3 3259.47 1065.86 3258.26 1067.31 3253.93 1063.76 3255.14 1062.3 3266.23 1048.76 3269.31 1045 3274.25 1038.96 3277.33 1035.2 3282.28 1029.16 3285.35 1025.41 3290.32 1019.37 3293.38 1015.62 3298.33 1009.58 3301.41 1005.82 3306.36 999.78 3309.43 996.02 3314.39 989.99 3317.47 986.23 3322.42 980.19 3325.49 976.44 3345.81 951.64 3350.42 946.01 3351.07 946.55 3353.24 948.33 3354.77 949.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3358.4 950.47 3352.76 957.34 3350.16 955.2 3345.81 951.64 3344.49 950.55 3343.21 949.51 3348.84 942.63 3350.12 943.68 3352.1 945.29 3354.26 947.08 3358.4 950.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3364.86 934.16 3354.26 947.08 3353.24 948.33 3351.07 946.55 3352.1 945.29 3362.69 932.39 3364.86 934.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "3266.36 1084.05 3257.99 1094.25 3257.14 1095.29 3241.93 1082.83 3238.43 1079.96 3226.5 1070.19 3227.19 1069.35 3235.73 1058.93 3243.33 1065.17 3247.65 1068.71 3258.75 1077.82 3266.36 1084.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M3251.09,1220.97l-151.64-124.27,6.32-7.71c23.81,23.24,51.61,42,82.06,55.41,5.8,8.74,12.17,17.09,19.07,25,14.74,16.87,31.73,31.62,50.51,43.83l-6.32,7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3317.84,1256.57l-1.6,.59-10.39,3.89c-7.56-4.38-15-9.17-22.12-14.25-9.25-6.51-18.13-13.51-26.51-20.61-.11-.09-.23-.19-.32-.28-2-1.64-3.87-3.32-5.75-5-4.7-4.13-9.22-8.28-13.53-12.37-18.84-17.83-36.36-37-52.41-57.38l3.92-4.8,2.58-3.12,4.6-5.61c.09,.17,.17,.37,.28,.55,27.73,56.58,121.25,118.39,121.25,118.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3196.3,1137.57l-11.09,13.54s-80.7-39.17-131.41-96.7l2-12.65s79.47,80.12,140.5,95.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3261.57 1246.73 3257.02 1252.3 3244.32 1241.88 3243.98 1241.61 3248.53 1236.06 3248.87 1236.33 3261.57 1246.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3272.87 1246.7 3268.31 1252.26 3261.57 1246.73 3248.87 1236.33 3248.53 1236.06 3253.09 1230.5 3253.43 1230.77 3272.87 1246.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3283.93 1246.49 3283.73 1246.75 3279.38 1252.05 3272.87 1246.7 3253.43 1230.77 3253.09 1230.5 3256.9 1225.86 3257.65 1224.95 3257.98 1225.22 3283.93 1246.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3074.41,
    y: 1092.83,
    width: 7.18,
    height: 16.99,
    transform: "translate(275.33 2784.18) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3075.63,
    y: 1080.06,
    width: 7.18,
    height: 25.77,
    transform: "translate(282.25 2782.05) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3076.88,
    y: 1067.57,
    width: 7.18,
    height: 34.27,
    transform: "translate(289.08 2780) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3162.46,
    y: 1165.71,
    width: 15.36,
    height: 3.09,
    transform: "translate(257.77 2879.09) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3257.98 1225.22 3257.23 1226.14 3253.43 1230.77 3248.87 1236.33 3244.32 1241.88 3218.27 1273.68 3216.75 1275.53 3210.66 1282.96 3209.13 1284.82 3203.06 1292.23 3202.3 1293.15 3180.67 1275.42 3178.73 1273.83 3150.9 1251.03 3148.96 1249.45 3125.7 1230.38 3120.28 1225.93 3119.38 1225.19 3090.1 1201.19 3062.26 1178.39 3060.33 1176.8 3040.41 1160.49 3041.18 1159.55 3047.25 1152.14 3048.78 1150.28 3054.84 1142.86 3056.37 1141 3082.42 1109.22 3086.96 1103.66 3091.52 1098.11 3095.3 1093.49 3096.08 1092.54 3096.22 1092.66 3100.13 1095.86 3118.49 1110.92 3172.48 1155.16 3175.07 1157.26 3179.44 1160.85 3237.62 1208.52 3251.78 1220.13 3257.65 1224.95 3257.98 1225.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 3111.39,
    y: 1095.64,
    width: 73.68,
    height: 192.69,
    transform: "translate(230.92 2871.71) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 3078.94,
    y: 1156.57,
    width: 51.59,
    height: 28.09,
    transform: "translate(231.51 2830.24) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3109.11,
    y: 1184.02,
    width: 83.38,
    height: 8.99,
    transform: "translate(234.25 2871.92) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M3218.27,1273.68l-7.51-6.16-71-58.21-4.37-3.59-2.58-2.1-22.17-18.18-21.72-17.8-27.16-22.24-5.35-4.4-10.62-8.7-16.72,20.41,2.46,2,87.13,71.4,.9,.74,5.42,4.44,87.21,71.47,.77-.93,16-19.49-10.69-8.66Zm-185.77-121.24l6.07-7.41,1.51-1.87,6.08-7.41,8.68,7.11,5.36,4.4,14.56,11.92,1.94,1.59,10.66,8.73,17.16,14.08,1.93,1.59,2.63,2.13,22.17,18.18,2.58,2.1,4.37,3.59,25.21,20.66,1.93,1.59,27.84,22.8,1.93,1.58,14.12,11.58,7.52,6.16,8.68,7.11-6.09,7.42-1.52,1.86-6.08,7.41-8.68-7.11-21.63-17.73-1.94-1.59-27.82-22.81-1.94-1.59-29.59-24.24-27.35-22.42-1.94-1.58-27.82-22.81-1.94-1.59-19.91-16.3-8.68-7.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 3127.84,
    y: 1100.36,
    width: 2.4,
    height: 234.26,
    transform: "translate(204.16 2866.2) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3161.75,
    y: 1074.83,
    width: 4.31,
    height: 196.06,
    transform: "translate(251.45 2876.82) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3124.46,
    y: 1134.48,
    width: 15.36,
    height: 4.21,
    transform: "translate(267.58 2838.47) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3203.27,
    y: 1199.37,
    width: 15.36,
    height: 4.21,
    transform: "translate(246.25 2923.17) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 3056.73,
    y: 1166.78,
    width: 23.98,
    height: 2.5,
    transform: "translate(220.33 2801.43) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 3086.72,
    y: 1191.55,
    width: 23.98,
    height: 2.5,
    transform: "translate(212.15 2833.7) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 3145.69,
    y: 1239.97,
    width: 23.98,
    height: 2.5,
    transform: "translate(196.29 2897.05) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 3175.22,
    y: 1263.95,
    width: 23.98,
    height: 2.5,
    transform: "translate(188.56 2928.67) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M3159.91,1332.25l-151.64-124.27,6.32-7.71c23.81,23.24,51.61,42,82.06,55.4,5.8,8.74,12.17,17.09,19.07,25,14.72,16.89,31.72,31.67,50.49,43.9l-6.3,7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3226.63,1367.79l-4,1.49-8,3c-7.56-4.38-14.95-9.17-22.12-14.24-9.24-6.52-18.12-13.52-26.5-20.62-.12-.09-.23-.18-.33-.28-2-1.64-3.85-3.31-5.73-5-4.71-4.13-9.22-8.28-13.54-12.38-18.84-17.82-36.36-37-52.41-57.37l3.93-4.8,1.26-1.52,5.91-7.22c.23,.45,.44,.93,.68,1.37,28.25,56.42,120.85,117.57,120.85,117.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3105.1,1248.88l-11.1,13.54s-80.69-39.16-131.4-96.7l2-12.65s79.47,80.08,140.5,95.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3170.38 1358.01 3165.81 1363.58 3153.11 1353.15 3152.79 1352.9 3157.32 1347.33 3157.66 1347.6 3170.38 1358.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3181.66 1357.98 3177.11 1363.53 3170.38 1358.01 3157.66 1347.6 3157.32 1347.33 3161.89 1341.77 3162.23 1342.04 3181.66 1357.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3192.73 1357.77 3192.52 1358.02 3188.17 1363.32 3181.66 1357.98 3162.23 1342.04 3161.89 1341.77 3165.69 1337.13 3166.44 1336.22 3166.78 1336.49 3192.73 1357.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2983.32,
    y: 1204.03,
    width: 7.18,
    height: 16.99,
    transform: "translate(155.95 2754.44) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2984.39,
    y: 1191.35,
    width: 7.18,
    height: 25.77,
    transform: "translate(162.76 2752.24) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2985.66,
    y: 1178.85,
    width: 7.18,
    height: 34.27,
    transform: "translate(169.6 2750.2) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3071.25,
    y: 1276.96,
    width: 15.36,
    height: 3.09,
    transform: "translate(138.34 2849.27) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M3166.78,1336.49l-.76,.92-3.8,4.63-4.56,5.56-4.55,5.55-26.06,31.81-1.51,1.85-6.09,7.42-1.52,1.86-6.08,7.41-.75,.92-21.64-17.73c-.63-.53-1.28-1-1.93-1.59l-27.84-22.8-1.93-1.58-23.25-19.06-5.43-4.46c-.3-.24-.6-.47-.89-.73l-27.37-22.41-1-.81c-.32-.26-.65-.52-1-.79-9.28-7.59-18.56-15.19-27.83-22.8l-1.94-1.58-19.91-16.32,.76-.94,6.08-7.41,1.52-1.86,6.08-7.41,1.53-1.86,26-31.79,4.55-5.55,4.56-5.55,3.78-4.62,.78-1,.14,.12,3.91,3.2,18.36,15.06,54,44.23,2.72,2.19,4.36,3.58,58.19,47.67,14.17,11.62,5.85,4.81,.3,.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 3020.19,
    y: 1206.92,
    width: 73.68,
    height: 192.69,
    transform: "translate(111.44 2841.91) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2987.68,
    y: 1267.88,
    width: 51.59,
    height: 28.09,
    transform: "translate(112 2800.41) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3018.33,
    y: 1295.07,
    width: 83.38,
    height: 8.99,
    transform: "translate(115.4 2842.87) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M3127.05,1384.96l-7.5-6.15-71-58.22-4.37-3.59-2.58-2.11-22.16-18.16-21.72-17.8-27.16-22.26-5.34-4.39-10.62-8.7-16.73,20.4,2.47,2,87.13,71.4,.88,.73,5.44,4.46,87.2,71.45,.77-.93,16-19.46-10.71-8.67Zm-185.76-121.25l6.08-7.41,1.52-1.86,6.08-7.41,8.68,7.11,5.34,4.39,14.58,11.93,1.93,1.59,10.66,8.73,17.17,14.08,1.93,1.59,2.65,2.12,22.15,18.17,2.59,2.1,4.36,3.59,25.21,20.66,1.94,1.59,27.83,22.8,1.94,1.59,14.13,11.58,7.5,6.15,8.68,7.11-6.08,7.42-1.53,1.86-6.07,7.41-8.69-7.11-21.63-17.73-1.94-1.59-27.82-22.81-1.94-1.59-29.63-24.2-27.37-22.43-1.93-1.58-27.82-22.81-1.94-1.59-19.92-16.32-8.64-7.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 3036.65,
    y: 1211.61,
    width: 2.4,
    height: 234.26,
    transform: "translate(84.71 2836.41) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3070.55,
    y: 1186.12,
    width: 4.31,
    height: 196.06,
    transform: "translate(131.96 2847.04) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3033.35,
    y: 1245.91,
    width: 15.36,
    height: 4.21,
    transform: "translate(148.04 2808.8) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3112.01,
    y: 1310.51,
    width: 15.36,
    height: 4.21,
    transform: "translate(126.88 2893.28) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2965.63,
    y: 1278.21,
    width: 23.98,
    height: 2.5,
    transform: "translate(100.77 2771.77) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2995.34,
    y: 1302.49,
    width: 23.98,
    height: 2.5,
    transform: "translate(92.87 2803.64) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 3054.27,
    y: 1350.84,
    width: 23.98,
    height: 2.5,
    transform: "translate(76.79 2866.41) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 3084.04,
    y: 1375.22,
    width: 23.98,
    height: 2.5,
    transform: "translate(69.09 2898.89) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2941.74,1265.64c-9.29,2.43-18.93,3.25-28.5,2.42-13.76-1.26-27.03-5.71-38.77-13,40.1,45.45,90.61,80.52,147.2,102.22l12.84-15.66-92.77-75.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3145.39,1477.12c-51.14-29.66-94.57-70.96-126.76-120.55-.13-.21-.26-.42-.4-.62l-2-3.11,.22-.28,11.85-14.46,.77-.94,5.43,4.46,23.26,19.05c.65,.54,1.29,1.07,1.94,1.58,9.27,7.63,18.54,15.23,27.82,22.81,.65,.54,1.3,1.06,1.93,1.59l21.64,17.73,10.62,8.7,.13,.1c-.57,9.59,.52,19.21,3.22,28.43,3.69,12.46,10.07,23.96,18.69,33.68,.59,.67,1.16,1.28,1.64,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M3020.91,1353.84l-11.61,14.17s-84.44-41-137.51-101.19l2.12-13.25s83.12,83.81,147,100.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M3148.08,1478.27l-12.56,4.68-4.07-2.39c-20.81-12.54-40.38-28-57.51-43.43-3-2.71-5.94-5.41-8.78-8.1-20.11-18.92-38.79-39.31-55.88-61l5.32-6.49,4-4.92,.28-.35,2-2.41,1.38,2.75c26.45,51.14,102.53,105.68,121.49,118.73,2.77,1.9,4.33,2.93,4.33,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M3068.69,1443.57l-151.64-124.27,6.32-7.71c14.94,14.56,31.46,27.39,49.25,38.27,10.54,6.44,21.5,12.17,32.81,17.14,5.8,8.74,12.17,17.09,19.07,25,14.74,16.87,31.73,31.62,50.51,43.83l-6.32,7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3135.44,1479.07l-4,1.49-8,3c-7.56-4.37-15-9.17-22.12-14.24-9.25-6.52-18.12-13.51-26.49-20.61-.12-.08-.23-.18-.33-.28-2-1.64-3.85-3.3-5.75-5-4.7-4.12-9.22-8.27-13.54-12.38-18.84-17.82-36.35-37-52.4-57.37l3.93-4.8,1.25-1.52,5.91-7.22c.22,.47,.45,.93,.7,1.38,28.25,56.41,120.84,117.55,120.84,117.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3013.91,1360.16l-11.1,13.54s-80.69-39.17-131.4-96.7l2-12.65s79.5,80.08,140.5,95.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3079.17 1469.28 3079.16 1469.29 3074.61 1474.85 3061.92 1464.44 3061.58 1464.17 3066.13 1458.62 3066.47 1458.88 3079.17 1469.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3090.46 1469.25 3085.89 1474.81 3079.16 1469.29 3066.47 1458.88 3066.13 1458.62 3070.7 1453.05 3071.03 1453.32 3090.46 1469.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3101.52 1469.04 3101.32 1469.3 3096.98 1474.6 3090.46 1469.25 3071.03 1453.32 3070.7 1453.05 3074.5 1448.41 3075.25 1447.5 3075.59 1447.77 3101.52 1469.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2892.08,
    y: 1315.32,
    width: 7.18,
    height: 16.99,
    transform: "translate(36.46 2724.62) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2893.23,
    y: 1302.59,
    width: 7.18,
    height: 25.77,
    transform: "translate(43.32 2722.46) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2894.47,
    y: 1290.1,
    width: 7.19,
    height: 34.27,
    transform: "translate(50.15 2720.41) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2980.13,
    y: 1388.38,
    width: 15.36,
    height: 3.09,
    transform: "translate(18.81 2819.59) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3075.59 1447.77 3074.83 1448.69 3071.03 1453.32 3066.47 1458.88 3061.92 1464.44 3035.86 1496.24 3034.35 1498.09 3028.26 1505.51 3026.74 1507.37 3020.66 1514.78 3019.9 1515.7 2998.27 1497.97 2996.33 1496.39 2968.5 1473.59 2966.57 1472 2936.99 1447.75 2909.63 1425.34 2907.7 1423.74 2879.87 1400.94 2877.93 1399.36 2858 1383.03 2858.77 1382.09 2864.85 1374.68 2866.37 1372.82 2872.45 1365.41 2873.97 1363.55 2900.02 1331.76 2904.57 1326.21 2909.12 1320.66 2912.9 1316.04 2913.68 1315.1 2913.82 1315.21 2917.74 1318.41 2936.09 1333.47 2990.07 1377.7 2992.67 1379.81 2997.04 1383.4 3055.21 1431.06 3069.38 1442.68 3075.25 1447.5 3075.59 1447.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2929,
    y: 1318.2,
    width: 73.68,
    height: 192.69,
    transform: "translate(-8.03 2812.13) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2896.59,
    y: 1379.11,
    width: 51.59,
    height: 28.09,
    transform: "translate(-7.4 2770.68) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2927.26,
    y: 1406.29,
    width: 83.38,
    height: 8.99,
    transform: "translate(-3.98 2813.15) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M3035.91,1496.24l-7.51-6.16-71.05-58.22-4.35-3.57-2.59-2.13-22.16-18.15-21.73-17.81-27.16-22.26-5.34-4.39-10.62-8.69-16.73,20.39,89.6,73.43,93.54,76.66,16.71-20.41-10.61-8.69Zm-6.51,25.65l-8.69-7.11-21.63-17.73-1.94-1.59-27.82-22.81-1.94-1.59-29.58-24.24-27.36-22.41-1.93-1.59-27.83-22.81-1.93-1.59-19.93-16.33-8.69-7.11,6.08-7.41,1.53-1.86,6.07-7.41,8.69,7.11,5.34,4.39,14.57,11.93,1.94,1.59,10.66,8.73,17.16,14.08,1.94,1.59,2.62,2.13,22.16,18.17,2.59,2.11,4.36,3.58,25.21,20.66,1.93,1.59,27.84,22.8,1.93,1.59,14.13,11.58,7.52,6.16,8.67,7.1-6.16,7.38-1.51,1.87-6,7.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2945.47,
    y: 1322.9,
    width: 2.4,
    height: 234.26,
    transform: "translate(-34.76 2806.63) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2979.36,
    y: 1297.4,
    width: 4.31,
    height: 196.06,
    transform: "translate(12.5 2817.25) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2942.13,
    y: 1357.14,
    width: 15.36,
    height: 4.21,
    transform: "translate(28.62 2778.97) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 3020.81,
    y: 1421.78,
    width: 15.36,
    height: 4.21,
    transform: "translate(7.44 2863.48) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2874.43,
    y: 1389.48,
    width: 23.98,
    height: 2.5,
    transform: "translate(-18.69 2741.97) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2904.35,
    y: 1414.2,
    width: 23.98,
    height: 2.5,
    transform: "translate(-27.09 2773.66) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2963.25,
    y: 1462.5,
    width: 23.98,
    height: 2.5,
    transform: "translate(-43.13 2836.36) rotate(-50.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2992.99,
    y: 1486.85,
    width: 23.98,
    height: 2.5,
    transform: "translate(-50.83 2868.81) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2942.46,1453.97h0l-12.23,14.94c-.2,.23-.4,.48-.6,.73l-2.72-1.07c-.22-.1-.46-.18-.68-.27l-4.54-1.84c-53.4-21.87-101.04-55.75-139.23-99,.74,.46,1.55,.94,2.43,1.45,11.14,6.43,23.54,10.35,36.35,11.5,9.57,.83,19.21,.01,28.5-2.42,28.81,23.62,57.62,47.23,86.45,70.84,2.04,1.74,4.16,3.42,6.27,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3053.33,1589.43c-51.15-29.63-94.58-70.92-126.75-120.51-.13-.21-.26-.42-.4-.62-.69-1.06-1.35-2.09-2-3.11l.21-.28c4.22-5.12,8.41-10.25,12.63-15.38,1.8,1.49,3.61,2.98,5.42,4.45,29.12,23.85,58.23,47.71,87.34,71.58-.56,9.58,.53,19.19,3.22,28.4,3.7,12.47,10.08,23.97,18.71,33.7,.58,.64,1.12,1.24,1.62,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M2928.84,1466.16l-11.61,14.17s-84.45-41-137.51-101.19l2.13-13.24s83.12,83.8,146.99,100.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M3056.02,1590.57l-12.56,4.7c-1.36-.79-2.72-1.6-4.06-2.41-20.82-12.53-40.39-28-57.52-43.43-3-2.7-5.9-5.39-8.73-8.07-20.12-18.92-38.81-39.31-55.92-61l5.31-6.48,4-4.93,.28-.35,2-2.41c.45,.93,.9,1.84,1.38,2.76,26.46,51.17,102.55,105.69,121.5,118.74,2.78,1.88,4.32,2.88,4.32,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M2976.64,1555.84l-151.65-124.27,6.32-7.71c14.94,14.55,31.46,27.39,49.26,38.27,10.54,6.44,21.5,12.16,32.81,17.13,5.8,8.74,12.17,17.1,19.07,25,14.73,16.87,31.73,31.62,50.51,43.83l-6.32,7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3043.38,1591.38l-4,1.49-8,3c-7.56-4.37-15-9.17-22.12-14.26-9.25-6.5-18.12-13.49-26.51-20.6-.11-.09-.22-.18-.32-.28-2-1.64-3.87-3.29-5.76-5-4.64-4.08-9.13-8.19-13.41-12.26-18.89-17.85-36.45-37.07-52.54-57.48l3.94-4.8,1.26-1.53,5.91-7.2c.23,.46,.45,.93,.69,1.37,28.25,56.39,120.86,117.55,120.86,117.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2921.85,1472.47l-11.1,13.55s-80.69-39.17-131.41-96.71l2-12.64s79.48,80.08,140.51,95.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "2987.12 1581.62 2982.57 1587.17 2969.86 1576.74 2969.53 1576.48 2974.08 1570.93 2974.42 1571.19 2987.12 1581.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "2998.41 1581.57 2993.85 1587.13 2987.12 1581.62 2974.42 1571.19 2974.08 1570.93 2978.63 1565.38 2978.97 1565.64 2998.41 1581.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "3009.48 1581.36 3009.28 1581.6 3004.93 1586.91 2998.41 1581.57 2978.97 1565.64 2978.63 1565.38 2982.45 1560.72 2983.18 1559.82 2983.19 1559.81 3009.48 1581.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2799.93,
    y: 1427.68,
    width: 7.18,
    height: 16.99,
    transform: "translate(-84.2 2694.49) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2801.12,
    y: 1414.93,
    width: 7.18,
    height: 25.77,
    transform: "translate(-77.3 2692.35) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2802.38,
    y: 1402.43,
    width: 7.18,
    height: 34.27,
    transform: "translate(-70.46 2690.31) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2888.06,
    y: 1500.65,
    width: 15.36,
    height: 3.09,
    transform: "translate(-101.72 2789.48) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "2983.52 1560.09 2982.77 1561 2978.97 1565.64 2974.42 1571.19 2969.86 1576.74 2943.81 1608.55 2942.28 1610.41 2936.21 1617.82 2934.68 1619.68 2928.61 1627.09 2928.18 1627.6 2927.85 1628.01 2906.22 1610.28 2904.49 1608.86 2904.28 1608.7 2876.45 1585.9 2874.51 1584.31 2851.27 1565.25 2845.83 1560.79 2844.93 1560.06 2817.57 1537.65 2815.65 1536.05 2787.81 1513.25 2785.88 1511.67 2765.96 1495.35 2766.29 1494.93 2766.72 1494.43 2772.79 1487.01 2774.32 1485.16 2780.39 1477.72 2781.92 1475.87 2807.96 1444.09 2812.51 1438.52 2817.07 1432.97 2820.85 1428.35 2821.62 1427.42 2821.63 1427.41 2825.68 1430.72 2844.03 1445.77 2898.03 1490.02 2900.6 1492.14 2904.97 1495.72 2963.28 1543.49 2977.32 1555 2983.18 1559.82 2983.52 1560.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2836.94,
    y: 1430.54,
    width: 73.68,
    height: 192.69,
    transform: "translate(-128.64 2782.06) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2804.5,
    y: 1491.46,
    width: 51.59,
    height: 28.09,
    transform: "translate(-128.03 2740.59) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2835.13,
    y: 1518.66,
    width: 83.38,
    height: 8.99,
    transform: "translate(-124.64 2783.04) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2943.81,1608.57l-7.5-6.15-71.05-58.22-4.35-3.63-2.57-2.12-22.17-18.15-21.73-17.82-27.15-22.25-5.35-4.4-10.63-8.69-16.74,20.43,2.15,1.75,87.45,71.65,.89,.74,5.44,4.46,87.2,71.46,1.1-1.35,15.63-19-10.62-8.71Zm-185.78-121.24l6.08-7.41,1.51-1.87,6.09-7.42,8.68,7.11,5.36,4.4,14.57,11.93,1.94,1.59,10.63,8.73,17.18,14.07,1.93,1.59,2.63,2.16,22.16,18.15,2.58,2.11,4.37,3.59,25.22,20.66,1.93,1.58,27.82,22.81,1.94,1.59,14.13,11.58,7.5,6.15,8.69,7.11-6.08,7.41-1.52,1.86-6.08,7.41-8.68-7.11-21.64-17.73-1.93-1.59-27.83-22.8-1.94-1.58-29.58-24.26-27.36-22.4-1.94-1.59-27.82-22.81-1.94-1.59-19.91-16.32-8.69-7.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2853.43,
    y: 1435.21,
    width: 2.4,
    height: 234.26,
    transform: "translate(-155.35 2776.57) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2887.3,
    y: 1409.72,
    width: 4.31,
    height: 196.06,
    transform: "translate(-108.1 2787.18) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2850.09,
    y: 1469.48,
    width: 15.36,
    height: 4.21,
    transform: "translate(-91.95 2748.91) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2928.79,
    y: 1534.2,
    width: 15.36,
    height: 4.21,
    transform: "translate(-113.19 2833.47) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2782.44,
    y: 1501.92,
    width: 23.98,
    height: 2.5,
    transform: "translate(-139.77 2710.97) rotate(-50.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2812.33,
    y: 1526.63,
    width: 23.98,
    height: 2.5,
    transform: "translate(-147.73 2743.65) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2871.14,
    y: 1574.69,
    width: 23.98,
    height: 2.5,
    transform: "translate(-163.38 2806.72) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2900.86,
    y: 1598.99,
    width: 23.98,
    height: 2.5,
    transform: "translate(-171.07 2839.14) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2758.83,1488.81c-9.29,2.43-18.93,3.26-28.5,2.43-13.76-1.27-27.03-5.72-38.77-13,40.1,45.45,90.6,80.52,147.2,102.22l12.84-15.66-92.77-75.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2962.48,1700.28c-51.15-29.62-94.59-70.91-126.76-120.5l-.4-.64c-.69-1-1.35-2.06-2-3.09l.22-.28,11.51-14c.25-.31,.51-.64,.77-.94l.33-.41,5.44,4.46,23.25,19c.65,.54,1.29,1.07,1.94,1.59,9.27,7.62,18.54,15.22,27.82,22.81l1.94,1.59,21.63,17.73,10.62,8.7,.13,.1c-.56,9.59,.53,19.21,3.22,28.43,3.7,12.49,10.11,24.01,18.77,33.74l1.57,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M2837.98,1577.02l-11.61,14.17s-84.44-41-137.51-101.2l2.13-13.23s83.12,83.81,146.99,100.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M2965.16,1701.45l-12.55,4.68c-1.37-.79-2.72-1.59-4.06-2.41-20.82-12.52-40.4-28-57.52-43.43-2.96-2.67-5.85-5.33-8.66-8-20.15-18.96-38.87-39.38-56-61.11l5.31-6.48,4-4.93,.29-.36,2-2.41c.43,.92,.9,1.82,1.37,2.75,26.51,51.22,102.72,105.82,121.57,118.82,2.72,1.87,4.25,2.88,4.25,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M2885.78,1666.7l-151.64-124.27,6.32-7.71c23.81,23.24,51.61,42,82.06,55.4,5.8,8.74,12.17,17.1,19.07,25,14.73,16.87,31.73,31.62,50.51,43.83l-6.32,7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2952.53,1702.23l-4,1.49-8,3c-7.54-4.36-14.94-9.15-22.1-14.24-9.25-6.51-18.12-13.49-26.51-20.6-.11-.09-.22-.18-.32-.28-2-1.65-3.86-3.31-5.76-5-4.7-4.13-9.21-8.28-13.53-12.38-18.84-17.82-36.35-36.98-52.4-57.35l3.93-4.8,1.26-1.52,5.91-7.23c.21,.47,.44,.93,.69,1.39,28.21,56.39,120.83,117.52,120.83,117.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2830.99,1583.33l-11.08,13.54s-80.69-39.16-131.41-96.7l2-12.64s79.46,80.04,140.49,95.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "2896.25 1692.46 2891.69 1698.02 2879 1687.61 2878.67 1687.34 2883.23 1681.78 2883.56 1682.05 2896.25 1692.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "2907.54 1692.42 2903 1697.99 2896.25 1692.46 2883.56 1682.05 2883.23 1681.78 2887.78 1676.23 2888.12 1676.5 2907.54 1692.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "2918.62 1692.22 2918.42 1692.47 2914.07 1697.77 2907.54 1692.42 2888.12 1676.5 2887.78 1676.23 2891.59 1671.59 2892.33 1670.68 2892.67 1670.95 2918.62 1692.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2709.13,
    y: 1538.49,
    width: 7.18,
    height: 16.99,
    transform: "translate(-203.17 2664.84) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2710.3,
    y: 1525.77,
    width: 7.18,
    height: 25.77,
    transform: "translate(-196.3 2662.69) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2711.51,
    y: 1513.28,
    width: 7.18,
    height: 34.27,
    transform: "translate(-189.48 2660.61) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2797.19,
    y: 1611.47,
    width: 15.36,
    height: 3.09,
    transform: "translate(-220.7 2759.78) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "2892.67 1670.95 2891.91 1671.87 2888.12 1676.5 2883.56 1682.05 2879 1687.61 2852.96 1719.41 2851.43 1721.26 2845.35 1728.69 2843.82 1730.55 2837.75 1737.95 2836.99 1738.88 2815.36 1721.15 2813.42 1719.56 2785.59 1696.76 2783.65 1695.18 2754.07 1670.92 2724.78 1646.92 2696.95 1624.12 2695.02 1622.53 2675.1 1606.21 2675.87 1605.28 2681.94 1597.87 2683.47 1596.01 2689.53 1588.59 2691.05 1586.73 2717.11 1554.95 2721.65 1549.39 2726.2 1543.84 2729.99 1539.22 2730.77 1538.27 2730.91 1538.39 2734.82 1541.59 2753.18 1556.65 2807.17 1600.89 2809.75 1602.99 2814.12 1606.58 2872.3 1654.24 2886.47 1665.85 2892.33 1670.68 2892.67 1670.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 2746.08,
    y: 1541.4,
    width: 73.68,
    height: 192.69,
    transform: "translate(-247.67 2752.38) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2709.13,
    y: 1583.58,
    width: 51.33,
    height: 27.95,
    transform: "translate(-233.42 2702.54) rotate(-50.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2744.27,
    y: 1629.52,
    width: 83.38,
    height: 8.99,
    transform: "translate(-243.67 2753.36) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2852.96,1719.4l-7.52-6.15-71-58.21-4.37-3.59-2.6-2.11-22.15-18.17-21.72-17.8-27.16-22.24-5.36-4.4-10.62-8.7-16.71,20.41,89.59,73.42,93.53,76.65,16.72-20.42-10.63-8.69Zm-6.53,25.67l-8.68-7.11-21.64-17.74-1.93-1.58-27.83-22.81-1.93-1.59-29.59-24.24-27.35-22.43-1.94-1.58-27.82-22.82-1.94-1.58-19.87-16.31-8.69-7.11,6.08-7.41,1.51-1.87,6.08-7.41,8.68,7.11,5.36,4.4,14.56,11.92,1.93,1.59,10.66,8.72,17.16,14.09,1.94,1.58,2.63,2.14,22.15,18.17,2.6,2.11,4.37,3.59,25.19,20.65,1.94,1.59,27.83,22.8,1.94,1.58,14.13,11.59,7.51,6.15,8.67,7.11-6.08,7.42-1.51,1.87-6.12,7.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2762.58,
    y: 1546.08,
    width: 2.4,
    height: 234.26,
    transform: "translate(-274.37 2746.9) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2796.43,
    y: 1520.6,
    width: 4.31,
    height: 196.06,
    transform: "translate(-227.15 2757.5) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2759.25,
    y: 1580.36,
    width: 15.36,
    height: 4.21,
    transform: "translate(-210.96 2719.25) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2837.93,
    y: 1645.04,
    width: 15.36,
    height: 4.21,
    transform: "translate(-232.18 2803.77) rotate(-50.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2691.6,
    y: 1612.82,
    width: 23.98,
    height: 2.5,
    transform: "translate(-258.4 2682.34) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2721.3,
    y: 1637.04,
    width: 23.98,
    height: 2.5,
    transform: "translate(-266.27 2714.19) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2780.3,
    y: 1685.62,
    width: 23.98,
    height: 2.5,
    transform: "translate(-282.23 2777.61) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 2809.91,
    y: 1709.6,
    width: 23.98,
    height: 2.5,
    transform: "translate(-289.94 2809.3) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2969.91,1576.75l-26,31.8,10.62,8.7-15.63,19,.13,.1c-.56,9.59,.53,19.21,3.22,28.43,3.66,12.5,10.03,24.03,18.66,33.79,2.72,1.88,4.25,2.89,4.25,2.89l-12.55,4.68c-1.37-.79-2.72-1.59-4.06-2.41l-8,3c-7.54-4.36-14.94-9.15-22.1-14.24l-4.35,5.3-6.53-5.35-4.54,5.57-6.75-5.53-4.56,5.56-12.72-10.47-26,31.79,10.6,8.69-16.72,20.42-93.53-76.65,.76-.94,.76-.92,3.6-4.38h0l2.47-3,1.52-1.86,6.09-7.42,1.52-1.86,26-31.78,2.73-3.33,6.33-7.72,3.92-4.78,.69-.85,1.54-1.87,5-6.08,4.63-5.65,.57-.68,5.37-6.56,4-4.83,1.57-1.91,11.81-14.42,.76-.93,.35-.41,.41-.52,3.6-4.38,2.48-3,1.52-1.86,6.08-7.41,1.48-1.9,26.06-31.79,2.73-3.34,6.31-7.7,3.93-4.8,.68-.83,1.54-1.88,5-6.07,4.62-5.64,.57-.71,5.35-6.53,4-4.85,1.57-1.91,12.93-15.76c2.09,1.73,4.21,3.46,6.32,5.18h0c29.12,23.85,58.23,47.71,87.34,71.58-.56,9.58,.53,19.19,3.22,28.4,3.7,12.47,10.08,23.97,18.71,33.7,2.76,1.9,4.3,2.92,4.3,2.92l-12.56,4.7c-1.36-.79-2.72-1.6-4.06-2.41l-8,3c-7.56-4.37-15-9.17-22.12-14.26l-4.35,5.31-6.52-5.34-4.56,5.56-6.73-5.51-4.55,5.55-12.73-10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M3153.11,1353.15l-26.06,31.81,10.62,8.7-16,19.46,.13,.1c-.57,9.59,.52,19.21,3.22,28.43,3.69,12.46,10.07,23.96,18.69,33.68,2.76,1.91,4.32,2.94,4.32,2.94l-12.56,4.68-4.07-2.39-8,3c-7.56-4.37-15-9.17-22.12-14.24l-4.34,5.3-6.52-5.35-4.57,5.56-6.73-5.51-4.55,5.55-12.66-10.43-26.06,31.8,10.61,8.69-16.71,20.41-93.54-76.66,.77-.93,.76-.93,3.59-4.38,2.48-3,1.53-1.86,6.08-7.42,1.52-1.84,26-31.8,2.74-3.33,6.32-7.7,3.92-4.8,.7-.85,1.52-1.86,5-6.09,4.62-5.64,.58-.69,5.37-6.55,3.95-4.83,1.56-1.91,12.17-14.83,.76-.94,.76-.92,3.59-4.39,2.49-3,1.52-1.86,6.08-7.43,1.51-1.85,26.06-31.78,2.72-3.34,6.33-7.7,3.93-4.79,.69-.85,1.53-1.86,5-6.09,4.63-5.64,.57-.69,5.37-6.55,3.95-4.83,1.58-1.92,12.14-14.83,.77-.94,.75-.92,3.6-4.38,2.48-3,1.52-1.86,6.09-7.42,1.52-1.86,26-31.77,2.73-3.34,6.31-7.71,3.93-4.79,.7-.85,1.52-1.86,5-6.08,4.62-5.64,1.88-2.3,4-4.94,5.86-7.14,1.1-1.35,39.34-48,1-1.2,6-7.34,2.22-2.71,6.15-7.5,11.22-13.61,3.08-3.76,5-6,3.07-3.77,4.95-6,3.07-3.75,5-6,3.07-3.75,5-6,3.07-3.76,4.95-6,3.08-3.76,4.94-6,3.08-3.76,5-6,3.07-3.74,20.33-24.82,5.63-6.87,2,1.61,10.59-12.9,2.17,1.77-10.6,12.92,4.14,3.39-5.64,6.87-2.6-2.14-20.32,24.8,7.38,6-3.08,3.76-7.38-6-5,6,7.39,6-3.08,3.76-7.39-6-4.94,6,7.38,6.06-3.07,3.74-7.38-6.06-5,6.06,7.39,6.06-3.07,3.74-7.39-6.06-4.95,6,7.38,6.05-3.08,3.76-7.38-6.06-4.95,6.05,7.39,6-3.08,3.76-7.39-6.06-5,6,7.4,6.06-3.08,3.76-7.4-6.07-4.94,6,7.38,6-3.07,3.75-7.38-6.06-11.1,13.56,5.43,4.46-6.15,7.5,7.61,6.23-8.37,10.2c4.09,26.52,11.49,52.43,22,77.12,12.51,29.35,29.19,56.74,49.53,81.32l1.55,1-12.56,4.69-2.22-1.31-10.39,3.89c-7.56-4.38-15-9.17-22.12-14.25l-4.35,5.3-6.51-5.34-4.56,5.55-6.74-5.53-4.55,5.57-12.71-10.42-26,31.8,10.61,8.68-16,19.49,.13,.1c-.56,9.59,.52,19.2,3.21,28.42,3.71,12.49,10.11,24.01,18.77,33.75,2.72,1.87,4.25,2.88,4.25,2.88l-12.55,4.68c-1.37-.79-2.72-1.59-4.08-2.4l-8,3c-7.56-4.38-14.95-9.17-22.12-14.24l-4.35,5.29-6.51-5.34-4.55,5.55-6.73-5.52-4.57,5.57-12.84-10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2492.51,1397.68c-9.13,20.19-29.17,64.81-29.17,64.81l-16.84,27s-15.35,1.6-23-8.59l-1-1.29c-6.69-9.09-6.89-11.17-1.55-12.76,10.35-3.08,9.82-32,25.25-55.45,2.88-4.37,8.48-11.83,11.77-23.17,.77-2.53,1.38-5.1,1.82-7.71,1.21-7.39,.67-13.39,2.48-22.67,.17-1.59,.8-3.09,1.8-4.33,.26-.27,.55-.52,.87-.73,1.34-.88,3.47-1.26,7.69-.71,3.38,.41,6.7,1.25,9.87,2.5,1.43,1.59,22.5,11.39,22.5,11.39,0,0-3.37,11.52-12.49,31.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2444.44,1432.46c-6.6,9.1-11.75,29.81-15.65,35.8-3.06,4.7-4.47,9.56-6.23,11.31-6.69-9.09-6.89-11.17-1.55-12.76,10.35-3.08,9.82-32,25.25-55.45,2.88-4.37,8.48-11.83,11.77-23.17,.77-2.53,1.38-5.1,1.82-7.71,1.21-7.39,.67-13.39,2.48-22.67,.17-1.59,.8-3.09,1.8-4.33,.26-.27,.55-.52,.87-.73-.34,4.24-.67,8.4-.91,10.87-.62,6.52-.94,12.31-1.27,19.79s-4.58,26-4.58,26c0,0-7.21,13.95-13.8,23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2329.02,1339.4s14.06,5.87,17.64,6.52,10.11,.84,10.71-.6,2.91-3,2.88-5.58-1.17-6.41-3.05-7.2-20-7.49-22.29-5.92-6.23,11-6.06,11.87l.17,.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2611.91,1448.81c-.4,.58-.8,1.14-1.2,1.65-.61,.84-1.31,1.6-2.09,2.28q-2.09,1.66-4.18,1.64c-2.09-.02-34.21-16.82-39.86-20s-11.3-4.72-19.34-7.23-15.18-5.49-19.05-8-42.28-17.58-45.28-18.86-12.2-4.25-23.51-9-27.68-10.71-32.74-12-.57-5.32,0-8.45,7.19-8.85,7.19-8.85c0,0,19.35,5.54,23.22,6.31s28.26,14.34,39.87,18.34,28.27,11,36.3,15.15c7.1,3.71,16.75,5.19,23.42,7.37,.89,.28,1.72,.59,2.48,.91,6.55,2.73,19.93,10.85,24.69,12.84s9.81,4.95,16.07,6.71,11.6,5.69,16.07,6.71c3.1,.7,2.46,2.3,1.67,4-.37,.71-.64,1.47-.81,2.26-.11,1.45-1.45,3.98-2.92,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2648.8,1462l-.3,.62-1.21,2.89s-5.66-1.52-11.91-3.28c-4.59-1.42-9.26-2.53-14-3.31-2.69-.27-9.82-4.94-10.41-6.88-.17-.51-.27-1.04-.3-1.58,0-.65,.07-1.3,.22-1.93,.16-.76,.4-1.7,.7-3,.91-3.86,1.8-2.64,2.4-4.08,.16-.37,.78-.73,1.7-1,3.62-1,7.38-1.42,11.13-1.22,4.77,.29,12.21,2.55,15.19,3.8s8,4.19,8,4.19c0,0,2.37,4.38,2.66,5.35,.29,.77-2.87,7.37-3.87,9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2441.74,1361.91l-1.8,4.33c-.6,1.44-1.51,3.6-3.3,4.55s-8.34-1.79-8.34-1.79c0,0-18.74-8.67-19.64-8.2,0,0-.26-7.73,.64-9.89,1.41-2.57,3.11-4.97,5.08-7.14,.73-.88,1.54-1.69,2.41-2.43,2.09-1.67,4.76,2,9.82,3.25s8,5.89,9.22,6.39,5.91,10.93,5.91,10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2647.45,1572.4c-2.44,2.2-5.25,3.07-6.87,2.9-2.68-.27-18.44-9.39-24.39-11.87-2.2-.99-4.28-2.22-6.22-3.65-4.74-3.4-9.07-7.76-8-9.08,1.5-1.91,14.45-34.6,18.06-43.25s25.19-36.9,25.19-36.9c0,0,24.41,8.5,28.86,12.9,2.6,2.4,3.52,6.11,2.35,9.44,0,0-1.65,3.43-3.53,7.12h0c-1.41,2.8-2.95,5.76-4,7.52-2.4,4.07-3,7.21-5.42,13-2.13,5.07-4.64,9.96-7.51,14.65-.7,1.1-1.2,4.14-1.64,8-.9,7.72-1.54,18.63-3,23.14-.73,2.34-2.07,4.44-3.88,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2590.31,1550.08l-8-2.52-16.7-5.25-19-16.4c1.87-5.42,4.08-10.72,6.62-15.87,3.61-7,5.11-8.87,7.21-13.92s4.83-14.91,6.34-18.52,6-16.11,11.42-22.32,14.78-6.71,14.31-6.35,13.72,2.81,15.8,4.53c1.17,1,3.72,5.95,5.79,10.63,1.29,2.66,2.33,5.45,3.08,8.31,.28,2.66-6.34,18.52-10.25,27.89s-8.12,17.77-9.33,20.66,1.45,11.61,.53,17.15-7.82,11.98-7.82,11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2475.5,1490.3s-5.11,10.56-8.7,12.45c-1.31,.69-3.64,.28-6.43-.59-4.84-1.51-11.06-4.4-15.6-5.22-7.15-1.29-16.35-11.06-16-15.16s2.71-6.49,7.22-15.61,31.35-70.92,31.35-70.92l29.65,11.51,1,.39s5,4,3.16,6.66-12,23.76-14.75,33.63-4.83,16.61-4.85,20-6.05,22.86-6.05,22.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2529.63,1421.76s-14.91,24.81-19.42,35.62-21.05,45.39-20.47,49,5.93,7.56,14.56,10.32,19.63,9.89,22,9.19,5.08-3.8,6.58-5.72,11.15-28.36,11.15-28.36l7.3-35.9s7.22-17.3,7.24-20.68-.85-11.36-6.21-11.91-22.73-1.56-22.73-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2435.8,1431.39c-4.51,9.13-12.9,19.17-17.11,27.57s-9,18.25-9,18.25c0,0-1.18,.35-5.43-.93-2.4-.74-4.76-1.61-7.07-2.6-10.12-4.22-25.88-11.65-25.88-11.65,0,0-4.46-4.4,2.43-12.53s24.3-38.11,25.81-41.71,8.72-19.22,10.52-21.86,9.27-7.13,11.66-7.83c1.42-.41,9.91,3,16.86,6.18,4.72,2.14,8.73,4.16,9.32,4.75,.92,.93-7.61,33.24-12.11,42.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2331.17,1430.89c-2.1,5-5.38,4.53-9.85,3.51-2.59-.64-5.08-1.63-7.4-2.94-.59-.32-.93-.54-.93-.54,0,0-15.15-12.25-12.44-18.74s4.82-13.23,9-23.32,12.58-16.76,16.79-25.16,9-21.51,9-21.51c0,0,8.55,3.46,14.2,5.8l1.92,.79c5.36,2.24,4.75,3.68,5.64,4.9s-.63,9.89-1.54,13.74-12.05,30.53-12.05,30.53c0,0-10.23,27.89-12.34,32.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2367.19,1443.39c-3,8.9-5.69,6.93-9,8.1s-4.47,.68-11-2.06c-.84-.35-1.85-.81-3-1.35-7.53-3.64-19.94-10.75-19.94-10.75,0,0,5.74-18.77,9-25s6.3-8.38,15-17.45,5.69-5.25,9-11.49,1.21-4.57,4.22-11.78,8.7-14.15,9.31-15.59l7.73,3.23c.18,.07,1.43,.81,3.12,1.84,4.14,2.52,10.94,6.82,11.15,7.51,.3,1,0,6.76,.55,12.08s-1.53,10.36-6.06,22.87-9.3,15.58-15.29,23.24-1.77,7.7-4.79,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2717.42,1518.49c-.9,2.16-13.71-.64-13.71-.64,0,0-5.66,.17-8.64-1.07s-22.23-8.12-22-9.19c.13-.66,.29-1.49,.54-2.39,.89-3.38,2.78-7.77,7.25-7.91,5.67-.17,13.71,.65,25.63,2.23,4.4,.59,7.37,1.85,9.37,3.38,2.57,1.9,4.06,4.93,4,8.13-.04,3.38-1.54,5.3-2.44,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2673.44,1558.57c-6,12.73-6.32,15.14-9,16.56s-5.08,2.11-7.46,1.12c-.94-.39-2.17-.9-3.54-1.53-2.36-1.06-4.65-2.28-6.84-3.65-3.84-2.45,2.71-15,5.21-16.87s3.2-5,6.8-12,3-7.21,5.73-15.39,5.42-14.67,6.62-15.86c0,0,4.78-1.39,6.83-.87,1,.27,2.82,2.74,4.56,5.46s3.47,5.83,4.06,6.94c1.19,2.19-.91,5.55-3.33,13s-3.63,10.34-9.64,23.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2701.73,1564.43s-6.61,14.17-9.92,20.41-10.12-2.53-10.12-2.53c0,0-1-.41-2.42-1.06-3.15-1.37-6.22-2.92-9.19-4.63-4.45-2.71-.58-3.63,1.52-7s6.63-17.55,8.76-26.4,5.13-16.9,7.53-21c2.09-3.19,4.5-6.15,7.19-8.85,0,0,4.86-.27,9.67-.29,2.34,0,4.68,0,6.43,.23,5.36,.55,2.36,6.07,2.35,7.76,.18,2.75-.04,5.51-.63,8.2-1.09,5.13-2.7,10.13-4.83,14.92-3.31,7.96-6.34,20.24-6.34,20.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2331.17,1430.89c-2.1,5-5.38,4.53-9.85,3.51-2.59-.64-5.08-1.63-7.4-2.94-.53-7.68,8.1-22.17,12-29.85s6.64-20.93,17.14-36c5.61-8.07,6.69-13.91,6.49-17.6l1.92,.79c5.36,2.24,4.75,3.68,5.64,4.9s-.63,9.89-1.54,13.74-12.05,30.53-12.05,30.53c0,0-10.24,27.87-12.35,32.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2367.19,1443.39c-3,8.9-5.69,6.93-9,8.1s-4.47,.68-11-2.06c-.84-.35-1.85-.81-3-1.35,3.09-3.86,7.95-8.27,11.66-12.79,5.7-6.94,12.63-25.21,15-31s.63-9.89,2.47-21c1.16-7.06,4.88-15.47,8.28-22.25,4.14,2.52,10.94,6.82,11.15,7.51,.3,1,0,6.76,.55,12.08s-1.53,10.36-6.06,22.87-9.3,15.58-15.29,23.24-1.74,7.75-4.76,16.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2673.44,1558.57c-6,12.73-6.32,15.14-9,16.56s-5.08,2.11-7.46,1.12c-.94-.39-2.17-.9-3.54-1.53,1.5-1.9,3.61-3.6,10.75-12.39s7.81-13.67,7.81-13.67l6-11s3.66-13.29,4.34-22.06c1.78,2.79,3.47,5.83,4.06,6.94,1.19,2.19-.91,5.55-3.33,13s-3.62,10.28-9.63,23.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2701.73,1564.43s-6.61,14.17-9.92,20.41-10.12-2.53-10.12-2.53c0,0-1-.41-2.42-1.06,3.14-3.87,9-9.73,9-9.73,0,0,6-12.73,7.83-18.75s6-17.8,7.23-20.68,.94-8.93,1.26-16.41c0-.8,.08-1.66,.14-2.57,2.34,0,4.68,0,6.43,.23,5.36,.55,2.36,6.07,2.35,7.76,.18,2.75-.04,5.51-.63,8.2-1.09,5.13-2.7,10.13-4.83,14.92-3.29,7.93-6.32,20.21-6.32,20.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2646.91,1569.05c.55-8.98,2.48-17.83,5.72-26.23,.67-1.7,1.38-3.34,2.13-4.93,.14-.72,.38-1.41,.72-2.06,2.87-4.68,5.38-9.58,7.51-14.65,2.41-5.77,3-8.9,5.42-13,1-1.75,2.57-4.71,4-7.51h0c-2.18-5.93-6.28-10.97-11.65-14.3-2.58-1.54-5.41-2.63-8.35-3.23l-6.55,3.78c-.52,.51-1,1.06-1.44,1.65-1.3,1.74-2.23,3.72-2.73,5.83-.58,2.23-4,8.6-16.43,27.06l-5.76,13.2c-.77,8.34-3.59,16.36-8.22,23.34-.57,.85-1.17,1.66-1.77,2.44,1.94,1.43,4.02,2.66,6.22,3.65,6,2.48,21.71,11.6,24.39,11.87,2.25-.03,4.43-.84,6.14-2.31,.2-1.53,.42-3.08,.65-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2587.35,1545.46l-5.05,2.1-16.7-5.25-19-16.4c1.87-5.42,4.08-10.72,6.62-15.87,3.61-7,5.11-8.87,7.21-13.92s4.83-14.91,6.34-18.52,6-16.11,11.42-22.32,14.78-6.71,14.31-6.35,13.72,2.81,15.8,4.53c1.17,1,3.72,5.95,5.79,10.63-1.73,5.32-4.92,13.69-6.79,16.89-2.41,4.07-9.31,15.58-10.84,25.95s-3.36,18.07-4,22.89-5.11,15.64-5.11,15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2435.8,1431.39c-4.51,9.13-12.9,19.17-17.11,27.57s-9,18.25-9,18.25c0,0-1.18,.35-5.43-.93,.41-1.67,.94-3.31,1.58-4.91,2.71-6.49,25.83-46.79,28.83-50.62,2.44-3.11,3.58-27.46,3.92-36.47,4.72,2.14,8.73,4.16,9.32,4.75,.92,.93-7.61,33.24-12.11,42.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2475.5,1490.3s-5.11,10.56-8.7,12.45c-1.31,.69-3.64,.28-6.43-.59,1.33-2.68,2.46-5.45,5-7.63,3.29-2.86,12.61-21.83,14.43-29.54s7-28.41,8.49-33.71,8.11-16.08,8.11-16.08c0,0,.28-4,.58-8.44l1,.39s5,4,3.16,6.66-12,23.76-14.75,33.63-4.83,16.61-4.85,20-6.04,22.86-6.04,22.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2441.74,1361.91l-1.8,4.33c-2.37-4.37-1.77-5.82-3.84-9.22-1.5-2.47-14.38-9.24-21.72-13.25,.73-.88,1.54-1.69,2.41-2.43,2.09-1.67,4.76,2,9.82,3.25s8,5.89,9.22,6.39,5.91,10.93,5.91,10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2648.8,1462c-6.65-2.53-22.62-8.52-31-11.33-2-.67-4-1.27-6-1.86-.33-.1-.65-.2-1-.28-8.16-2.4-16.54-4.65-25.8-9.83-11.89-6.66-30.05-13.4-29.13-18.94,.34-2.07-.3-6.19-1.25-10.55,.89,.28,1.72,.59,2.48,.91,6.55,2.73,19.93,10.85,24.69,12.84s9.81,4.95,16.07,6.71,11.6,5.69,16.07,6.71c3.1,.7,2.46,2.3,1.67,4,3.62-1,7.38-1.42,11.13-1.22,4.77,.29,12.21,2.55,15.19,3.8s8,4.19,8,4.19c0,0,2.37,4.38,2.66,5.35,.38,.84-2.78,7.44-3.78,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2360.48,1333.92s-15.79-.67-16.69-.2-9,3-8.67,5.69,14.14,12.72,14.14,12.72l13-5.64s7.19-8.85,6.9-9.82-8.98-2.03-8.68-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2717.42,1518.49c-.9,2.16-13.71-.64-13.71-.64,0,0-5.66,.17-8.64-1.07s-22.23-8.12-22-9.19c.13-.66,.29-1.49,.54-2.39l28.64,9.49s10.47-8.33,12-10.25c.49-.57,1.04-1.09,1.64-1.54,2.57,1.9,4.06,4.93,4,8.13-.07,3.38-1.57,5.3-2.47,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M2630.91,1598.03c2.5,.2,4.97,.72,7.34,1.55,11.92,4,37.61,8.37,40.89,7s7.82-13.24,7.82-13.24c0,0-2.67-14.53-3.88-18.43s-2-17.72-2-17.72l-2.55-.34-66.7-8.82c-1.29-.55-14.93,7.65-19.2,10.29s-15.19,7.31-17.2,11.62c-.65,1.33-1.1,2.75-1.33,4.21l56.81,23.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2736.83,1456.08c-.79,2.5-3.83,8.69-7.88,16.43-9.49,18.12-24.58,44.69-29.46,52-7,10.45-5,16-10.47,24.94s-17.28,13.46-30.23,14.5c-5.59,.44-15.53-1.06-25.32-3.76-12.88-3.54-25.51-9.13-27.63-15-.23-.62-.42-1.2-.59-1.75-3.31-10.73,3.35-8.75,7.82-15.49,4-6,10.43-15.66,13-22.09,.43-1,.76-2.03,1-3.09,1.21-6,10.84-16.59,11.9-22.18s11.18-6.1,14.09-7.89,15.91-10.16,18.33-13.88,1.52-6.7,1.68-12.24c.15-4.87-3.3-3.57,11.54-12.49,2-1.22,4.38-2.62,7.14-4.26,23-13.66,44.33,4.36,48.91,8.87s-1.12,8.94-3.79,17.22c.04,.06-.02,.11-.04,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2665.91,1463.92c.27-.38,2.33-.16,8.09-2.06s13.33-8.64,15.11-8.76,6.22,7.79,7.4,12.17,6.09,7.08,11.08,7,16,3.48,16-4.72-1.36-20.42-13.1-25.34-28.44-4.17-34.44,.87-1,11.21-2.85,13.47-8.32,8.13-8.32,8.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2611.79,1551.39s-3.78,14.35-2.31,19.07,24.22,18.35,35.34,14,27-22.89,27-22.89c0,0-31.82,3.62-60.03-10.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2657.91,1523.47s-6.81,.81-7.7,.86-12.52,2.09-17.85,2.44-21.34,15.42-24.13,16.4c-.95,.29-1.96,.39-2.95,.28-3.31-10.73,3.35-8.75,7.82-15.49,4-6,10.43-15.66,13-22.09,2.72-1.22,5.83-1.27,8.58-.12,8,3.13,17.54,9.09,19.52,12.08s3.71,5.64,3.71,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2689.02,1549.47c-5.46,8.92-17.28,13.46-30.23,14.5-5.59,.44-15.53-1.06-25.32-3.76,11.92-2,25.86-6.19,30.72-7.57,7.35-2.09,12.49-15.9,20-32.17s22.61-38.63,25.28-40.73c5.67-4.26,12.45-6.77,19.52-7.23-9.49,18.12-24.58,44.69-29.46,52-7.01,10.47-5.04,16.06-10.51,24.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2639.33,1479.24c.19,.07,1.22-4.45,5-5.24s41.46-18.63,43-20.78,7.07,5.77,9.18,12-27.17,35-27.17,35l-30.01-20.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2736.91,1455.93c-.84,.11-1.63-.43-1.84-1.25-2.37-6.17-8.86-11.27-19.64-17.95-9-5.6-25-3.47-30.78-2.63,2-1.22,4.38-2.62,7.14-4.26,23-13.66,44.33,4.36,48.91,8.87s-1.15,8.94-3.79,17.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2736.72,1435.76c.19,.08,8.56,5.31,9.39,8.47s1.09,8.22,1.51,9.26,2.54,.63,.11,6.94-35.72,72.8-39.49,75.1-13.36,.13-12.06-5.1,43.89-78,43.89-78l-3.35-16.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2640.04,1479.1s-4.27,5.54-3.62,8.62,2.18,4.58,5.78,7.82,11.16,10.93,16.3,10.5,10.69-2.85,10.56-6.14,1.28-6.15-5.17-9.28-21.36-12.84-23.85-11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2664.08,1505.57h0c-6.17,2.12-12.74,2.83-19.22,2.07,0,0-4.3-.53-13.83-5.59-.39-.2-1.33-.72-1.35-1.42,0-1.24,2.86-1.34,5.2-3.65s2.08-5,3.48-5.22,2.12,1.8,3.82,3.76c.02,.05,6.21,7.16,21.9,10.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2630.91,1598.03c2.5,.2,4.97,.72,7.34,1.55,11.92,4,37.61,8.37,40.89,7s7.82-13.24,7.82-13.24c0,0-2.67-14.53-3.88-18.43s-2-17.72-2-17.72l-2.55-.34c-.94,5-4.09,11.22-12.57,17.11-14.48,10.06-42.76,7.31-60.12,13.51l25.07,10.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M2656.42,1346.1l-6.18,10.76,27.39,15.73,3.36-5.87s-19.41-13.75-24.57-20.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M2704.05,1373.45l-6.18,10.76-27.38-15.72,3.36-5.87s21.67,9.83,30.2,10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M2783.6,1419.12l-6.18,10.76,27.39,15.69,3.37-5.86s-19.42-13.72-24.58-20.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M2831.24,1446.47l-6.18,10.76-27.39-15.73,3.37-5.86s21.67,9.83,30.2,10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M2639.61,1285.64l-2.34,17.45s136.89,94.81,244.07,135l12-11.92s-115.85-40.02-253.73-140.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M2637.43,1267.09l-2.5,18.72s146.84,101.7,261.81,144.81l12.84-12.79s-124.24-42.93-272.15-150.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M2644.43,1308.48l-3.15,11.43c.34,.15,223.08,124.64,222.45,124.29l8.33-9.31s-125.69-61.48-227.63-126.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 2729.47,
    y: 1287.01,
    width: 11.48,
    height: 241.47,
    transform: "translate(152.54 3078.95) rotate(-60.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M2680.2,1338.41c-41.33,65.24-82.64,130.49-123.92,195.74l27.67,15,113.59-200.82-17.34-9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M2824.73,1421.38l-106.58,205.7-26.93-16.32c38.72-66.44,77.44-132.88,116.17-199.33l17.34,9.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "2588.44 1552.43 2611.14 1512.3 2576.28 1492.29 2551.59 1531.28 2588.44 1552.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "2723.84 1630.16 2745.07 1589.19 2710.2 1569.17 2686.99 1609.01 2723.84 1630.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2682.41,
    y: 1333.85,
    width: 8.15,
    height: 27.41,
    transform: "translate(180.27 3006.47) rotate(-60.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 2810.26,
    y: 1407.22,
    width: 8.15,
    height: 27.41,
    transform: "translate(180.83 3154.19) rotate(-60.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 2728.15,
    y: 1381.04,
    width: 31.85,
    height: 20.37,
    transform: "translate(171.32 3078.35) rotate(-60.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1862.76,1351.19l9.33-2.48,.29-8-9.25,.17s-.13,10.83-.37,10.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M2172.37,1359.2l-294.08-11.55c-3.19,2.66-5.98,5.75-8.29,9.2-4.73,7.17-7.35,15.52-7.56,24.11l308.72,11.31,1.21-33.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M2210.62,1275.35l-1.27,34.62-339.75-12.4v-.25c0-.51,.16-1.76,.34-3.59,.87-8.83,3.29-31.2,7-48.78,4.68-22.43,25.18-21.42,25.18-21.42l280.26,10.27c29.91,2.84,28.24,41.55,28.24,41.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M2209.35,1309.97l-3.16,86.15-66.14-2.42c.87-3.71,.94-7.56,.19-11.29-.24-1.23-.57-2.45-1-3.63-4.88-13.76-19.99-20.95-33.75-16.07-10.21,3.62-17.18,13.12-17.57,23.95-.07,1.72,.04,3.44,.31,5.14l-170.74-6.23c.39-1.68,.62-3.39,.68-5.11,.56-14.59-10.81-26.87-25.39-27.43-14.59-.56-26.87,10.81-27.43,25.39-.07,1.76,.04,3.51,.32,5.25l-3.33-.12,1.23-33.33,8.28-1.92,.26-7.16,20.49-5.43,1.36-37.28,315.39,11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1869.71,1378.66c-.44,12.18,9.07,22.41,21.24,22.85,12.18,.44,22.41-9.07,22.85-21.24,.44-12.17-9.06-22.4-21.23-22.85-12.17-.44-22.4,9.07-22.86,21.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1905.35,1379.97c.28-7.51-5.58-13.82-13.09-14.09-7.51-.28-13.82,5.58-14.09,13.09-.28,7.51,5.58,13.82,13.09,14.09h.01c7.5,.28,13.8-5.58,14.08-13.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1904.07,1379.92c.24-6.79-5.07-12.5-11.86-12.74-6.79-.24-12.5,5.07-12.74,11.86-.24,6.79,5.06,12.49,11.84,12.74,6.8,.25,12.51-5.06,12.76-11.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1899.46,1379.75c.16-4.25-3.16-7.82-7.41-7.98-4.25-.16-7.82,3.16-7.98,7.41-.16,4.24,3.15,7.81,7.39,7.98,4.25,.17,7.83-3.14,8-7.39v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1897.66,1379.68c.11-3.26-2.43-5.99-5.69-6.1-3.26-.11-5.99,2.43-6.1,5.69-.11,3.25,2.43,5.98,5.68,6.1,3.26,.12,5.99-2.43,6.11-5.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1893.38,1370.28c.02-.71-.53-1.3-1.24-1.32-.71-.02-1.3,.53-1.32,1.23h0c-.02,.71,.53,1.3,1.24,1.32,.71,.02,1.3-.53,1.32-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1886.42,1371.83c-.48-.52-1.29-.55-1.81-.07-.52,.48-.55,1.29-.07,1.81,.48,.52,1.29,.55,1.81,.07,.51-.48,.55-1.29,.07-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1882.58,1377.85c-.71-.02-1.3,.53-1.32,1.23-.02,.71,.53,1.3,1.23,1.33s1.3-.53,1.33-1.23c.02-.71-.53-1.3-1.24-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1884.12,1384.82c-.52,.48-.55,1.3-.06,1.81,.48,.52,1.3,.55,1.81,.07s.55-1.3,.06-1.81c-.48-.52-1.3-.55-1.81-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1890.14,1388.65c-.03,.71,.52,1.32,1.23,1.35,.71,.03,1.32-.52,1.35-1.23,.03-.71-.52-1.32-1.23-1.35h-.02c-.71-.02-1.3,.52-1.33,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1897.11,1387.11c.48,.52,1.29,.55,1.81,.07,.52-.48,.55-1.29,.07-1.81-.48-.52-1.29-.55-1.81-.07-.52,.47-.56,1.28-.08,1.79v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1900.91,1381.09c.71,.02,1.3-.53,1.32-1.24,.02-.71-.53-1.3-1.24-1.32-.7-.02-1.29,.53-1.32,1.23-.02,.71,.53,1.3,1.24,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1899.4,1374.12c.52-.48,.55-1.29,.07-1.81-.48-.52-1.29-.55-1.81-.07-.52,.48-.55,1.29-.07,1.81,.48,.52,1.29,.55,1.81,.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M2210.26,1306.15l-.13,3.59-340.5-12.47c0-.51,.16-1.76,.34-3.59l340.29,12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1930.58,1371.13l159.55,5.85c-.49,1.17-.9,2.37-1.22,3.59l-158.42-5.81,.09-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M2156.74,1379.42l-.13,3.59-16.37-.6c-.24-1.23-.57-2.45-1-3.63l17.5,.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1936.5,
    y: 1231.7,
    width: 31.91,
    height: 51.1,
    rx: 1.95,
    ry: 1.95,
    transform: "translate(618.17 3157.89) rotate(-87.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1939.71,
    y: 1300.93,
    width: 31.88,
    height: 51.06,
    rx: 1.95,
    ry: 1.95,
    transform: "translate(558.43 3232.19) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1895.49,
    y: 1308.93,
    width: 31.88,
    height: 31.82,
    rx: 1.54,
    ry: 1.54,
    transform: "translate(517.44 3186.44) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1993.57,
    y: 1302.91,
    width: 31.88,
    height: 51.06,
    rx: 1.95,
    ry: 1.95,
    transform: "translate(608.32 3287.92) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2047.42,
    y: 1304.88,
    width: 31.88,
    height: 51.06,
    rx: 1.95,
    ry: 1.95,
    transform: "translate(658.23 3343.63) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2097.81,
    y: 1316.79,
    width: 31.91,
    height: 51.1,
    rx: 1.95,
    ry: 1.95,
    transform: "translate(688.01 3400.76) rotate(-87.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1927.76,1230.84l-13.53-.49c-17.59-.64-32.36,13.1-33,30.69h0l45.39,1.66,1.14-31.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1991.41,
    y: 1233.9,
    width: 31.91,
    height: 51.1,
    rx: 1.95,
    ry: 1.95,
    transform: "translate(668.68 3214.87) rotate(-87.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2049.52,
    y: 1226.38,
    width: 31.88,
    height: 51.06,
    rx: 1.95,
    ry: 1.95,
    transform: "translate(738.71 3270.11) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2104.4,
    y: 1228.4,
    width: 31.88,
    height: 51.06,
    rx: 1.95,
    ry: 1.95,
    transform: "translate(789.56 3326.9) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2171.11,1239.76l-19.17-.71c-1.72-.06-3.18,1.28-3.27,3l-.93,25.56c-.07,1.73,1.27,3.18,3,3.26l44.73,1.64c1.73,.07,3.18-1.27,3.26-3h0c.58-15.84-11.78-29.15-27.62-29.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2133.84,
    y: 1342.15,
    width: 67.23,
    height: 19.5,
    rx: 1.91,
    ry: 1.91,
    transform: "translate(737.05 3468.36) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2155.63,
    y: 1342.96,
    width: 67.23,
    height: 19.5,
    rx: 1.91,
    ry: 1.91,
    transform: "translate(757.22 3490.92) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2149.08,1244.93l-.89,24.46c-.32-.52-.47-1.13-.45-1.74l.89-24.46c.32,.52,.48,1.13,.45,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2181.08,1324.57l-2.19,59.9c-.32-.52-.47-1.11-.45-1.72l2.19-59.9,.45,1.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 2114.36,
    cy: 1387.64,
    r: 22.07,
    transform: "translate(662.44 3458.39) rotate(-88.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2127.91,1388.12c.28-7.51-5.58-13.82-13.09-14.09-7.51-.28-13.82,5.58-14.09,13.09s5.58,13.81,13.09,14.09h0c7.5,.27,13.81-5.59,14.09-13.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M2126.64,1388.07c.25-6.8-5.06-12.51-11.86-12.76s-12.51,5.06-12.76,11.86c-.25,6.8,5.06,12.51,11.86,12.76h0c6.8,.25,12.51-5.06,12.76-11.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M2122.02,1387.9c.15-4.25-3.17-7.82-7.42-7.97-4.25-.15-7.82,3.17-7.97,7.42-.15,4.24,3.15,7.8,7.39,7.97,4.25,.17,7.83-3.14,8-7.39v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2120.23,1387.84c.12-3.26-2.42-5.99-5.68-6.11-3.26-.12-5.99,2.42-6.11,5.68-.12,3.25,2.42,5.99,5.67,6.11,3.25,.13,5.99-2.4,6.12-5.65v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2115.91,1378.44c.03-.71-.52-1.3-1.23-1.33-.71-.03-1.3,.52-1.33,1.23h0c-.03,.71,.52,1.3,1.23,1.33,.71,.03,1.3-.52,1.33-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2108.98,1379.98c-.48-.52-1.29-.54-1.81-.06-.52,.48-.54,1.29-.06,1.81,.48,.51,1.28,.54,1.8,.07,.52-.48,.55-1.3,.07-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2105.15,1386c-.71-.03-1.32,.52-1.35,1.23-.03,.71,.52,1.32,1.23,1.35s1.32-.52,1.35-1.23v-.02c.02-.71-.52-1.3-1.23-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2106.69,1392.97c-.52,.48-.55,1.29-.07,1.81,.48,.52,1.29,.55,1.81,.07,.52-.48,.55-1.29,.07-1.81-.48-.52-1.29-.55-1.81-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2112.71,1396.81c-.02,.71,.53,1.3,1.24,1.32,.71,.02,1.3-.53,1.32-1.23,.03-.71-.52-1.3-1.23-1.33h0c-.71-.02-1.3,.53-1.33,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2119.68,1395.26c.48,.52,1.29,.54,1.81,.06,.52-.48,.54-1.29,.06-1.81-.48-.52-1.29-.54-1.81-.06-.52,.48-.54,1.29-.06,1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2123.51,1389.24c.71,.03,1.3-.52,1.33-1.23,.03-.71-.52-1.3-1.23-1.33-.71-.03-1.3,.52-1.33,1.23-.03,.7,.51,1.3,1.21,1.33h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2121.97,1382.27c.52-.48,.54-1.29,.06-1.81-.48-.52-1.29-.54-1.81-.06-.52,.48-.54,1.29-.06,1.81,.48,.52,1.29,.54,1.81,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1981.75,1235.66h-.32l-44.72-1.64c-1.72-.06-3.18,1.28-3.27,3l-.93,25.56c-.01,.1-.01,.21,0,.31-1.6-.22-2.78-1.62-2.72-3.24l.93-25.56c.09-1.73,1.54-3.06,3.27-3l44.73,1.64c1.61,.06,2.92,1.32,3.03,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1981.69,1314.22h-.31l-44.73-1.64c-1.73-.07-3.18,1.27-3.26,3l-.94,25.56v.32c-1.6-.22-2.78-1.62-2.72-3.24l.94-25.56c.08-1.73,1.53-3.07,3.26-3l44.73,1.63c1.61,.06,2.92,1.32,3.03,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1927.91,1311.9v.34l-26.49-1c-1.37-.05-2.52,1.02-2.57,2.39h0l-1,26.55h-.33c-1.37-.05-2.45-1.2-2.4-2.58h0l1-26.88c.04-1.37,1.19-2.44,2.56-2.4h.01l26.83,1c1.37,.05,2.44,1.2,2.39,2.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2035.54,1316.2c-.1,0-.21,0-.31,0l-44.73-1.64c-1.72-.06-3.18,1.28-3.27,3l-.93,25.55v.32c-1.6-.22-2.78-1.62-2.72-3.24l.94-25.56c.08-1.73,1.53-3.07,3.26-3l44.73,1.64c1.61,.06,2.92,1.32,3.03,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2089.39,1318.17h-.32l-44.73-1.64c-1.72-.06-3.17,1.28-3.26,3l-.94,25.56v.31c-1.61-.22-2.79-1.62-2.72-3.24l.93-25.56c.09-1.72,1.55-3.06,3.27-3l44.73,1.64c1.61,.05,2.93,1.32,3.04,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2143.23,1320.14h-.31l-44.73-1.64c-1.73-.07-3.18,1.27-3.26,3l-.94,25.56v.31c-1.6-.22-2.78-1.61-2.72-3.23l.94-25.56c.09-1.72,1.54-3.06,3.26-3l44.73,1.64c1.61,.06,2.91,1.32,3.03,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1927.76,1230.84l-.1,2.82-19.4-.71c-12.78-.47-23.53,9.51-24,22.29v.02l-.22,5.88-2.82-.1,.32-8.7c.47-12.79,11.21-22.77,24-22.31l22.22,.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2036.62,1237.67h-.31l-44.73-1.64c-1.72-.06-3.18,1.28-3.27,3l-.93,25.56c-.01,.1-.01,.21,0,.31-1.61-.22-2.79-1.62-2.72-3.24l.94-25.56c.08-1.73,1.53-3.07,3.26-3l44.73,1.64c1.61,.06,2.92,1.32,3.03,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2091.49,1239.68h-.31l-44.73-1.64c-1.73-.06-3.18,1.28-3.26,3l-.94,25.56v.31c-1.6-.22-2.78-1.62-2.72-3.24l.94-25.56c.08-1.72,1.53-3.06,3.26-3l44.73,1.64c1.61,.06,2.92,1.32,3.03,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2146.36,1241.69h-.31l-44.73-1.64c-1.73-.06-3.18,1.28-3.26,3l-.94,25.56v.31c-1.61-.22-2.79-1.62-2.73-3.24l.94-25.56c.09-1.72,1.54-3.06,3.26-3l44.73,1.64c1.61,.05,2.93,1.32,3.04,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2192.41,1250.42c-5.05-4.75-11.65-7.5-18.58-7.74l-19.17-.7c-1.73-.07-3.19,1.27-3.27,3l-.93,25.56c-.01,.1-.01,.21,0,.31-1.6-.22-2.78-1.61-2.72-3.23l.93-25.56c.09-1.72,1.55-3.06,3.27-3l19.17,.71c7.62,.26,14.82,3.56,20,9.15,.44,.47,.88,.98,1.3,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2178.37,1321.42h-.25l-13.33-.49c-1.69-.07-3.12,1.25-3.19,2.95v.05l-2.24,61v.24c-1.6-.18-2.78-1.56-2.72-3.17l2.24-61c.04-1.7,1.46-3.04,3.16-3h.03l13.33,.49c1.6,.06,2.89,1.33,2.97,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M2200.16,1322.22h-.24l-13.34-.48c-1.69-.07-3.12,1.25-3.19,2.95v.05l-2.23,61c0,.08,0,.16,0,.24-1.59-.19-2.78-1.57-2.72-3.17l2.24-61c.04-1.7,1.44-3.04,3.14-3h.04l13.34,.49c1.6,.06,2.88,1.32,2.96,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M2138.66,1310.72l-204.76-7.5c-1.45-.05-2.58-1.27-2.53-2.72l.63-17.07c.05-1.45,1.27-2.57,2.72-2.52h0l204.75,7.5c1.45,.05,2.58,1.27,2.53,2.72l-.63,17.06c-.05,1.45-1.26,2.58-2.71,2.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2138.19,1309.42l-204.76-7.51c-1.44-.05-2.57-1.26-2.52-2.7h0l.62-17.08c.05-1.45,1.27-2.57,2.72-2.52h0l204.76,7.5c1.44,.05,2.57,1.26,2.52,2.7v.02l-.62,17.06c-.05,1.45-1.27,2.58-2.72,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1856.04,12.48S1834.82-.88,1807.8,.12c-27-1.47-48.45,11.52-48.45,11.52-89.16,58.94-17.5,132.49-17.5,132.49,6.88,4.46,44.89,43.14,44.89,43.14l19.37,.17h.12l19.37,.16s38.68-38,45.63-42.34c0,0,72.93-72.28-15.19-132.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1845.2,12.39S1828.76-.94,1807.8,.12c-20.93-1.42-37.6,11.61-37.6,11.61-69.28,59.12-13.84,132.53-13.84,132.53,5.33,4.45,34.74,43.05,34.74,43.05l15,.13h.1l15,.13s30.08-38.09,35.48-42.44c.04,.01,56.75-72.42-11.48-132.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1833.04,12.28s-11.07-13.27-25.24-12.16c-14.14-1.36-25.44,11.72-25.44,11.72-47,59.31-9.72,132.56-9.72,132.56,3.58,4.43,23.35,43,23.35,43l10.15,.08h.06l10.15,.08s20.44-38.17,24.1-42.53c0-.03,38.53-72.62-7.41-132.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1818.91,12.16s-4.83-13.22-11.1-12c-6.25-1.29-11.31,11.84-11.31,11.84-21.07,59.54-4.94,132.61-4.94,132.61,1.56,4.41,10.12,42.84,10.12,42.84h8.97s9.23-38.26,10.87-42.65c.02,.03,17.39-72.74-2.61-132.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1797.94,
    y: 202.2,
    width: 21.37,
    height: 1.26,
    transform: "translate(1587.72 2009.34) rotate(-89.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1806.41,239.63h0c-8.68-.08-15.66-7.18-15.58-15.86h0l.06-7.54,31.43,.28-.06,7.54c-.08,8.68-7.17,15.65-15.85,15.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1803.8,
    y: 197.17,
    width: 5.66,
    height: 35.21,
    transform: "translate(1576.1 2019.46) rotate(-89.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1787.86,
    y: 191.31,
    width: 1.26,
    height: 20.74,
    transform: "translate(2.49 424.33) rotate(-13.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1814.03,
    y: 201.46,
    width: 20.74,
    height: 1.26,
    transform: "translate(1171.36 1917.55) rotate(-75.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1835.23,178.27l-58.47,.12,4.29,13.24,49.66,.43c1.51-4.6,3.01-9.2,4.52-13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1820.05,74.25c-16.13,17.48-41.16,20.6-55.93,7s-13.66-38.83,2.46-56.3,41.16-20.6,55.93-7,13.66,38.83-2.46,56.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M3133.03,710.02s-9.18-14.19-26-21.24c-16.08-8.56-32.87-6.7-32.87-6.7-71.2,10.73-48.27,76-48.27,76,2.94,4.67,15.19,39.09,15.19,39.09l11.79,5.59h.07l11.79,5.6s34.42-12.26,39.89-12.94c.03,.04,65.1-23.45,28.41-85.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M3126.43,706.88s-6.27-12.8-19.37-18.1c-12.39-6.81-26.27-3.57-26.27-3.57-59.1,16.48-46,77.06-46,77.06,2,4.23,9,36.16,9,36.16l9.14,4.34h.06l9.14,4.34s29.18-14.75,33.71-15.87c-.02,.03,55.18-28.15,30.59-84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M3119.03,703.37s-3-11.25-12-14.59c-8.26-4.84-18.87-.05-18.87-.05-45.53,22.91-43.54,78.24-43.54,78.24,.94,3.73,2.09,32.87,2.09,32.87l6.18,2.93h0l6.17,2.93s23.31-17.52,26.79-19.15c.06,.02,44.2-33.41,33.18-83.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M3110.43,699.29s.8-9.46-3.37-10.51c-3.45-2.56-10.27,4-10.27,4-29.76,30.41-40.63,79.63-40.63,79.63-.3,3.14-6,29-6,29l2.73,1.3h0l2.73,1.29s16.49-20.76,18.73-23c.06,.1,31.33-39.43,36.08-81.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 3041.78,
    y: 811.8,
    width: 14.4,
    height: 0.85,
    transform: "translate(1007.03 3217.73) rotate(-64.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M3038.28,834.74h0c-5.27-2.52-7.51-8.83-5-14.11l2.18-4.59,19.13,9.08-2.18,4.59c-2.51,5.29-8.84,7.54-14.13,5.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 3043.46,
    y: 807.86,
    width: 3.81,
    height: 23.72,
    transform: "translate(998.61 3219.1) rotate(-64.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 3031.14,
    y: 806.11,
    width: 13.97,
    height: 0.85,
    transform: "translate(1648.97 3626.28) rotate(-78.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 3052.76,
    y: 816.22,
    width: 13.97,
    height: 0.85,
    transform: "translate(486.91 2663.11) rotate(-50.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M3073.3,805.42l-35.76-16.51-1.14,9.3,30.22,14.35,6.68-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3093.52,737.57c-14.81,6.11-31,.92-36.16-11.59s2.67-27.61,17.48-33.71,31-.91,36.15,11.6-2.67,27.58-17.47,33.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1236.28,
    y: 1196.38,
    width: 316.25,
    height: 71.18,
    transform: "translate(-350.71 586.45) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1221.37,
    y: 1185.32,
    width: 324.48,
    height: 6.92,
    transform: "translate(-335.83 579.6) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1291.91,1246.79l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm0,0l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm69.38-26.85l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm0,0l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm-69.36,26.89l10,25.75,23-8.9-10-25.76-23,8.91Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.7,13.38l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm34.68-13.42l10,25.75,23-8.91-10-25.73-23,8.89Zm34.7-13.43l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm34.68-13.42l10,25.75,23-8.9-10-25.74-23,8.89Zm0,0l10,25.75,23-8.9-10-25.74-23,8.89Zm-34.68,13.42l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm-34.7,13.43l10,25.75,23-8.91-10-25.73-23,8.89Zm-34.66,13.46l10,25.75,23-8.9-10-25.76-23,8.91Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.7,13.38l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm34.68-13.42l10,25.75,23-8.91-10-25.73-23,8.89Zm34.7-13.43l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm34.68-13.42l10,25.75,23-8.9-10-25.74-23,8.89Zm0,0l10,25.75,23-8.9-10-25.74-23,8.89Zm-34.68,13.42l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm-34.7,13.43l10,25.75,23-8.91-10-25.73-23,8.89Zm-34.66,13.46l10,25.75,23-8.9-10-25.76-23,8.91Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.7,13.38l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm34.68-13.42l10,25.75,23-8.91-10-25.73-23,8.89Zm34.7-13.43l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm34.68-13.42l10,25.75,23-8.9-10-25.74-23,8.89Zm-208.1,80.53l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm34.68-13.42l10,25.75,23-8.91-10-25.73-23,8.89Zm34.7-13.43l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm34.68-13.42l10,25.75,23-8.9-10-25.74-23,8.89Zm50.9,13.51l-11.46-29.6-1.93-11.13-.61-3.47-.45-2.59-.51,.2-302.59,117.1h-.12l.36,.56,3,4.66,6.07,9.54,11.46,29.59-15.22,5.94,7,6.31,.13,.13,2.17,5.59,11.32-4.39,295.75-114.44,11.34-4.4-2.65-6.86-.12-.33c.76-2.76,1.54-5.5,2.31-8.24l-15.25,5.83Zm-256.51,99.19l-29.06,11.24-12.31-31.85,29.05-11.24,12.32,31.85Zm34.68-13.42l-29.06,11.24-12.31-31.85,29-11.25,12.37,31.86Zm34.7-13.43l-29.08,11.25-12.29-31.86,29-11.24,12.37,31.85Zm34.68-13.42l-29.06,11.24-12.31-31.85,29-11.25,12.37,31.86Zm34.68-13.42l-29.06,11.24-12.31-31.85,29.05-11.25,12.32,31.86Zm34.68-13.43l-29.06,11.25-12.31-31.86,29-11.24,12.37,31.85Zm34.7-13.42l-29.06,11.24-12.31-31.85,29-11.25,12.37,31.86Zm34.68-13.43l-29.06,11.25-12.31-31.86,29-11.24,12.37,31.85Zm-14.18-27.62l-23,8.89,10,25.75,23-8.9-10-25.74Zm-34.7,13.43l-23,8.88,10,25.75,22.95-8.9-9.95-25.73Zm-34.68,13.42l-23,8.89,10,25.75,23-8.91-10-25.73Zm-34.69,13.4l-23,8.91,10,25.75,23-8.9-10-25.76Zm-34.68,13.43l-23,8.9,10,25.75,23-8.9-10-25.75Zm-34.68,13.42l-23,8.9,10,25.75,23-8.9-10-25.75Zm-34.7,13.43l-23,8.89,10,25.76,23-8.9-10-25.75Zm-23,8.89l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm34.68-13.42l10,25.75,23-8.91-10-25.73-23,8.89Zm34.7-13.43l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm34.68-13.42l10,25.75,23-8.9-10-25.74-23,8.89Zm0,0l10,25.75,23-8.9-10-25.74-23,8.89Zm-34.68,13.42l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm-34.7,13.43l10,25.75,23-8.91-10-25.73-23,8.89Zm-34.64,13.46l10,25.75,23-8.9-10-25.76-23,8.91Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.7,13.38l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm34.68-13.42l10,25.75,23-8.91-10-25.73-23,8.89Zm34.7-13.43l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm34.68-13.42l10,25.75,23-8.9-10-25.74-23,8.89Zm0,0l10,25.75,23-8.9-10-25.74-23,8.89Zm-34.68,13.42l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm-34.7,13.43l10,25.75,23-8.91-10-25.73-23,8.89Zm-34.66,13.46l10,25.75,23-8.9-10-25.76-23,8.91Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.7,13.38l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm34.68-13.42l10,25.75,23-8.91-10-25.73-23,8.89Zm34.7-13.43l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm0,0l10,25.75,22.95-8.9-10-25.73-22.95,8.88Zm-34.7,13.43l10,25.75,23-8.91-10-25.73-23,8.89Zm-34.66,13.46l10,25.75,23-8.9-10-25.76-23,8.91Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.7,13.38l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm34.68-13.42l10,25.75,23-8.9-10-25.76-23,8.91Zm0,0l10,25.75,23-8.9-10-25.76-23,8.91Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.76,23-8.9-10-25.75-23,8.89Zm0,0l10,25.76,23-8.9-10-25.75-23,8.89Zm34.68-13.42l10,25.75,23-8.9-10-25.75-23,8.9Zm0,0l10,25.75,23-8.9-10-25.75-23,8.9Zm-34.68,13.42l10,25.76,23-8.9-10-25.75-23,8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1602.09,1314.48l36.87,95.2,7.21-2.8,11.44,29.62h-.07l-111.15,43-3-7.8-8.42-21.8,5.6-2.17-36.87-95.16-2.63-6.81-.46-1.18-.8,.31-9.24-8.86-1-1-2.17-5.6c2.14-.82,4.27-1.65,6.41-2.49l-1.15-2.93c-32-39.07-65.49-21.85-65.49-21.85,0,0-36.31,9.78-33.72,60.25l1.15,2.94,7.2-2.79,2.17,5.59h0l-1,14.16-1.45,.55-.17,.07,.22,.55,2.89,7.45,36.84,95.19,6.41-2.47,5.42,14,3.35,8.69,2.67,6.91-.17,.07-110.95,42.94h-.09l-2.53-6.53-3.36-8.68-5.57-14.4,6.41-2.48-36.85-95.2-2.87-7.45-.22-.55-.28,.1-.51,.22-10.25-9.84-2.16-5.59c2.13-.84,4.26-1.67,6.4-2.49-10.15-26.32-20.28-52.64-30.41-78.95l295.75-114.45c10.23,26.27,20.45,52.55,30.66,78.84l7.21-2.78,2.17,5.59-.09,1.39-.87,12.78-1.61,.63,.68,1.73,2.45,6.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1261.43,
    y: 1254.72,
    width: 24.64,
    height: 27.61,
    transform: "translate(-372.02 545.32) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1305.77,
    y: 1338.32,
    width: 55.81,
    height: 31.34,
    transform: "translate(-398.83 572.71) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1295.61,
    y: 1325.82,
    width: 73.12,
    height: 48.65,
    transform: "translate(-397.54 571.91) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1299.97,
    y: 1330.15,
    width: 64.46,
    height: 39.99,
    transform: "translate(-397.54 571.92) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1304.2,
    y: 1334.3,
    width: 55.81,
    height: 31.34,
    transform: "translate(-397.49 571.87) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1494.96,
    y: 1248.68,
    width: 73.12,
    height: 48.65,
    transform: "translate(-356.26 638.67) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1499.27,
    y: 1252.99,
    width: 64.46,
    height: 39.99,
    transform: "translate(-356.26 638.66) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1503.51,
    y: 1257.14,
    width: 55.81,
    height: 31.34,
    transform: "translate(-356.2 638.62) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1300.74,
    y: 1401.51,
    width: 106,
    height: 8.65,
    transform: "translate(-416.2 583.45) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1403.96,1368.16h0l-1,14.16-1.62,.62,.21,.56-98.34,38.07-.21-.56c-.26,.1-.54,.2-.79,.32l-10.3-9.76,112.05-43.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1602.39,1292.73h0l-.95,14.17-1.62,.61,.21,.56-98.4,38.08-.21-.56-.79,.32-10.26-9.84,112.02-43.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1498.02,
    y: 1325.08,
    width: 106.43,
    height: 8.65,
    transform: "translate(-375.29 649.59) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1283.09,1264.92c-1.97-5.16-7.75-7.75-12.91-5.78-5.16,1.97-7.75,7.75-5.78,12.91,1.97,5.16,7.75,7.75,12.91,5.78l.09-.04c5.12-1.98,7.67-7.73,5.7-12.85v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1317.79,1251.49c-1.97-5.16-7.75-7.75-12.91-5.78-5.16,1.97-7.75,7.75-5.78,12.91,1.97,5.16,7.75,7.75,12.91,5.78l.09-.04c5.1-2,7.64-7.75,5.69-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1352.49,1238.06c-1.97-5.16-7.75-7.75-12.91-5.78-5.16,1.97-7.75,7.75-5.78,12.91,1.97,5.16,7.75,7.75,12.91,5.78l.09-.04c5.1-2,7.64-7.75,5.69-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1387.19,1224.63c-1.97-5.16-7.75-7.75-12.91-5.78-5.16,1.97-7.75,7.75-5.78,12.91,1.97,5.16,7.75,7.75,12.91,5.78l.09-.04c5.1-2,7.64-7.75,5.69-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1421.91,1211.2c-1.97-5.16-7.75-7.75-12.91-5.78-5.16,1.97-7.75,7.75-5.78,12.91,1.97,5.16,7.75,7.75,12.91,5.78l.09-.04c5.1-2,7.64-7.75,5.69-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1456.58,1197.77c-1.97-5.16-7.75-7.75-12.91-5.78-5.16,1.97-7.75,7.75-5.78,12.91,1.97,5.16,7.75,7.75,12.91,5.78,.03-.01,.07-.03,.1-.04,5.1-2.01,7.63-7.75,5.68-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1491.28,1184.34c-1.97-5.16-7.75-7.75-12.91-5.78-5.16,1.97-7.75,7.75-5.78,12.91,1.97,5.16,7.75,7.75,12.91,5.78l.09-.04c5.12-1.98,7.67-7.73,5.7-12.85v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1525.98,1170.92c-1.97-5.16-7.75-7.75-12.91-5.78-5.16,1.97-7.75,7.75-5.78,12.91,1.97,5.16,7.75,7.75,12.91,5.78l.09-.04c5.12-1.98,7.67-7.73,5.7-12.85v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1408.15,1495.75l1.48-3.35-1.25-3.23-6.54,2.53c-.48-1.11-1.16-2.13-2-3,0,0-4.19-13.21-4.32-15.94-.25-2.65-.65-5.28-1.19-7.88,0,0-7.1-11.16-7-15.81s-4.11-5.83-6.66-7.62-4.86-10.17-4.86-10.17l-11.06-2.22s-10.48,4.06-14.2,6.43-2.39,13-3.56,17.14,.07,7.38,.2,10.11,6,10.67,6,10.67c1,3.07,1.61,6.26,1.82,9.49,.58,6.27,2.32,8.38,2.14,10.3s8.76,5.88,9.57,5.57l1.11,6.06-3,1.14,1.25,3.23,3.35,1.48,8.12,21-2,4.48,3.12,8.06,45.16-17.48-3.12-8.06-4.48-2-8.08-20.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1613.56,1440.36l-8.11-21,1.48-3.35-1.25-3.23-6.54,2.54c-.48-1.11-1.16-2.13-2-3,0,0-4.19-13.22-4.32-15.95-.25-2.65-.65-5.28-1.19-7.88,0,0-7.1-11.15-7.05-15.81s-4.11-5.83-6.66-7.62-4.86-10.17-4.86-10.17l-11.06-2.21s-10.48,4-14.2,6.42-2.39,13-3.56,17.14,.07,7.39,.2,10.12,6,10.66,6,10.66c1,3.08,1.61,6.27,1.82,9.5,.57,6.26,2.31,8.37,2.13,10.3s8.76,5.87,9.57,5.56l1.11,6.06-3,1.15,1.25,3.22,3.35,1.48,8.12,21-2,4.47,3.12,8.06,21.77-8.42,1.62-.63,21.77-8.42-3.12-8.06-4.39-1.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1345.67,
    y: 1526.01,
    width: 118.98,
    height: 25.36,
    transform: "translate(-460.69 610.97) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1543.33,
    y: 1449.34,
    width: 119.84,
    height: 25.36,
    transform: "translate(-419.65 677.31) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1223.4,
    y: 1190.52,
    width: 324.48,
    height: 6.92,
    transform: "translate(-337.57 580.68) rotate(-21.16)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "1563.91 1182.48 1566.56 1189.34 1248.15 1312.57 1245.99 1306.98 1245.85 1306.85 1563.91 1182.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "1345.46 1549.8 1345.54 1549.77 1376.2 1537.78 1421.29 1520.15 1456.36 1506.43 1456.53 1506.37 1453.18 1497.68 1414.71 1512.72 1376.07 1527.83 1342.1 1541.12 1345.46 1549.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "1543.16 1472.49 1543.25 1472.46 1573.91 1460.47 1619 1442.84 1654.07 1429.13 1654.24 1429.06 1650.88 1420.37 1612.42 1435.41 1573.78 1450.52 1539.8 1463.81 1543.16 1472.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M72.59,1420.05s-23.86,11.53-38.09,36.28c-16.44,23.35-16.82,49.84-16.82,49.84,2.84,112.86,108.85,89.89,108.85,89.89,7.85-3.66,63.78-16,63.78-16l11-17.25,.07-.11,11-17.25s-12.38-55.93-12.37-64.59c0-.04-23.88-105.84-127.42-60.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M66.43,1429.71s-21.14,7.26-31.93,26.62c-13,18-10.66,40.18-10.66,40.18,14.14,95.15,110.93,86.62,110.93,86.62,7-2.28,58-7,58-7l8.53-13.38,.05-.09,8.53-13.37s-17.26-48.27-18.13-55.55c.02,.01-33.08-91.35-125.32-64.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M59.53,1440.57s-18.1,2.47-25,15.78c-9.14,11.9-3.76,29.35-3.76,29.35,26.81,75.29,113.27,83,113.27,83,6-.73,51.55,3.15,51.55,3.15l5.77-9v-.06l5.77-9s-22.74-39.68-24.6-45.41c0-.14-43.43-75.3-123-67.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M51.5,1453.13s-14.55-3.08-17,3.2c-4.66,4.87,4.27,16.76,4.27,16.76,41.52,52.22,116,78.71,116,78.71,4.83,1.07,44,14.93,44,14.93l2.55-4h0l2.55-4s-29.1-29.7-32.11-33.63c.03-.02-55.4-56.35-120.26-71.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 214.32,
    y: 1559.71,
    width: 1.33,
    height: 22.58,
    transform: "translate(-1225.03 907.21) rotate(-57.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M248.21,1591.73h0c-4.93,7.73-15.19,10-22.93,5.08l-6.71-4.29,17.85-28,6.72,4.28c7.73,4.93,10,15.19,5.08,22.92h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 207.53,
    y: 1574.47,
    width: 37.19,
    height: 5.98,
    transform: "translate(-1225.56 920.09) rotate(-57.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 203.6,
    y: 1575.75,
    width: 1.33,
    height: 21.9,
    transform: "translate(-1365.3 1277.22) rotate(-71.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 223.97,
    y: 1543.63,
    width: 1.33,
    height: 21.9,
    transform: "translate(-1007.91 580.91) rotate(-43.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M209.41,1531.57l-32.65,52.43,14.26,3.58,28.2-44.24-9.81-11.77Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 70.7,
    cy: 1497.01,
    rx: 38.42,
    ry: 45.47,
    transform: "translate(-391.77 71.47) rotate(-15.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M3237.07,2312.97c.15-.54-43.14-75.62-91.23-158.81-6.19-10.71-12.46-21.57-18.74-32.42-54.42-94.1-108.63-187.6-108.63-187.6,41.16-28.82,65.42-11.39,76-5.33s19.55,37.39,29.35,36.81,3.4,4.12,13.31,5.5,4.77-5.8,4.77-5.8c40.86-32.23,69.89-48.93,90.12-57.29h0c1.87-.77,3.66-1.47,5.39-2.11,27.59-10.19,36.45-3.56,36.45-3.56,14.6,.71,44.8,31.95,44.8,31.95,0,0,5.34,8,10.77,14.95h0l.16,.2c1.27,1.61,2.54,3.16,3.75,4.53,.05,.06,.09,.12,.15,.18,.98,1.12,2.02,2.19,3.12,3.19,.7,.69,1.51,1.25,2.39,1.67,5.24,2,9.13-5.27,9.13-5.27l.76-.57,1.34-1,3.55-2.68c-1.06,.46-2.14,.87-3.24,1.22h0c-11.82,3.74-14.58-4.28-14-6.49,.64-2.4,10.33-4.94,16.41-8.46s11.06-12.46,16-16.29c3.74-2.93,12.53-9.37,17.16-12.65,1.43-1,2.46-1.72,2.82-1.92q1.52-.88,6-5.48c4.48-4.6,5.44-1.11,7.28-3.19s2.54-2.47,3.16-4.61c0-.08,.06-.19,.09-.3,.65-2.4,8.81-4.07,11.09-5.38s5.44-1.12,7.4-1.23,8.17-1.67,10.13-1.79,6.64-.79,6.64-.79c2.83,.78,5.55,1.94,8.07,3.45,3.28,2.17,4.8,1.29,4.8,1.29l10.48,4.1,4.71,6.4,3.28,2.17,3.6,1,2.54,2.9,3.37,3.83c.96,.69,1.87,1.45,2.72,2.28,.44,.41,.92,.87,1.43,1.41,2.52,2.6,.88,1.52,3.4,4.13s4.06,8.8,4.18,10.76,1,10.56,1.14,12.53c.07,3.82-.09,7.64-.49,11.44l-3.22,12c-1,3.6,.76-.44,.88,1.52s-.41,6.32-.29,8.28-1.41,2.84-3.25,4.92l-5.53,6.23c-1.34,1.61-3,2.91-4.88,3.83-2.29,1.32-7.49,6.35-8.26,6.79s-5.64,4.27-9.45,6.47c-2.05,1.18-6,1.68-9.6,2h0c-3.08,.24-5.9,.34-7.15,.59-.47,.1-.92,.25-1.36,.44h0c-1.54,.78-2.99,1.73-4.32,2.84-1.24,.93-2.75,2.1-4.72,3.53h0c-.41,.3-.86,.62-1.31,1-3.01,1.93-6.29,3.43-9.72,4.44h-.08c-7.55,2.48-16.06,4-18.38,4.7-.74,.26-1.46,.6-2.14,1h0c-3.27,1.74-8.66,5.27-12.76,7.55h0c-2.49,1.39-4.51,2.33-5.29,2.12s-1.5-1.21-1.81-2.51h0c-.5-2.49-.06-5.07,1.24-7.25h0c2.15-3.25,2.78-5.64,.83-5.52-1.65,.09-6.45,3.44-8.57,5.48-.33,.3-.63,.63-.88,1-.24,.36,0,1,.46,1.77,1.7,2.75,6.76,7.24,6.76,7.24,8.14,17.62,12.07,70.11,7.77,83.74s-35.78,39.91-53.4,48.05-28.05,11.12-42.39,21.41-5.65,4.28-14.89,7.58-8.93,2.11-15.45,4.86,.41,20,.41,20c0,0,20.25,22.79,19.93,50.36s-46.38,47.87-46.06,46.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3382.43,2039.49c-2.52-.03-5.04-.27-7.52-.73-1.21-.33-7.17-3.91-13.26-8-1.84-1.25-3.7-2.53-5.43-3.79-3.84-2.78-7.1-5.41-8.4-7.07l-1.53-1.94c-.33-.42-.66-.85-1-1.29-1-1.24-1.95-2.52-2.92-3.79-1.11-1.43-2.21-2.86-3.29-4.27l-3.21-4.13c-3.84-4.88-6.12-3.57-10.6-6.05s-3.27-2.17-4.15-3.69,1.4-2.84,5.53-6.23,5-1.87,5-1.87c0,0,6-5.47,7.37-8.31s2.14-10.36,2.14-10.36l-3.92,.23s-2.64-4.56-4.39-7.6c-.67-1.16-3.21-1.52-6.11-1.53-2.14,.02-4.28,.16-6.41,.41-2.33,.24-4,.53-4,.53,0,0,7.55-6.21,12.67-10.37l.25-.21c.09-.06,.17-.12,.24-.19v.05c0,.05,.05,.11,.08,.16,.93,1.78,2.24,3.34,3.83,4.56l.18,.15c1.37,1.1,2.97,1.89,4.68,2.31,.47,.1,.96,.16,1.44,.18,1.91,.08,3.06-.53,8.49-2.87l.76-.57,.76-.31,.14,2.33h0c0,.44,.06,1,.09,1.57,0,.32,0,.66,.08,1h0c.13,1.35,.36,2.69,.69,4h0c1.2,4.86,4.36,13.16,13.1,29.51,.57,1.06,1.13,2.08,1.69,3,1.24,2.16,2.45,4,3.6,5.68h0c4.43,6.33,8.14,9.09,11,10.23,.49,.2,.99,.37,1.5,.49,2.57,.63,4.17-.05,4.65,.08,.94,.25-1.19,1.65-2.51,2.46l-.85,.5c-2.5,1.04-5.09,1.85-7.73,2.42-.89,.19-1.36,1.12-1.58,2.28-.22,1.58-.22,3.18,0,4.76,.06,.56,.12,.92,.12,.92l8.73,15.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3428.97,1942.67s-11.09,5.38-15,5.62-9.59-2.58-11.12-1.7l-7.6,4.39c-.76,.44-3.48,1-.53,4.36s8.43,9.33,11.15,8.78,22.94-11.21,24.34-14.05,2.17-3.28,1.73-4c-.92-1.19-1.91-2.33-2.97-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3416.1,1964.29s-5.65,4.27-7.61,4.39-4.79-1.29-3.48,1l2.64,4.57,6.08-3.51c1.52-.89,2.37-6.45,2.37-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M3392.91,1957.42s-2.28,1.31-1.85,2.07,.8,6.64,1.23,7.41c1.57,2.22,3.41,4.24,5.48,6,1.64,1.09,3.27,2.17,3.6,1s1.52-.88,.64-2.4-5.82-11.85-6.26-12.61-2.12-1.91-2.84-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M3412.91,2002.65s-21.8-2.63-31.19-8.37c-9.39-5.74-16-17.14-19.17-24.43s1.16-33.12,6.69-39.35,12.14-14.1,12.14-14.1c0,0-24.1,18-29,28.87s-3.48,27.36,5.51,39.42c11.85,15.9,19.05,22.47,19.05,22.47,2.28,1.65,8.39,5.81,7.66,9.77-.42,2.3-2.85,2.87-3.57,6.11-.57,2.61,.15,6.06,2,7,2.41,1.17,5.37-2.66,10.65-6.15,9.2-6.07,13.32-3.11,28.94-9.6,5.43-2.25,3.37-2,11.85-5.82,7.23-3.29,14.76-5.47,24.14-10.88,5.32-3.08,10-3.75,9.45-6.47s-14.63-7.78-16.15-6.9c-8.2,4.72-12.94,6.47-31.75,15.27-3.07,1.41-5.63,2.49-7.25,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3071.78,1943.94c-1.2-.32-17-1.35-19.17,1.93s-11.5,11.7-6.75,25.19,19.87,36.19,21.62,39.24-9.92-27.74-10.91-31.22-2-7,1.9-14.28,13.31-20.86,13.31-20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3077.91,1961.67c-1.2-.32-10.65,6.14-14.66,11.5s3.08,31.68,8.79,41.57,19,27.59,19,27.59c-5.24-8.14-9.83-16.68-13.73-25.54-5.5-13-13.6-23.58-9.51-34.06,2.93-7.22,6.3-14.26,10.11-21.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3087.17,1977.64c-.51,1.9-9.33,8.43-10.62,13.23s5.48,32.33,11.62,43,8.66,13.25,8.66,13.25c0,0-6.26-12.61-8.69-20.33s-7.2-28.29-5.47-32.33,7.66-16.59,7.66-16.59c0,0-2.52-2.63-3.16-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M3285.43,1976.82c-6.82,3.51-15.75,7.89-23.7,11.73-4.48,2.16-8.65,4.14-12,5.69-5,2.33-8,3.7-7.17,3.24l4.31-2.41c14.63-8.13,62-34.4,79.26-43.94l.39-.21,2.66-1.48c.09-.04,.18-.09,.27-.14h0l.16,.2c1.27,1.61,2.54,3.16,3.75,4.53l.18,.15h0c-1,.65-2.38,1.54-3.81,2.58-.95,.69-1.92,1.42-2.88,2.22l-.11,.08c-4.36,3.44-25.04,9.37-41.31,17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3226.23,2171.18s-25,9.37-33.41,7.12-17.47-9.19-22.06-13.64-12.27-14.22-12.27-14.22c0,0,8.93,24.26,16.25,28.15s18.31,3.63,23.43,3.71,24.38-7,31.22-10.91-3.16-.21-3.16-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3097.24,1988.06c-.33,1.2-13.75,17.4-13.14,22.45s5.24,16.58,9.4,20.27,11.41,19.78,10.8,29.26,4,28.08,4.8,27.64-1.64-1.08,5.7-16.47,14.48-27.62,13-26.74-13.9,11.06-16.38,15.54-5.91-6.73-3.78-17.09,14.13-33.5,19.22-40.5-10.53,8.11-16.38,15.54-8.22,13.87-9.34,8.43-3.3-9.25-2.34-12.85,1.43-22.12,1.32-24.08-2.88-1.4-2.88-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3277.4,2085.89c-3.91,1.34-7.9,2.45-11.95,3.31h0c-7.65,1.69-14.63,2.54-13,.93,2.6-2.52,13.69-7.9,26.07-18.09s26.3-14.16,39.55-22.82,49.45-28.53,49.45-28.53c0,0,4.12-3.39,5.76-2.31,.81,.62,1.42,1.46,1.76,2.43,.15,.38,.28,.77,.39,1.17l.05,.2-.39,.23c-2.76,1.61-19.61,11.57-30.25,20.49-11.59,9.75-58.2,39.67-67.44,42.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3374.67,1955.75c1.16-1.32,1.87,5,5.47,6,3.15,.91,5.81,3.01,7.43,5.85,1.32,2.28,8,15.65,6.3,19.69s-2.05,5.24-4.89,3.83-4.59-4.44-6.35-7.49-1.11-5.44-4.83-8.37-3.71-2.92-3.95-6.84-2.87-8.52,.82-12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M3424.15,1960.66c.76-.44,3.6,1,6.11,3.57s7.9,13.69,8.78,15.22l1.32,2.28s-1.41,2.84-3.48,1-9.54-14.77-11.3-17.82-2.19-3.8-2.19-3.8l.76-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M3414.37,1941.97c.82-1.91,.69-4.08-.35-5.88-1.76-3.05-4.07-8.81-5-10.33s-2.86-8.49-5.26-9.13-4-1.73-3.16-.21,5.18,14.25,7.37,18.06c1.68,2.77,3.55,5.42,5.59,7.93l.81-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3376.2,2086.68s-8,3.63-9.36,1.35,1-15.8,1-15.8c0,0-18.9,12.93-18.25,10.53s14.42-15.42,12.46-15.3-10.53,8.1-14.77,9.54-11.21,3.42-8.61,.9,11.74-7.78,15.86-11.17,1.73-4-4-1.73-79.55,44.89-108.9,34.44c0,0,43.25-.61,51.85-1.52s-26.21,9-29.37,8.84,6.11,3.57,15,1.46,17.85-4.22,19.81-4.33-59.42,13-71.21,6.61,3.63,8.05,13.75,6.26,44.85-6.61,51.93-6.64-23.69,11.65-32.74,11.79-40.64-1.9-35.4,.15,44.45-.29,47.17-.85,12.52-1.14,12.52-1.14c0,0-37.77,6.58-43.66,6.93s5.92,6.73,10.28,7.26,34.35-10.69,34.35-10.69c0,0-16.29,10.42-18.57,11.73s11.88,1.26,18.52,.47,39.93-9.86,47.22-13-11.94,10.94-22.06,12.73-48.89,4.89-51.17,6.2,20.83,6.23,25.19,6.76,66.24-24,77.65-30.61-3.57,6.12-12.82,9.42-55.56,25-63.4,25.43-18.4,1.5-18.4,1.5c0,0,29.43,5.32,42.48-.18s52.52-23.21,55.56-25-41.6,28.06-51.72,29.84-21.45,3.25-23,4.13-4.45,4.59,3.72,2.93,36.69-5,48.42-12.73,36.48-28.15,36.48-28.15c0,0-5.62-15-4.65-18.61s4.09-10.47,1.9-14.28-1.06-5.47-1.06-5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3349.75,1956.34c-3.29,1.49-8.73,2.6-8.06,7.28s-.49,11.44,.5,14.92,3.08,5.33,1.23,7.4-4.12,3.4-5.32,3.08-.61,9.48-.06,12.2,.15,9,3.43,11.2,11.88,1.26,16.23,1.79,8.61-.91,11-.27,6.76,1.17,9-.14l3.8-2.2s-26.38-21.79-28.38-34.58-3.37-20.68-3.37-20.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3123.25,1982.18s2.46,14.8,6.85,22.41,7.37,18.05,11.41,19.78,6.2-1.55,8.08,3.45,10.3,14.34,10.09,17.5,2.2,30.16,16.45,51.34,15.13,22.71,15.13,22.71c0,0,13,13.78,15.54,16.38,2.58,2.67,5.36,5.13,8.31,7.38,1.64,1.08,5.56,.84,3.92-.24-2.81-2.3-5.35-4.92-7.55-7.81-.88-1.52,2.69-7.64,2.25-8.4s-3.19-7.28-7.87-6.61-5.88,.35-9.92-1.37-2.84-1.41-9.62-9.66-16.13-26.19-18.12-33.15-2.69-18.72-1.93-19.16,5.32-3.08,8,1.49,6,8.69,7.9,13.69,3.19,7.29,5.18,14.25,1.34,9.36,4.86,15.45,5.59,7.93,5.47,6,.06-12.2-.38-13-1.26-14.49-8.93-24.26-16.53-19.87-21.13-24.31-5.15-7.17-5.59-7.93,.53-4.36,.53-4.36l-.67-4.68s-7.64-2.69-12.24-7.14-4.06-8.81-4.94-10.33-3.87-12-3.87-12c-.5,.79-1.12,1.49-1.84,2.08-.76,.44-1.08,1.64-5.15-7.17s-4.51-9.56-5.38-11.09-4.84-1.24-4.84-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3280.91,1914.57c-2,.11-19.31-7.11-22.15-8.52s-15.48-2.22-24,.65-67.11,48.86-70.8,53-5.29,10.15-5.94,12.55,6.29-6.67,5.65-4.27-1.14,13.84,.3,18.08,1.55,6.2,2.4,.64-3.05-24.61,12.81-35.78,39.2-28.71,39.2-28.71c0,0-29.75,22.24-35.93,30.87s-13.54,16.94-13.83,25.22,2.66,11.65,2.66,11.65c0,0,3.66-11.24,8.43-17s17.75-25.46,24.6-29.41,20.22-10.65,20.22-10.65c0,0-41.9,36.34-45.23,46.38s-2.25,34.76-2.25,34.76c0,0,1.84,24.28,3,24.61s10.51-15.19,11.15-17.59,48.42-39.09,53-41.72,16.62-11.62,16.62-11.62c0,0-22.38,13.93-31.51,19.2s-29.43,21-31.39,21.15,35.28-28.47,49.3-37.57,23.46-15.57,23.46-15.57c0,0,5.53-6.23,10.09-8.86s10.21-6.91,10.86-9.31,3.13-6.87,2.25-8.39-5-5.21-7.11-7c-2.09-2.14-4.05-4.41-5.86-6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3176.76,2192.63c.87,1.52,35.41,52.58,43.16,57.23s21.07,10.15,25.43,10.68,17.08-3.78,17.08-3.78c0,0-5.85,7.44-10.85,9.31s-5.29,10.15-16,2.14-15.19-10.51-21.42-16-38.93-58.66-38.93-58.66l1.53-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3181.99,2194.68c.88,1.52,26.11,41.72,31,45s17.47,9.19,22.59,9.27,13.49-4.74,16.09-7.25,4.57-2.64,2.61-2.52-9.69,2.55-14.81,2.46-7,2-15-1.46-12.55-5.94-14.63-7.79-14.25-21.18-17.32-26.5-5-10.33-6.15-10.65c-1.45-.28-2.91-.46-4.38-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3253.51,2285.23s-20.74-11.35-28.06-15.24-16.18-14-16.18-14c0,0,9.77,18.69,14,24.34s10.5,11.17,14.86,11.7,13.72-.82,16-2.13,2-5.24,2-5.24l-2.62,.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3188.4,2189.97c.44,.76,11.65,23.7,18.2,28s13.87,8.22,17,8.42l9.48,.62,1.41-2.84-8.72-1.05s-14.08-5.06-15.39-7.35,3.8-2.19,3.36-2.95,.21-3.16-.23-3.92-.65,2.4-4.92-3.25-3.51-6.08-8.54-11.29l-7.55-7.81-4.1,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3131.91,2055.24s-11.18,10.5-12.67,18.46-4.51,16.79,.21,23.2,12.26,14.22,14.22,14.1,6.76,1.17,3.57-6.11-8-8.58-8.14-17.62,0-19.28,.35-20.48,4-12.43,4-12.43l-1.54,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3313.04,2168.75s-36.48,1.79-41-.7-11.59-9.54-5.24-2.05c3.79,4.71,8,9.06,12.58,13,4.16,3.69,3,3.37,8.52,4.22s25.86-14.93,25.86-14.93l-.72,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3425.7,1940.5c1.08-1.64,4.44-4.59,2.57-9.59s-5.86-18.93-12.61-20.1c0,0,12.37,16.18,9.16,28.17l.88,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3425.23,1959.02l.37-.14c2.09-.76,12.49-4.1,17.51,3,5.59,7.93,3.77,17.09,4.65,18.61s2.4,.64,2-.12-.12-2,.21-3.16-1.47-11.32-4.1-15.89c-2.53-4.18-6.49-7.3-11.15-8.77-3.6-1-9.69,2.54-11.21,3.42s-2.16,3.28-2.48,4.48-1.52,.88-.33,1.2l4.53-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3321.19,1982.57c2.4,.64-8,10.71-10.83,16.39s3.72,2.92,3.19,7.28-7.84,.47,.35,5.88,11.8,6.38,16.92,6.47,25.69-4.68,14.16-.06-18.93,5.85-20.66,9.89-6.61,7.87-11.06,12.46-2.13,10.36-7.49,6.35-10-3.33-9.3-10.85,3.89-7.32,.05-12.2-7.54-7.81-9.3-10.86-1.32-2.28-1.79-10.12-5.85-18.93,1.26-11.88,7.78,11.73,9.19,8.89,3.13-6.87,5-8.95,1.76,3,7.84-.47,10.07-8.88,12.47-8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3202.8,2193.83s7.69-9.51,12.05-9,15.33-6.82,15.33-6.82c0,0-.79-6.64,4.95,10.33s10.09,17.5,10.09,17.5c0,0,10.25,.17,11.56,2.45s2.17-3.27,7,12.17,14,24.35,13,26-5.29,10.15-4.86,10.91,4.89-3.83,6.21-1.55,2.95,3.36-.41,6.32c-2.19,2.14-3.8,4.81-4.65,7.75,0,0,1.37,16.44,.61,16.88s-6.77-8.2-6.77-8.2c0,0-2.86-8.48-3.22-14.36s.3-8.28-2.54-9.69-4.48-2.48-5.8-4.77-8.75-8.13-8.75-8.13c0,0-1.31-2.28-.79-6.64s-.35-5.88-.9-8.6,2-5.24-3.08-5.33-5.12-.09-9.59-2.57-2.67-11.65-4.31-12.73-2.07-1.84-5.35-4c-1.75-1.21-3.66-2.15-5.68-2.81,0,0-4.48-2.48-6.44-2.37s-7.66-2.74-7.66-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3245.62,2094.09c-2,.11-24.31-5.24-26.39-7.08s-21.25-26.28-23.47-37.16c-3.47-17,4.35-30.27,6.61-34.23,2.82-4.94,6.4-9.41,10.62-13.23-.4-.88-1.16-1.54-2.08-1.82-1.66-.31-3.93,1.47-4.67,4.72-.61,.51-1.31,.91-2.06,1.19-2.72,.56-10.41,10.06-12.81,9.42s-4.68,.67-5.45,1.11-11.46,18.79-11.46,18.79l2.75,6.52s1.93-7.2,5.18-12.11l6.49-9.83c-1.08,1.64-5.23,24.31-4.56,29,.6,3.54,1.88,6.94,3.75,10,.87,1.52,4.38,7.61,4.59,4.45s-5.56-27.21-5-31.57c.37-2.96,1.57-5.76,3.45-8.08,1.09-1.64,2.17-3.28,2-.12s-2.55,16.68-2.31,20.6,4.21,17.85,7.17,21.21,17.85,22.15,24.4,26.48,5.56,.85,11.88,1.26l28.44,1.84s-15.11-1.48-17.07-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3397.34,1907.18l-6.88-3.13s.21-3.16,2.17-3.28l2-.12s-4.16-3.68,3.36-2.95c4.87,.47,6.27,.82,7,1.1,.3,.2,.64,.34,1,.39,.93,.06,1.68-.71,2.28-1.32,.76-.77,1.15-1.16,1.09-1.63-.13-.91-1.76-.82-2.08-1.85s1.1-2.82,2-2.72c.23,0,.45,.08,.64,.21,1.64,1.08,1.52-.88,2.84,1.4,.33,.64,.79,1.21,1.35,1.66,.45,.34,1.53,1.53,2.37,1.27,.67-.22,.47-1.12,1.4-2.84,.39-.73,1.33-2.46,2.6-2.52,.49,0,.41,.23,1.2,.32,1,.12,1.5-.26,2.5,0,.23,.03,.46,.12,.66,.24,.74,.48,3.54,3.12,6.12,3.57,1.31,.14,2.64,.06,3.92-.24,.85-.18,1.38-.4,2-.11,.91,.44,1.19,1.72,1.32,2.28,.08,.66,.12,1.33,.11,2,.25,1.56,1.61,3.28,3,3.36s1.83-1.84,3-1.75c1.88,.14,3.75,5,4.07,8.8,0,.94,.18,1.87,.56,2.73,.92,1.86,2.35,1.87,3,3.36s-.6,1.89-.52,4.36c.22,2.45,1.51,4.67,3.51,6.09,1.64,1.08,.85-5.56,3.28,2.16,1.42,4.57,4.12,8.65,7.78,11.73,0,0,2.31,5.77,2.75,6.53,0,.03,0,.05,0,.08-.08,.06-1.1-.8-1.16-.74,1.8,1.71,3.46,3.56,4.95,5.54,.93,1.36,1.5,2.57,4.19,10.77l.56,2.72-3.37,3c-1.38,.66-2.72,1.4-4,2.23h.23c1.33-.43,4.15-1.62,5-1.87s2.48-.26,4.8,1.29c1.3,2.51,1.12,3.88,.67,4.68-1.55,2.76-7.81,1.33-8.8,4.06,0,.07-.21,3.16-.21,3.16h0l-.52,4.36-6.62,7.87-1.2-.32c-3.07-.55-6.77-1.63-7.31-3.89s2.23-3.81,4.33-6.55c7.78-10.19,.78-27.73-.24-30.29-1.53-3.82-3.6-7.41-6.14-10.65l-7.47-12.93s-4.27-5.64-6.46-9.45-2.75-6.52-4-6.84-3.4-4.13-4.6-4.45-8.19-5.41-8.63-6.17-.88-1.53-4.36-.53-6.2,1.55-6.2,1.55c-5.28-.43-10.53,1.15-14.69,4.42l-.15-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3405.5,1905.51c.54,1,3.95,.33,5.12,.09,1.75-.36,3.44-.99,5-1.87,4.41-2.42,11.68-2,16.12-.18,5.73,2.36,8.24,7.72,11.5,14.66,4.94,10.53,1.78,11.37,5.85,18.93,5.53,10.27,14.07,13.71,14.25,21.18v7.08h0c-.26,6.25-2.18,10.07-4,12.44-2.08,2.74-5,4.89-4.33,6.55,.49,1.22,2.61,1.39,2.83,1.4,4.07,.29,7.47-4.45,9.78-7.66,2.81-3.92,5-7,5.61-11.35,1.26-8.82-4.7-16.3-7-19.26-6.3-7.9-11.63-7.82-13.46-14.54-1.07-3.93,.52-4.83-.59-9.8-.3-1.37-1.28-5.15-7.46-12.93-7-8.82-10.51-13.22-16.62-14.75-3.91-.92-7.99-.67-11.76,.71-6.43,2.29-11.63,7.81-10.84,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3465.69,1918.44c-.32,1.2,.79,6.64,2.55,9.69s1.87,5,3.83,4.88,6.64-.79,6.2-1.55,.32-1.2-2.51-2.6-3.72-2.93-5.36-4-1.32-2.28-1.32-2.28l-3.39-4.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3101.83,1966.14c-.76,.44-6.32-.41-7.4,1.23-.75,1.25-1.34,2.59-1.73,4,0,0,.23,3.92,3,3.37,1.78-.28,3.48-.92,5-1.88l2.21-1.29c.72-.59,1.34-1.29,1.84-2.08l.65-2.4-3.57-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3106.45,1977.67s-2.4-.64-3.16-.2c-.89,.38-1.57,1.14-1.84,2.07-.37,.88-1.02,1.61-1.84,2.08,0,0-1.2-.32-.33,1.2s3.16,.21,4.69-.67,2.72-.56,3.48-1-1-3.48-1-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3115.76,1988.57c-.76,.44-5,1.87-5.33,3.07-.18,1.7-.21,3.41-.08,5.12l1,3.48s3.28,2.17,3.16,.21-1.32-2.29-.23-3.93,1.52-.87,2.6-2.51,2.6-2.52,2.17-3.28-3.29-2.16-3.29-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3140.66,2029.93l-12.37,10.18,5.35,4s5.85-7.43,7.26-10.27-.24-3.91-.24-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3146.13,2035.9c-3.8,2.19-11.73,7.78-12.37,10.18s4.07,8.8,4.51,9.56,1.49-8,2.89-10.79,3.57-6.12,4.33-6.56,.64-2.39,.64-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3147.25,2041.34s-7.78,14.63-6.79,18.11-.29,8.28,.56,2.72,5.93-12.55,5.93-12.55c0,0-1.08,1.64-.08,5.12s.91,8.6,1.23,7.4-1.47-11.32,1.84-2.08,1.67,8.17,3.42,11.21l5.27,9.13c-.44-.76-2-14-2.9-15.57s-.23-3.92-.35-5.88,1.26-11.88-.79-6.64-2.37,6.44-2.37,6.44c0,0-1.31-2.29-2.19-3.81s-2.78-13.6-2.78-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3150.78,2001.78s6,1.61,6.12,3.57-.21,3.16-2.61,2.52-3.39-4.13-6.11-3.57-4.68,.67-4.24,1.43,5.79,4.77,5.79,4.77c0,0,3-1.76,2.84,1.4s-1,3.6,0,7.08,2.43,7.73,4.83,8.37c1.8,.55,3.68,.84,5.56,.85,3.16,.2,3.48-1,5.56,.85s2.51,2.6,3.71,2.92,3-1.75,2.49-4.47-1.23-7.41-1.23-7.41c-.29-3.65-1.31-7.2-3-10.44l-3.07-5.33,1.52-.87c.76-.44,1-3.6,.09-5.12s-.24-3.92-3.4-4.13,1.76,3-5.76,2.31-8.95-5-10.36-2.13,1.27,7.4,1.27,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3255.09,2272.15c-.12-2-.58-9.8-1.78-10.12s-3.49,1-5.45,1.11c-3.53,.15-7.06,.49-10.56,1-2.72,.55-15.27-5.38-18.11-6.79s2.52,2.6,7,5.09,10.6,6.06,10.6,6.06c0,0,1.75,3,3.71,2.92s6.76,1.17,6.76,1.17l7.83-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3261.41,2272.57c-.19,.1-.39,.17-.59,.22-1.53,.42-5.26,1-7.57,1.45-2.72,.56-2.6,2.52-6.2,1.55-2.6-.74-5.15-1.64-7.64-2.69,0,0-15.71-6.14-16.15-6.9s13,6.7,15.07,8.54,6.55,4.33,9.39,5.73,3,3.37,5.24,2.05,2.4,.65,6.08-3.51,4-5.35,4-5.35l-1.63-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3241.04,2247.81s-14.48,1.26-16.12,.18-7.31-3.89-9.39-5.74-23-29.31-23-29.31c0,0,8.34,14.45,10.86,17.05s9,12.06,12.26,14.22,12.78,9.86,15.62,11.27,3.72,2.92,7.64,2.69,9-.15,9-.15c0,0-.32,1.2-.44-.76s1.52-.88-1-3.48-5.43-5.97-5.43-5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3231.61,2129.57s-1.78,16.24-2.87,17.88-1,3.59,.36,5.88,3.54,13.16,2.51,2.6-.7-11.76,.06-12.2,4.13-3.39,5-1.87,.15,9,.15,9l-.85,5.56c-.08,1.46-.26,2.92-.52,4.36-.32,1.2,1.43,4.24,1.43,4.24l3,3.36,3,3.37s-4-6.85-3.63-8,2.05-5.23,2.69-7.63,.09-5.12,2-5.24,3.8-2.2,4,1.73-1.17,6.75-1.05,8.71,.55,2.73,.67,4.69-.73,7.52,3,3.36,3.24-4.92,5.2-5,3.49-1,5.45-1.11,3.36-3,.4-6.32-6.58-11.41-13.9-15.31-9.3-10.85-11.7-11.49c-1.43-.41-2.91-.6-4.4-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3165.21,2039.08s5.36,4,7,5.09,3.39,4.13,5.58,7.93l7.47,12.94c2.63,4.56,2.31,5.76,4.83,8.36,1.26,1.37,2.65,2.6,4.15,3.69,0,0,1.32,2.28,2.52,2.6s4,1.73,.64-2.4-7.34-11-10.86-17-15.89-22.27-17.09-22.59-3.39-4.13-4.91-3.25-3.16-.2-3,1.76-1.41,2.84-.21,3.16c1.3,.11,2.61,0,3.88-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3199.71,2083.06c-.85-.23-.52,4.36,0,7.08s3.63,8,5.83,11.85,5.47,6,6.26,12.61,2.46,14.8,3,17.52,0,7.09,3.07,5.33,3.92-.23,4.56-2.63-.38-13-3.13-19.49-5.39-11.09-7.9-13.69-4.16-3.69-5.91-6.73-2.08-1.85-3.08-5.33-1.5-6.2-2.7-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3278.37,1904.84s6.88,3.13,9.95,8.46,4.71,6.4,4.83,8.36-1,3.6,.67,4.69c1.29,.9,2.54,1.88,3.72,2.92,0,0,2.72-.55,4.36,.53s.88,1.52,3.39,4.12,3.72,2.93,4.16,3.69,.88,1.52,1.2,.32l.64-2.4c.32-1.2,1.29-4.8,.09-5.12s-7.47-12.93-33.01-25.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3247.08,2026.32c-2.28,1.32-14.57,6.38-17.5,10.1s-3.68,4.15-6.41,4.71,7,5.09,9.28,3.77c1.53-.93,2.91-2.07,4.12-3.39,0,0,2-.12,1.64,1.08s-3.36,3-2.92,3.72l.88,1.52,6.2-1.55s2.72-.56,6.2-1.55c2.02-.51,3.96-1.29,5.77-2.31,.76-.44,2.72-.56,2.6-2.52s1.4-2.84-.24-3.92-7-5.09-7-5.09l-2.62-4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3263.08,2050.57c-2,.12-10.56,1-11.64,2.66s-1.29,4.8-.85,5.56,7.2,1.93,7.64,2.69c.33,.87,.52,1.79,.56,2.72l-4.13,3.4s-4.07-8.81-6-8.69l-3.92,.23c-.42,.23-.57,.75-.34,1.17l.02,.03c.42,.85,.14,1.87-.64,2.4-.76,.44-3.92,.24-1.85,2.08s3.28,2.16,5.24,2.05,4.13-3.4,4.56-2.64,2.4,.65,.56,2.73-3,1.75-2.93,3.71-.2,3.16,1.56,6.2,.11,2,3.51,6.09,3.63,8.05,4.59,4.45,1-3.6,1.93-7.2,2.17-3.28,4.65-7.75c1.45-2.56,2.61-5.27,3.46-8.08,0,0,.52-4.36-1.23-7.4l-3.08-5.33-1.67-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3234.7,2062.87s2.84,1.4,3.4,4.12,4.39,7.61,5.38,11.09c.61,2.16,.87,4.4,.79,6.64l-4.27-5.64s1.64,1.08-1.52,.88-3.6-1-4.8-1.29-1.84,2.08-1.75-3,.08-5.12,.41-6.32,.08-5.16,2.36-6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3229.91,2054.5s-.76,.44-2.84-1.4c-1.49-1.45-2.78-3.1-3.84-4.89l-3.71-2.93s-1.44-4.24-.68-4.68,6.24,5.53,7.44,5.86,3.16,.2,4.15,3.68,2.2,3.81,1.44,4.24c-.62,.25-1.31,.3-1.96,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3361.83,2037.18s-16.29,10.41-18.9,12.93-8.69,6-7.49,6.35c1.28,.52,2.72,.43,3.92-.24,1.53-.87,4.57-2.63,4.57-2.63,0,0,2.4,.64,1.64,1.08s.44,.76-2.61,2.52-7.17,5.15-3.68,4.15c2.57-.7,5.03-1.77,7.28-3.19,2.28-1.31,5.77-2.31,6.09-3.51s2.28-1.31,.64-2.4-5.56-.84-3.28-2.16,2.61-2.52,4.13-3.4l4.56-2.63,4.57-2.63c.76-.44,1.64,1.08,2.72-.56s2.28-1.31,1.84-2.08-.56-2.72-1.32-2.28-4.68,.68-4.68,.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3412.97,1971.17c.76-.44,2.08,1.84,1.76,3s-1,3.6-1,3.6c-.89,.97-1.62,2.08-2.16,3.28-.22,.66-.18,1.37,.11,2,0,0,7.29-3.19,6.85-3.95s.32-1.2,.64-2.4c.24-.94,.04-1.94-.55-2.72-.44-.77-.56-2.73-1.76-3-1.44-.26-2.9-.44-4.36-.52l.47,.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3163.64,2157.57h21.27s-3.69,4.16-5.65,4.27-1.2-.32-1.52,.88,4,1.73,6,1.61c1.49-.2,2.93-.69,4.24-1.43,0,0-.64,2.4-4.13,3.39s-3,1.76-5.44,1.11-2,.12-4.36-.52-2.08-1.85-3.71-2.93-6.7-6.38-6.7-6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3210.34,2148.92c-.76,.44-4.88,3.83-5.65,4.27s-2.72,.56-2.6,2.52-.2,3.16,2.75,6.52,3.4,4.13,4.6,4.45,5.23,2,5-1.87-1.14-12.53-1.58-13.29c-.76-.94-1.6-1.81-2.52-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3157.64,2103.28c.5,.25,.94,.59,1.31,1,2.26,2.18,6.26,7.21,6.36,8.76,.11,2,3.51,6.09,3.51,6.09,0,0-1.64-1.09,6.88,3.13s8.86,10.09,8.86,10.09c0,0-.32,1.2-4.24,1.43s-6.32-.41-6.64,.79,3.39,4.13,3.39,4.13l10.56-1s5.45-1.11,3.6,1,3.28,2.17,3,3.36-2.6,2.52-4.13,3.4,2.52,2.6,2.52,2.6c0,0,2.52,2.61,7-2s7.17-5.15,5.09-7-5.35-4-6.55-4.33-5.68-2.81-5.35-4,5.88-.35,3.36-2.95c-1.62-1.72-3.05-3.62-4.27-5.65,0,0-1.44-4.24-3.51-6.09s-4.6-4.44-3.6-1,.23,3.92,.23,3.92l-4-1.73s-1.43-4.24-2.63-4.56-.88-1.52-1.2-.32,1.32,2.28,1.76,3,.87,1.52,1.31,2.28,1.32,2.28-.32,1.2-3.6-1-4.48-2.49l-1.75-3-2.64-4.56c-.87-1.52,0,0-2.95-3.37s-3.51-6.08-3-3.36c.39,1.75,1.02,3.43,1.88,5l2.63,4.57,3,3.36,.55,2.72s.56,2.72-1.08,1.64c-1.45-1.08-2.62-2.5-3.4-4.13-.87-1.52-1.31-2.28-2.19-3.8s-1-3.48-2.63-4.56-6.12-3.57-6.12-3.57h-.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3055.19,1962.63c-.76,.44-3,1.76-1.14,13.84s4.54,16.65,5.41,18.17,4,1.73,3.6,1,.88,1.52-.67-4.68-.67-4.68-2.11-8.93-2.87-8.48-2.55-9.68,.74-7.52,.3-8.28,1.84-2.08,.64-2.4-3.48,.96-3.48,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3076.11,1963.75s-4.57,2.63-8.46,9.94-3.71,23.44-.64,28.77,11,19,12.73,22.06,10,15.53,11.18,15.85,1.52-.87,1.08-1.63,1.53-.88-3.62-8.05-7.23-9-10-15.54-8.11-10.53-7.93-20.77-2.14-16,1.87-21.36c2.24-2.92,4.16-6.06,5.73-9.39l-1.94,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3090.33,1977.85c-.16,.11-.32,.23-.46,.36-1.4,1.21-5,4.94-6.59,6.75-1.84,2.08-5.65,4.27-4.74,12.87s7.85,25.9,9.48,27c.82,.69,1.8,1.17,2.84,1.4,1.2,.32,1.08-1.64,.09-5.12s-5.39-11.09-6.18-17.73-2.1-8.92-1.14-12.52,6.7-13.01,6.7-13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3338.26,1956.48l-2.8,1.61c-3.66,2.11-4.85,.24-5.72-1.31-.58-1-1-1.91-1.92-1.38-1.11,.64-3.83,2.21-7.48,4.09-4.52,2.34-9.17,4.42-13.93,6.24-8.39,3.14-34.13,17-44.68,22.82-2,1.12-3.5,1.94-4.18,2.33-2.49,1.35-5.09,2.47-7.78,3.36-1.09,.37-2.08,.65-2.86,.83-1.12,.24-1.81,.25-1.71-.11,.28-1.06,65.48-35.63,81-43.83l.39-.21,2.41-1.27,.46-.25,.14,.06h.08c1.27,1.61,2.54,3.16,3.75,4.53l.18,.15c1.36,1.11,2.95,1.91,4.65,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M3277.4,2085.89c-3.91,1.34-7.9,2.45-11.95,3.31,1.23-.23,15.19-8.22,21.92-14.13s21.95-14.69,28.79-18.64,11.85-5.82,16.74-9.66c4.39-3.45,25.71-17.48,30.46-20.56,.53-.34,.85-.55,.93-.59l5.32-3.07c1.73-.83,3.56-1.41,5.45-1.73,.9-.17,1.52-.26,1.52-.26l-1.13,1.43-.34,.43c-2.76,1.61-19.61,11.57-30.25,20.49-11.61,9.74-58.22,39.66-67.46,42.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3162.04,2159.08c-2.88,1.43-3.58,2.66-3.6,3.56,0,.66,.31,1.12,.11,2-.24,1-1.2,2.19-1.84,2.08-1.49-.25,.3-7-3-10.44-2-2.13-5.35-2.29-7.89-2.08-6.19-10.71-12.46-21.57-18.74-32.42-.38-1.17-.52-2.4-.44-3.63,1-3.6,1.72-4,3.24-4.91s5.56,.85,7.52,.73,3.72,2.92,6.68,6.29,1.75,3,4.27,5.65,1.52-.88,1.52-.88c0,0-.56-2.72-1.11-5.44s2-.12,3.6,1,3,3.37,4.91,3.25-.55-2.72-1.43-4.24-8.87-10.1-10.19-12.38-2-7-3.86-12-1.32-2.28-3.72-2.92-4.94-10.33-5.73-17,4.94-16,4.94-16l.76-.44,1.26,14.49,5.21-5s1.17,19.6,12.47,37.42,2.51,2.6,8.86,10.09c.85,1,1.62,1.84,2.35,2.58,.32,.34,.58,.59,.71,.72,6.84,6.66,10.25,10,9.64,11.68-.31,.86-1.34,1.2-3,1.76-3.78,1.23-6.16-.11-6.64,.79-.58,1.07,2,4.64,5.47,6,1.81,.68,3.11,.48,4,1.72,.54,.72,.6,1.46,1.76,3,.35,.49,.49,.63,.43,.76-.28,.65-4.43-.18-8-1.49-1.61-.59-2-.88-2.91-.82-2.32,.16-4.7,2.4-4.38,4,.14,.72,.81,1.23,2.08,1.85,3.12,1.51,5.5,1.54,10.36,2.13,6.57,.8,5.74,.9,7.32,1,3.35,.2,4.69-.12,5.75,.59,1.64,1.08-12.84,2.34-12.84,2.34-3.15,.18-6.28,.64-9.36,1.35-3.23,.92-4.22-.32-5.21,.8-.08,.1-.16,.2-.23,.31-.13,.23-.56,1.05-1.1,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3449.91,1898.14c-1.42,.75-3.16,.54-4.36-.53-2.08-1.84,.2-3.16-.24-3.92s.32-1.2,.76-.44,3.72,2.93,4.16,3.69c.25,.41,.12,.93-.29,1.18l-.03,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3481.41,1950.95c.43,.76-2.29,1.31-1,3.6s2.4,.64,3,3.36c.18,1.2,.51,2.37,1,3.48,0,0,1.2,.32,.64-2.4s1-3.6,.09-5.12-1.31-2.28-1.31-2.28l-2.42-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3213.03,2141.28c.44,.76,7.43,5.85,10.3,14.34s8.69,20.33,11.65,23.7,9.83,6.49,8.52,4.21-4-1.73-6.79-8.25-.88-1.52-2-7-1.56-6.21-3.63-8.05-3.72-2.92-4.6-4.45-.79-6.64-2.87-8.48-.55-2.72-2.95-3.37-7.63-2.65-7.63-2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "2963.6 1857.23 3103.7 1809.43 3096.87 1789.42 2949.05 1839.85 2963.6 1857.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "2956.3 1848.51 3094.35 1801.54 3090.95 1791.56 2949.04 1839.84 2956.3 1848.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "3068.82 1982.89 3144.44 1846.23 3125.93 1835.99 3054.27 1965.51 3068.82 1982.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "3061.6 1974.26 3134.07 1843.05 3124.83 1837.95 3054.34 1965.6 3061.6 1974.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 2999.34,
    y: 1869.88,
    width: 134.53,
    height: 21.18,
    transform: "translate(-493.73 2394.49) rotate(-39.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 2988.99,
    y: 1858.87,
    width: 128.92,
    height: 10.55,
    transform: "translate(-484.43 2395.14) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M3505.71,1517.57l-27.15-32.42c1.08,.38,2.22,.53,3.36,.42,1.2-.1,2.4-.32,3.56-.64,11.83-3.2,30-17,30-17l44.13-37,13.58,16.21-44.14,37s-16.73,15.52-22,26.6c-1.14,2.67-1.73,5.02-1.34,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3565.13,1441.08l-72.6,60.79-12.38-14.79,1.76-1.51c1.2-.1,2.4-.32,3.56-.64,11.83-3.2,30-17,30-17l42.42-35.51,7.24,8.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 3145.73,
    y: 1665.21,
    width: 340.13,
    height: 15.27,
    transform: "translate(-300.42 2518.94) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 3144.4,
    y: 1668.67,
    width: 331.9,
    height: 8.15,
    transform: "translate(-301.63 2515.42) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 3122.35,
    y: 1637.27,
    width: 340.13,
    height: 15.27,
    transform: "translate(-287.94 2497.41) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 3121.02,
    y: 1640.74,
    width: 331.9,
    height: 8.15,
    transform: "translate(-289.15 2493.89) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 3577.29,
    y: 1395.92,
    width: 68.73,
    height: 12.38,
    transform: "translate(-57.6 2645.72) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M3021.49,1822.06l10.86,1.41-8.64,67.1-6.89,5.41-4.82-.62c3.16-24.44,6.32-48.87,9.49-73.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 2982.2,
    y: 1856.58,
    width: 73.9,
    height: 4.79,
    transform: "translate(787.77 4614.33) rotate(-82.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M3099.81,1915.57l-82.2-3.94c.07-1.53,.14-3.07,.22-4.6v-.1l6.8-6,75.7,3.75-.3,6.33-.22,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3099.81,1915.57l-82.2-3.94c.07-1.53,.14-3.07,.22-4.6l82.2,3.93-.22,4.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 3677.49,
    y: 1335.8,
    width: 20.56,
    height: 5.18,
    transform: "translate(1.07 2679.72) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 3694.28,
    y: 1325.43,
    width: 11.75,
    height: 5.18,
    transform: "translate(10.62 2685.25) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 3703.28,
    y: 1317.86,
    width: 11.75,
    height: 5.18,
    transform: "translate(17.57 2689.26) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 3712.3,
    y: 1310.34,
    width: 11.75,
    height: 5.18,
    transform: "translate(24.51 2693.3) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 3721.3,
    y: 1302.76,
    width: 11.75,
    height: 5.18,
    transform: "translate(31.47 2697.31) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 3730.32,
    y: 1295.26,
    width: 11.75,
    height: 5.18,
    transform: "translate(38.39 2701.35) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 3739.34,
    y: 1287.75,
    width: 11.75,
    height: 5.18,
    transform: "translate(45.32 2705.38) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 3627.69,
    y: 1357.74,
    width: 65.21,
    height: 7.31,
    transform: "translate(-20.11 2667.44) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M3186.91,1835.08c-2.99,2.51-6.21,4.71-9.63,6.59-.33,.19-.66,.36-1,.53s-.66,.35-1,.51l-.44,.22-.6,.29h0c-.17,.08-.34,.17-.52,.24l-.33,.16-.79,.35c-.13,.07-.27,.12-.4,.18l-.3,.12-.45,.2-.32,.13c-.65,.26-1.3,.52-2,.76l-1,.37-1,.35c-.83,.28-1.67,.53-2.51,.76l-1,.29c-.37,.09-.74,.19-1.12,.27-.55,.14-1.11,.26-1.67,.38-4.97,1.04-10.04,1.44-15.11,1.2-.58,0-1.16-.06-1.73-.11-32.99-2.49-57.71-31.24-55.23-64.23,.06-.8,.14-1.59,.23-2.39,.07-.56,.14-1.13,.22-1.69,.68-4.71,1.92-9.32,3.68-13.74,.19-.47,.39-.94,.59-1.4s.41-.94,.62-1.4,.41-.87,.62-1.3,.3-.61,.46-.92l.33-.64c.22-.42,.44-.83,.67-1.24l.68-1.2c.04-.05,.08-.11,.11-.17l.79-1.28,.06-.11s.06-.07,.08-.11c.23-.36,.46-.72,.7-1.08s.52-.79,.8-1.17,.39-.57,.6-.86,.55-.75,.83-1.11c2.7-3.55,5.79-6.78,9.21-9.64,.46-.38,.91-.75,1.37-1.11l1.28-1,.87-.64,.6-.42,.23-.17,.5-.34c.29-.2,.58-.4,.88-.59,.59-.39,1.2-.77,1.81-1.13,.3-.19,.6-.36,.91-.54l.81-.47,1-.55c.93-.5,1.87-.97,2.82-1.41,.47-.22,1-.44,1.42-.64l1.44-.61c5.76-2.34,11.85-3.76,18.05-4.21,1-.08,2-.13,3-.14,8.85-.22,17.65,1.52,25.75,5.09,8.38,3.71,15.79,9.3,21.67,16.33,1.77,2.11,3.39,4.34,4.85,6.67,3.28,5.22,5.73,10.93,7.26,16.91,2.31,9.02,2.48,18.46,.51,27.56-.22,1-.48,2.09-.76,3.13-1.4,5.12-3.47,10.04-6.16,14.62-.25,.43-.51,.85-.78,1.29-.12,.2-.25,.39-.38,.59-.47,.74-1,1.48-1.47,2.2l-.76,1-.75,1c-.15,.18-.29,.37-.44,.56s-.42,.52-.63,.78l-.82,1-.14,.16-.86,1c-.28,.32-.58,.64-.87,1s-.52,.55-.78,.81c-.02,.03-.05,.07-.08,.09h0l-.92,.93-.56,.53s-.08,.09-.13,.13l-.07,.06h0l-.26,.24c-.28,.27-.57,.54-.87,.8-.61,.51-1.12,.95-1.67,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M3097.91,1757.06l73.3,87.55c5.72-2.34,11.04-5.56,15.78-9.53,.51-.43,1-.87,1.51-1.31,2.59-2.32,4.97-4.86,7.12-7.59l-75.29-89.92c-3.14,1.68-6.12,3.63-8.91,5.83-.46,.36-.91,.73-1.37,1.11-3.42,2.86-6.51,6.09-9.21,9.64-1.07,1.37-2.04,2.78-2.93,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M3177.32,1841.67c-5.17,2.85-10.75,4.92-16.53,6.12-27.77-45.21-55.79-71-67.93-81,2-5.01,4.67-9.71,7.94-14,43.44,36.48,67.21,72.72,76.52,88.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M3188.46,1833.77c-33.4-55.1-67.27-84-77.08-91.68,4.43-3.51,9.35-6.37,14.59-8.49,39.8,34.55,63.3,68.2,74.15,86-3.13,5.3-7.06,10.08-11.66,14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M3037.21,1840.17c7.71-6.46,8.73-17.94,2.27-25.65s-17.94-8.73-25.65-2.27-8.73,17.94-2.27,25.65h0c6.45,7.71,17.93,8.73,25.64,2.28h.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-114",
    cx: 3096.41,
    cy: 1910.74,
    r: 18.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3101.75,1928.3c-9.62,2.93-19.8-2.49-22.73-12.11s2.49-19.8,12.11-22.73c4.53-1.38,9.41-.94,13.62,1.22-9.62,2.95-15.03,13.14-12.08,22.76,1.44,4.7,4.71,8.61,9.08,10.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3166.05,1846.45c-31.65,9.7-65.17-8.1-74.87-39.75-9.7-31.65,8.1-65.17,39.75-74.87,14.92-4.57,31.04-3.15,44.92,3.98-31.66,9.79-49.39,43.38-39.6,75.04,4.76,15.38,15.5,28.21,29.8,35.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3031.23,1844.08c-9.62,2.94-19.81-2.47-22.75-12.1-2.94-9.62,2.47-19.81,12.1-22.75,4.54-1.39,9.43-.95,13.65,1.22-9.62,2.96-15.03,13.16-12.07,22.78,1.44,4.69,4.71,8.6,9.07,10.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M3491.91,1569.76c-2.23,1.86-4.61,3.53-7.12,5-8.58,5.03-18.41,7.5-28.34,7.13l-1.5-.07c-28.81-1.88-50.65-26.76-48.77-55.57,.05-.77,.12-1.54,.2-2.3,.1-.9,.22-1.82,.37-2.71,.6-3.73,1.61-7.38,3-10.89,.29-.72,.59-1.44,.91-2.15,.13-.31,.26-.6,.41-.89s.15-.34,.23-.5c.19-.39,.42-.86,.68-1.34l.36-.68s.05-.1,.08-.14c.18-.34,.36-.67,.56-1,.04-.09,.09-.18,.14-.26l.55-.93c.51-.83,1-1.65,1.59-2.45,.23-.31,.47-.65,.73-1l.25-.32c.16-.23,.34-.46,.52-.71s.21-.28,.33-.42c.33-.43,.7-.89,1.1-1.38l.09-.11c.1-.12,.21-.24,.31-.37l.27-.32h0l.38-.44c1.71-1.92,3.55-3.72,5.53-5.36,4.53-3.8,9.67-6.81,15.21-8.88,3.02-1.14,6.15-1.99,9.33-2.54,28.45-4.98,55.55,14.05,60.53,42.51,1.57,8.96,.77,18.17-2.31,26.72-1.17,3.27-2.67,6.41-4.47,9.38-2.98,4.91-6.74,9.3-11.15,12.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M3484.8,1574.79c-5.2,3.05-10.89,5.18-16.82,6.28-6.46-19.08-17.41-36.32-31.93-50.28-7.95-7.56-16.88-14.02-26.55-19.2,.35-1.25,.79-2.48,1.3-3.67,0,0,.53-1.16,1.19-2.42,1.98-3.8,4.42-7.35,7.27-10.55l39.53,25.17,26.01,54.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M3491.91,1569.76c-2.23,1.86-4.61,3.53-7.12,5-3.11,1.83-6.41,3.32-9.83,4.47-6.03-19.39-16.65-37.04-30.94-51.46-9.28-9.29-19.97-17.05-31.68-23l-.16-.08c.76-1.27,1.79-2.89,3.08-4.7,.23-.31,.47-.65,.73-1l.25-.32c.16-.23,.34-.46,.52-.71s.21-.28,.33-.42c.36-.47,.76-1,1.19-1.49,.1-.12,.21-.24,.31-.37l.28-.32,.38-.44c1.71-1.92,3.55-3.72,5.53-5.36,4.53-3.8,9.67-6.81,15.21-8.88,3.02-1.14,6.15-1.99,9.33-2.54,28.45-4.98,55.55,14.05,60.53,42.51,1.57,8.96,.77,18.17-2.31,26.72-1.17,3.27-2.67,6.41-4.47,9.38-2.98,4.92-6.75,9.32-11.16,13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M3503.08,1556.78c-14-41.81-47.16-66.33-63.08-76.07,3.02-1.14,6.15-1.99,9.33-2.54,33.83,18.72,50.93,51.15,58.22,69.23-1.17,3.27-2.67,6.41-4.47,9.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 3683.69,
    y: 1334.99,
    width: 2.94,
    height: 11.75,
    transform: "translate(-1.13 2678.62) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 3635.31,
    y: 1373.08,
    width: 3.52,
    height: 15.27,
    transform: "translate(-37.93 2657.04) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3386.14,
    y: 1572.66,
    width: 16.45,
    height: 21.15,
    transform: "translate(-224.56 2548.48) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 3389.66,
    y: 1572.66,
    width: 9.4,
    height: 21.15,
    transform: "translate(-224.57 2548.47) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3350.57,
    y: 1602.45,
    width: 16.45,
    height: 21.15,
    transform: "translate(-251.99 2532.59) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 3354.06,
    y: 1602.46,
    width: 9.4,
    height: 21.15,
    transform: "translate(-252 2532.56) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3314.95,
    y: 1632.25,
    width: 16.45,
    height: 21.15,
    transform: "translate(-279.43 2516.67) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 3318.49,
    y: 1632.24,
    width: 9.4,
    height: 21.15,
    transform: "translate(-279.42 2516.68) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3279.38,
    y: 1662.04,
    width: 16.45,
    height: 21.15,
    transform: "translate(-306.85 2500.79) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 3282.92,
    y: 1662.03,
    width: 9.4,
    height: 21.15,
    transform: "translate(-306.84 2500.8) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3243.79,
    y: 1691.84,
    width: 16.45,
    height: 21.15,
    transform: "translate(-334.29 2484.89) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 3233.49,
    y: 1700.44,
    width: 9.41,
    height: 21.18,
    transform: "translate(-345.79 2465.04) rotate(-39.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3208.22,
    y: 1721.63,
    width: 16.45,
    height: 21.15,
    transform: "translate(-361.71 2469) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 3211.78,
    y: 1721.61,
    width: 9.4,
    height: 21.15,
    transform: "translate(-361.69 2469.02) rotate(-39.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M3517.48,1464.86l.7-7.87s19.45,6.31,21.38,26.91l-6.62-.58c-3.89-7.11-9.15-13.38-15.46-18.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3090.52,1783.57c-.53-.44-1-.87-1.56-1.29,.07-.56,.14-1.13,.22-1.69s.11-1.11,.16-1.67c.62,.44,1.26,.92,1.91,1.44,.4,.32,.78,.64,1.15,1l-1.88,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3107,1794.57c-1.16-1.16-2.35-2.32-3.53-3.44l-2,2.12c1.17,1.12,2.34,2.25,3.49,3.4l2.04-2.08Zm-7.15-6.81c-1.22-1.1-2.46-2.21-3.69-3.29l-1.93,2.22c1.21,1,2.44,2.15,3.64,3.25l1.98-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3120.4,1809.12c-1.06-1.25-2.14-2.51-3.23-3.74l-2.2,1.94c1.07,1.22,2.14,2.46,3.19,3.7l2.24-1.9Zm3.14,3.81l-2.28,1.85c1,1.26,2,2.55,3,3.82l2.32-1.79c-.98-1.24-2.01-2.6-3.04-3.88h0Zm-9.68-11.22c-1.12-1.21-2.25-2.42-3.39-3.59l-2.11,2c1.12,1.16,2.24,2.36,3.34,3.55l2.16-1.96Zm15.72,19l-2.37,1.74c1,1.31,1.93,2.64,2.86,4l2.4-1.69c-.95-1.34-1.92-2.69-2.89-4.01v-.04Zm5.69,8.08l-2.44,1.64c.9,1.35,1.81,2.72,2.67,4.08l2.48-1.59c-.89-1.35-1.79-2.72-2.71-4.09v-.04Zm5.33,8.33l-2.51,1.52c.84,1.39,1.68,2.79,2.49,4.19l2.55-1.47c-.83-1.37-1.68-2.79-2.53-4.2v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3147.34,1849.09l-1.66-.1c-.58,0-1.16-.06-1.73-.11-.31-.58-.63-1.16-1-1.76l2.57-1.42,.72,1.31c.41,.71,.77,1.4,1.1,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3407.38,1524.57l-1-.62c.1-.9,.22-1.82,.37-2.71l.83,.46c.39,.24,.77,.46,1.13,.69-.43,.76-.88,1.48-1.33,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3415.96,1527.31c-1.16-.86-2.37-1.71-3.57-2.52-.47,.71-.94,1.42-1.42,2.12,1.17,.79,2.35,1.62,3.5,2.46,.51-.68,1-1.37,1.49-2.06Zm5.62,6.94l1.27-1.49c-1.11-1-2.25-1.89-3.39-2.8l-.71,.91-.86,1.1c1.11,.88,2.22,1.79,3.31,2.73l.38-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3452.01,1570.97l-2.31,1.08c.61,1.29,1.2,2.6,1.75,3.9l2.35-1c-.57-1.31-1.17-2.66-1.79-3.98Zm-4-7.78l-1.47,.82-.75,.43c.71,1.24,1.4,2.51,2,3.77l1.55-.8,.72-.37c-.66-1.28-1.37-2.58-2.09-3.85h.04Zm-4.65-7.47l-2.11,1.42c.57,.85,1.14,1.7,1.69,2.57,.22,.35,.44,.69,.65,1l.14-.09,2-1.25c-.82-1.2-1.58-2.44-2.41-3.65h.04Zm-14-17c-1-1-2.11-2.06-3.17-3.05l-1.73,1.88c1,1,2.09,2,3.1,3l1.8-1.83Zm8.8,9.87l-2,1.59c.89,1.11,1.77,2.27,2.61,3.42l2.06-1.51c-.92-1.15-1.8-2.33-2.71-3.52l.04,.02Zm-2.81-3.4c-1-1.11-1.94-2.22-2.93-3.29-.63,.57-1.25,1.16-1.87,1.73,1,1.06,1.94,2.14,2.87,3.22l1.93-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3456.55,1582.19l-1.43-.31-1.47-.33c-.19-.54-.4-1.09-.6-1.64l2.38-.9c.16,.41,.31,.82,.46,1.24,.24,.66,.46,1.32,.66,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3145.79,1732.18l-1.25-.91c-.86-.64-1.67-1.28-2.44-1.91h1.92c1-.08,2-.13,3-.14l.62,.44-1.85,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3156.32,1736.48c-1.41-1.16-2.86-2.33-4.3-3.45l-1.9,2.43c1.42,1.11,2.84,2.25,4.23,3.4l1.97-2.38Zm8.29,7.29l-1-1c-.15-.13-.3-.26-.44-.4l-.66-.6-1.95-1.74-2,2.32,1.29,1.15,1,.87c.14,.14,.29,.27,.44,.4l1.33,1.23,1.99-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3201.97,1791.86l-.21-.4-2.71,1.49c.86,1.56,1.71,3.17,2.52,4.76h0l2.76-1.41c-.75-1.46-1.55-2.96-2.36-4.44Zm-5.4-9.27l-.41-.65-2.61,1.65c.21,.33,.41,.67,.62,1,.75,1.19,1.49,2.41,2.19,3.62l2.67-1.56c-.8-1.35-1.62-2.72-2.46-4.08v.02Zm-3.91-6c-.85-1.27-1.74-2.54-2.63-3.79l-2.52,1.79c.94,1.32,1.87,2.66,2.77,4,.11,.16,.22,.31,.32,.47l2.57-1.72-.51-.75Zm-20.19-25c-.98-1.02-1.98-2.02-3-3-.29-.3-.58-.59-.88-.88l-2.17,2.2,.68,.67c1.06,1,2.11,2.12,3.13,3.19l2.24-2.18Zm14.06,16.49c-1-1.36-2.09-2.72-3.15-4l-2.41,1.93c.87,1.08,1.73,2.18,2.58,3.29,.21,.26,.41,.53,.61,.8l.15,.19,1-.76,1.46-1.1-.24-.35Zm-6.67-8.3c-1.19-1.4-2.41-2.8-3.63-4.15l-2.3,2.07c1.2,1.33,2.41,2.7,3.58,4.08l2.35-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M3206.28,1804.94c-.17,.46-.35,.91-.52,1.37-.37-.76-.73-1.52-1.1-2.29l-.65-1.4,2.78-1.33c.09,.17,.17,.34,.25,.52l-.76,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3107.1,1917.23c2.83-.07,5-2.88,5-6.29s-2.44-6.11-5.26-6-5.05,2.88-5,6.29,2.44,6.07,5.26,6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 3175.17,
    cy: 1808.75,
    rx: 19.5,
    ry: 23.51,
    transform: "translate(-35.53 63.85) rotate(-1.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 3489.89,
    cy: 1528.43,
    rx: 16.74,
    ry: 20.18,
    transform: "translate(-36.05 85.11) rotate(-1.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3036.2,1832.57c2.83-.07,5.05-2.89,5-6.29s-2.44-6.12-5.26-6-5.05,2.89-5,6.29c.05,3.4,2.44,6.05,5.26,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3473.67,1579.67c-27.61,8.45-56.85-7.08-65.31-34.69-8.45-27.61,7.08-56.85,34.69-65.31,13.01-3.98,27.06-2.74,39.16,3.47-27.62,8.5-43.12,37.77-34.62,65.39,4.14,13.47,13.54,24.69,26.07,31.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "3749.69 1286.5 3589.35 1420.76 3585.37 1416.01 3631.76 1377.16 3630.84 1376.06 3633.54 1373.79 3636.1 1376.85 3681.59 1338.76 3680.16 1337.05 3682.41 1335.17 3684.52 1337.69 3748.03 1284.51 3749.69 1286.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M3577.39,1414.7l.69-7.87s19.45,6.31,21.38,26.91l-6.62-.58-15.45-18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M3585.73,1447.57c-1.8,1.51-3.87,2.67-6.1,3.42l-.5,.16c-.66,.2-1.33,.36-2,.49-2.86,.53-5.8,.39-8.59-.4-3.42-.96-6.49-2.87-8.85-5.52l-.39-.44v-.06c-2.43-2.88-3.93-6.44-4.29-10.19-.3-2.99,.12-6.01,1.22-8.81,.12-.3,.25-.59,.38-.89,0,0,.19-.41,.43-.87,0-.08,.08-.16,.13-.24l.15-.28c.18-.33,.38-.65,.58-1s.21-.32,.32-.48l.26-.36,.09-.12s.05-.09,.09-.12c.03-.05,.06-.09,.1-.13l.11-.15,.14-.18,.29-.36,.12-.13,.1-.12s.09-.1,.13-.16c.62-.69,1.29-1.33,2-1.92l.08-.07,.3-.24c1.53-1.23,3.25-2.2,5.09-2.89,3.3-1.23,6.87-1.51,10.32-.82h0c1.68,.33,3.3,.9,4.82,1.67,.55,.28,1.09,.59,1.61,.93,1.6,1.03,3.03,2.29,4.25,3.75,4.29,5.13,5.54,12.15,3.28,18.44-1.14,3.12-3.07,5.88-5.62,8l-.05,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M3583.17,1449.35c-1.12,.66-2.31,1.2-3.54,1.61l-.5,.16c-.66,.2-1.33,.36-2,.49-.25-.73-.55-1.55-.91-2.44-1.68-4.17-3.97-8.07-6.8-11.57-1.18-1.43-2.43-2.79-3.77-4.07-2.86-2.72-6.07-5.04-9.55-6.91v-.12h0c.12-.41,.26-.81,.43-1.2,0,0,.19-.41,.43-.87,0-.08,.08-.16,.13-.24l.15-.28c.18-.32,.38-.64,.58-1,.1-.16,.21-.32,.32-.48l.26-.36c.06-.08,.12-.16,.18-.24,.03-.05,.06-.09,.1-.13l.11-.15,.14-.18,.29-.36,.12-.13,.1-.12s.09-.1,.13-.16h0l10.81,6.88,3.38,2.15,9.41,19.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M3585.73,1447.57c-.81,.67-1.67,1.28-2.57,1.81-1.12,.66-2.3,1.2-3.53,1.61-2.17-6.97-5.98-13.32-11.12-18.5-3.34-3.34-7.18-6.13-11.39-8.27h-.06c.27-.45,.64-1,1.11-1.69l.26-.36,.09-.12c.06-.08,.12-.17,.19-.25l.11-.15,.43-.54,.12-.13,.09-.12,.14-.16c.62-.69,1.29-1.33,2-1.92,7.84-6.8,19.72-5.96,26.52,1.88,6.8,7.84,5.96,19.72-1.88,26.52-.16,.14-.33,.28-.5,.42v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M3589.74,1442.87c-5-15-17-23.84-22.68-27.35,1.09-.41,2.21-.71,3.35-.91,12.17,6.73,18.31,18.39,20.94,24.89-.42,1.17-.96,2.3-1.61,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3585.45,1440.13c3.35-.09,6-3.43,5.89-7.47s-2.89-7.25-6.25-7.17-6,3.43-5.89,7.47,2.9,7.25,6.25,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3579.13,1451.12c-.66,.2-1.33,.36-2,.49-2.86,.53-5.8,.39-8.59-.4l-.1,.09c-3.39-1.01-6.42-2.95-8.75-5.61-.12-.12-.22-.24-.33-.37l-.06-.07c-4.34-5.23-5.55-12.39-3.16-18.75h0c.28-.79,.61-1.55,1-2.29,.68-1.27,1.51-2.47,2.46-3.55,.63-.72,1.32-1.39,2.05-2l.3-.24,.6-.46c4.24-3.17,9.62-4.42,14.83-3.43,1.79,.33,3.52,.93,5.13,1.76l-.32,.1c-.87,.27-1.73,.6-2.55,1-.96,.47-1.87,1.03-2.73,1.66-.34,.25-.68,.51-1,.78s-.89,.78-1.3,1.19c-1.84,1.84-3.27,4.05-4.2,6.48-2.48,6.43-1.28,13.7,3.13,19,.79,.95,1.68,1.82,2.65,2.59,.92,.77,1.9,1.45,2.94,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M3254.21,2651.13c0,475.25-264.48,888.77-654.42,1101.74-39.8,21.77-80.77,41.33-122.72,58.61h-.12c-147.61,60.91-309.39,94.5-479,94.5-73.8,.03-147.45-6.4-220.13-19.21-134.6-23.73-264.39-69.4-384.18-135.2-23.05-12.63-45.64-25.97-67.79-40-56.97-36.09-110.95-76.71-161.42-121.45h-.07c-259.32-229.89-422.73-565.33-422.73-938.91-.07-97.35,11.19-194.37,33.56-289.11h0c1.16-5.11,2.38-10.18,3.68-15.26,1.86-7.57,3.81-15.08,5.86-22.6h0c115.32-428,451.58-765.47,879.06-883,35.33-9.74,71.26-17.93,107.78-24.57,74.68-13.58,150.43-20.41,226.34-20.4,13.26,0,26.47,.21,39.63,.64,67.9,2.08,135.52,9.66,202.19,22.66,35.68,6.95,70.8,15.38,105.37,25.27,366.4,105,664.19,372.08,810.69,718.58,4,9.51,7.9,19,11.67,28.66,57.5,146.21,86.93,301.94,86.75,459.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M943.91,2417.39c3.23,12.91,0,3.23,6.46,19.36,3.75,9.53,9.23,18.28,16.15,25.83l32.32,3.22s29.08-6.45,25.85-16.13-9.7-38.73-9.7-38.73c0,0,0-12.91-6.46-19.37s-3.23-19.37-3.23-22.59,6.46-16.14-9.7-12.91-45.23,19.36-45.23,19.36l3.23,16.14c-3.25,3.23-12.95,12.91-9.69,25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1044.06,2546.49c6.46,3.23,16.15,3.23,16.15,3.23,0,0,9.69,3.23,12.93-6.45s16.15-3.23,3.23-19.37-19.39-16.14-16.16-22.59,9.69-6.46,0-9.69-32.31,0-32.31,0c-3.23,12.91-19.39,29-9.69,38.74s19.38,12.91,25.85,16.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2029.59,1629.85c0,6.46,6.46,16.14,6.46,16.14,0,0,0,12.91,3.23,16.14s6.47,0,19.39-6.46,9.7-16.14,16.16-22.59,0-16.14,0-16.14l-12.93-9.68s-9.69,0-16.15,6.45-16.16,9.69-16.16,16.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1667.7,1455.57c0,12.91-3.23,12.91-16.17,22.61s-32.32,32.28-32.32,32.28c0,0-22.6,9.68-58.15,16.13s-32.32,12.9-32.32,12.9v22.6l38.78,6.45s-6.46,3.23-19.37,35.51-12.95,32.28-19.41,38.73-74.32,12.9-74.32,12.9c0,0-64.63,0-84,12.93s-32.32,19.35-35.55,25.8,3.23,38.73,3.23,58.11,9.69,0,51.69-16.12,32.32-16.16,58.18-29.06,25.86-16.15,48.46-16.15,25.86,16.15,25.86,22.6,0,25.83,6.45,74.24c6.45,48.41,12.92,48.4,12.92,64.56s-19.37,16.12-35.55,48.4-16.14,12.9-29,12.9-35.55-12.9-42-25.8-29.09,6.45-29.09,6.45c0,0-19.4,16.13-25.86,38.74s3.23,19.35,3.23,51.63-6.45,12.9-16.14,38.73c-9.69,25.83-35.55,9.67-35.55,9.67,0,0-16.17,3.23-22.63,3.23s-19.37-9.68-29.09-12.9-32.28,3.22-61.37,12.9-6.46,12.93-12.92,22.6-12.94,12.9-38.8,42-12.92,12.9-35.52,22.6-25.86,16.13-51.72,35.51-16.14,19.35-38.77,51.63-3.23,29.06,0,51.63-19.37,25.83-45.23,38.73-25.86,0-25.86,0l9.71-74.23s-3.26-32.25-3.26-42-16.14-29-16.14-29h-35.55s-19.37,3.22-25.85,6.45c-5.52,2.75-15.77,12.57-18.61,15.36-.15,.51-.34,1.01-.56,1.49l1.94,6.81-3.7-3.61c-2.32,3.33-5.05,6.35-8.13,9,0,0-25.86,58.08-32.32,77.46s-3.23,29,0,38.73c4.29,13.6,13.52,25.1,25.86,32.25,16.14,9.71,22.6,12.93,22.6,12.93,4.34,14.67,6.51,29.89,6.46,45.19,0,25.83-12.92,19.35-32.32,25.83s-9.69,25.8-12.91,41.95,0,16.13,3.22,29.06,13,12.9,13,12.9c0,0,19.37,25.8,0,51.63s3.23,54.88,6.46,61.34c1.7,3.43,16.37,36.26,45.23,45.18,8.63,2.66,29.09,6.45,29.09,6.45,0,0,22.19-5.08,32.28-6.45,19.88-2.73,35.2,3.05,61.41,12.9,25.48,9.58,40.54,29.05,55,29.05,9.68,0,22.6,16.16,29.06,22.61,19.58,19.52,10,38.55,25.86,54.85,9.51,9.77,15.79,7.48,35.54,16.16,37.84,16.56,60.15,44.86,67.86,54.86,15.37,20.1,26.38,43.19,32.32,67.78,23.57,53.19,32.94,73.12,51.69,93.59,7.66,8.56,16.35,16.15,25.86,22.6,19.26,12.85,36.72,17.07,45.23,19.36,35,9.47,30.53,16.74,96.93,45.21,51.86,22.22,57.12,18.7,84,35.5,25.83,16.13,51.69,35.48,54.92,54.86s-12.91,61.33-29.09,74.23,0,0-25.83,29.06-12.94,25.8-25.86,45.18-9.68,35.51-12.91,67.79,0,35.5-6.49,45.18-51.69,32.28-74.32,25.83-6.46,0-16.14,3.22-25.86,6.45-35.55,12.9-3.23,6.45-3.23,22.61-3.23,51.63-9.69,61.31-3.22,12.93-16.17,22.6-22.6,35.51-32.32,42l-9.68,6.45s-16.15,45.18-19.37,51.63c-.83,1.64-.42,3.87,.67,6.3-56.98-36.08-110.97-76.69-161.44-121.44h-.06c-17.61-23-30.26-44-36.31-59.1-19.37-48.41-19.37-35.51-35.51-74.24s-22.76-58.23-22.76-64.67-16.18-45.18-16.18-45.18l-19.37-38.73c-3.23-6.46-12.91-32.29-19.4-45.19s-29.06-29.05-38.78-32.28-35.51-41.95-35.51-41.95c0,0-25.86-35.51-29.09-54.89s-22.63-38.73-29.09-77.46-29.09-45.18-32.32-71-9.68-42-9.68-42c0,0,9.68-35.5,16.14-71s13-48.41,19.4-61.31,3.23-19.38,6.46-32.28-3.23-41.95-6.46-61.33-19.4-42-25.86-54.86-16.14-22.6-19.37-41.95-6.46-48.41-9.71-67.79-19.38-54.86-25.83-64.56-6.46-67.76-16.18-106.49c-1.76-6.53-3.06-13.17-3.9-19.88h0c-1.12-10.23,1.26-12.25,3.7-15.24,1.68-1.97,2.85-4.32,3.43-6.84,1.67-6.68,2.5-11.64,2.41-15.77h0c115.32-428,451.59-765.47,879.08-882.95,2.49,4.39,3.83,9.33,3.9,14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2018.41,1637.12c17.29,1.22,18.68-14.37,48.42-25.36,18.16-6.71,21.8-2.43,46.11-11.53s28.55-16.37,30-20.75c1.57-4.86,1.05-10.16-4.61-23.05-11.21-25.55-20.16-46-39.2-53-12.3-4.58-18.41,.29-39.19,2.3-16.38,1.59-39.74,1.19-69.09-8.18-36.54-5.21-62.83-9.37-80.79-12.91-6.28-1.24-19.46-2.92-37.17-4-5.93-.3-11.88-.04-17.76,.77-25.85,3.23-38.77-9.68-80.78,6.46s-90.47,38.73-90.47,38.73c0,0-22.62,19.36-38.78,29s-22.62,6.46-29.08,19.37-16.16,22.59-19.39,32.28-3.23,3.22-6.46,16.14-12.93,32.27-12.93,32.27l-38.77,29.05,19.39,22.59c6.46,6.46,58.16,3.23,61.39,0s3.23-19.36,9.69-25.82,16.16-19.36,16.16-19.36c13.47-8.84,16.63-10.74,19.39-12.91,6.87-5.4,15-15.38,19.39-35.51v-19.36s-6.47-29,6.46-35.51,38.77-12.91,48.47-9.68c8.34,2.61,15.31,8.41,19.38,16.14,3.24,6.45,29.09,6.45,19.39,29s0,9.68-25.85,45.18-32.31,45.19-32.31,45.19l-19.39,38.73-9.69,51.64s0,12.91,9.69,19.37,22.62,6.45,22.62,6.45c0,0-9.69,16.14,16.16-6.45s22.62-22.6,42-42c12.41-12.39,14.23-20.81,21.54-27,4-3.37,9.28-5.55,20.47-8.54,22.54-6,32.68-4,48.47-6.46,33.46-5.25,57.15-25.33,64.62-32.27,12.12-11.26,22.62-25.82,22.62-25.82,6.88-9.49,7-11.12,12.93-19.37,3.15-4.36,6-8.36,7.61-9.65,6.69-5.32,21.4,12.58,39.34,13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2039.28,1736.36c25.86-25.82-3.23-19.36-3.23-29s-6.46-16.13-9.69-19.36-9.7-12.91-16.16-16.14-12.92,25.82-12.92,25.82l-16.16,16.14c-6.46,6.45-9.69,6.45-9.69,6.45,0,0,0,16.14-9.7,25.82s19.39,25.82,22.62,29l29.09-12.91,25.84-25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2129.76,1558.84v19.37c0,6.45,0,3.23,38.77,12.91s6.47-6.46,19.39-12.91,3.23-19.37,3.23-19.37l-19.38-19.36c-6.93-7.12-13.41-14.66-19.39-22.6-9.7-12.91-25.85-6.45-25.85-6.45l-9.7,3.23s-3.23,16.13-6.46,22.59,16.16,22.59,19.39,22.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2129.76,1952.57l19.39,3.23s3.23,3.23,12.92-3.23,22.62-9.68,22.62-22.59,6.46-16.14,9.7-16.14,3.23-6.45,6.46,6.46,3.23,6.45,0,19.36,0,16.14-6.46,22.6-9.7,3.22-6.47,12.91,6.47,12.91,6.47,12.91h9.69c-3.23-3.23,19.39-22.6,19.39-22.6h12.92s6.46,6.46,9.7-12.91-3.24-32.27-3.24-32.27l-19.38-32.28s3.23-22.59-16.16-22.59-6.46-16.14-29.08,0-32.31,19.36-25.85,25.82,12.92,9.68,9.69,12.91-9.69,6.45-9.69,6.45c0,0-22.62,6.46-29.08,9.69s-16.16,6.45-12.93,12.91,19.39,19.36,19.39,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M3175.07,2571.51c-1.91-.18-3.82,.29-5.43,1.34-.04,0-.07,0-.11,0-3.09,2-6.91,6-11.52,13.55-1,1.59-2,3.23-2.95,5.07,0,0-30.05,16.67-36.77,13.35s-16.64-20-23.3-33.34-6.63-26.63-13.37-36.65-33.3-40-40-43.28-36.65-20-50-36.68-3.32,10-36.63-33.27-13.42-100-13.42-100c0,0,2.18,.32,5.17,1,7.75,1.7,21.51,6.15,21.51,15.74,0,13.26,6.65,16.66,16.65,26.66s3.4,6.65,23.36,20,26.73,20,43.38,36.65,30,36.65,30,36.65c0,0,13.37,13.33,13.37,23.3s16.67,69.93,16.67,69.93c0,0,0-3.32,10,0s6.61,6.72,33.36-6.63,36.68-20,36.68-20c0,0,.77-1.48,1.93-4.09,4.38-9.67,14.73-34.79,14.73-55.89,0-26.64-6.65-23.27-6.65-39.92v-100c0-13.37,3.29-23.36-6.7-30s-20-16.6-20-16.6c-13.13-25.8-14.58-46-13.36-60,.91-10.35,3.32-17.37,5.75-26.34-3.77-9.63-7.65-19.15-11.67-28.66-146.5-346.5-444.29-613.57-810.69-718.58l16.19,7.36s16.65,16.72,23.33,26.71,16.66,19.89,16.66,19.89c0,0,10,33.38,3.34,50-2.81,6.99-6.47,13.6-10.9,19.69h0c-1.77,2.45-3.69,4.78-5.75,7-7.59,2.23-15.45,3.35-23.36,3.32-13.29,0-20-6.63-36.7-13.38s-6.63-19.92-30-6.61c-16,9.18-24.19,12-31,17.24h-.05c-3.42,2.69-6.45,5.84-9,9.36-10,13.33-13.26,20-13.26,33.36s10,29.93,13.26,40,13.4,20,10,30-10,19.94-20.06,33.29c-5.98,8.02-10.47,17.04-13.26,26.64,0,0,3.32,3.33,13.26,13.35s-16.6,20,40.09,26.62l33.36,23.34,30,10c3.27,3.27,19.94,10,26.64,3.27,2.68-2.64,5.34-5.34,7.54-7.54,.59-.57,1.11-1.11,1.61-1.61,.32-.27,.62-.57,.89-.89,.86-.88,1.59-1.59,2.15-2.11,.13-.18,.29-.34,.48-.46,.2-.25,.41-.48,.64-.7h0c3.87-2.44,7.26-5.56,10-9.22,2.75-3.87,4.68-8.7,3.34-14.08-3.34-13.27,0-13.27-10-23.33s-13.36-9.94-30-26.64-26.67-30-26.67-33.27v-20l10-13.36s1-.36,2.59-.86c4.92-1.57,15.69-4.18,20.73,.86,6.7,6.7,6.7,0,13.38,16.72s6.63,19.94,13.3,33.29,13.36,10,26.73,26.64,23.3,23.32,23.3,23.32c0,0,23.37,26.64,20,33.29s0-3.31-10,13.35c-10,16.66-13.33,13.36-6.68,23.37,.34,.42,.71,.8,1.11,1.16,.16,.18,.37,.3,.55,.48-7.47,6.65-15,13.33-18.33,14.94-6.65,3.32-33.34,6.7-33.34,6.7,0,0-16.66-3.38-30,3.32s-33.32,10-33.32,10c0,0-22.71,6.18-34,12.08-3.11,1.53-5.31,3.14-6.06,4.55-3.34,6.7-13.31,26.63-13.31,26.63l-3,27.3-.32,2.73-10,6.65-24.48-10.88h0l-2.45-1.07-3.09-1.34s-4.65,9.38-10.15,20.28c-6.72,13.47-14.65,29.32-16.49,33-3.4,6.65-10,10-3.4,23.32s3.4,0,30,30,23.37,33.27,23.37,33.27c1.05,1.69,1.62,3.62,1.66,5.61-.09,2.86-1.84,6.13-8.38,7.74-13.26,3.32-10,6.66-26.62,13.29s-46.73,3.36-46.73,3.36c0,0-10-6.65-30,0-9.57,3.26-18.88,7.23-27.86,11.88-5.43,2.81-8.77,4.77-8.77,4.77l20,43.35s3.4,20,3.4,26.61,6.61,0,3.25,10-6.65,6.65-6.65,13.3-6.68,10,13.35,16.7,33.34,6.65,33.34,6.65c0,0,6.67,0,13.39,10s10,6.65,10,13.38-6.73,26.61-6.73,26.61c.39,.74,.72,1.5,1,2.29,.63,1.94,1.11,4.37-1,4.37s-7.85,2.54-7.42,5.24c-7.15,3.23-9.43,3-14.08,6.72-1.8,1.45-3.52,3-5.13,4.66-10,10-13.4,33.4-13.4,43.4s10,10,0,23.27c-3.4,4.53-7.05,8.87-10.93,13-9.73,10.2-20.58,19.26-32.36,27-3.43,2.24-5.9,4.06-7.81,5.58-2.47,2.07-4.75,4.36-6.81,6.84l-.11,.11c-3.75,4.27-9.16,9.92-28.69,24.07-20.28,14.79-29.38,18.31-35.11,21.92-4.63,2.9-7.13,5.86-11.56,14.78-10,20-20.05,30-23.32,49.92s0-13.29,3.27,59.95,13.36,96.68,13.36,96.68c0,0,20,53.25,20,73.26,0,11,6,34.08,12.6,55.43-1.61,24.71-1.77,53.82,4.32,69,11.74,29.41,17.62,70.58,17.62,70.58l-5.88,35.27,53,29.43s5.88,11.74,17.69,0,70.6-47.05,94.15-29.43,35.39,17.52,35.39,17.52c0,0,26.59-5.27,44.38-26,.93-1.07,1.81-2.23,2.72-3.39,1.93-2.73,4.33-5.1,7.09-7,13.85-8.85,24,12.88,34.13,12.88,11.76,0,41.17-5.91,41.17-5.91,0,0,2.61-2.86,6.7-7.38,8.72-9.47,24.16-26.09,36-37.88h82.5l10,3.37,43.35,10,23.3,20s6.77,6.68,10,26.66c2.04,12.12,2.04,24.51,0,36.63,0,0-10,13.33-10,30s10,36.65,10,36.65l26.75,16.63,33.34,46.64s6.65-13.31,10,16.72,3.38,39.94-3.32,56.61c-3.94,9.79-7.28,19.81-10,30l-20,30-20,30-16.76,43.31,30,96.65c4.2,8.53,7.58,17.44,10.08,26.61,3.32,13.38,3.32,36.66,3.32,36.66,0,0-6.68,33.36-13.4,50s-3.27,40-3.27,40c10.74,22.67,21.46,45.33,32.16,68,69.55-45.73,134.2-98.49,192.94-157.46,.43-.46,.88-.89,1.31-1.34,93.69-94.52,171.25-203.76,229.57-323.39,0-23.05,0-46.08,.09-69.31,.14-36.74,.41-73.23,.82-109.48,3.39-10,20.06-143.27,56.73-176.59,13.26-25.43,23.74-52.23,31.25-79.91,27.36-101.28,13.8-213.76-7.79-216.74Zm-286.71-332.4c3.63,.44,6.63-1.9-10.13,9.27-30,20-73.42,33.34-73.42,33.34,0,0-16.65-3.32-43.33-6.72s-20-3.27-26.64-3.27-38-3.18-46.08,2.65c-.12,.11-.24,.24-.34,.37-.11,.09-.22,.13-.36,.25s-.14,.11-.16,.2-.29,.3-.48,.5c-.5,.48-.9,.91-1.36,1.36l-1.27,1.25c-.39,.41-.82,.86-1.2,1.23l-1.14,1.11c-.45,.39-.79,.84-1.2,1.2s-.89,.89-1.32,1.39c-.16,.18-.35,.35-.54,.5-.15,.15-.29,.31-.41,.48-4.16,4.08-7.54,7.51-7.54,7.51,.56,1.93,.67,3.96,.31,5.93-.52,2.77-2.29,5.79-7,7.34-10,3.36-10,13.37-36.67,6.65s-40-10-50.08-13.31-33.36-16.62-33.36-16.62c0,0-6.67-3.32-20-13.38s-23.3-26.61-23.3-26.61l-26.68-20-26.71-6.65s-23.3-16.71-40-3.38-10,10-26.71,23.27c-2.54,2.09-4.79,4-6.76,5.93q-.09,0-.14,.09c-2.43,2.23-4.52,4.34-6.38,6.36-6.81,7-11.24,12.15-20,14.38-8.27,2.07-16.15,5.45-23.35,10,0,0-40,3.27-43.31,3.27s-3.38-3.27-13.39-3.27-20.06,13.26-20.06,0v-19.44c2.41-.55,4.95-1.09,7.59-1.71,13.74-3.11,29.18-7.06,29.18-8.85,.23-1.64,.77-3.21,1.61-4.64,1.51-3,3.18-5.92,5-8.74,0,0,10-3.32,13.31-26.62,1.98-13.25,3.1-26.61,3.36-40l13.36-40,20-33.27s1.75-1.15,5-3.24c4.52-2.91,12-7.63,21.73-13.42,16.65-10,33.31-10,40-10s40,6.68,40,10,6.72,6.63,23.37,13.28,30,13.35,40,23.35,20,13.3,30,20,13.26,10,23.26,13.27,33.43,3.38,33.43,3.38c0,0,5.6,0-1.21-7.72-.63-.71-1.34-1.45-2.2-2.32-10-10-16.65-16.62-30-26.61s-50-33.32-53.3-36.63-13.36-13.33-13.36-16.7-3.33-20-3.33-20c2.6-1.55,5.43-2.66,8.38-3.29,4.92-1.26,10.08-1.26,15,0,13.33,3.29,20,6.65,43.35,23.27s43.38,33.36,50,43.33,3.4,13.29,16.76,30,20,23.28,20,23.28c0,0-6.58,19.64,9.58,.52,.19-.18,.3-.38,.46-.52,2.07-2.53,4.42-4.81,7-6.81,9.81-7.59,17.06-5.54,16.35-12.67-.22-2.32-1.27-5.59-3.38-10.5-10-23.3-13.31-20-13.31-26.63s-3-12.68,8-18.88c.64-.4,1.34-.74,2-1.11,8.83-4.45,19.25-8.88,22.16-15.3,1.59-3.18,1.18-6.91-2.13-11.36-10-13.33-10-20-16.72-30s-10-13.31-10-29.93c0-15.67-17.74-22.46-.36-31.57,1.2-.65,2.43-1.23,3.7-1.74,23.37-10,23.37-3.34,43.37-13.34s3.29-13.33,30-6.67,50.07,10,56.75,20,16.69,20,16.69,23.25,13.28,6.7,3.27,20c-3.14,4.2-3,6.7-2.43,8.56,1.2,3.95,4.22,4.54-20.89,11.4-36.68,10-30,6.66-50,16.67-4.25,2.14-8.61,4.05-13.06,5.72-5.84,2.41-5.72,2.91-10.27,14.26-6.7,16.7-23.34,13.36-16.66,46.65s13.35,36.68,16.66,40-20,0,6.66,3.38,13.31,13.28,40,3.32,10-3.32,36.69-13.36,23.3-13.31,36.66-13.31c5.1-.19,10.14-1.08,15-2.63-1.41,9.33-.86,20,1.68,22.6,3.39,3.38,16.74,13.37,16.74,13.37l6.65,16.63s6.64,30,6.64,36.65,10-10-3.32,16.64c-6.03,11.84-2.82,13.86,.04,14.13Zm23.21-267.22c-16.67-16.64-26.69-23.39-33.34-30s-26.71-16.66-26.71-16.66c0,0-3.31-20-6.67-23.3s-20-3.34-3.34-10.06c.79-.3,1.61-.62,2.5-.89,17.6-5.43,51.21-2.23,57.54,.89,6.63,3.36,16.69,13.37,16.69,13.37,0,0,3.32,3.36,10,13.33s13.36,29.91,20,33.32,0-6.66,13.38,16.62c8.38,14.63,11.47,24,14.26,29l2.36,14.33c-.07,1.81-.46,3.59-1.14,5.27-1.59,3.86-4.84,6.79-8.83,8q-10,3.36-16.67,0c-6.67-3.36-13.35-6.66-13.35-6.66,0,0-.05,.14-.16,.39-2.11-11.15-5.31-22.51-9.86-27-9.99-9.98-.02-3.27-16.66-19.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1451.19,1978.43l6.47,19.37s16.15,3.23,25.85,3.23,9.69,0,19.38-3.23c9.69-3.23,16.16,3.23,19.39-6.45s0-9.69,3.23-19.37,3.23-6.46,3.23-16.14,0-12.91-3.23-12.91,6.47,0-9.69-3.23-19.39-6.45-22.62-3.22-3.23,6.45-12.92,3.22-29.09,3.23-29.09,3.23l3.24,6.45c0,3.23-9.7,12.92-9.7,12.92l6.46,16.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2375.34,1533.02c-32.32-16.14-29.08-19.36-35.55-19.36s-9.69,3.22-12.92-3.23-3.23-6.46-6.47-12.91-3.23-6.46-9.69-9.68-16.15,3.22-16.15,3.22c-3.24,3.23-9.7,3.23-9.7,9.69s0,12.91,6.46,16.13,6.47-3.22,12.93,3.23,12.92,9.68,16.15,12.91,3.24-3.23,6.47,6.46,3.23,12.91,6.46,16.13,0,3.23,12.93,6.46,22.61,6.46,25.85,3.23,12.92-3.23,9.69-12.91,25.85-3.23-6.46-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1551.36,2998.36c16.16-9.68,32.32,9.68,51.71,12.91s29.07-32.27,29.07-32.27l-19.38-22.6-32.31-12.91s-51.71-32.27-67.86-61.32-29.08-67.78-29.08-67.78c0,0-22.62-25.82-29.08-32.28s-42-6.45-45.24-3.23-25.85,51.65-42,74.24-22.62,19.37-38.77,32.27-3.24,6.46-6.47,32.28,19.39,38.73,22.62,42h-3.23s74.32,51.64,100.17,54.87,35.55,0,80.78-3.23,12.92-3.27,29.07-12.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1170.07,2744.99c54.94,50,64.63,50,64.63,50,0,0,16.16-3.23,25.85,12.91s19.39,29,19.39,29l25.85,16.14c16.15,3.23,19.38,0,25.85-6.46s16.15-61.32,0-83.92,3.23-29-35.55-38.73-32.31-6.45-61.39-16.13-80.78-22.6-77.55-12.91-42.01,.08,12.92,50.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1777.8,3886.8c-134.59-23.74-264.37-69.42-384.16-135.23-.88-22.72,.85-47.88,14.06-57.73,22.83-17.09,79.86-96.87,85.56-51.28s17.11,91.16,45.64,102.56,68.42-17.09,91.26-5.71,85.56,51.28,96.95,85.46c5.8,17.28,29.06,41.88,50.69,61.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2052.22,1443.39s-28.5,28.47-62.73,28.47-62.76-17.1-62.76-17.1l-22.82,11.41h-17.11c-11.42,0-34.23,5.69-45.62-17.09s-22.83,0-45.64,0-34.23-5.69-34.23-5.69c0,0-5.69-11.41,5.7-22.81,1.43-1.43,2.95-2.77,4.55-4,74.69-13.55,150.44-20.34,226.35-20.31,13.27,0,26.48,.22,39.63,.65,3.61,6.71,5.2,7.5,14.68,12.28,11.42,5.69,0,34.19,0,34.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2623.16,3723.21c0,6.49-10.77,18.35-23.37,29.66-39.8,21.77-80.77,41.33-122.72,58.61h-.12c-4.31,.87-6.88,.93-6.88-.11,0-5.88-5.88-11.76,0-23.5s41.22-58.82,41.22-58.82l29.43-47.06s-11.76-47-23.55-88.2,47.1-23.5,76.53-41.15c0,0,23.55,29.39,29.46,41.15s-11.79,35.29-17.67,47,11.76,23.53,17.67,47,0,23.65,0,35.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3254.21,2651.93c0,475.24-264.48,888.76-654.42,1101.73-39.8,21.77-80.77,41.34-122.72,58.61l-.12,.05c-147.61,60.91-309.39,94.49-479,94.49-73.81,.03-147.48-6.41-220.16-19.24-109.54-19.32-216.01-53.21-316.57-100.76-22.91-10.83-45.43-22.33-67.58-34.5-23.05-12.62-45.64-25.95-67.79-40-18.23-11.56-36.14-23.58-53.71-36.07-37.43-26.47-73.39-54.98-107.71-85.38h0c-9.26-8.2-18.4-16.53-27.41-25,14.06,7.33,28.28,14.39,42.67,21.16,100.56,47.55,207.03,81.44,316.58,100.77,72.67,12.81,146.33,19.24,220.12,19.21,169.64,0,331.42-33.59,479-94.5h.12c41.95-17.28,82.92-36.84,122.72-58.61,389.95-213,654.42-626.49,654.42-1101.74,.19-157.14-29.23-312.92-86.74-459.16-3.77-9.63-7.65-19.15-11.67-28.66-68.27-161.19-169.42-306.35-297-426.21,258.62,134.46,464.5,356.15,578.62,626.05,4,9.52,7.9,19,11.67,28.66,57.48,146.23,86.88,301.98,86.68,459.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2944.05,1825.57c-129.47-103.68-278.24-180.64-437.67-226.41-34.56-9.88-69.69-18.3-105.38-25.27-66.67-12.99-134.29-20.56-202.18-22.62-8-.26-16-.42-24-.51-5.2-.07-10.42-.12-15.67-.12-33.27,0-66.24,1.28-98.9,3.83-.51,.05-1,.07-1.53,.12s-.93,.09-1.39,.11c-4.99,.4-9.96,.83-14.92,1.3-37,3.38-73.5,8.34-109.5,14.89-54,9.82,0,0,0,0-36.5,6.59-72.42,14.78-107.76,24.55-213.77,58.73-404.7,172.48-556.62,325-151.92,152.52-264.79,344-322.46,557.92v.07c-2.04,7.49-3.99,15-5.85,22.55h0c-2.44,3-4.78,5-3.69,15.24h0c-22.4,94.78-33.68,191.84-33.62,289.23,0,317.28,117.88,607.06,312.29,828-17.33-13.76-34.26-27.98-50.77-42.65h-.07c-9.26-8.21-18.39-16.55-27.4-25,.65,.32,1.3,.65,1.92,1-244.49-229-397.24-554.51-397.24-915.7-.07-97.34,11.19-194.35,33.55-289.08h0c-1.09-10.21,1.25-12.25,3.69-15.25h0c1.86-7.54,3.81-15.06,5.85-22.55v-.07c57.66-214,170.53-405.35,322.45-557.92s342.86-266.3,556.62-325c35.33-9.73,71.26-17.92,107.77-24.56h0c36-6.54,72.52-11.52,109.57-14.94,4.97-.47,9.94-.91,14.92-1.3,.47,0,.93-.07,1.4-.12l1.53-.11c32.62-2.53,65.59-3.81,98.9-3.83,5.24,0,10.46,.04,15.66,.11,8,.1,16,.27,24,.51,67.89,2.06,135.51,9.61,202.18,22.58,35.66,6.94,70.78,15.36,105.37,25.27,235.21,67.37,442.15,201.56,598.95,380.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3592.74,2422.15c-807.69,476.5-1345.91,624.42-1686.77,669.07-17.78,2.33-34.57,4.32-35.33,4.41-50.22,5.94-1075.64,119.75-1218-225.63-34.29-83.2-32-228.52,32.48-341.11,13.78-24.01,30.21-46.39,49-66.72,3.2-5.95,7.91-10.95,13.66-14.5,3.58-2.18,7.5-3.75,11.6-4.64-1.55,6.19-3.09,12.38-4.64,18.57-25.36,33.09-66.58,96.42-80.52,184.76-13.6,86.15,5.12,155.7,10.9,172.59,63.09,184.17,692.11,246.51,1267,113.71,236.61-54.66,622.06-178.88,1041.92-496.45l598.7-14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2953.06,2785.3c-8.15,4.79-16.31,9.56-24.48,14.33-12.52,7.33-25.04,14.67-37.56,22-2.39,1.42-5.14,2.11-7.91,2-78.57-3.38-157.15-6.76-235.75-10.13-7.95-.35-14.1-7.07-13.75-15.02,.2-4.54,2.53-8.72,6.28-11.27,38.72-26.21,77.43-52.41,116.14-78.6,3.53-2.41,7.95-3.11,12.06-1.93l181.68,52.39c7.64,2.22,12.02,10.21,9.8,17.85-1.02,3.52-3.35,6.52-6.51,8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2928.58,2799.63c-12.52,7.33-25.04,14.67-37.56,22-2.39,1.42-5.14,2.11-7.91,2-78.57-3.38-157.15-6.76-235.75-10.13-6.49-.19-12.01-4.78-13.39-11.12l140.32-24.19,154.29,21.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2777.67,2608.83c-57.25,38.83-114.5,77.67-171.75,116.54-5.77,3.93-11.55,7.85-17.33,11.77-13.87-1.64-24.25-2.89-38.15-4.52l-2.29-2.52-181.5-199.6c-6.89-7.58-7.07-19.09-.43-26.89,1.26-1.5,2.74-2.8,4.38-3.86,30.3-19.76,60.6-39.51,90.91-59.25,5.85-3.81,13.25-4.36,19.6-1.45l256.57,117.45,37,17c10.22,4.68,14.71,16.77,10.03,26.99-1.54,3.37-3.98,6.25-7.04,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2777.67,2608.83c-57.25,38.83-114.5,77.67-171.75,116.54-18.78,3.95-38.47,6.07-57.77,4.73l-181.5-199.6c-6.89-7.58-7.07-19.09-.43-26.89,47,40.72,123.61,101.67,164.26,110.71,47.6,10.58,159.49-36.31,207.2-57.82l37,17c10.22,4.68,14.71,16.77,10.03,26.99-1.54,3.37-3.98,6.25-7.04,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M4115.38,2648.07c-11.24,6.11-22.87,12.9-34,19.48-27.64,16.31-52.55,31.5-61.84,32.73-5.27,.68-9.56,1-12.2,1.18-210.6-60.67-421.21-121.3-631.84-181.9,50.34-29.1,100.67-58.19,151-87.26,70.4-40.67,140.8-81.35,211.2-122.06,6,.55,12.08,1.07,18.12,1.61l362.31,310.56c6.56,5.63,7.32,15.52,1.69,22.08-1.25,1.45-2.75,2.67-4.44,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M4081.34,2667.57c-27.64,16.31-52.55,31.5-61.84,32.73-5.27,.68-9.56,1-12.2,1.18-210.6-60.67-421.21-121.3-631.84-181.9,50.34-29.1,100.67-58.19,151-87.26,4.45,9.68,11.65,18.88,22.69,26.73,55.5,39.47,288.52,137.26,318.5,148.55,24.52,9.22,148.74,47.03,213.69,59.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M4092.08,2135.57l-934,537.7c-91.21,52.94-242.11,123.66-346.71,137.16l-237.52,30.65c-14.72,1.9-29.54-2.61-40.71-12.38-18.82-16.46-37.63-32.92-56.44-49.38l-1.71-1.5c86.53-64,173.07-128,259.6-192,556.27-344.27,1073.18-649.93,1172.27-701.74,34.13-17.85,111.43-54.79,189.3-37.86,3.75,.82,7.5,1.74,11.16,2.76,19.64,5.36,37.47,12.92,48.33,17.52,1.94,.82,3.95,1.68,6,2.57,12.91,5.53,27.8,12.19,41.86,19.82,22.19,12,42.35,26.43,49.49,42.51,19.41,43.77-45.09,129.49-160.92,204.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M4092.08,2135.57l-934,537.7c-91.21,52.94-242.11,123.66-346.71,137.16l-237.52,30.65c-14.72,1.9-29.54-2.61-40.71-12.38-18.82-16.46-37.63-32.92-56.44-49.38,26.48-1.42,63.1-3.46,113.52-6.34,222.79-12.74,431-127.85,460.07-144s956.62-558.19,956.62-558.19c0,0,196.13-96.12,199.47-156.29,.51-8.64-.46-17.3-2.88-25.61,22.19,12,42.35,26.43,49.49,42.51,19.42,43.77-45.08,129.49-160.91,204.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2687.15,2705.39c-8.74,7.63-20.46,17.71-33.56,28.63-41.52,34.61-97,77.6-116.43,77.6-27.1,0-218.29-46.21-280.6-61.45-4.32-1.06-6.96-5.42-5.9-9.74,.53-2.14,1.91-3.98,3.83-5.07l4.36-2.49,60.7-34.68c7.92-4.52,16.88-6.9,26-6.91h336.36c4.42-.04,8.03,3.51,8.08,7.92,.02,2.38-1.02,4.65-2.84,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3543.01,2262.69c-7.2,4.36-14.76,9.15-23,14.44-52.33,33.75-131,88.27-308.83,186.81-12.58,7-22.78,12.78-29.11,16.42-297.41-92.75-594.83-185.49-892.26-278.22-11.45-3.29-12.47-19.12-1.55-23.86l18.17-7.91,123.58-53.8c1.99-.88,4.18-1.22,6.34-1,180.99,17.85,361.86,36.89,542.62,57.14,186.47,20.87,372.81,43,559,66.4,11.99,1.55,15.32,17.31,5.04,23.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3545.83,2168.68v26c0,4.22-2.69,7.96-6.69,9.3l-4.75,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.21,2.7-7.95,6.69-9.3l4.75-1.58c3.32-1.1,6.97-.34,9.57,2h0s.14,.11,.38,.33c1.89,1.83,2.95,4.34,2.95,6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3544.45,2163.66c-2.45-1.48-5.43-1.81-8.14-.9l-4.74,1.58c-4,1.34-6.7,5.08-6.7,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.76-4.77-4.95-4.76-8.4v-26c0-4.21,2.7-7.95,6.69-9.3l4.75-1.58c4.37-1.46,9.17,.33,11.52,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3545.83,2168.68v26c0,4.22-2.69,7.96-6.69,9.3l-4.75,1.57c-3.35,1.14-7.05,.38-9.67-2,17.69-10.56,17.78-41.48,17.78-42.16,0,0,.14,.11,.38,.33,1.89,1.82,2.95,4.34,2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3591.8,2141.64v26c0,4.21-2.7,7.96-6.69,9.3l-4.75,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.22,2.7-7.96,6.7-9.3l4.74-1.58c3.32-1.11,6.98-.34,9.58,2h0l.37,.32c1.89,1.83,2.95,4.35,2.95,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3590.42,2136.62c-2.45-1.48-5.43-1.81-8.14-.9l-4.74,1.58c-4,1.34-6.7,5.08-6.7,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.75-4.77-4.95-4.76-8.39v-26c0-4.22,2.7-7.96,6.7-9.3l4.74-1.58c4.37-1.46,9.17,.32,11.52,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3591.8,2141.64v26c0,4.21-2.7,7.96-6.69,9.3l-4.75,1.57c-3.35,1.14-7.05,.38-9.67-2,17.69-10.56,17.79-41.48,17.79-42.16l.37,.32c1.89,1.83,2.95,4.34,2.95,6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3637.77,2114.57v26c0,4.22-2.69,7.96-6.69,9.31l-4.75,1.56c-5.13,1.71-10.68-1.06-12.4-6.2-.33-.99-.5-2.04-.5-3.08v-26c0-4.22,2.7-7.96,6.7-9.3l4.74-1.59c3.32-1.1,6.98-.33,9.58,2h0l.37,.32c1.89,1.83,2.95,4.35,2.95,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3636.39,2109.57c-2.45-1.49-5.43-1.82-8.14-.91l-4.74,1.59c-4,1.34-6.7,5.08-6.7,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.75-4.77-4.95-4.76-8.39v-26c0-4.22,2.7-7.96,6.7-9.3l4.74-1.59c4.37-1.45,9.17,.34,11.52,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3637.77,2114.57v26c0,4.22-2.69,7.96-6.69,9.31l-4.75,1.56c-3.34,1.14-7.04,.37-9.66-2,17.68-10.56,17.78-41.49,17.78-42.16l.37,.32c1.89,1.83,2.95,4.34,2.95,6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3683.74,2087.57v26c0,4.22-2.69,7.96-6.69,9.3l-4.74,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.22,2.69-7.96,6.69-9.31l4.74-1.58c3.32-1.1,6.98-.33,9.58,2h0l.38,.32c1.89,1.84,2.95,4.36,2.94,6.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3682.36,2082.57c-2.44-1.49-5.42-1.82-8.13-.91l-4.75,1.58c-4,1.35-6.69,5.09-6.69,9.31v26c0,1.76,.47,3.49,1.38,5-2.96-1.76-4.78-4.95-4.76-8.4v-26c0-4.22,2.69-7.96,6.69-9.31l4.74-1.58c4.38-1.46,9.17,.34,11.52,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3683.74,2087.57v26c0,4.22-2.69,7.96-6.69,9.3l-4.74,1.57c-3.35,1.14-7.05,.38-9.67-2,17.68-10.56,17.78-41.48,17.78-42.15l.38,.32c1.88,1.83,2.94,4.34,2.94,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3729.72,2060.51v26c0,4.22-2.7,7.96-6.7,9.3l-4.74,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.21,2.7-7.96,6.69-9.3l4.75-1.58c3.32-1.1,6.97-.33,9.57,2h0l.38,.33c1.89,1.83,2.96,4.34,2.95,6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3728.34,2055.5c-2.45-1.49-5.43-1.82-8.14-.91l-4.75,1.58c-3.99,1.34-6.69,5.09-6.69,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.76-4.78-4.95-4.76-8.4v-26c0-4.21,2.7-7.96,6.69-9.3l4.75-1.58c4.38-1.46,9.18,.34,11.52,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3729.72,2060.51v26c0,4.22-2.7,7.96-6.7,9.3l-4.74,1.57c-3.35,1.14-7.05,.38-9.67-2,17.68-10.56,17.78-41.48,17.78-42.16l.38,.33c1.89,1.82,2.95,4.34,2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3775.69,2033.47v26c0,4.22-2.7,7.96-6.7,9.3l-4.74,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.58c3.32-1.1,6.97-.34,9.57,2h0s.14,.11,.38,.33c1.89,1.83,2.96,4.34,2.95,6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3774.31,2028.45c-2.45-1.48-5.43-1.81-8.14-.9l-4.75,1.58c-4,1.34-6.69,5.08-6.69,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.76-4.77-4.95-4.76-8.4v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.58c4.37-1.46,9.17,.33,11.52,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3775.69,2033.47v26c0,4.22-2.7,7.96-6.7,9.3l-4.74,1.57c-3.35,1.14-7.05,.38-9.67-2,17.69-10.56,17.78-41.48,17.78-42.16,0,0,.14,.11,.38,.33,1.89,1.82,2.95,4.34,2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3821.66,2006.43v26c0,4.21-2.7,7.95-6.69,9.3l-4.75,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.58c3.32-1.1,6.97-.34,9.57,2h0l.38,.32c1.89,1.83,2.95,4.35,2.95,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3820.28,2001.41c-2.45-1.48-5.43-1.81-8.14-.9l-4.75,1.58c-4,1.34-6.69,5.08-6.69,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.75-4.77-4.95-4.76-8.39v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.58c4.37-1.46,9.17,.33,11.52,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3821.66,2006.43v26c0,4.21-2.7,7.95-6.69,9.3l-4.75,1.57c-3.35,1.14-7.05,.38-9.67-2,17.69-10.56,17.78-41.48,17.78-42.16l.38,.32c1.89,1.83,2.95,4.34,2.95,6.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3867.63,1978.03v26c0,4.22-2.69,7.96-6.69,9.3l-4.75,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.22,2.7-7.96,6.69-9.31l4.75-1.58c3.32-1.1,6.97-.33,9.57,2h0c.13,.1,.26,.21,.38,.32,1.89,1.83,2.96,4.36,2.95,6.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3866.25,1973.02c-2.45-1.49-5.43-1.82-8.14-.91l-4.74,1.58c-4,1.34-6.7,5.09-6.7,9.31v26c0,1.76,.47,3.49,1.38,5-2.96-1.76-4.77-4.95-4.76-8.4v-26c0-4.22,2.7-7.96,6.69-9.31l4.75-1.58c4.38-1.46,9.17,.34,11.52,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3867.63,1978.03v26c0,4.22-2.69,7.96-6.69,9.3l-4.75,1.57c-3.35,1.14-7.05,.38-9.67-2,17.69-10.56,17.78-41.48,17.78-42.15,.13,.1,.26,.21,.38,.32,1.89,1.82,2.95,4.34,2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2879.24,2571.57v26c0,4.22-2.69,7.96-6.69,9.31l-4.75,1.57c-5.14,1.71-10.68-1.07-12.39-6.21-.33-.99-.5-2.03-.5-3.08v-26c0-4.22,2.69-7.96,6.69-9.3l4.74-1.59c3.32-1.1,6.97-.33,9.58,2h0l.38,.32c1.88,1.83,2.94,4.35,2.94,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2877.91,2566.57c-2.45-1.49-5.43-1.82-8.14-.91l-4.74,1.59c-4,1.34-6.69,5.08-6.69,9.3v26c0,1.76,.47,3.49,1.38,5-2.97-1.75-4.78-4.95-4.76-8.39v-26c0-4.22,2.69-7.96,6.69-9.3l4.74-1.59c4.37-1.45,9.17,.34,11.52,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2879.24,2571.57v26c0,4.22-2.69,7.96-6.69,9.31l-4.75,1.57c-3.34,1.13-7.04,.37-9.66-2,17.68-10.56,17.78-41.49,17.78-42.16l.38,.32c1.88,1.83,2.94,4.34,2.94,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2925.22,2545.92v26c0,4.22-2.7,7.97-6.7,9.31l-4.74,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.59c3.32-1.1,6.97-.33,9.57,2h0l.38,.32c1.89,1.83,2.95,4.35,2.95,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2923.84,2540.9c-2.45-1.49-5.43-1.82-8.14-.91l-4.79,1.58c-4,1.34-6.69,5.08-6.69,9.3v26c0,1.76,.47,3.49,1.38,5-2.97-1.75-4.78-4.95-4.76-8.39v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.59c4.39-1.47,9.21,.33,11.56,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2925.22,2545.92v26c0,4.22-2.7,7.97-6.7,9.31l-4.74,1.57c-3.35,1.13-7.05,.37-9.67-2,17.68-10.56,17.78-41.49,17.78-42.16l.38,.32c1.88,1.83,2.95,4.34,2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2971.19,2520.23v26c0,4.22-2.7,7.97-6.7,9.31l-4.74,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.59c3.32-1.1,6.97-.33,9.57,2h0l.38,.32c1.89,1.83,2.95,4.35,2.95,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2969.81,2515.21c-2.45-1.49-5.43-1.82-8.14-.91l-4.75,1.59c-4,1.34-6.69,5.08-6.69,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.75-4.77-4.95-4.76-8.39v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.59c4.37-1.45,9.17,.34,11.52,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2971.19,2520.23v26c0,4.22-2.7,7.97-6.7,9.31l-4.74,1.57c-3.35,1.14-7.05,.37-9.67-2,17.69-10.56,17.78-41.49,17.78-42.16l.38,.32c1.88,1.83,2.95,4.34,2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3017.16,2494.57v26c0,4.22-2.7,7.96-6.69,9.31l-4.75,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.59c3.32-1.1,6.97-.33,9.57,2h0l.38,.32c1.89,1.83,2.95,4.35,2.95,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3015.78,2489.57c-2.45-1.49-5.43-1.82-8.14-.91l-4.75,1.59c-4,1.34-6.69,5.08-6.69,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.75-4.77-4.95-4.76-8.39v-26c0-4.22,2.69-7.96,6.69-9.3l4.75-1.59c4.37-1.45,9.17,.34,11.52,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3017.16,2494.57v26c0,4.22-2.7,7.96-6.69,9.31l-4.75,1.57c-3.35,1.14-7.05,.38-9.67-2,17.69-10.56,17.78-41.49,17.78-42.16l.38,.32c1.88,1.83,2.95,4.34,2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3063.13,2468.85v26c0,4.22-2.69,7.96-6.69,9.31l-4.75,1.57c-5.14,1.71-10.69-1.08-12.4-6.22-.33-.99-.5-2.03-.5-3.07v-26c0-4.21,2.7-7.95,6.69-9.3l4.75-1.59c3.32-1.1,6.97-.34,9.57,2h0l.38,.32c1.89,1.83,2.95,4.35,2.95,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3061.75,2463.83c-2.45-1.49-5.43-1.82-8.14-.91l-4.75,1.59c-3.99,1.35-6.68,5.09-6.69,9.3v26c0,1.76,.47,3.49,1.38,5-2.96-1.75-4.77-4.95-4.76-8.39v-26c0-4.21,2.7-7.95,6.69-9.3l4.75-1.59c4.37-1.45,9.17,.34,11.52,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3063.13,2468.85v26c0,4.22-2.69,7.96-6.69,9.31l-4.75,1.57c-3.35,1.14-7.05,.38-9.67-2,17.69-10.56,17.78-41.49,17.78-42.16l.38,.32c1.88,1.83,2.95,4.34,2.95,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M3977.15,1903.49l37.86-22.12,1.71,38.39-38.22,23.81-1.35-40.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M4161.63,1869.07l-69.55,13.65c-8.56-7.66-17.12-15.33-25.69-23l40.91-10.76c19.64,5.36,37.47,12.92,48.33,17.52,1.94,.84,3.95,1.7,6,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M4056.91,1862.44l22.92,25.6-57.38,28.53c-.23-12.82-.45-25.64-.68-38.46l35.14-15.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M2464.15,2745.37l-.81,.51c-7.79,.19,.81-.51,.81-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M3456.35,2263.57s-102.91,84-196.67,95.51c-6.35-2.24-34.57-12.92-48.67-42.51-.12-.25-.24-.51-.37-.77-5.37-11.74-7.84-24.6-7.2-37.49,1.43-1.45,49.52-89.17,185.59-147l57.47,112.9,9.85,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3456.35,2263.57s-102.91,84-196.67,95.51c-6.35-2.24-34.57-12.92-48.67-42.51,6.11,1.63,12.69,3,19.78,4.2,66.25,10.81,161.44-84.23,161.44-84.23l54.27,7.68,9.85,19.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-123",
    cx: 3421.19,
    cy: 2198.69,
    rx: 44.71,
    ry: 74.28,
    transform: "translate(-614.96 1700.43) rotate(-25.69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 3424.16,
    cy: 2195.02,
    rx: 35.43,
    ry: 58.86,
    transform: "translate(-613.16 1702.06) rotate(-25.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M3437.61,2189.32c10,20.87,8,42.68-4.57,48.72s-30.88-6-40.92-26.84-8-42.68,4.57-48.72,30.88,5.97,40.92,26.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M3426.99,2192.91c4.06,8.44,3.23,17.27-1.85,19.71s-12.49-2.41-16.55-10.85-3.24-17.27,1.84-19.72,12.48,2.42,16.56,10.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M3937.79,2422.57s-102.91,84-196.66,95.51c-6.36-2.24-34.58-12.93-48.68-42.51l-.36-.77c-5.37-11.74-7.85-24.6-7.21-37.49,1.43-1.45,49.53-89.17,185.59-147l57.48,112.9,9.84,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3937.79,2422.57s-102.91,84-196.66,95.51c-6.36-2.24-34.58-12.93-48.68-42.51,6.11,1.62,12.7,3,19.78,4.19,66.26,10.82,161.44-84.22,161.44-84.22l54.28,7.68,9.84,19.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-123",
    cx: 3902.71,
    cy: 2356.81,
    rx: 44.71,
    ry: 74.28,
    transform: "translate(-635.98 1925.59) rotate(-25.7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 3905.59,
    cy: 2353.96,
    rx: 35.43,
    ry: 58.86,
    transform: "translate(-634.46 1926.56) rotate(-25.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M3919.05,2348.29c10,20.86,8,42.68-4.56,48.72s-30.89-6-40.93-26.84-8-42.68,4.57-48.72,30.88,5.97,40.92,26.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M3908.43,2351.88c4.06,8.44,3.24,17.26-1.85,19.71s-12.49-2.42-16.55-10.86-3.23-17.26,1.85-19.71,12.49,2.42,16.55,10.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3520.05,2277.13c-52.33,33.75-131,88.27-308.83,186.81-12.58,7-22.78,12.78-29.11,16.42-297.41-92.75-594.83-185.49-892.26-278.22-11.45-3.29-12.47-19.12-1.55-23.86l18.17-7.91c230.59,69.47,802.94,239,874.48,232.23,63.13-6.03,239.65-81.23,339.1-125.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2653.59,2734.02c-41.52,34.61-97,77.6-116.43,77.6-27.1,0-218.29-46.21-280.6-61.45-4.32-1.06-6.96-5.42-5.9-9.74,.53-2.14,1.91-3.98,3.83-5.07l4.36-2.49c56.46,13.12,207.2,47.41,231,45.3,22.69-2.02,120.84-31.16,163.74-44.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3545.59,3363.74h-471.53c-.07-.28-.11-.58-.18-.86h-532.23c-.42-5-.7-10-.7-15-.03-92.78,75.17-168.02,167.95-168.05h.1c8.69,0,17.36,.67,25.95,2,19.74-124.68,127.69-220,257.92-220,123.26,0,226.55,85.39,254,200.24,72.9,4.8,134.1,56.69,150.74,127.83,50.08-26.06,111.79-6.58,137.85,43.49,4.96,9.54,8.39,19.79,10.15,30.4l-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3545.59,3363.74h-92.24c-8.84-26.27-26.34-49.66-49.5-65-32.21-21.28-74.56-26.38-110.92-13.34,3.9-33.18-11.44-67.94-38.59-87.44s-65-22.88-95.18-8.56c-7.13-44.39-38.15-82.77-77-105.44s-84.72-31-129.66-31c-60.57,0-125.2,17-164,63.53-27,32.44-38.25,75.12-44.77,116.84-43.55-23.18-98.48-23.6-142.41-1.09-11.65,5.99-22.45,13.49-32.14,22.3,31.15-46.74,83.62-74.8,139.79-74.77,8.69,0,17.36,.67,25.95,2,19.74-124.68,127.69-220,257.92-220,123.26,0,226.55,85.39,254,200.24,72.9,4.8,134.1,56.69,150.74,127.83,50.08-26.06,111.79-6.58,137.85,43.49,4.96,9.54,8.39,19.79,10.15,30.4h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelHistory);
export default __webpack_public_path__ + "static/media/travel-history.7a54d456a939ed7c0282aeed8496ba7c.svg";
export { ForwardRef as ReactComponent };